/*eslint-disable block-scoped-var, id-length, no-control-regex, no-magic-numbers, no-mixed-operators, no-prototype-builtins, no-redeclare, no-shadow, no-var, sort-vars, default-case, jsdoc/require-param*/
import $protobuf from "protobufjs/minimal.js";

// Common aliases
const $Reader = $protobuf.Reader, $Writer = $protobuf.Writer, $util = $protobuf.util;

// Exported root namespace
const $root = $protobuf.roots["default"] || ($protobuf.roots["default"] = {});

export const rti = $root.rti = (() => {

    /**
     * Namespace rti.
     * @exports rti
     * @namespace
     */
    const rti = {};

    rti.Base = (function() {

        /**
         * Properties of a Base.
         * @typedef {Object} rti.Base.$Properties
         * @property {number|null} [templateId] Base templateId
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding
         */

        /**
         * Properties of a Base.
         * @memberof rti
         * @interface IBase
         * @augments rti.Base.$Properties
         * @deprecated Use rti.Base.$Properties instead.
         */

        /**
         * Shape of a Base.
         * @typedef {rti.Base.$Properties} rti.Base.$Shape
         */

        /**
         * Constructs a new Base.
         * @memberof rti
         * @classdesc Represents a Base.
         * @constructor
         * @param {rti.Base.$Properties=} [properties] Properties to set
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding
         */
        function Base(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null && keys[i] !== "__proto__")
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Base templateId.
         * @member {number} templateId
         * @memberof rti.Base
         * @instance
         */
        Base.prototype.templateId = 0;

        /**
         * Creates a new Base instance using the specified properties.
         * @function create
         * @memberof rti.Base
         * @static
         * @param {rti.Base.$Properties=} [properties] Properties to set
         * @returns {rti.Base} Base instance
         * @type {{
         *   (properties: rti.Base.$Shape): rti.Base & rti.Base.$Shape;
         *   (properties?: rti.Base.$Properties): rti.Base;
         * }}
         */
        Base.create = function create(properties) {
            return new Base(properties);
        };

        /**
         * Encodes the specified Base message. Does not implicitly {@link rti.Base.verify|verify} messages.
         * @function encode
         * @memberof rti.Base
         * @static
         * @param {rti.Base.$Properties} message Base message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Base.encode = function encode(message, writer, _depth) {
            if (!writer)
                writer = $Writer.create();
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw Error("max depth exceeded");
            if (message.templateId != null && Object.hasOwnProperty.call(message, "templateId"))
                writer.uint32(/* id 154467, wireType 0 =*/1235736).int32(message.templateId);
            if (message.$unknowns != null && Object.hasOwnProperty.call(message, "$unknowns"))
                for (let i = 0; i < message.$unknowns.length; ++i)
                    writer.raw(message.$unknowns[i]);
            return writer;
        };

        /**
         * Encodes the specified Base message, length delimited. Does not implicitly {@link rti.Base.verify|verify} messages.
         * @function encodeDelimited
         * @memberof rti.Base
         * @static
         * @param {rti.Base.$Properties} message Base message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Base.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer && writer.len ? writer.fork() : writer).ldelim();
        };

        /**
         * Decodes a Base message from the specified reader or buffer.
         * @function decode
         * @memberof rti.Base
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {rti.Base & rti.Base.$Shape} Base
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Base.decode = function decode(reader, length, _end, _depth, _target) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $Reader.recursionLimit)
                throw Error("max depth exceeded");
            let end = length === undefined ? reader.len : reader.pos + length, message = _target || new $root.rti.Base(), value;
            while (reader.pos < end) {
                let start = reader.pos;
                let tag = reader.tag();
                if (tag === _end) {
                    _end = undefined;
                    break;
                }
                let wireType = tag & 7;
                switch (tag >>>= 3) {
                case 154467: {
                        if (wireType !== 0)
                            break;
                        if (value = reader.int32())
                            message.templateId = value;
                        else
                            delete message.templateId;
                        continue;
                    }
                }
                reader.skipType(wireType, _depth, tag);
                if (!reader.discardUnknown) {
                    $util.makeProp(message, "$unknowns", false);
                    (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
                }
            }
            if (_end !== undefined)
                throw Error("missing end group");
            return message;
        };

        /**
         * Decodes a Base message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof rti.Base
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {rti.Base & rti.Base.$Shape} Base
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Base.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Base message.
         * @function verify
         * @memberof rti.Base
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Base.verify = function verify(message, _depth) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                return "max depth exceeded";
            if (message.templateId != null && message.hasOwnProperty("templateId"))
                if (!$util.isInteger(message.templateId))
                    return "templateId: integer expected";
            return null;
        };

        /**
         * Creates a Base message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof rti.Base
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {rti.Base} Base
         */
        Base.fromObject = function fromObject(object, _depth) {
            if (object instanceof $root.rti.Base)
                return object;
            if (!$util.isObject(object))
                throw TypeError(".rti.Base: object expected");
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw Error("max depth exceeded");
            let message = new $root.rti.Base();
            if (object.templateId != null)
                if (Number(object.templateId) !== 0)
                    message.templateId = object.templateId | 0;
            return message;
        };

        /**
         * Creates a plain object from a Base message. Also converts values to other types if specified.
         * @function toObject
         * @memberof rti.Base
         * @static
         * @param {rti.Base} message Base
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Base.toObject = function toObject(message, options, _depth) {
            if (!options)
                options = {};
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw Error("max depth exceeded");
            let object = {};
            if (options.defaults)
                object.templateId = 0;
            if (message.templateId != null && message.hasOwnProperty("templateId"))
                object.templateId = message.templateId;
            return object;
        };

        /**
         * Converts this Base to JSON.
         * @function toJSON
         * @memberof rti.Base
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Base.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the type url for Base
         * @function getTypeUrl
         * @memberof rti.Base
         * @static
         * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
         * @returns {string} The type url
         */
        Base.getTypeUrl = function getTypeUrl(prefix) {
            if (prefix === undefined)
                prefix = "type.googleapis.com";
            return prefix + "/rti.Base";
        };

        return Base;
    })();

    rti.ExchangeOrderNotification = (function() {

        /**
         * Properties of an ExchangeOrderNotification.
         * @typedef {Object} rti.ExchangeOrderNotification.$Properties
         * @property {number|null} [templateId] ExchangeOrderNotification templateId
         * @property {string|null} [userTag] ExchangeOrderNotification userTag
         * @property {rti.ExchangeOrderNotification.NotifyType|null} [notifyType] ExchangeOrderNotification notifyType
         * @property {boolean|null} [isSnapshot] ExchangeOrderNotification isSnapshot
         * @property {boolean|null} [isRithmicInternalMsg] ExchangeOrderNotification isRithmicInternalMsg
         * @property {string|null} [reportType] ExchangeOrderNotification reportType
         * @property {string|null} [status] ExchangeOrderNotification status
         * @property {string|null} [basketId] ExchangeOrderNotification basketId
         * @property {string|null} [originalBasketId] ExchangeOrderNotification originalBasketId
         * @property {string|null} [linkedBasketIds] ExchangeOrderNotification linkedBasketIds
         * @property {string|null} [fcmId] ExchangeOrderNotification fcmId
         * @property {string|null} [ibId] ExchangeOrderNotification ibId
         * @property {string|null} [userId] ExchangeOrderNotification userId
         * @property {string|null} [accountId] ExchangeOrderNotification accountId
         * @property {string|null} [symbol] ExchangeOrderNotification symbol
         * @property {string|null} [exchange] ExchangeOrderNotification exchange
         * @property {string|null} [tradeExchange] ExchangeOrderNotification tradeExchange
         * @property {string|null} [tradeRoute] ExchangeOrderNotification tradeRoute
         * @property {string|null} [exchangeOrderId] ExchangeOrderNotification exchangeOrderId
         * @property {string|null} [tpExchangeOrderId] ExchangeOrderNotification tpExchangeOrderId
         * @property {string|null} [instrumentType] ExchangeOrderNotification instrumentType
         * @property {number|null} [quantity] ExchangeOrderNotification quantity
         * @property {number|null} [price] ExchangeOrderNotification price
         * @property {number|null} [triggerPrice] ExchangeOrderNotification triggerPrice
         * @property {rti.ExchangeOrderNotification.TransactionType|null} [transactionType] ExchangeOrderNotification transactionType
         * @property {rti.ExchangeOrderNotification.Duration|null} [duration] ExchangeOrderNotification duration
         * @property {rti.ExchangeOrderNotification.PriceType|null} [priceType] ExchangeOrderNotification priceType
         * @property {rti.ExchangeOrderNotification.PriceType|null} [origPriceType] ExchangeOrderNotification origPriceType
         * @property {rti.ExchangeOrderNotification.OrderPlacement|null} [manualOrAuto] ExchangeOrderNotification manualOrAuto
         * @property {rti.ExchangeOrderNotification.BracketType|null} [bracketType] ExchangeOrderNotification bracketType
         * @property {number|null} [confirmedSize] ExchangeOrderNotification confirmedSize
         * @property {string|null} [confirmedTime] ExchangeOrderNotification confirmedTime
         * @property {string|null} [confirmedDate] ExchangeOrderNotification confirmedDate
         * @property {string|null} [confirmedId] ExchangeOrderNotification confirmedId
         * @property {number|null} [modifiedSize] ExchangeOrderNotification modifiedSize
         * @property {string|null} [modifiedTime] ExchangeOrderNotification modifiedTime
         * @property {string|null} [modifiedDate] ExchangeOrderNotification modifiedDate
         * @property {string|null} [modifyId] ExchangeOrderNotification modifyId
         * @property {number|null} [cancelledSize] ExchangeOrderNotification cancelledSize
         * @property {string|null} [cancelledTime] ExchangeOrderNotification cancelledTime
         * @property {string|null} [cancelledDate] ExchangeOrderNotification cancelledDate
         * @property {string|null} [cancelledId] ExchangeOrderNotification cancelledId
         * @property {number|null} [fillPrice] ExchangeOrderNotification fillPrice
         * @property {number|null} [fillSize] ExchangeOrderNotification fillSize
         * @property {string|null} [fillTime] ExchangeOrderNotification fillTime
         * @property {string|null} [fillDate] ExchangeOrderNotification fillDate
         * @property {string|null} [fillId] ExchangeOrderNotification fillId
         * @property {number|null} [avgFillPrice] ExchangeOrderNotification avgFillPrice
         * @property {number|null} [totalFillSize] ExchangeOrderNotification totalFillSize
         * @property {number|null} [totalUnfilledSize] ExchangeOrderNotification totalUnfilledSize
         * @property {string|null} [triggerId] ExchangeOrderNotification triggerId
         * @property {number|null} [trailByTicks] ExchangeOrderNotification trailByTicks
         * @property {number|null} [trailByPriceId] ExchangeOrderNotification trailByPriceId
         * @property {string|null} [sequenceNumber] ExchangeOrderNotification sequenceNumber
         * @property {string|null} [origSequenceNumber] ExchangeOrderNotification origSequenceNumber
         * @property {string|null} [corSequenceNumber] ExchangeOrderNotification corSequenceNumber
         * @property {string|null} [currency] ExchangeOrderNotification currency
         * @property {string|null} [countryCode] ExchangeOrderNotification countryCode
         * @property {string|null} [text] ExchangeOrderNotification text
         * @property {string|null} [reportText] ExchangeOrderNotification reportText
         * @property {string|null} [remarks] ExchangeOrderNotification remarks
         * @property {string|null} [windowName] ExchangeOrderNotification windowName
         * @property {string|null} [originatorWindowName] ExchangeOrderNotification originatorWindowName
         * @property {number|null} [cancelAtSsboe] ExchangeOrderNotification cancelAtSsboe
         * @property {number|null} [cancelAtUsecs] ExchangeOrderNotification cancelAtUsecs
         * @property {number|null} [cancelAfterSecs] ExchangeOrderNotification cancelAfterSecs
         * @property {number|null} [ssboe] ExchangeOrderNotification ssboe
         * @property {number|null} [usecs] ExchangeOrderNotification usecs
         * @property {number|null} [sourceSsboe] ExchangeOrderNotification sourceSsboe
         * @property {number|null} [sourceUsecs] ExchangeOrderNotification sourceUsecs
         * @property {number|null} [sourceNsecs] ExchangeOrderNotification sourceNsecs
         * @property {number|null} [exchReceiptSsboe] ExchangeOrderNotification exchReceiptSsboe
         * @property {number|null} [exchReceiptNsecs] ExchangeOrderNotification exchReceiptNsecs
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding
         */

        /**
         * Properties of an ExchangeOrderNotification.
         * @memberof rti
         * @interface IExchangeOrderNotification
         * @augments rti.ExchangeOrderNotification.$Properties
         * @deprecated Use rti.ExchangeOrderNotification.$Properties instead.
         */

        /**
         * Shape of an ExchangeOrderNotification.
         * @typedef {rti.ExchangeOrderNotification.$Properties} rti.ExchangeOrderNotification.$Shape
         */

        /**
         * Constructs a new ExchangeOrderNotification.
         * @memberof rti
         * @classdesc Represents an ExchangeOrderNotification.
         * @constructor
         * @param {rti.ExchangeOrderNotification.$Properties=} [properties] Properties to set
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding
         */
        function ExchangeOrderNotification(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null && keys[i] !== "__proto__")
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ExchangeOrderNotification templateId.
         * @member {number} templateId
         * @memberof rti.ExchangeOrderNotification
         * @instance
         */
        ExchangeOrderNotification.prototype.templateId = 0;

        /**
         * ExchangeOrderNotification userTag.
         * @member {string} userTag
         * @memberof rti.ExchangeOrderNotification
         * @instance
         */
        ExchangeOrderNotification.prototype.userTag = "";

        /**
         * ExchangeOrderNotification notifyType.
         * @member {rti.ExchangeOrderNotification.NotifyType} notifyType
         * @memberof rti.ExchangeOrderNotification
         * @instance
         */
        ExchangeOrderNotification.prototype.notifyType = 0;

        /**
         * ExchangeOrderNotification isSnapshot.
         * @member {boolean} isSnapshot
         * @memberof rti.ExchangeOrderNotification
         * @instance
         */
        ExchangeOrderNotification.prototype.isSnapshot = false;

        /**
         * ExchangeOrderNotification isRithmicInternalMsg.
         * @member {boolean} isRithmicInternalMsg
         * @memberof rti.ExchangeOrderNotification
         * @instance
         */
        ExchangeOrderNotification.prototype.isRithmicInternalMsg = false;

        /**
         * ExchangeOrderNotification reportType.
         * @member {string} reportType
         * @memberof rti.ExchangeOrderNotification
         * @instance
         */
        ExchangeOrderNotification.prototype.reportType = "";

        /**
         * ExchangeOrderNotification status.
         * @member {string} status
         * @memberof rti.ExchangeOrderNotification
         * @instance
         */
        ExchangeOrderNotification.prototype.status = "";

        /**
         * ExchangeOrderNotification basketId.
         * @member {string} basketId
         * @memberof rti.ExchangeOrderNotification
         * @instance
         */
        ExchangeOrderNotification.prototype.basketId = "";

        /**
         * ExchangeOrderNotification originalBasketId.
         * @member {string} originalBasketId
         * @memberof rti.ExchangeOrderNotification
         * @instance
         */
        ExchangeOrderNotification.prototype.originalBasketId = "";

        /**
         * ExchangeOrderNotification linkedBasketIds.
         * @member {string} linkedBasketIds
         * @memberof rti.ExchangeOrderNotification
         * @instance
         */
        ExchangeOrderNotification.prototype.linkedBasketIds = "";

        /**
         * ExchangeOrderNotification fcmId.
         * @member {string} fcmId
         * @memberof rti.ExchangeOrderNotification
         * @instance
         */
        ExchangeOrderNotification.prototype.fcmId = "";

        /**
         * ExchangeOrderNotification ibId.
         * @member {string} ibId
         * @memberof rti.ExchangeOrderNotification
         * @instance
         */
        ExchangeOrderNotification.prototype.ibId = "";

        /**
         * ExchangeOrderNotification userId.
         * @member {string} userId
         * @memberof rti.ExchangeOrderNotification
         * @instance
         */
        ExchangeOrderNotification.prototype.userId = "";

        /**
         * ExchangeOrderNotification accountId.
         * @member {string} accountId
         * @memberof rti.ExchangeOrderNotification
         * @instance
         */
        ExchangeOrderNotification.prototype.accountId = "";

        /**
         * ExchangeOrderNotification symbol.
         * @member {string} symbol
         * @memberof rti.ExchangeOrderNotification
         * @instance
         */
        ExchangeOrderNotification.prototype.symbol = "";

        /**
         * ExchangeOrderNotification exchange.
         * @member {string} exchange
         * @memberof rti.ExchangeOrderNotification
         * @instance
         */
        ExchangeOrderNotification.prototype.exchange = "";

        /**
         * ExchangeOrderNotification tradeExchange.
         * @member {string} tradeExchange
         * @memberof rti.ExchangeOrderNotification
         * @instance
         */
        ExchangeOrderNotification.prototype.tradeExchange = "";

        /**
         * ExchangeOrderNotification tradeRoute.
         * @member {string} tradeRoute
         * @memberof rti.ExchangeOrderNotification
         * @instance
         */
        ExchangeOrderNotification.prototype.tradeRoute = "";

        /**
         * ExchangeOrderNotification exchangeOrderId.
         * @member {string} exchangeOrderId
         * @memberof rti.ExchangeOrderNotification
         * @instance
         */
        ExchangeOrderNotification.prototype.exchangeOrderId = "";

        /**
         * ExchangeOrderNotification tpExchangeOrderId.
         * @member {string} tpExchangeOrderId
         * @memberof rti.ExchangeOrderNotification
         * @instance
         */
        ExchangeOrderNotification.prototype.tpExchangeOrderId = "";

        /**
         * ExchangeOrderNotification instrumentType.
         * @member {string} instrumentType
         * @memberof rti.ExchangeOrderNotification
         * @instance
         */
        ExchangeOrderNotification.prototype.instrumentType = "";

        /**
         * ExchangeOrderNotification quantity.
         * @member {number} quantity
         * @memberof rti.ExchangeOrderNotification
         * @instance
         */
        ExchangeOrderNotification.prototype.quantity = 0;

        /**
         * ExchangeOrderNotification price.
         * @member {number} price
         * @memberof rti.ExchangeOrderNotification
         * @instance
         */
        ExchangeOrderNotification.prototype.price = 0;

        /**
         * ExchangeOrderNotification triggerPrice.
         * @member {number} triggerPrice
         * @memberof rti.ExchangeOrderNotification
         * @instance
         */
        ExchangeOrderNotification.prototype.triggerPrice = 0;

        /**
         * ExchangeOrderNotification transactionType.
         * @member {rti.ExchangeOrderNotification.TransactionType} transactionType
         * @memberof rti.ExchangeOrderNotification
         * @instance
         */
        ExchangeOrderNotification.prototype.transactionType = 0;

        /**
         * ExchangeOrderNotification duration.
         * @member {rti.ExchangeOrderNotification.Duration} duration
         * @memberof rti.ExchangeOrderNotification
         * @instance
         */
        ExchangeOrderNotification.prototype.duration = 0;

        /**
         * ExchangeOrderNotification priceType.
         * @member {rti.ExchangeOrderNotification.PriceType} priceType
         * @memberof rti.ExchangeOrderNotification
         * @instance
         */
        ExchangeOrderNotification.prototype.priceType = 0;

        /**
         * ExchangeOrderNotification origPriceType.
         * @member {rti.ExchangeOrderNotification.PriceType} origPriceType
         * @memberof rti.ExchangeOrderNotification
         * @instance
         */
        ExchangeOrderNotification.prototype.origPriceType = 0;

        /**
         * ExchangeOrderNotification manualOrAuto.
         * @member {rti.ExchangeOrderNotification.OrderPlacement} manualOrAuto
         * @memberof rti.ExchangeOrderNotification
         * @instance
         */
        ExchangeOrderNotification.prototype.manualOrAuto = 0;

        /**
         * ExchangeOrderNotification bracketType.
         * @member {rti.ExchangeOrderNotification.BracketType} bracketType
         * @memberof rti.ExchangeOrderNotification
         * @instance
         */
        ExchangeOrderNotification.prototype.bracketType = 0;

        /**
         * ExchangeOrderNotification confirmedSize.
         * @member {number} confirmedSize
         * @memberof rti.ExchangeOrderNotification
         * @instance
         */
        ExchangeOrderNotification.prototype.confirmedSize = 0;

        /**
         * ExchangeOrderNotification confirmedTime.
         * @member {string} confirmedTime
         * @memberof rti.ExchangeOrderNotification
         * @instance
         */
        ExchangeOrderNotification.prototype.confirmedTime = "";

        /**
         * ExchangeOrderNotification confirmedDate.
         * @member {string} confirmedDate
         * @memberof rti.ExchangeOrderNotification
         * @instance
         */
        ExchangeOrderNotification.prototype.confirmedDate = "";

        /**
         * ExchangeOrderNotification confirmedId.
         * @member {string} confirmedId
         * @memberof rti.ExchangeOrderNotification
         * @instance
         */
        ExchangeOrderNotification.prototype.confirmedId = "";

        /**
         * ExchangeOrderNotification modifiedSize.
         * @member {number} modifiedSize
         * @memberof rti.ExchangeOrderNotification
         * @instance
         */
        ExchangeOrderNotification.prototype.modifiedSize = 0;

        /**
         * ExchangeOrderNotification modifiedTime.
         * @member {string} modifiedTime
         * @memberof rti.ExchangeOrderNotification
         * @instance
         */
        ExchangeOrderNotification.prototype.modifiedTime = "";

        /**
         * ExchangeOrderNotification modifiedDate.
         * @member {string} modifiedDate
         * @memberof rti.ExchangeOrderNotification
         * @instance
         */
        ExchangeOrderNotification.prototype.modifiedDate = "";

        /**
         * ExchangeOrderNotification modifyId.
         * @member {string} modifyId
         * @memberof rti.ExchangeOrderNotification
         * @instance
         */
        ExchangeOrderNotification.prototype.modifyId = "";

        /**
         * ExchangeOrderNotification cancelledSize.
         * @member {number} cancelledSize
         * @memberof rti.ExchangeOrderNotification
         * @instance
         */
        ExchangeOrderNotification.prototype.cancelledSize = 0;

        /**
         * ExchangeOrderNotification cancelledTime.
         * @member {string} cancelledTime
         * @memberof rti.ExchangeOrderNotification
         * @instance
         */
        ExchangeOrderNotification.prototype.cancelledTime = "";

        /**
         * ExchangeOrderNotification cancelledDate.
         * @member {string} cancelledDate
         * @memberof rti.ExchangeOrderNotification
         * @instance
         */
        ExchangeOrderNotification.prototype.cancelledDate = "";

        /**
         * ExchangeOrderNotification cancelledId.
         * @member {string} cancelledId
         * @memberof rti.ExchangeOrderNotification
         * @instance
         */
        ExchangeOrderNotification.prototype.cancelledId = "";

        /**
         * ExchangeOrderNotification fillPrice.
         * @member {number} fillPrice
         * @memberof rti.ExchangeOrderNotification
         * @instance
         */
        ExchangeOrderNotification.prototype.fillPrice = 0;

        /**
         * ExchangeOrderNotification fillSize.
         * @member {number} fillSize
         * @memberof rti.ExchangeOrderNotification
         * @instance
         */
        ExchangeOrderNotification.prototype.fillSize = 0;

        /**
         * ExchangeOrderNotification fillTime.
         * @member {string} fillTime
         * @memberof rti.ExchangeOrderNotification
         * @instance
         */
        ExchangeOrderNotification.prototype.fillTime = "";

        /**
         * ExchangeOrderNotification fillDate.
         * @member {string} fillDate
         * @memberof rti.ExchangeOrderNotification
         * @instance
         */
        ExchangeOrderNotification.prototype.fillDate = "";

        /**
         * ExchangeOrderNotification fillId.
         * @member {string} fillId
         * @memberof rti.ExchangeOrderNotification
         * @instance
         */
        ExchangeOrderNotification.prototype.fillId = "";

        /**
         * ExchangeOrderNotification avgFillPrice.
         * @member {number} avgFillPrice
         * @memberof rti.ExchangeOrderNotification
         * @instance
         */
        ExchangeOrderNotification.prototype.avgFillPrice = 0;

        /**
         * ExchangeOrderNotification totalFillSize.
         * @member {number} totalFillSize
         * @memberof rti.ExchangeOrderNotification
         * @instance
         */
        ExchangeOrderNotification.prototype.totalFillSize = 0;

        /**
         * ExchangeOrderNotification totalUnfilledSize.
         * @member {number} totalUnfilledSize
         * @memberof rti.ExchangeOrderNotification
         * @instance
         */
        ExchangeOrderNotification.prototype.totalUnfilledSize = 0;

        /**
         * ExchangeOrderNotification triggerId.
         * @member {string} triggerId
         * @memberof rti.ExchangeOrderNotification
         * @instance
         */
        ExchangeOrderNotification.prototype.triggerId = "";

        /**
         * ExchangeOrderNotification trailByTicks.
         * @member {number} trailByTicks
         * @memberof rti.ExchangeOrderNotification
         * @instance
         */
        ExchangeOrderNotification.prototype.trailByTicks = 0;

        /**
         * ExchangeOrderNotification trailByPriceId.
         * @member {number} trailByPriceId
         * @memberof rti.ExchangeOrderNotification
         * @instance
         */
        ExchangeOrderNotification.prototype.trailByPriceId = 0;

        /**
         * ExchangeOrderNotification sequenceNumber.
         * @member {string} sequenceNumber
         * @memberof rti.ExchangeOrderNotification
         * @instance
         */
        ExchangeOrderNotification.prototype.sequenceNumber = "";

        /**
         * ExchangeOrderNotification origSequenceNumber.
         * @member {string} origSequenceNumber
         * @memberof rti.ExchangeOrderNotification
         * @instance
         */
        ExchangeOrderNotification.prototype.origSequenceNumber = "";

        /**
         * ExchangeOrderNotification corSequenceNumber.
         * @member {string} corSequenceNumber
         * @memberof rti.ExchangeOrderNotification
         * @instance
         */
        ExchangeOrderNotification.prototype.corSequenceNumber = "";

        /**
         * ExchangeOrderNotification currency.
         * @member {string} currency
         * @memberof rti.ExchangeOrderNotification
         * @instance
         */
        ExchangeOrderNotification.prototype.currency = "";

        /**
         * ExchangeOrderNotification countryCode.
         * @member {string} countryCode
         * @memberof rti.ExchangeOrderNotification
         * @instance
         */
        ExchangeOrderNotification.prototype.countryCode = "";

        /**
         * ExchangeOrderNotification text.
         * @member {string} text
         * @memberof rti.ExchangeOrderNotification
         * @instance
         */
        ExchangeOrderNotification.prototype.text = "";

        /**
         * ExchangeOrderNotification reportText.
         * @member {string} reportText
         * @memberof rti.ExchangeOrderNotification
         * @instance
         */
        ExchangeOrderNotification.prototype.reportText = "";

        /**
         * ExchangeOrderNotification remarks.
         * @member {string} remarks
         * @memberof rti.ExchangeOrderNotification
         * @instance
         */
        ExchangeOrderNotification.prototype.remarks = "";

        /**
         * ExchangeOrderNotification windowName.
         * @member {string} windowName
         * @memberof rti.ExchangeOrderNotification
         * @instance
         */
        ExchangeOrderNotification.prototype.windowName = "";

        /**
         * ExchangeOrderNotification originatorWindowName.
         * @member {string} originatorWindowName
         * @memberof rti.ExchangeOrderNotification
         * @instance
         */
        ExchangeOrderNotification.prototype.originatorWindowName = "";

        /**
         * ExchangeOrderNotification cancelAtSsboe.
         * @member {number} cancelAtSsboe
         * @memberof rti.ExchangeOrderNotification
         * @instance
         */
        ExchangeOrderNotification.prototype.cancelAtSsboe = 0;

        /**
         * ExchangeOrderNotification cancelAtUsecs.
         * @member {number} cancelAtUsecs
         * @memberof rti.ExchangeOrderNotification
         * @instance
         */
        ExchangeOrderNotification.prototype.cancelAtUsecs = 0;

        /**
         * ExchangeOrderNotification cancelAfterSecs.
         * @member {number} cancelAfterSecs
         * @memberof rti.ExchangeOrderNotification
         * @instance
         */
        ExchangeOrderNotification.prototype.cancelAfterSecs = 0;

        /**
         * ExchangeOrderNotification ssboe.
         * @member {number} ssboe
         * @memberof rti.ExchangeOrderNotification
         * @instance
         */
        ExchangeOrderNotification.prototype.ssboe = 0;

        /**
         * ExchangeOrderNotification usecs.
         * @member {number} usecs
         * @memberof rti.ExchangeOrderNotification
         * @instance
         */
        ExchangeOrderNotification.prototype.usecs = 0;

        /**
         * ExchangeOrderNotification sourceSsboe.
         * @member {number} sourceSsboe
         * @memberof rti.ExchangeOrderNotification
         * @instance
         */
        ExchangeOrderNotification.prototype.sourceSsboe = 0;

        /**
         * ExchangeOrderNotification sourceUsecs.
         * @member {number} sourceUsecs
         * @memberof rti.ExchangeOrderNotification
         * @instance
         */
        ExchangeOrderNotification.prototype.sourceUsecs = 0;

        /**
         * ExchangeOrderNotification sourceNsecs.
         * @member {number} sourceNsecs
         * @memberof rti.ExchangeOrderNotification
         * @instance
         */
        ExchangeOrderNotification.prototype.sourceNsecs = 0;

        /**
         * ExchangeOrderNotification exchReceiptSsboe.
         * @member {number} exchReceiptSsboe
         * @memberof rti.ExchangeOrderNotification
         * @instance
         */
        ExchangeOrderNotification.prototype.exchReceiptSsboe = 0;

        /**
         * ExchangeOrderNotification exchReceiptNsecs.
         * @member {number} exchReceiptNsecs
         * @memberof rti.ExchangeOrderNotification
         * @instance
         */
        ExchangeOrderNotification.prototype.exchReceiptNsecs = 0;

        /**
         * Creates a new ExchangeOrderNotification instance using the specified properties.
         * @function create
         * @memberof rti.ExchangeOrderNotification
         * @static
         * @param {rti.ExchangeOrderNotification.$Properties=} [properties] Properties to set
         * @returns {rti.ExchangeOrderNotification} ExchangeOrderNotification instance
         * @type {{
         *   (properties: rti.ExchangeOrderNotification.$Shape): rti.ExchangeOrderNotification & rti.ExchangeOrderNotification.$Shape;
         *   (properties?: rti.ExchangeOrderNotification.$Properties): rti.ExchangeOrderNotification;
         * }}
         */
        ExchangeOrderNotification.create = function create(properties) {
            return new ExchangeOrderNotification(properties);
        };

        /**
         * Encodes the specified ExchangeOrderNotification message. Does not implicitly {@link rti.ExchangeOrderNotification.verify|verify} messages.
         * @function encode
         * @memberof rti.ExchangeOrderNotification
         * @static
         * @param {rti.ExchangeOrderNotification.$Properties} message ExchangeOrderNotification message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ExchangeOrderNotification.encode = function encode(message, writer, _depth) {
            if (!writer)
                writer = $Writer.create();
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw Error("max depth exceeded");
            if (message.symbol != null && Object.hasOwnProperty.call(message, "symbol"))
                writer.uint32(/* id 110100, wireType 2 =*/880802).string(message.symbol);
            if (message.exchange != null && Object.hasOwnProperty.call(message, "exchange"))
                writer.uint32(/* id 110101, wireType 2 =*/880810).string(message.exchange);
            if (message.instrumentType != null && Object.hasOwnProperty.call(message, "instrumentType"))
                writer.uint32(/* id 110116, wireType 2 =*/880930).string(message.instrumentType);
            if (message.isSnapshot != null && Object.hasOwnProperty.call(message, "isSnapshot"))
                writer.uint32(/* id 110121, wireType 0 =*/880968).bool(message.isSnapshot);
            if (message.basketId != null && Object.hasOwnProperty.call(message, "basketId"))
                writer.uint32(/* id 110300, wireType 2 =*/882402).string(message.basketId);
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 110303, wireType 2 =*/882426).string(message.status);
            if (message.price != null && Object.hasOwnProperty.call(message, "price"))
                writer.uint32(/* id 110306, wireType 1 =*/882449).double(message.price);
            if (message.fillPrice != null && Object.hasOwnProperty.call(message, "fillPrice"))
                writer.uint32(/* id 110307, wireType 1 =*/882457).double(message.fillPrice);
            if (message.fillSize != null && Object.hasOwnProperty.call(message, "fillSize"))
                writer.uint32(/* id 110308, wireType 0 =*/882464).int32(message.fillSize);
            if (message.fillTime != null && Object.hasOwnProperty.call(message, "fillTime"))
                writer.uint32(/* id 110309, wireType 2 =*/882474).string(message.fillTime);
            if (message.fillDate != null && Object.hasOwnProperty.call(message, "fillDate"))
                writer.uint32(/* id 110310, wireType 2 =*/882482).string(message.fillDate);
            if (message.fillId != null && Object.hasOwnProperty.call(message, "fillId"))
                writer.uint32(/* id 110311, wireType 2 =*/882490).string(message.fillId);
            if (message.cancelledSize != null && Object.hasOwnProperty.call(message, "cancelledSize"))
                writer.uint32(/* id 110318, wireType 0 =*/882544).int32(message.cancelledSize);
            if (message.cancelledTime != null && Object.hasOwnProperty.call(message, "cancelledTime"))
                writer.uint32(/* id 110319, wireType 2 =*/882554).string(message.cancelledTime);
            if (message.cancelledDate != null && Object.hasOwnProperty.call(message, "cancelledDate"))
                writer.uint32(/* id 110320, wireType 2 =*/882562).string(message.cancelledDate);
            if (message.cancelledId != null && Object.hasOwnProperty.call(message, "cancelledId"))
                writer.uint32(/* id 110321, wireType 2 =*/882570).string(message.cancelledId);
            if (message.avgFillPrice != null && Object.hasOwnProperty.call(message, "avgFillPrice"))
                writer.uint32(/* id 110322, wireType 1 =*/882577).double(message.avgFillPrice);
            if (message.confirmedTime != null && Object.hasOwnProperty.call(message, "confirmedTime"))
                writer.uint32(/* id 110326, wireType 2 =*/882610).string(message.confirmedTime);
            if (message.confirmedDate != null && Object.hasOwnProperty.call(message, "confirmedDate"))
                writer.uint32(/* id 110327, wireType 2 =*/882618).string(message.confirmedDate);
            if (message.confirmedSize != null && Object.hasOwnProperty.call(message, "confirmedSize"))
                writer.uint32(/* id 110329, wireType 0 =*/882632).int32(message.confirmedSize);
            if (message.confirmedId != null && Object.hasOwnProperty.call(message, "confirmedId"))
                writer.uint32(/* id 110330, wireType 2 =*/882642).string(message.confirmedId);
            if (message.linkedBasketIds != null && Object.hasOwnProperty.call(message, "linkedBasketIds"))
                writer.uint32(/* id 110358, wireType 2 =*/882866).string(message.linkedBasketIds);
            if (message.sequenceNumber != null && Object.hasOwnProperty.call(message, "sequenceNumber"))
                writer.uint32(/* id 112002, wireType 2 =*/896018).string(message.sequenceNumber);
            if (message.transactionType != null && Object.hasOwnProperty.call(message, "transactionType"))
                writer.uint32(/* id 112003, wireType 0 =*/896024).int32(message.transactionType);
            if (message.quantity != null && Object.hasOwnProperty.call(message, "quantity"))
                writer.uint32(/* id 112004, wireType 0 =*/896032).int32(message.quantity);
            if (message.duration != null && Object.hasOwnProperty.call(message, "duration"))
                writer.uint32(/* id 112005, wireType 0 =*/896040).int32(message.duration);
            if (message.priceType != null && Object.hasOwnProperty.call(message, "priceType"))
                writer.uint32(/* id 112008, wireType 0 =*/896064).int32(message.priceType);
            if (message.tradeRoute != null && Object.hasOwnProperty.call(message, "tradeRoute"))
                writer.uint32(/* id 112016, wireType 2 =*/896130).string(message.tradeRoute);
            if (message.tradeExchange != null && Object.hasOwnProperty.call(message, "tradeExchange"))
                writer.uint32(/* id 112021, wireType 2 =*/896170).string(message.tradeExchange);
            if (message.reportType != null && Object.hasOwnProperty.call(message, "reportType"))
                writer.uint32(/* id 120001, wireType 2 =*/960010).string(message.reportType);
            if (message.text != null && Object.hasOwnProperty.call(message, "text"))
                writer.uint32(/* id 120008, wireType 2 =*/960066).string(message.text);
            if (message.reportText != null && Object.hasOwnProperty.call(message, "reportText"))
                writer.uint32(/* id 120028, wireType 2 =*/960226).string(message.reportText);
            if (message.userId != null && Object.hasOwnProperty.call(message, "userId"))
                writer.uint32(/* id 131003, wireType 2 =*/1048026).string(message.userId);
            if (message.exchangeOrderId != null && Object.hasOwnProperty.call(message, "exchangeOrderId"))
                writer.uint32(/* id 149238, wireType 2 =*/1193906).string(message.exchangeOrderId);
            if (message.modifyId != null && Object.hasOwnProperty.call(message, "modifyId"))
                writer.uint32(/* id 149244, wireType 2 =*/1193954).string(message.modifyId);
            if (message.triggerPrice != null && Object.hasOwnProperty.call(message, "triggerPrice"))
                writer.uint32(/* id 149247, wireType 1 =*/1193977).double(message.triggerPrice);
            if (message.origSequenceNumber != null && Object.hasOwnProperty.call(message, "origSequenceNumber"))
                writer.uint32(/* id 149263, wireType 2 =*/1194106).string(message.origSequenceNumber);
            if (message.corSequenceNumber != null && Object.hasOwnProperty.call(message, "corSequenceNumber"))
                writer.uint32(/* id 149264, wireType 2 =*/1194114).string(message.corSequenceNumber);
            if (message.triggerId != null && Object.hasOwnProperty.call(message, "triggerId"))
                writer.uint32(/* id 149266, wireType 2 =*/1194130).string(message.triggerId);
            if (message.modifiedSize != null && Object.hasOwnProperty.call(message, "modifiedSize"))
                writer.uint32(/* id 149267, wireType 0 =*/1194136).int32(message.modifiedSize);
            if (message.modifiedTime != null && Object.hasOwnProperty.call(message, "modifiedTime"))
                writer.uint32(/* id 149268, wireType 2 =*/1194146).string(message.modifiedTime);
            if (message.modifiedDate != null && Object.hasOwnProperty.call(message, "modifiedDate"))
                writer.uint32(/* id 149269, wireType 2 =*/1194154).string(message.modifiedDate);
            if (message.isRithmicInternalMsg != null && Object.hasOwnProperty.call(message, "isRithmicInternalMsg"))
                writer.uint32(/* id 149373, wireType 0 =*/1194984).bool(message.isRithmicInternalMsg);
            if (message.ssboe != null && Object.hasOwnProperty.call(message, "ssboe"))
                writer.uint32(/* id 150100, wireType 0 =*/1200800).int32(message.ssboe);
            if (message.usecs != null && Object.hasOwnProperty.call(message, "usecs"))
                writer.uint32(/* id 150101, wireType 0 =*/1200808).int32(message.usecs);
            if (message.sourceSsboe != null && Object.hasOwnProperty.call(message, "sourceSsboe"))
                writer.uint32(/* id 150400, wireType 0 =*/1203200).int32(message.sourceSsboe);
            if (message.sourceUsecs != null && Object.hasOwnProperty.call(message, "sourceUsecs"))
                writer.uint32(/* id 150401, wireType 0 =*/1203208).int32(message.sourceUsecs);
            if (message.sourceNsecs != null && Object.hasOwnProperty.call(message, "sourceNsecs"))
                writer.uint32(/* id 150404, wireType 0 =*/1203232).int32(message.sourceNsecs);
            if (message.exchReceiptSsboe != null && Object.hasOwnProperty.call(message, "exchReceiptSsboe"))
                writer.uint32(/* id 150405, wireType 0 =*/1203240).int32(message.exchReceiptSsboe);
            if (message.exchReceiptNsecs != null && Object.hasOwnProperty.call(message, "exchReceiptNsecs"))
                writer.uint32(/* id 150406, wireType 0 =*/1203248).int32(message.exchReceiptNsecs);
            if (message.notifyType != null && Object.hasOwnProperty.call(message, "notifyType"))
                writer.uint32(/* id 153625, wireType 0 =*/1229000).int32(message.notifyType);
            if (message.tpExchangeOrderId != null && Object.hasOwnProperty.call(message, "tpExchangeOrderId"))
                writer.uint32(/* id 153647, wireType 2 =*/1229178).string(message.tpExchangeOrderId);
            if (message.accountId != null && Object.hasOwnProperty.call(message, "accountId"))
                writer.uint32(/* id 154008, wireType 2 =*/1232066).string(message.accountId);
            if (message.fcmId != null && Object.hasOwnProperty.call(message, "fcmId"))
                writer.uint32(/* id 154013, wireType 2 =*/1232106).string(message.fcmId);
            if (message.ibId != null && Object.hasOwnProperty.call(message, "ibId"))
                writer.uint32(/* id 154014, wireType 2 =*/1232114).string(message.ibId);
            if (message.totalFillSize != null && Object.hasOwnProperty.call(message, "totalFillSize"))
                writer.uint32(/* id 154111, wireType 0 =*/1232888).int32(message.totalFillSize);
            if (message.totalUnfilledSize != null && Object.hasOwnProperty.call(message, "totalUnfilledSize"))
                writer.uint32(/* id 154112, wireType 0 =*/1232896).int32(message.totalUnfilledSize);
            if (message.userTag != null && Object.hasOwnProperty.call(message, "userTag"))
                writer.uint32(/* id 154119, wireType 2 =*/1232954).string(message.userTag);
            if (message.countryCode != null && Object.hasOwnProperty.call(message, "countryCode"))
                writer.uint32(/* id 154172, wireType 2 =*/1233378).string(message.countryCode);
            if (message.currency != null && Object.hasOwnProperty.call(message, "currency"))
                writer.uint32(/* id 154382, wireType 2 =*/1235058).string(message.currency);
            if (message.templateId != null && Object.hasOwnProperty.call(message, "templateId"))
                writer.uint32(/* id 154467, wireType 0 =*/1235736).int32(message.templateId);
            if (message.cancelAfterSecs != null && Object.hasOwnProperty.call(message, "cancelAfterSecs"))
                writer.uint32(/* id 154488, wireType 0 =*/1235904).int32(message.cancelAfterSecs);
            if (message.originalBasketId != null && Object.hasOwnProperty.call(message, "originalBasketId"))
                writer.uint32(/* id 154497, wireType 2 =*/1235978).string(message.originalBasketId);
            if (message.windowName != null && Object.hasOwnProperty.call(message, "windowName"))
                writer.uint32(/* id 154629, wireType 2 =*/1237034).string(message.windowName);
            if (message.originatorWindowName != null && Object.hasOwnProperty.call(message, "originatorWindowName"))
                writer.uint32(/* id 154671, wireType 2 =*/1237370).string(message.originatorWindowName);
            if (message.manualOrAuto != null && Object.hasOwnProperty.call(message, "manualOrAuto"))
                writer.uint32(/* id 154710, wireType 0 =*/1237680).int32(message.manualOrAuto);
            if (message.origPriceType != null && Object.hasOwnProperty.call(message, "origPriceType"))
                writer.uint32(/* id 154770, wireType 0 =*/1238160).int32(message.origPriceType);
            if (message.remarks != null && Object.hasOwnProperty.call(message, "remarks"))
                writer.uint32(/* id 154806, wireType 2 =*/1238450).string(message.remarks);
            if (message.trailByTicks != null && Object.hasOwnProperty.call(message, "trailByTicks"))
                writer.uint32(/* id 157064, wireType 0 =*/1256512).int32(message.trailByTicks);
            if (message.trailByPriceId != null && Object.hasOwnProperty.call(message, "trailByPriceId"))
                writer.uint32(/* id 157065, wireType 0 =*/1256520).int32(message.trailByPriceId);
            if (message.cancelAtSsboe != null && Object.hasOwnProperty.call(message, "cancelAtSsboe"))
                writer.uint32(/* id 157085, wireType 0 =*/1256680).int32(message.cancelAtSsboe);
            if (message.cancelAtUsecs != null && Object.hasOwnProperty.call(message, "cancelAtUsecs"))
                writer.uint32(/* id 157086, wireType 0 =*/1256688).int32(message.cancelAtUsecs);
            if (message.bracketType != null && Object.hasOwnProperty.call(message, "bracketType"))
                writer.uint32(/* id 157087, wireType 0 =*/1256696).int32(message.bracketType);
            if (message.$unknowns != null && Object.hasOwnProperty.call(message, "$unknowns"))
                for (let i = 0; i < message.$unknowns.length; ++i)
                    writer.raw(message.$unknowns[i]);
            return writer;
        };

        /**
         * Encodes the specified ExchangeOrderNotification message, length delimited. Does not implicitly {@link rti.ExchangeOrderNotification.verify|verify} messages.
         * @function encodeDelimited
         * @memberof rti.ExchangeOrderNotification
         * @static
         * @param {rti.ExchangeOrderNotification.$Properties} message ExchangeOrderNotification message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ExchangeOrderNotification.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer && writer.len ? writer.fork() : writer).ldelim();
        };

        /**
         * Decodes an ExchangeOrderNotification message from the specified reader or buffer.
         * @function decode
         * @memberof rti.ExchangeOrderNotification
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {rti.ExchangeOrderNotification & rti.ExchangeOrderNotification.$Shape} ExchangeOrderNotification
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ExchangeOrderNotification.decode = function decode(reader, length, _end, _depth, _target) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $Reader.recursionLimit)
                throw Error("max depth exceeded");
            let end = length === undefined ? reader.len : reader.pos + length, message = _target || new $root.rti.ExchangeOrderNotification(), value;
            while (reader.pos < end) {
                let start = reader.pos;
                let tag = reader.tag();
                if (tag === _end) {
                    _end = undefined;
                    break;
                }
                let wireType = tag & 7;
                switch (tag >>>= 3) {
                case 154467: {
                        if (wireType !== 0)
                            break;
                        if (value = reader.int32())
                            message.templateId = value;
                        else
                            delete message.templateId;
                        continue;
                    }
                case 154119: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.string()).length)
                            message.userTag = value;
                        else
                            delete message.userTag;
                        continue;
                    }
                case 153625: {
                        if (wireType !== 0)
                            break;
                        if (value = reader.int32())
                            message.notifyType = value;
                        else
                            delete message.notifyType;
                        continue;
                    }
                case 110121: {
                        if (wireType !== 0)
                            break;
                        if (value = reader.bool())
                            message.isSnapshot = value;
                        else
                            delete message.isSnapshot;
                        continue;
                    }
                case 149373: {
                        if (wireType !== 0)
                            break;
                        if (value = reader.bool())
                            message.isRithmicInternalMsg = value;
                        else
                            delete message.isRithmicInternalMsg;
                        continue;
                    }
                case 120001: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.string()).length)
                            message.reportType = value;
                        else
                            delete message.reportType;
                        continue;
                    }
                case 110303: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.string()).length)
                            message.status = value;
                        else
                            delete message.status;
                        continue;
                    }
                case 110300: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.string()).length)
                            message.basketId = value;
                        else
                            delete message.basketId;
                        continue;
                    }
                case 154497: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.string()).length)
                            message.originalBasketId = value;
                        else
                            delete message.originalBasketId;
                        continue;
                    }
                case 110358: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.string()).length)
                            message.linkedBasketIds = value;
                        else
                            delete message.linkedBasketIds;
                        continue;
                    }
                case 154013: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.string()).length)
                            message.fcmId = value;
                        else
                            delete message.fcmId;
                        continue;
                    }
                case 154014: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.string()).length)
                            message.ibId = value;
                        else
                            delete message.ibId;
                        continue;
                    }
                case 131003: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.string()).length)
                            message.userId = value;
                        else
                            delete message.userId;
                        continue;
                    }
                case 154008: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.string()).length)
                            message.accountId = value;
                        else
                            delete message.accountId;
                        continue;
                    }
                case 110100: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.string()).length)
                            message.symbol = value;
                        else
                            delete message.symbol;
                        continue;
                    }
                case 110101: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.string()).length)
                            message.exchange = value;
                        else
                            delete message.exchange;
                        continue;
                    }
                case 112021: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.string()).length)
                            message.tradeExchange = value;
                        else
                            delete message.tradeExchange;
                        continue;
                    }
                case 112016: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.string()).length)
                            message.tradeRoute = value;
                        else
                            delete message.tradeRoute;
                        continue;
                    }
                case 149238: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.string()).length)
                            message.exchangeOrderId = value;
                        else
                            delete message.exchangeOrderId;
                        continue;
                    }
                case 153647: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.string()).length)
                            message.tpExchangeOrderId = value;
                        else
                            delete message.tpExchangeOrderId;
                        continue;
                    }
                case 110116: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.string()).length)
                            message.instrumentType = value;
                        else
                            delete message.instrumentType;
                        continue;
                    }
                case 112004: {
                        if (wireType !== 0)
                            break;
                        if (value = reader.int32())
                            message.quantity = value;
                        else
                            delete message.quantity;
                        continue;
                    }
                case 110306: {
                        if (wireType !== 1)
                            break;
                        if ((value = reader.double()) !== 0)
                            message.price = value;
                        else
                            delete message.price;
                        continue;
                    }
                case 149247: {
                        if (wireType !== 1)
                            break;
                        if ((value = reader.double()) !== 0)
                            message.triggerPrice = value;
                        else
                            delete message.triggerPrice;
                        continue;
                    }
                case 112003: {
                        if (wireType !== 0)
                            break;
                        if (value = reader.int32())
                            message.transactionType = value;
                        else
                            delete message.transactionType;
                        continue;
                    }
                case 112005: {
                        if (wireType !== 0)
                            break;
                        if (value = reader.int32())
                            message.duration = value;
                        else
                            delete message.duration;
                        continue;
                    }
                case 112008: {
                        if (wireType !== 0)
                            break;
                        if (value = reader.int32())
                            message.priceType = value;
                        else
                            delete message.priceType;
                        continue;
                    }
                case 154770: {
                        if (wireType !== 0)
                            break;
                        if (value = reader.int32())
                            message.origPriceType = value;
                        else
                            delete message.origPriceType;
                        continue;
                    }
                case 154710: {
                        if (wireType !== 0)
                            break;
                        if (value = reader.int32())
                            message.manualOrAuto = value;
                        else
                            delete message.manualOrAuto;
                        continue;
                    }
                case 157087: {
                        if (wireType !== 0)
                            break;
                        if (value = reader.int32())
                            message.bracketType = value;
                        else
                            delete message.bracketType;
                        continue;
                    }
                case 110329: {
                        if (wireType !== 0)
                            break;
                        if (value = reader.int32())
                            message.confirmedSize = value;
                        else
                            delete message.confirmedSize;
                        continue;
                    }
                case 110326: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.string()).length)
                            message.confirmedTime = value;
                        else
                            delete message.confirmedTime;
                        continue;
                    }
                case 110327: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.string()).length)
                            message.confirmedDate = value;
                        else
                            delete message.confirmedDate;
                        continue;
                    }
                case 110330: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.string()).length)
                            message.confirmedId = value;
                        else
                            delete message.confirmedId;
                        continue;
                    }
                case 149267: {
                        if (wireType !== 0)
                            break;
                        if (value = reader.int32())
                            message.modifiedSize = value;
                        else
                            delete message.modifiedSize;
                        continue;
                    }
                case 149268: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.string()).length)
                            message.modifiedTime = value;
                        else
                            delete message.modifiedTime;
                        continue;
                    }
                case 149269: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.string()).length)
                            message.modifiedDate = value;
                        else
                            delete message.modifiedDate;
                        continue;
                    }
                case 149244: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.string()).length)
                            message.modifyId = value;
                        else
                            delete message.modifyId;
                        continue;
                    }
                case 110318: {
                        if (wireType !== 0)
                            break;
                        if (value = reader.int32())
                            message.cancelledSize = value;
                        else
                            delete message.cancelledSize;
                        continue;
                    }
                case 110319: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.string()).length)
                            message.cancelledTime = value;
                        else
                            delete message.cancelledTime;
                        continue;
                    }
                case 110320: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.string()).length)
                            message.cancelledDate = value;
                        else
                            delete message.cancelledDate;
                        continue;
                    }
                case 110321: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.string()).length)
                            message.cancelledId = value;
                        else
                            delete message.cancelledId;
                        continue;
                    }
                case 110307: {
                        if (wireType !== 1)
                            break;
                        if ((value = reader.double()) !== 0)
                            message.fillPrice = value;
                        else
                            delete message.fillPrice;
                        continue;
                    }
                case 110308: {
                        if (wireType !== 0)
                            break;
                        if (value = reader.int32())
                            message.fillSize = value;
                        else
                            delete message.fillSize;
                        continue;
                    }
                case 110309: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.string()).length)
                            message.fillTime = value;
                        else
                            delete message.fillTime;
                        continue;
                    }
                case 110310: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.string()).length)
                            message.fillDate = value;
                        else
                            delete message.fillDate;
                        continue;
                    }
                case 110311: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.string()).length)
                            message.fillId = value;
                        else
                            delete message.fillId;
                        continue;
                    }
                case 110322: {
                        if (wireType !== 1)
                            break;
                        if ((value = reader.double()) !== 0)
                            message.avgFillPrice = value;
                        else
                            delete message.avgFillPrice;
                        continue;
                    }
                case 154111: {
                        if (wireType !== 0)
                            break;
                        if (value = reader.int32())
                            message.totalFillSize = value;
                        else
                            delete message.totalFillSize;
                        continue;
                    }
                case 154112: {
                        if (wireType !== 0)
                            break;
                        if (value = reader.int32())
                            message.totalUnfilledSize = value;
                        else
                            delete message.totalUnfilledSize;
                        continue;
                    }
                case 149266: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.string()).length)
                            message.triggerId = value;
                        else
                            delete message.triggerId;
                        continue;
                    }
                case 157064: {
                        if (wireType !== 0)
                            break;
                        if (value = reader.int32())
                            message.trailByTicks = value;
                        else
                            delete message.trailByTicks;
                        continue;
                    }
                case 157065: {
                        if (wireType !== 0)
                            break;
                        if (value = reader.int32())
                            message.trailByPriceId = value;
                        else
                            delete message.trailByPriceId;
                        continue;
                    }
                case 112002: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.string()).length)
                            message.sequenceNumber = value;
                        else
                            delete message.sequenceNumber;
                        continue;
                    }
                case 149263: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.string()).length)
                            message.origSequenceNumber = value;
                        else
                            delete message.origSequenceNumber;
                        continue;
                    }
                case 149264: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.string()).length)
                            message.corSequenceNumber = value;
                        else
                            delete message.corSequenceNumber;
                        continue;
                    }
                case 154382: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.string()).length)
                            message.currency = value;
                        else
                            delete message.currency;
                        continue;
                    }
                case 154172: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.string()).length)
                            message.countryCode = value;
                        else
                            delete message.countryCode;
                        continue;
                    }
                case 120008: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.string()).length)
                            message.text = value;
                        else
                            delete message.text;
                        continue;
                    }
                case 120028: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.string()).length)
                            message.reportText = value;
                        else
                            delete message.reportText;
                        continue;
                    }
                case 154806: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.string()).length)
                            message.remarks = value;
                        else
                            delete message.remarks;
                        continue;
                    }
                case 154629: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.string()).length)
                            message.windowName = value;
                        else
                            delete message.windowName;
                        continue;
                    }
                case 154671: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.string()).length)
                            message.originatorWindowName = value;
                        else
                            delete message.originatorWindowName;
                        continue;
                    }
                case 157085: {
                        if (wireType !== 0)
                            break;
                        if (value = reader.int32())
                            message.cancelAtSsboe = value;
                        else
                            delete message.cancelAtSsboe;
                        continue;
                    }
                case 157086: {
                        if (wireType !== 0)
                            break;
                        if (value = reader.int32())
                            message.cancelAtUsecs = value;
                        else
                            delete message.cancelAtUsecs;
                        continue;
                    }
                case 154488: {
                        if (wireType !== 0)
                            break;
                        if (value = reader.int32())
                            message.cancelAfterSecs = value;
                        else
                            delete message.cancelAfterSecs;
                        continue;
                    }
                case 150100: {
                        if (wireType !== 0)
                            break;
                        if (value = reader.int32())
                            message.ssboe = value;
                        else
                            delete message.ssboe;
                        continue;
                    }
                case 150101: {
                        if (wireType !== 0)
                            break;
                        if (value = reader.int32())
                            message.usecs = value;
                        else
                            delete message.usecs;
                        continue;
                    }
                case 150400: {
                        if (wireType !== 0)
                            break;
                        if (value = reader.int32())
                            message.sourceSsboe = value;
                        else
                            delete message.sourceSsboe;
                        continue;
                    }
                case 150401: {
                        if (wireType !== 0)
                            break;
                        if (value = reader.int32())
                            message.sourceUsecs = value;
                        else
                            delete message.sourceUsecs;
                        continue;
                    }
                case 150404: {
                        if (wireType !== 0)
                            break;
                        if (value = reader.int32())
                            message.sourceNsecs = value;
                        else
                            delete message.sourceNsecs;
                        continue;
                    }
                case 150405: {
                        if (wireType !== 0)
                            break;
                        if (value = reader.int32())
                            message.exchReceiptSsboe = value;
                        else
                            delete message.exchReceiptSsboe;
                        continue;
                    }
                case 150406: {
                        if (wireType !== 0)
                            break;
                        if (value = reader.int32())
                            message.exchReceiptNsecs = value;
                        else
                            delete message.exchReceiptNsecs;
                        continue;
                    }
                }
                reader.skipType(wireType, _depth, tag);
                if (!reader.discardUnknown) {
                    $util.makeProp(message, "$unknowns", false);
                    (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
                }
            }
            if (_end !== undefined)
                throw Error("missing end group");
            return message;
        };

        /**
         * Decodes an ExchangeOrderNotification message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof rti.ExchangeOrderNotification
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {rti.ExchangeOrderNotification & rti.ExchangeOrderNotification.$Shape} ExchangeOrderNotification
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ExchangeOrderNotification.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an ExchangeOrderNotification message.
         * @function verify
         * @memberof rti.ExchangeOrderNotification
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ExchangeOrderNotification.verify = function verify(message, _depth) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                return "max depth exceeded";
            if (message.templateId != null && message.hasOwnProperty("templateId"))
                if (!$util.isInteger(message.templateId))
                    return "templateId: integer expected";
            if (message.userTag != null && message.hasOwnProperty("userTag"))
                if (!$util.isString(message.userTag))
                    return "userTag: string expected";
            if (message.notifyType != null && message.hasOwnProperty("notifyType"))
                switch (message.notifyType) {
                default:
                    return "notifyType: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                    break;
                }
            if (message.isSnapshot != null && message.hasOwnProperty("isSnapshot"))
                if (typeof message.isSnapshot !== "boolean")
                    return "isSnapshot: boolean expected";
            if (message.isRithmicInternalMsg != null && message.hasOwnProperty("isRithmicInternalMsg"))
                if (typeof message.isRithmicInternalMsg !== "boolean")
                    return "isRithmicInternalMsg: boolean expected";
            if (message.reportType != null && message.hasOwnProperty("reportType"))
                if (!$util.isString(message.reportType))
                    return "reportType: string expected";
            if (message.status != null && message.hasOwnProperty("status"))
                if (!$util.isString(message.status))
                    return "status: string expected";
            if (message.basketId != null && message.hasOwnProperty("basketId"))
                if (!$util.isString(message.basketId))
                    return "basketId: string expected";
            if (message.originalBasketId != null && message.hasOwnProperty("originalBasketId"))
                if (!$util.isString(message.originalBasketId))
                    return "originalBasketId: string expected";
            if (message.linkedBasketIds != null && message.hasOwnProperty("linkedBasketIds"))
                if (!$util.isString(message.linkedBasketIds))
                    return "linkedBasketIds: string expected";
            if (message.fcmId != null && message.hasOwnProperty("fcmId"))
                if (!$util.isString(message.fcmId))
                    return "fcmId: string expected";
            if (message.ibId != null && message.hasOwnProperty("ibId"))
                if (!$util.isString(message.ibId))
                    return "ibId: string expected";
            if (message.userId != null && message.hasOwnProperty("userId"))
                if (!$util.isString(message.userId))
                    return "userId: string expected";
            if (message.accountId != null && message.hasOwnProperty("accountId"))
                if (!$util.isString(message.accountId))
                    return "accountId: string expected";
            if (message.symbol != null && message.hasOwnProperty("symbol"))
                if (!$util.isString(message.symbol))
                    return "symbol: string expected";
            if (message.exchange != null && message.hasOwnProperty("exchange"))
                if (!$util.isString(message.exchange))
                    return "exchange: string expected";
            if (message.tradeExchange != null && message.hasOwnProperty("tradeExchange"))
                if (!$util.isString(message.tradeExchange))
                    return "tradeExchange: string expected";
            if (message.tradeRoute != null && message.hasOwnProperty("tradeRoute"))
                if (!$util.isString(message.tradeRoute))
                    return "tradeRoute: string expected";
            if (message.exchangeOrderId != null && message.hasOwnProperty("exchangeOrderId"))
                if (!$util.isString(message.exchangeOrderId))
                    return "exchangeOrderId: string expected";
            if (message.tpExchangeOrderId != null && message.hasOwnProperty("tpExchangeOrderId"))
                if (!$util.isString(message.tpExchangeOrderId))
                    return "tpExchangeOrderId: string expected";
            if (message.instrumentType != null && message.hasOwnProperty("instrumentType"))
                if (!$util.isString(message.instrumentType))
                    return "instrumentType: string expected";
            if (message.quantity != null && message.hasOwnProperty("quantity"))
                if (!$util.isInteger(message.quantity))
                    return "quantity: integer expected";
            if (message.price != null && message.hasOwnProperty("price"))
                if (typeof message.price !== "number")
                    return "price: number expected";
            if (message.triggerPrice != null && message.hasOwnProperty("triggerPrice"))
                if (typeof message.triggerPrice !== "number")
                    return "triggerPrice: number expected";
            if (message.transactionType != null && message.hasOwnProperty("transactionType"))
                switch (message.transactionType) {
                default:
                    return "transactionType: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                    break;
                }
            if (message.duration != null && message.hasOwnProperty("duration"))
                switch (message.duration) {
                default:
                    return "duration: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                    break;
                }
            if (message.priceType != null && message.hasOwnProperty("priceType"))
                switch (message.priceType) {
                default:
                    return "priceType: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                    break;
                }
            if (message.origPriceType != null && message.hasOwnProperty("origPriceType"))
                switch (message.origPriceType) {
                default:
                    return "origPriceType: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                    break;
                }
            if (message.manualOrAuto != null && message.hasOwnProperty("manualOrAuto"))
                switch (message.manualOrAuto) {
                default:
                    return "manualOrAuto: enum value expected";
                case 0:
                case 1:
                case 2:
                    break;
                }
            if (message.bracketType != null && message.hasOwnProperty("bracketType"))
                switch (message.bracketType) {
                default:
                    return "bracketType: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                    break;
                }
            if (message.confirmedSize != null && message.hasOwnProperty("confirmedSize"))
                if (!$util.isInteger(message.confirmedSize))
                    return "confirmedSize: integer expected";
            if (message.confirmedTime != null && message.hasOwnProperty("confirmedTime"))
                if (!$util.isString(message.confirmedTime))
                    return "confirmedTime: string expected";
            if (message.confirmedDate != null && message.hasOwnProperty("confirmedDate"))
                if (!$util.isString(message.confirmedDate))
                    return "confirmedDate: string expected";
            if (message.confirmedId != null && message.hasOwnProperty("confirmedId"))
                if (!$util.isString(message.confirmedId))
                    return "confirmedId: string expected";
            if (message.modifiedSize != null && message.hasOwnProperty("modifiedSize"))
                if (!$util.isInteger(message.modifiedSize))
                    return "modifiedSize: integer expected";
            if (message.modifiedTime != null && message.hasOwnProperty("modifiedTime"))
                if (!$util.isString(message.modifiedTime))
                    return "modifiedTime: string expected";
            if (message.modifiedDate != null && message.hasOwnProperty("modifiedDate"))
                if (!$util.isString(message.modifiedDate))
                    return "modifiedDate: string expected";
            if (message.modifyId != null && message.hasOwnProperty("modifyId"))
                if (!$util.isString(message.modifyId))
                    return "modifyId: string expected";
            if (message.cancelledSize != null && message.hasOwnProperty("cancelledSize"))
                if (!$util.isInteger(message.cancelledSize))
                    return "cancelledSize: integer expected";
            if (message.cancelledTime != null && message.hasOwnProperty("cancelledTime"))
                if (!$util.isString(message.cancelledTime))
                    return "cancelledTime: string expected";
            if (message.cancelledDate != null && message.hasOwnProperty("cancelledDate"))
                if (!$util.isString(message.cancelledDate))
                    return "cancelledDate: string expected";
            if (message.cancelledId != null && message.hasOwnProperty("cancelledId"))
                if (!$util.isString(message.cancelledId))
                    return "cancelledId: string expected";
            if (message.fillPrice != null && message.hasOwnProperty("fillPrice"))
                if (typeof message.fillPrice !== "number")
                    return "fillPrice: number expected";
            if (message.fillSize != null && message.hasOwnProperty("fillSize"))
                if (!$util.isInteger(message.fillSize))
                    return "fillSize: integer expected";
            if (message.fillTime != null && message.hasOwnProperty("fillTime"))
                if (!$util.isString(message.fillTime))
                    return "fillTime: string expected";
            if (message.fillDate != null && message.hasOwnProperty("fillDate"))
                if (!$util.isString(message.fillDate))
                    return "fillDate: string expected";
            if (message.fillId != null && message.hasOwnProperty("fillId"))
                if (!$util.isString(message.fillId))
                    return "fillId: string expected";
            if (message.avgFillPrice != null && message.hasOwnProperty("avgFillPrice"))
                if (typeof message.avgFillPrice !== "number")
                    return "avgFillPrice: number expected";
            if (message.totalFillSize != null && message.hasOwnProperty("totalFillSize"))
                if (!$util.isInteger(message.totalFillSize))
                    return "totalFillSize: integer expected";
            if (message.totalUnfilledSize != null && message.hasOwnProperty("totalUnfilledSize"))
                if (!$util.isInteger(message.totalUnfilledSize))
                    return "totalUnfilledSize: integer expected";
            if (message.triggerId != null && message.hasOwnProperty("triggerId"))
                if (!$util.isString(message.triggerId))
                    return "triggerId: string expected";
            if (message.trailByTicks != null && message.hasOwnProperty("trailByTicks"))
                if (!$util.isInteger(message.trailByTicks))
                    return "trailByTicks: integer expected";
            if (message.trailByPriceId != null && message.hasOwnProperty("trailByPriceId"))
                if (!$util.isInteger(message.trailByPriceId))
                    return "trailByPriceId: integer expected";
            if (message.sequenceNumber != null && message.hasOwnProperty("sequenceNumber"))
                if (!$util.isString(message.sequenceNumber))
                    return "sequenceNumber: string expected";
            if (message.origSequenceNumber != null && message.hasOwnProperty("origSequenceNumber"))
                if (!$util.isString(message.origSequenceNumber))
                    return "origSequenceNumber: string expected";
            if (message.corSequenceNumber != null && message.hasOwnProperty("corSequenceNumber"))
                if (!$util.isString(message.corSequenceNumber))
                    return "corSequenceNumber: string expected";
            if (message.currency != null && message.hasOwnProperty("currency"))
                if (!$util.isString(message.currency))
                    return "currency: string expected";
            if (message.countryCode != null && message.hasOwnProperty("countryCode"))
                if (!$util.isString(message.countryCode))
                    return "countryCode: string expected";
            if (message.text != null && message.hasOwnProperty("text"))
                if (!$util.isString(message.text))
                    return "text: string expected";
            if (message.reportText != null && message.hasOwnProperty("reportText"))
                if (!$util.isString(message.reportText))
                    return "reportText: string expected";
            if (message.remarks != null && message.hasOwnProperty("remarks"))
                if (!$util.isString(message.remarks))
                    return "remarks: string expected";
            if (message.windowName != null && message.hasOwnProperty("windowName"))
                if (!$util.isString(message.windowName))
                    return "windowName: string expected";
            if (message.originatorWindowName != null && message.hasOwnProperty("originatorWindowName"))
                if (!$util.isString(message.originatorWindowName))
                    return "originatorWindowName: string expected";
            if (message.cancelAtSsboe != null && message.hasOwnProperty("cancelAtSsboe"))
                if (!$util.isInteger(message.cancelAtSsboe))
                    return "cancelAtSsboe: integer expected";
            if (message.cancelAtUsecs != null && message.hasOwnProperty("cancelAtUsecs"))
                if (!$util.isInteger(message.cancelAtUsecs))
                    return "cancelAtUsecs: integer expected";
            if (message.cancelAfterSecs != null && message.hasOwnProperty("cancelAfterSecs"))
                if (!$util.isInteger(message.cancelAfterSecs))
                    return "cancelAfterSecs: integer expected";
            if (message.ssboe != null && message.hasOwnProperty("ssboe"))
                if (!$util.isInteger(message.ssboe))
                    return "ssboe: integer expected";
            if (message.usecs != null && message.hasOwnProperty("usecs"))
                if (!$util.isInteger(message.usecs))
                    return "usecs: integer expected";
            if (message.sourceSsboe != null && message.hasOwnProperty("sourceSsboe"))
                if (!$util.isInteger(message.sourceSsboe))
                    return "sourceSsboe: integer expected";
            if (message.sourceUsecs != null && message.hasOwnProperty("sourceUsecs"))
                if (!$util.isInteger(message.sourceUsecs))
                    return "sourceUsecs: integer expected";
            if (message.sourceNsecs != null && message.hasOwnProperty("sourceNsecs"))
                if (!$util.isInteger(message.sourceNsecs))
                    return "sourceNsecs: integer expected";
            if (message.exchReceiptSsboe != null && message.hasOwnProperty("exchReceiptSsboe"))
                if (!$util.isInteger(message.exchReceiptSsboe))
                    return "exchReceiptSsboe: integer expected";
            if (message.exchReceiptNsecs != null && message.hasOwnProperty("exchReceiptNsecs"))
                if (!$util.isInteger(message.exchReceiptNsecs))
                    return "exchReceiptNsecs: integer expected";
            return null;
        };

        /**
         * Creates an ExchangeOrderNotification message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof rti.ExchangeOrderNotification
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {rti.ExchangeOrderNotification} ExchangeOrderNotification
         */
        ExchangeOrderNotification.fromObject = function fromObject(object, _depth) {
            if (object instanceof $root.rti.ExchangeOrderNotification)
                return object;
            if (!$util.isObject(object))
                throw TypeError(".rti.ExchangeOrderNotification: object expected");
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw Error("max depth exceeded");
            let message = new $root.rti.ExchangeOrderNotification();
            if (object.templateId != null)
                if (Number(object.templateId) !== 0)
                    message.templateId = object.templateId | 0;
            if (object.userTag != null)
                if (typeof object.userTag !== "string" || object.userTag.length)
                    message.userTag = String(object.userTag);
            if (object.notifyType !== 0 && (typeof object.notifyType !== "string" || $root.rti.ExchangeOrderNotification.NotifyType[object.notifyType] !== 0))
                switch (object.notifyType) {
                default:
                    if (typeof object.notifyType === "number") {
                        message.notifyType = object.notifyType;
                        break;
                    }
                    break;
                case "NOTIFYTYPE_UNSPECIFIED":
                case 0:
                    message.notifyType = 0;
                    break;
                case "STATUS":
                case 1:
                    message.notifyType = 1;
                    break;
                case "MODIFY":
                case 2:
                    message.notifyType = 2;
                    break;
                case "CANCEL":
                case 3:
                    message.notifyType = 3;
                    break;
                case "TRIGGER":
                case 4:
                    message.notifyType = 4;
                    break;
                case "FILL":
                case 5:
                    message.notifyType = 5;
                    break;
                case "REJECT":
                case 6:
                    message.notifyType = 6;
                    break;
                case "NOT_MODIFIED":
                case 7:
                    message.notifyType = 7;
                    break;
                case "NOT_CANCELLED":
                case 8:
                    message.notifyType = 8;
                    break;
                case "GENERIC":
                case 9:
                    message.notifyType = 9;
                    break;
                }
            if (object.isSnapshot != null)
                if (object.isSnapshot)
                    message.isSnapshot = Boolean(object.isSnapshot);
            if (object.isRithmicInternalMsg != null)
                if (object.isRithmicInternalMsg)
                    message.isRithmicInternalMsg = Boolean(object.isRithmicInternalMsg);
            if (object.reportType != null)
                if (typeof object.reportType !== "string" || object.reportType.length)
                    message.reportType = String(object.reportType);
            if (object.status != null)
                if (typeof object.status !== "string" || object.status.length)
                    message.status = String(object.status);
            if (object.basketId != null)
                if (typeof object.basketId !== "string" || object.basketId.length)
                    message.basketId = String(object.basketId);
            if (object.originalBasketId != null)
                if (typeof object.originalBasketId !== "string" || object.originalBasketId.length)
                    message.originalBasketId = String(object.originalBasketId);
            if (object.linkedBasketIds != null)
                if (typeof object.linkedBasketIds !== "string" || object.linkedBasketIds.length)
                    message.linkedBasketIds = String(object.linkedBasketIds);
            if (object.fcmId != null)
                if (typeof object.fcmId !== "string" || object.fcmId.length)
                    message.fcmId = String(object.fcmId);
            if (object.ibId != null)
                if (typeof object.ibId !== "string" || object.ibId.length)
                    message.ibId = String(object.ibId);
            if (object.userId != null)
                if (typeof object.userId !== "string" || object.userId.length)
                    message.userId = String(object.userId);
            if (object.accountId != null)
                if (typeof object.accountId !== "string" || object.accountId.length)
                    message.accountId = String(object.accountId);
            if (object.symbol != null)
                if (typeof object.symbol !== "string" || object.symbol.length)
                    message.symbol = String(object.symbol);
            if (object.exchange != null)
                if (typeof object.exchange !== "string" || object.exchange.length)
                    message.exchange = String(object.exchange);
            if (object.tradeExchange != null)
                if (typeof object.tradeExchange !== "string" || object.tradeExchange.length)
                    message.tradeExchange = String(object.tradeExchange);
            if (object.tradeRoute != null)
                if (typeof object.tradeRoute !== "string" || object.tradeRoute.length)
                    message.tradeRoute = String(object.tradeRoute);
            if (object.exchangeOrderId != null)
                if (typeof object.exchangeOrderId !== "string" || object.exchangeOrderId.length)
                    message.exchangeOrderId = String(object.exchangeOrderId);
            if (object.tpExchangeOrderId != null)
                if (typeof object.tpExchangeOrderId !== "string" || object.tpExchangeOrderId.length)
                    message.tpExchangeOrderId = String(object.tpExchangeOrderId);
            if (object.instrumentType != null)
                if (typeof object.instrumentType !== "string" || object.instrumentType.length)
                    message.instrumentType = String(object.instrumentType);
            if (object.quantity != null)
                if (Number(object.quantity) !== 0)
                    message.quantity = object.quantity | 0;
            if (object.price != null)
                if (Number(object.price) !== 0)
                    message.price = Number(object.price);
            if (object.triggerPrice != null)
                if (Number(object.triggerPrice) !== 0)
                    message.triggerPrice = Number(object.triggerPrice);
            if (object.transactionType !== 0 && (typeof object.transactionType !== "string" || $root.rti.ExchangeOrderNotification.TransactionType[object.transactionType] !== 0))
                switch (object.transactionType) {
                default:
                    if (typeof object.transactionType === "number") {
                        message.transactionType = object.transactionType;
                        break;
                    }
                    break;
                case "TRANSACTIONTYPE_UNSPECIFIED":
                case 0:
                    message.transactionType = 0;
                    break;
                case "BUY":
                case 1:
                    message.transactionType = 1;
                    break;
                case "SELL":
                case 2:
                    message.transactionType = 2;
                    break;
                case "SS":
                case 3:
                    message.transactionType = 3;
                    break;
                }
            if (object.duration !== 0 && (typeof object.duration !== "string" || $root.rti.ExchangeOrderNotification.Duration[object.duration] !== 0))
                switch (object.duration) {
                default:
                    if (typeof object.duration === "number") {
                        message.duration = object.duration;
                        break;
                    }
                    break;
                case "DURATION_UNSPECIFIED":
                case 0:
                    message.duration = 0;
                    break;
                case "DAY":
                case 1:
                    message.duration = 1;
                    break;
                case "GTC":
                case 2:
                    message.duration = 2;
                    break;
                case "IOC":
                case 3:
                    message.duration = 3;
                    break;
                case "FOK":
                case 4:
                    message.duration = 4;
                    break;
                }
            if (object.priceType !== 0 && (typeof object.priceType !== "string" || $root.rti.ExchangeOrderNotification.PriceType[object.priceType] !== 0))
                switch (object.priceType) {
                default:
                    if (typeof object.priceType === "number") {
                        message.priceType = object.priceType;
                        break;
                    }
                    break;
                case "PRICETYPE_UNSPECIFIED":
                case 0:
                    message.priceType = 0;
                    break;
                case "LIMIT":
                case 1:
                    message.priceType = 1;
                    break;
                case "MARKET":
                case 2:
                    message.priceType = 2;
                    break;
                case "STOP_LIMIT":
                case 3:
                    message.priceType = 3;
                    break;
                case "STOP_MARKET":
                case 4:
                    message.priceType = 4;
                    break;
                }
            if (object.origPriceType !== 0 && (typeof object.origPriceType !== "string" || $root.rti.ExchangeOrderNotification.PriceType[object.origPriceType] !== 0))
                switch (object.origPriceType) {
                default:
                    if (typeof object.origPriceType === "number") {
                        message.origPriceType = object.origPriceType;
                        break;
                    }
                    break;
                case "PRICETYPE_UNSPECIFIED":
                case 0:
                    message.origPriceType = 0;
                    break;
                case "LIMIT":
                case 1:
                    message.origPriceType = 1;
                    break;
                case "MARKET":
                case 2:
                    message.origPriceType = 2;
                    break;
                case "STOP_LIMIT":
                case 3:
                    message.origPriceType = 3;
                    break;
                case "STOP_MARKET":
                case 4:
                    message.origPriceType = 4;
                    break;
                }
            if (object.manualOrAuto !== 0 && (typeof object.manualOrAuto !== "string" || $root.rti.ExchangeOrderNotification.OrderPlacement[object.manualOrAuto] !== 0))
                switch (object.manualOrAuto) {
                default:
                    if (typeof object.manualOrAuto === "number") {
                        message.manualOrAuto = object.manualOrAuto;
                        break;
                    }
                    break;
                case "ORDERPLACEMENT_UNSPECIFIED":
                case 0:
                    message.manualOrAuto = 0;
                    break;
                case "MANUAL":
                case 1:
                    message.manualOrAuto = 1;
                    break;
                case "AUTO":
                case 2:
                    message.manualOrAuto = 2;
                    break;
                }
            if (object.bracketType !== 0 && (typeof object.bracketType !== "string" || $root.rti.ExchangeOrderNotification.BracketType[object.bracketType] !== 0))
                switch (object.bracketType) {
                default:
                    if (typeof object.bracketType === "number") {
                        message.bracketType = object.bracketType;
                        break;
                    }
                    break;
                case "BRACKETTYPE_UNSPECIFIED":
                case 0:
                    message.bracketType = 0;
                    break;
                case "STOP_ONLY":
                case 1:
                    message.bracketType = 1;
                    break;
                case "TARGET_ONLY":
                case 2:
                    message.bracketType = 2;
                    break;
                case "TARGET_AND_STOP":
                case 3:
                    message.bracketType = 3;
                    break;
                case "STOP_ONLY_STATIC":
                case 4:
                    message.bracketType = 4;
                    break;
                case "TARGET_ONLY_STATIC":
                case 5:
                    message.bracketType = 5;
                    break;
                case "TARGET_AND_STOP_STATIC":
                case 6:
                    message.bracketType = 6;
                    break;
                }
            if (object.confirmedSize != null)
                if (Number(object.confirmedSize) !== 0)
                    message.confirmedSize = object.confirmedSize | 0;
            if (object.confirmedTime != null)
                if (typeof object.confirmedTime !== "string" || object.confirmedTime.length)
                    message.confirmedTime = String(object.confirmedTime);
            if (object.confirmedDate != null)
                if (typeof object.confirmedDate !== "string" || object.confirmedDate.length)
                    message.confirmedDate = String(object.confirmedDate);
            if (object.confirmedId != null)
                if (typeof object.confirmedId !== "string" || object.confirmedId.length)
                    message.confirmedId = String(object.confirmedId);
            if (object.modifiedSize != null)
                if (Number(object.modifiedSize) !== 0)
                    message.modifiedSize = object.modifiedSize | 0;
            if (object.modifiedTime != null)
                if (typeof object.modifiedTime !== "string" || object.modifiedTime.length)
                    message.modifiedTime = String(object.modifiedTime);
            if (object.modifiedDate != null)
                if (typeof object.modifiedDate !== "string" || object.modifiedDate.length)
                    message.modifiedDate = String(object.modifiedDate);
            if (object.modifyId != null)
                if (typeof object.modifyId !== "string" || object.modifyId.length)
                    message.modifyId = String(object.modifyId);
            if (object.cancelledSize != null)
                if (Number(object.cancelledSize) !== 0)
                    message.cancelledSize = object.cancelledSize | 0;
            if (object.cancelledTime != null)
                if (typeof object.cancelledTime !== "string" || object.cancelledTime.length)
                    message.cancelledTime = String(object.cancelledTime);
            if (object.cancelledDate != null)
                if (typeof object.cancelledDate !== "string" || object.cancelledDate.length)
                    message.cancelledDate = String(object.cancelledDate);
            if (object.cancelledId != null)
                if (typeof object.cancelledId !== "string" || object.cancelledId.length)
                    message.cancelledId = String(object.cancelledId);
            if (object.fillPrice != null)
                if (Number(object.fillPrice) !== 0)
                    message.fillPrice = Number(object.fillPrice);
            if (object.fillSize != null)
                if (Number(object.fillSize) !== 0)
                    message.fillSize = object.fillSize | 0;
            if (object.fillTime != null)
                if (typeof object.fillTime !== "string" || object.fillTime.length)
                    message.fillTime = String(object.fillTime);
            if (object.fillDate != null)
                if (typeof object.fillDate !== "string" || object.fillDate.length)
                    message.fillDate = String(object.fillDate);
            if (object.fillId != null)
                if (typeof object.fillId !== "string" || object.fillId.length)
                    message.fillId = String(object.fillId);
            if (object.avgFillPrice != null)
                if (Number(object.avgFillPrice) !== 0)
                    message.avgFillPrice = Number(object.avgFillPrice);
            if (object.totalFillSize != null)
                if (Number(object.totalFillSize) !== 0)
                    message.totalFillSize = object.totalFillSize | 0;
            if (object.totalUnfilledSize != null)
                if (Number(object.totalUnfilledSize) !== 0)
                    message.totalUnfilledSize = object.totalUnfilledSize | 0;
            if (object.triggerId != null)
                if (typeof object.triggerId !== "string" || object.triggerId.length)
                    message.triggerId = String(object.triggerId);
            if (object.trailByTicks != null)
                if (Number(object.trailByTicks) !== 0)
                    message.trailByTicks = object.trailByTicks | 0;
            if (object.trailByPriceId != null)
                if (Number(object.trailByPriceId) !== 0)
                    message.trailByPriceId = object.trailByPriceId | 0;
            if (object.sequenceNumber != null)
                if (typeof object.sequenceNumber !== "string" || object.sequenceNumber.length)
                    message.sequenceNumber = String(object.sequenceNumber);
            if (object.origSequenceNumber != null)
                if (typeof object.origSequenceNumber !== "string" || object.origSequenceNumber.length)
                    message.origSequenceNumber = String(object.origSequenceNumber);
            if (object.corSequenceNumber != null)
                if (typeof object.corSequenceNumber !== "string" || object.corSequenceNumber.length)
                    message.corSequenceNumber = String(object.corSequenceNumber);
            if (object.currency != null)
                if (typeof object.currency !== "string" || object.currency.length)
                    message.currency = String(object.currency);
            if (object.countryCode != null)
                if (typeof object.countryCode !== "string" || object.countryCode.length)
                    message.countryCode = String(object.countryCode);
            if (object.text != null)
                if (typeof object.text !== "string" || object.text.length)
                    message.text = String(object.text);
            if (object.reportText != null)
                if (typeof object.reportText !== "string" || object.reportText.length)
                    message.reportText = String(object.reportText);
            if (object.remarks != null)
                if (typeof object.remarks !== "string" || object.remarks.length)
                    message.remarks = String(object.remarks);
            if (object.windowName != null)
                if (typeof object.windowName !== "string" || object.windowName.length)
                    message.windowName = String(object.windowName);
            if (object.originatorWindowName != null)
                if (typeof object.originatorWindowName !== "string" || object.originatorWindowName.length)
                    message.originatorWindowName = String(object.originatorWindowName);
            if (object.cancelAtSsboe != null)
                if (Number(object.cancelAtSsboe) !== 0)
                    message.cancelAtSsboe = object.cancelAtSsboe | 0;
            if (object.cancelAtUsecs != null)
                if (Number(object.cancelAtUsecs) !== 0)
                    message.cancelAtUsecs = object.cancelAtUsecs | 0;
            if (object.cancelAfterSecs != null)
                if (Number(object.cancelAfterSecs) !== 0)
                    message.cancelAfterSecs = object.cancelAfterSecs | 0;
            if (object.ssboe != null)
                if (Number(object.ssboe) !== 0)
                    message.ssboe = object.ssboe | 0;
            if (object.usecs != null)
                if (Number(object.usecs) !== 0)
                    message.usecs = object.usecs | 0;
            if (object.sourceSsboe != null)
                if (Number(object.sourceSsboe) !== 0)
                    message.sourceSsboe = object.sourceSsboe | 0;
            if (object.sourceUsecs != null)
                if (Number(object.sourceUsecs) !== 0)
                    message.sourceUsecs = object.sourceUsecs | 0;
            if (object.sourceNsecs != null)
                if (Number(object.sourceNsecs) !== 0)
                    message.sourceNsecs = object.sourceNsecs | 0;
            if (object.exchReceiptSsboe != null)
                if (Number(object.exchReceiptSsboe) !== 0)
                    message.exchReceiptSsboe = object.exchReceiptSsboe | 0;
            if (object.exchReceiptNsecs != null)
                if (Number(object.exchReceiptNsecs) !== 0)
                    message.exchReceiptNsecs = object.exchReceiptNsecs | 0;
            return message;
        };

        /**
         * Creates a plain object from an ExchangeOrderNotification message. Also converts values to other types if specified.
         * @function toObject
         * @memberof rti.ExchangeOrderNotification
         * @static
         * @param {rti.ExchangeOrderNotification} message ExchangeOrderNotification
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ExchangeOrderNotification.toObject = function toObject(message, options, _depth) {
            if (!options)
                options = {};
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw Error("max depth exceeded");
            let object = {};
            if (options.defaults) {
                object.symbol = "";
                object.exchange = "";
                object.instrumentType = "";
                object.isSnapshot = false;
                object.basketId = "";
                object.status = "";
                object.price = 0;
                object.fillPrice = 0;
                object.fillSize = 0;
                object.fillTime = "";
                object.fillDate = "";
                object.fillId = "";
                object.cancelledSize = 0;
                object.cancelledTime = "";
                object.cancelledDate = "";
                object.cancelledId = "";
                object.avgFillPrice = 0;
                object.confirmedTime = "";
                object.confirmedDate = "";
                object.confirmedSize = 0;
                object.confirmedId = "";
                object.linkedBasketIds = "";
                object.sequenceNumber = "";
                object.transactionType = options.enums === String ? "TRANSACTIONTYPE_UNSPECIFIED" : 0;
                object.quantity = 0;
                object.duration = options.enums === String ? "DURATION_UNSPECIFIED" : 0;
                object.priceType = options.enums === String ? "PRICETYPE_UNSPECIFIED" : 0;
                object.tradeRoute = "";
                object.tradeExchange = "";
                object.reportType = "";
                object.text = "";
                object.reportText = "";
                object.userId = "";
                object.exchangeOrderId = "";
                object.modifyId = "";
                object.triggerPrice = 0;
                object.origSequenceNumber = "";
                object.corSequenceNumber = "";
                object.triggerId = "";
                object.modifiedSize = 0;
                object.modifiedTime = "";
                object.modifiedDate = "";
                object.isRithmicInternalMsg = false;
                object.ssboe = 0;
                object.usecs = 0;
                object.sourceSsboe = 0;
                object.sourceUsecs = 0;
                object.sourceNsecs = 0;
                object.exchReceiptSsboe = 0;
                object.exchReceiptNsecs = 0;
                object.notifyType = options.enums === String ? "NOTIFYTYPE_UNSPECIFIED" : 0;
                object.tpExchangeOrderId = "";
                object.accountId = "";
                object.fcmId = "";
                object.ibId = "";
                object.totalFillSize = 0;
                object.totalUnfilledSize = 0;
                object.userTag = "";
                object.countryCode = "";
                object.currency = "";
                object.templateId = 0;
                object.cancelAfterSecs = 0;
                object.originalBasketId = "";
                object.windowName = "";
                object.originatorWindowName = "";
                object.manualOrAuto = options.enums === String ? "ORDERPLACEMENT_UNSPECIFIED" : 0;
                object.origPriceType = options.enums === String ? "PRICETYPE_UNSPECIFIED" : 0;
                object.remarks = "";
                object.trailByTicks = 0;
                object.trailByPriceId = 0;
                object.cancelAtSsboe = 0;
                object.cancelAtUsecs = 0;
                object.bracketType = options.enums === String ? "BRACKETTYPE_UNSPECIFIED" : 0;
            }
            if (message.symbol != null && message.hasOwnProperty("symbol"))
                object.symbol = message.symbol;
            if (message.exchange != null && message.hasOwnProperty("exchange"))
                object.exchange = message.exchange;
            if (message.instrumentType != null && message.hasOwnProperty("instrumentType"))
                object.instrumentType = message.instrumentType;
            if (message.isSnapshot != null && message.hasOwnProperty("isSnapshot"))
                object.isSnapshot = message.isSnapshot;
            if (message.basketId != null && message.hasOwnProperty("basketId"))
                object.basketId = message.basketId;
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = message.status;
            if (message.price != null && message.hasOwnProperty("price"))
                object.price = options.json && !isFinite(message.price) ? String(message.price) : message.price;
            if (message.fillPrice != null && message.hasOwnProperty("fillPrice"))
                object.fillPrice = options.json && !isFinite(message.fillPrice) ? String(message.fillPrice) : message.fillPrice;
            if (message.fillSize != null && message.hasOwnProperty("fillSize"))
                object.fillSize = message.fillSize;
            if (message.fillTime != null && message.hasOwnProperty("fillTime"))
                object.fillTime = message.fillTime;
            if (message.fillDate != null && message.hasOwnProperty("fillDate"))
                object.fillDate = message.fillDate;
            if (message.fillId != null && message.hasOwnProperty("fillId"))
                object.fillId = message.fillId;
            if (message.cancelledSize != null && message.hasOwnProperty("cancelledSize"))
                object.cancelledSize = message.cancelledSize;
            if (message.cancelledTime != null && message.hasOwnProperty("cancelledTime"))
                object.cancelledTime = message.cancelledTime;
            if (message.cancelledDate != null && message.hasOwnProperty("cancelledDate"))
                object.cancelledDate = message.cancelledDate;
            if (message.cancelledId != null && message.hasOwnProperty("cancelledId"))
                object.cancelledId = message.cancelledId;
            if (message.avgFillPrice != null && message.hasOwnProperty("avgFillPrice"))
                object.avgFillPrice = options.json && !isFinite(message.avgFillPrice) ? String(message.avgFillPrice) : message.avgFillPrice;
            if (message.confirmedTime != null && message.hasOwnProperty("confirmedTime"))
                object.confirmedTime = message.confirmedTime;
            if (message.confirmedDate != null && message.hasOwnProperty("confirmedDate"))
                object.confirmedDate = message.confirmedDate;
            if (message.confirmedSize != null && message.hasOwnProperty("confirmedSize"))
                object.confirmedSize = message.confirmedSize;
            if (message.confirmedId != null && message.hasOwnProperty("confirmedId"))
                object.confirmedId = message.confirmedId;
            if (message.linkedBasketIds != null && message.hasOwnProperty("linkedBasketIds"))
                object.linkedBasketIds = message.linkedBasketIds;
            if (message.sequenceNumber != null && message.hasOwnProperty("sequenceNumber"))
                object.sequenceNumber = message.sequenceNumber;
            if (message.transactionType != null && message.hasOwnProperty("transactionType"))
                object.transactionType = options.enums === String ? $root.rti.ExchangeOrderNotification.TransactionType[message.transactionType] === undefined ? message.transactionType : $root.rti.ExchangeOrderNotification.TransactionType[message.transactionType] : message.transactionType;
            if (message.quantity != null && message.hasOwnProperty("quantity"))
                object.quantity = message.quantity;
            if (message.duration != null && message.hasOwnProperty("duration"))
                object.duration = options.enums === String ? $root.rti.ExchangeOrderNotification.Duration[message.duration] === undefined ? message.duration : $root.rti.ExchangeOrderNotification.Duration[message.duration] : message.duration;
            if (message.priceType != null && message.hasOwnProperty("priceType"))
                object.priceType = options.enums === String ? $root.rti.ExchangeOrderNotification.PriceType[message.priceType] === undefined ? message.priceType : $root.rti.ExchangeOrderNotification.PriceType[message.priceType] : message.priceType;
            if (message.tradeRoute != null && message.hasOwnProperty("tradeRoute"))
                object.tradeRoute = message.tradeRoute;
            if (message.tradeExchange != null && message.hasOwnProperty("tradeExchange"))
                object.tradeExchange = message.tradeExchange;
            if (message.reportType != null && message.hasOwnProperty("reportType"))
                object.reportType = message.reportType;
            if (message.text != null && message.hasOwnProperty("text"))
                object.text = message.text;
            if (message.reportText != null && message.hasOwnProperty("reportText"))
                object.reportText = message.reportText;
            if (message.userId != null && message.hasOwnProperty("userId"))
                object.userId = message.userId;
            if (message.exchangeOrderId != null && message.hasOwnProperty("exchangeOrderId"))
                object.exchangeOrderId = message.exchangeOrderId;
            if (message.modifyId != null && message.hasOwnProperty("modifyId"))
                object.modifyId = message.modifyId;
            if (message.triggerPrice != null && message.hasOwnProperty("triggerPrice"))
                object.triggerPrice = options.json && !isFinite(message.triggerPrice) ? String(message.triggerPrice) : message.triggerPrice;
            if (message.origSequenceNumber != null && message.hasOwnProperty("origSequenceNumber"))
                object.origSequenceNumber = message.origSequenceNumber;
            if (message.corSequenceNumber != null && message.hasOwnProperty("corSequenceNumber"))
                object.corSequenceNumber = message.corSequenceNumber;
            if (message.triggerId != null && message.hasOwnProperty("triggerId"))
                object.triggerId = message.triggerId;
            if (message.modifiedSize != null && message.hasOwnProperty("modifiedSize"))
                object.modifiedSize = message.modifiedSize;
            if (message.modifiedTime != null && message.hasOwnProperty("modifiedTime"))
                object.modifiedTime = message.modifiedTime;
            if (message.modifiedDate != null && message.hasOwnProperty("modifiedDate"))
                object.modifiedDate = message.modifiedDate;
            if (message.isRithmicInternalMsg != null && message.hasOwnProperty("isRithmicInternalMsg"))
                object.isRithmicInternalMsg = message.isRithmicInternalMsg;
            if (message.ssboe != null && message.hasOwnProperty("ssboe"))
                object.ssboe = message.ssboe;
            if (message.usecs != null && message.hasOwnProperty("usecs"))
                object.usecs = message.usecs;
            if (message.sourceSsboe != null && message.hasOwnProperty("sourceSsboe"))
                object.sourceSsboe = message.sourceSsboe;
            if (message.sourceUsecs != null && message.hasOwnProperty("sourceUsecs"))
                object.sourceUsecs = message.sourceUsecs;
            if (message.sourceNsecs != null && message.hasOwnProperty("sourceNsecs"))
                object.sourceNsecs = message.sourceNsecs;
            if (message.exchReceiptSsboe != null && message.hasOwnProperty("exchReceiptSsboe"))
                object.exchReceiptSsboe = message.exchReceiptSsboe;
            if (message.exchReceiptNsecs != null && message.hasOwnProperty("exchReceiptNsecs"))
                object.exchReceiptNsecs = message.exchReceiptNsecs;
            if (message.notifyType != null && message.hasOwnProperty("notifyType"))
                object.notifyType = options.enums === String ? $root.rti.ExchangeOrderNotification.NotifyType[message.notifyType] === undefined ? message.notifyType : $root.rti.ExchangeOrderNotification.NotifyType[message.notifyType] : message.notifyType;
            if (message.tpExchangeOrderId != null && message.hasOwnProperty("tpExchangeOrderId"))
                object.tpExchangeOrderId = message.tpExchangeOrderId;
            if (message.accountId != null && message.hasOwnProperty("accountId"))
                object.accountId = message.accountId;
            if (message.fcmId != null && message.hasOwnProperty("fcmId"))
                object.fcmId = message.fcmId;
            if (message.ibId != null && message.hasOwnProperty("ibId"))
                object.ibId = message.ibId;
            if (message.totalFillSize != null && message.hasOwnProperty("totalFillSize"))
                object.totalFillSize = message.totalFillSize;
            if (message.totalUnfilledSize != null && message.hasOwnProperty("totalUnfilledSize"))
                object.totalUnfilledSize = message.totalUnfilledSize;
            if (message.userTag != null && message.hasOwnProperty("userTag"))
                object.userTag = message.userTag;
            if (message.countryCode != null && message.hasOwnProperty("countryCode"))
                object.countryCode = message.countryCode;
            if (message.currency != null && message.hasOwnProperty("currency"))
                object.currency = message.currency;
            if (message.templateId != null && message.hasOwnProperty("templateId"))
                object.templateId = message.templateId;
            if (message.cancelAfterSecs != null && message.hasOwnProperty("cancelAfterSecs"))
                object.cancelAfterSecs = message.cancelAfterSecs;
            if (message.originalBasketId != null && message.hasOwnProperty("originalBasketId"))
                object.originalBasketId = message.originalBasketId;
            if (message.windowName != null && message.hasOwnProperty("windowName"))
                object.windowName = message.windowName;
            if (message.originatorWindowName != null && message.hasOwnProperty("originatorWindowName"))
                object.originatorWindowName = message.originatorWindowName;
            if (message.manualOrAuto != null && message.hasOwnProperty("manualOrAuto"))
                object.manualOrAuto = options.enums === String ? $root.rti.ExchangeOrderNotification.OrderPlacement[message.manualOrAuto] === undefined ? message.manualOrAuto : $root.rti.ExchangeOrderNotification.OrderPlacement[message.manualOrAuto] : message.manualOrAuto;
            if (message.origPriceType != null && message.hasOwnProperty("origPriceType"))
                object.origPriceType = options.enums === String ? $root.rti.ExchangeOrderNotification.PriceType[message.origPriceType] === undefined ? message.origPriceType : $root.rti.ExchangeOrderNotification.PriceType[message.origPriceType] : message.origPriceType;
            if (message.remarks != null && message.hasOwnProperty("remarks"))
                object.remarks = message.remarks;
            if (message.trailByTicks != null && message.hasOwnProperty("trailByTicks"))
                object.trailByTicks = message.trailByTicks;
            if (message.trailByPriceId != null && message.hasOwnProperty("trailByPriceId"))
                object.trailByPriceId = message.trailByPriceId;
            if (message.cancelAtSsboe != null && message.hasOwnProperty("cancelAtSsboe"))
                object.cancelAtSsboe = message.cancelAtSsboe;
            if (message.cancelAtUsecs != null && message.hasOwnProperty("cancelAtUsecs"))
                object.cancelAtUsecs = message.cancelAtUsecs;
            if (message.bracketType != null && message.hasOwnProperty("bracketType"))
                object.bracketType = options.enums === String ? $root.rti.ExchangeOrderNotification.BracketType[message.bracketType] === undefined ? message.bracketType : $root.rti.ExchangeOrderNotification.BracketType[message.bracketType] : message.bracketType;
            return object;
        };

        /**
         * Converts this ExchangeOrderNotification to JSON.
         * @function toJSON
         * @memberof rti.ExchangeOrderNotification
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ExchangeOrderNotification.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the type url for ExchangeOrderNotification
         * @function getTypeUrl
         * @memberof rti.ExchangeOrderNotification
         * @static
         * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
         * @returns {string} The type url
         */
        ExchangeOrderNotification.getTypeUrl = function getTypeUrl(prefix) {
            if (prefix === undefined)
                prefix = "type.googleapis.com";
            return prefix + "/rti.ExchangeOrderNotification";
        };

        /**
         * NotifyType enum.
         * @name rti.ExchangeOrderNotification.NotifyType
         * @enum {number}
         * @property {number} NOTIFYTYPE_UNSPECIFIED=0 NOTIFYTYPE_UNSPECIFIED value
         * @property {number} STATUS=1 STATUS value
         * @property {number} MODIFY=2 MODIFY value
         * @property {number} CANCEL=3 CANCEL value
         * @property {number} TRIGGER=4 TRIGGER value
         * @property {number} FILL=5 FILL value
         * @property {number} REJECT=6 REJECT value
         * @property {number} NOT_MODIFIED=7 NOT_MODIFIED value
         * @property {number} NOT_CANCELLED=8 NOT_CANCELLED value
         * @property {number} GENERIC=9 GENERIC value
         */
        ExchangeOrderNotification.NotifyType = (function() {
            const valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "NOTIFYTYPE_UNSPECIFIED"] = 0;
            values[valuesById[1] = "STATUS"] = 1;
            values[valuesById[2] = "MODIFY"] = 2;
            values[valuesById[3] = "CANCEL"] = 3;
            values[valuesById[4] = "TRIGGER"] = 4;
            values[valuesById[5] = "FILL"] = 5;
            values[valuesById[6] = "REJECT"] = 6;
            values[valuesById[7] = "NOT_MODIFIED"] = 7;
            values[valuesById[8] = "NOT_CANCELLED"] = 8;
            values[valuesById[9] = "GENERIC"] = 9;
            return values;
        })();

        /**
         * TransactionType enum.
         * @name rti.ExchangeOrderNotification.TransactionType
         * @enum {number}
         * @property {number} TRANSACTIONTYPE_UNSPECIFIED=0 TRANSACTIONTYPE_UNSPECIFIED value
         * @property {number} BUY=1 BUY value
         * @property {number} SELL=2 SELL value
         * @property {number} SS=3 SS value
         */
        ExchangeOrderNotification.TransactionType = (function() {
            const valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "TRANSACTIONTYPE_UNSPECIFIED"] = 0;
            values[valuesById[1] = "BUY"] = 1;
            values[valuesById[2] = "SELL"] = 2;
            values[valuesById[3] = "SS"] = 3;
            return values;
        })();

        /**
         * Duration enum.
         * @name rti.ExchangeOrderNotification.Duration
         * @enum {number}
         * @property {number} DURATION_UNSPECIFIED=0 DURATION_UNSPECIFIED value
         * @property {number} DAY=1 DAY value
         * @property {number} GTC=2 GTC value
         * @property {number} IOC=3 IOC value
         * @property {number} FOK=4 FOK value
         */
        ExchangeOrderNotification.Duration = (function() {
            const valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "DURATION_UNSPECIFIED"] = 0;
            values[valuesById[1] = "DAY"] = 1;
            values[valuesById[2] = "GTC"] = 2;
            values[valuesById[3] = "IOC"] = 3;
            values[valuesById[4] = "FOK"] = 4;
            return values;
        })();

        /**
         * PriceType enum.
         * @name rti.ExchangeOrderNotification.PriceType
         * @enum {number}
         * @property {number} PRICETYPE_UNSPECIFIED=0 PRICETYPE_UNSPECIFIED value
         * @property {number} LIMIT=1 LIMIT value
         * @property {number} MARKET=2 MARKET value
         * @property {number} STOP_LIMIT=3 STOP_LIMIT value
         * @property {number} STOP_MARKET=4 STOP_MARKET value
         */
        ExchangeOrderNotification.PriceType = (function() {
            const valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "PRICETYPE_UNSPECIFIED"] = 0;
            values[valuesById[1] = "LIMIT"] = 1;
            values[valuesById[2] = "MARKET"] = 2;
            values[valuesById[3] = "STOP_LIMIT"] = 3;
            values[valuesById[4] = "STOP_MARKET"] = 4;
            return values;
        })();

        /**
         * BracketType enum.
         * @name rti.ExchangeOrderNotification.BracketType
         * @enum {number}
         * @property {number} BRACKETTYPE_UNSPECIFIED=0 BRACKETTYPE_UNSPECIFIED value
         * @property {number} STOP_ONLY=1 STOP_ONLY value
         * @property {number} TARGET_ONLY=2 TARGET_ONLY value
         * @property {number} TARGET_AND_STOP=3 TARGET_AND_STOP value
         * @property {number} STOP_ONLY_STATIC=4 STOP_ONLY_STATIC value
         * @property {number} TARGET_ONLY_STATIC=5 TARGET_ONLY_STATIC value
         * @property {number} TARGET_AND_STOP_STATIC=6 TARGET_AND_STOP_STATIC value
         */
        ExchangeOrderNotification.BracketType = (function() {
            const valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "BRACKETTYPE_UNSPECIFIED"] = 0;
            values[valuesById[1] = "STOP_ONLY"] = 1;
            values[valuesById[2] = "TARGET_ONLY"] = 2;
            values[valuesById[3] = "TARGET_AND_STOP"] = 3;
            values[valuesById[4] = "STOP_ONLY_STATIC"] = 4;
            values[valuesById[5] = "TARGET_ONLY_STATIC"] = 5;
            values[valuesById[6] = "TARGET_AND_STOP_STATIC"] = 6;
            return values;
        })();

        /**
         * OrderPlacement enum.
         * @name rti.ExchangeOrderNotification.OrderPlacement
         * @enum {number}
         * @property {number} ORDERPLACEMENT_UNSPECIFIED=0 ORDERPLACEMENT_UNSPECIFIED value
         * @property {number} MANUAL=1 MANUAL value
         * @property {number} AUTO=2 AUTO value
         */
        ExchangeOrderNotification.OrderPlacement = (function() {
            const valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "ORDERPLACEMENT_UNSPECIFIED"] = 0;
            values[valuesById[1] = "MANUAL"] = 1;
            values[valuesById[2] = "AUTO"] = 2;
            return values;
        })();

        return ExchangeOrderNotification;
    })();

    rti.ForcedLogout = (function() {

        /**
         * Properties of a ForcedLogout.
         * @typedef {Object} rti.ForcedLogout.$Properties
         * @property {number|null} [templateId] ForcedLogout templateId
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding
         */

        /**
         * Properties of a ForcedLogout.
         * @memberof rti
         * @interface IForcedLogout
         * @augments rti.ForcedLogout.$Properties
         * @deprecated Use rti.ForcedLogout.$Properties instead.
         */

        /**
         * Shape of a ForcedLogout.
         * @typedef {rti.ForcedLogout.$Properties} rti.ForcedLogout.$Shape
         */

        /**
         * Constructs a new ForcedLogout.
         * @memberof rti
         * @classdesc Represents a ForcedLogout.
         * @constructor
         * @param {rti.ForcedLogout.$Properties=} [properties] Properties to set
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding
         */
        function ForcedLogout(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null && keys[i] !== "__proto__")
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ForcedLogout templateId.
         * @member {number} templateId
         * @memberof rti.ForcedLogout
         * @instance
         */
        ForcedLogout.prototype.templateId = 0;

        /**
         * Creates a new ForcedLogout instance using the specified properties.
         * @function create
         * @memberof rti.ForcedLogout
         * @static
         * @param {rti.ForcedLogout.$Properties=} [properties] Properties to set
         * @returns {rti.ForcedLogout} ForcedLogout instance
         * @type {{
         *   (properties: rti.ForcedLogout.$Shape): rti.ForcedLogout & rti.ForcedLogout.$Shape;
         *   (properties?: rti.ForcedLogout.$Properties): rti.ForcedLogout;
         * }}
         */
        ForcedLogout.create = function create(properties) {
            return new ForcedLogout(properties);
        };

        /**
         * Encodes the specified ForcedLogout message. Does not implicitly {@link rti.ForcedLogout.verify|verify} messages.
         * @function encode
         * @memberof rti.ForcedLogout
         * @static
         * @param {rti.ForcedLogout.$Properties} message ForcedLogout message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ForcedLogout.encode = function encode(message, writer, _depth) {
            if (!writer)
                writer = $Writer.create();
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw Error("max depth exceeded");
            if (message.templateId != null && Object.hasOwnProperty.call(message, "templateId"))
                writer.uint32(/* id 154467, wireType 0 =*/1235736).int32(message.templateId);
            if (message.$unknowns != null && Object.hasOwnProperty.call(message, "$unknowns"))
                for (let i = 0; i < message.$unknowns.length; ++i)
                    writer.raw(message.$unknowns[i]);
            return writer;
        };

        /**
         * Encodes the specified ForcedLogout message, length delimited. Does not implicitly {@link rti.ForcedLogout.verify|verify} messages.
         * @function encodeDelimited
         * @memberof rti.ForcedLogout
         * @static
         * @param {rti.ForcedLogout.$Properties} message ForcedLogout message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ForcedLogout.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer && writer.len ? writer.fork() : writer).ldelim();
        };

        /**
         * Decodes a ForcedLogout message from the specified reader or buffer.
         * @function decode
         * @memberof rti.ForcedLogout
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {rti.ForcedLogout & rti.ForcedLogout.$Shape} ForcedLogout
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ForcedLogout.decode = function decode(reader, length, _end, _depth, _target) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $Reader.recursionLimit)
                throw Error("max depth exceeded");
            let end = length === undefined ? reader.len : reader.pos + length, message = _target || new $root.rti.ForcedLogout(), value;
            while (reader.pos < end) {
                let start = reader.pos;
                let tag = reader.tag();
                if (tag === _end) {
                    _end = undefined;
                    break;
                }
                let wireType = tag & 7;
                switch (tag >>>= 3) {
                case 154467: {
                        if (wireType !== 0)
                            break;
                        if (value = reader.int32())
                            message.templateId = value;
                        else
                            delete message.templateId;
                        continue;
                    }
                }
                reader.skipType(wireType, _depth, tag);
                if (!reader.discardUnknown) {
                    $util.makeProp(message, "$unknowns", false);
                    (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
                }
            }
            if (_end !== undefined)
                throw Error("missing end group");
            return message;
        };

        /**
         * Decodes a ForcedLogout message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof rti.ForcedLogout
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {rti.ForcedLogout & rti.ForcedLogout.$Shape} ForcedLogout
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ForcedLogout.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ForcedLogout message.
         * @function verify
         * @memberof rti.ForcedLogout
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ForcedLogout.verify = function verify(message, _depth) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                return "max depth exceeded";
            if (message.templateId != null && message.hasOwnProperty("templateId"))
                if (!$util.isInteger(message.templateId))
                    return "templateId: integer expected";
            return null;
        };

        /**
         * Creates a ForcedLogout message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof rti.ForcedLogout
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {rti.ForcedLogout} ForcedLogout
         */
        ForcedLogout.fromObject = function fromObject(object, _depth) {
            if (object instanceof $root.rti.ForcedLogout)
                return object;
            if (!$util.isObject(object))
                throw TypeError(".rti.ForcedLogout: object expected");
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw Error("max depth exceeded");
            let message = new $root.rti.ForcedLogout();
            if (object.templateId != null)
                if (Number(object.templateId) !== 0)
                    message.templateId = object.templateId | 0;
            return message;
        };

        /**
         * Creates a plain object from a ForcedLogout message. Also converts values to other types if specified.
         * @function toObject
         * @memberof rti.ForcedLogout
         * @static
         * @param {rti.ForcedLogout} message ForcedLogout
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ForcedLogout.toObject = function toObject(message, options, _depth) {
            if (!options)
                options = {};
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw Error("max depth exceeded");
            let object = {};
            if (options.defaults)
                object.templateId = 0;
            if (message.templateId != null && message.hasOwnProperty("templateId"))
                object.templateId = message.templateId;
            return object;
        };

        /**
         * Converts this ForcedLogout to JSON.
         * @function toJSON
         * @memberof rti.ForcedLogout
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ForcedLogout.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the type url for ForcedLogout
         * @function getTypeUrl
         * @memberof rti.ForcedLogout
         * @static
         * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
         * @returns {string} The type url
         */
        ForcedLogout.getTypeUrl = function getTypeUrl(prefix) {
            if (prefix === undefined)
                prefix = "type.googleapis.com";
            return prefix + "/rti.ForcedLogout";
        };

        return ForcedLogout;
    })();

    rti.Reject = (function() {

        /**
         * Properties of a Reject.
         * @typedef {Object} rti.Reject.$Properties
         * @property {number|null} [templateId] Reject templateId
         * @property {Array.<string>|null} [userMsg] Reject userMsg
         * @property {Array.<string>|null} [rpCode] Reject rpCode
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding
         */

        /**
         * Properties of a Reject.
         * @memberof rti
         * @interface IReject
         * @augments rti.Reject.$Properties
         * @deprecated Use rti.Reject.$Properties instead.
         */

        /**
         * Shape of a Reject.
         * @typedef {rti.Reject.$Properties} rti.Reject.$Shape
         */

        /**
         * Constructs a new Reject.
         * @memberof rti
         * @classdesc Represents a Reject.
         * @constructor
         * @param {rti.Reject.$Properties=} [properties] Properties to set
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding
         */
        function Reject(properties) {
            this.userMsg = [];
            this.rpCode = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null && keys[i] !== "__proto__")
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Reject templateId.
         * @member {number} templateId
         * @memberof rti.Reject
         * @instance
         */
        Reject.prototype.templateId = 0;

        /**
         * Reject userMsg.
         * @member {Array.<string>} userMsg
         * @memberof rti.Reject
         * @instance
         */
        Reject.prototype.userMsg = $util.emptyArray;

        /**
         * Reject rpCode.
         * @member {Array.<string>} rpCode
         * @memberof rti.Reject
         * @instance
         */
        Reject.prototype.rpCode = $util.emptyArray;

        /**
         * Creates a new Reject instance using the specified properties.
         * @function create
         * @memberof rti.Reject
         * @static
         * @param {rti.Reject.$Properties=} [properties] Properties to set
         * @returns {rti.Reject} Reject instance
         * @type {{
         *   (properties: rti.Reject.$Shape): rti.Reject & rti.Reject.$Shape;
         *   (properties?: rti.Reject.$Properties): rti.Reject;
         * }}
         */
        Reject.create = function create(properties) {
            return new Reject(properties);
        };

        /**
         * Encodes the specified Reject message. Does not implicitly {@link rti.Reject.verify|verify} messages.
         * @function encode
         * @memberof rti.Reject
         * @static
         * @param {rti.Reject.$Properties} message Reject message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Reject.encode = function encode(message, writer, _depth) {
            if (!writer)
                writer = $Writer.create();
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw Error("max depth exceeded");
            if (message.userMsg != null && message.userMsg.length)
                for (let i = 0; i < message.userMsg.length; ++i)
                    writer.uint32(/* id 132760, wireType 2 =*/1062082).string(message.userMsg[i]);
            if (message.rpCode != null && message.rpCode.length)
                for (let i = 0; i < message.rpCode.length; ++i)
                    writer.uint32(/* id 132766, wireType 2 =*/1062130).string(message.rpCode[i]);
            if (message.templateId != null && Object.hasOwnProperty.call(message, "templateId"))
                writer.uint32(/* id 154467, wireType 0 =*/1235736).int32(message.templateId);
            if (message.$unknowns != null && Object.hasOwnProperty.call(message, "$unknowns"))
                for (let i = 0; i < message.$unknowns.length; ++i)
                    writer.raw(message.$unknowns[i]);
            return writer;
        };

        /**
         * Encodes the specified Reject message, length delimited. Does not implicitly {@link rti.Reject.verify|verify} messages.
         * @function encodeDelimited
         * @memberof rti.Reject
         * @static
         * @param {rti.Reject.$Properties} message Reject message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Reject.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer && writer.len ? writer.fork() : writer).ldelim();
        };

        /**
         * Decodes a Reject message from the specified reader or buffer.
         * @function decode
         * @memberof rti.Reject
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {rti.Reject & rti.Reject.$Shape} Reject
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Reject.decode = function decode(reader, length, _end, _depth, _target) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $Reader.recursionLimit)
                throw Error("max depth exceeded");
            let end = length === undefined ? reader.len : reader.pos + length, message = _target || new $root.rti.Reject(), value;
            while (reader.pos < end) {
                let start = reader.pos;
                let tag = reader.tag();
                if (tag === _end) {
                    _end = undefined;
                    break;
                }
                let wireType = tag & 7;
                switch (tag >>>= 3) {
                case 154467: {
                        if (wireType !== 0)
                            break;
                        if (value = reader.int32())
                            message.templateId = value;
                        else
                            delete message.templateId;
                        continue;
                    }
                case 132760: {
                        if (wireType !== 2)
                            break;
                        if (!(message.userMsg && message.userMsg.length))
                            message.userMsg = [];
                        message.userMsg.push(reader.string());
                        continue;
                    }
                case 132766: {
                        if (wireType !== 2)
                            break;
                        if (!(message.rpCode && message.rpCode.length))
                            message.rpCode = [];
                        message.rpCode.push(reader.string());
                        continue;
                    }
                }
                reader.skipType(wireType, _depth, tag);
                if (!reader.discardUnknown) {
                    $util.makeProp(message, "$unknowns", false);
                    (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
                }
            }
            if (_end !== undefined)
                throw Error("missing end group");
            return message;
        };

        /**
         * Decodes a Reject message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof rti.Reject
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {rti.Reject & rti.Reject.$Shape} Reject
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Reject.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Reject message.
         * @function verify
         * @memberof rti.Reject
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Reject.verify = function verify(message, _depth) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                return "max depth exceeded";
            if (message.templateId != null && message.hasOwnProperty("templateId"))
                if (!$util.isInteger(message.templateId))
                    return "templateId: integer expected";
            if (message.userMsg != null && message.hasOwnProperty("userMsg")) {
                if (!Array.isArray(message.userMsg))
                    return "userMsg: array expected";
                for (let i = 0; i < message.userMsg.length; ++i)
                    if (!$util.isString(message.userMsg[i]))
                        return "userMsg: string[] expected";
            }
            if (message.rpCode != null && message.hasOwnProperty("rpCode")) {
                if (!Array.isArray(message.rpCode))
                    return "rpCode: array expected";
                for (let i = 0; i < message.rpCode.length; ++i)
                    if (!$util.isString(message.rpCode[i]))
                        return "rpCode: string[] expected";
            }
            return null;
        };

        /**
         * Creates a Reject message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof rti.Reject
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {rti.Reject} Reject
         */
        Reject.fromObject = function fromObject(object, _depth) {
            if (object instanceof $root.rti.Reject)
                return object;
            if (!$util.isObject(object))
                throw TypeError(".rti.Reject: object expected");
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw Error("max depth exceeded");
            let message = new $root.rti.Reject();
            if (object.templateId != null)
                if (Number(object.templateId) !== 0)
                    message.templateId = object.templateId | 0;
            if (object.userMsg) {
                if (!Array.isArray(object.userMsg))
                    throw TypeError(".rti.Reject.userMsg: array expected");
                message.userMsg = Array(object.userMsg.length);
                for (let i = 0; i < object.userMsg.length; ++i)
                    message.userMsg[i] = String(object.userMsg[i]);
            }
            if (object.rpCode) {
                if (!Array.isArray(object.rpCode))
                    throw TypeError(".rti.Reject.rpCode: array expected");
                message.rpCode = Array(object.rpCode.length);
                for (let i = 0; i < object.rpCode.length; ++i)
                    message.rpCode[i] = String(object.rpCode[i]);
            }
            return message;
        };

        /**
         * Creates a plain object from a Reject message. Also converts values to other types if specified.
         * @function toObject
         * @memberof rti.Reject
         * @static
         * @param {rti.Reject} message Reject
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Reject.toObject = function toObject(message, options, _depth) {
            if (!options)
                options = {};
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw Error("max depth exceeded");
            let object = {};
            if (options.arrays || options.defaults) {
                object.userMsg = [];
                object.rpCode = [];
            }
            if (options.defaults)
                object.templateId = 0;
            if (message.userMsg && message.userMsg.length) {
                object.userMsg = Array(message.userMsg.length);
                for (let j = 0; j < message.userMsg.length; ++j)
                    object.userMsg[j] = message.userMsg[j];
            }
            if (message.rpCode && message.rpCode.length) {
                object.rpCode = Array(message.rpCode.length);
                for (let j = 0; j < message.rpCode.length; ++j)
                    object.rpCode[j] = message.rpCode[j];
            }
            if (message.templateId != null && message.hasOwnProperty("templateId"))
                object.templateId = message.templateId;
            return object;
        };

        /**
         * Converts this Reject to JSON.
         * @function toJSON
         * @memberof rti.Reject
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Reject.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the type url for Reject
         * @function getTypeUrl
         * @memberof rti.Reject
         * @static
         * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
         * @returns {string} The type url
         */
        Reject.getTypeUrl = function getTypeUrl(prefix) {
            if (prefix === undefined)
                prefix = "type.googleapis.com";
            return prefix + "/rti.Reject";
        };

        return Reject;
    })();

    rti.RequestAccountList = (function() {

        /**
         * Properties of a RequestAccountList.
         * @typedef {Object} rti.RequestAccountList.$Properties
         * @property {number|null} [templateId] RequestAccountList templateId
         * @property {Array.<string>|null} [userMsg] RequestAccountList userMsg
         * @property {string|null} [fcmId] RequestAccountList fcmId
         * @property {string|null} [ibId] RequestAccountList ibId
         * @property {rti.RequestAccountList.UserType|null} [userType] RequestAccountList userType
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding
         */

        /**
         * Properties of a RequestAccountList.
         * @memberof rti
         * @interface IRequestAccountList
         * @augments rti.RequestAccountList.$Properties
         * @deprecated Use rti.RequestAccountList.$Properties instead.
         */

        /**
         * Shape of a RequestAccountList.
         * @typedef {rti.RequestAccountList.$Properties} rti.RequestAccountList.$Shape
         */

        /**
         * Constructs a new RequestAccountList.
         * @memberof rti
         * @classdesc Represents a RequestAccountList.
         * @constructor
         * @param {rti.RequestAccountList.$Properties=} [properties] Properties to set
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding
         */
        function RequestAccountList(properties) {
            this.userMsg = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null && keys[i] !== "__proto__")
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * RequestAccountList templateId.
         * @member {number} templateId
         * @memberof rti.RequestAccountList
         * @instance
         */
        RequestAccountList.prototype.templateId = 0;

        /**
         * RequestAccountList userMsg.
         * @member {Array.<string>} userMsg
         * @memberof rti.RequestAccountList
         * @instance
         */
        RequestAccountList.prototype.userMsg = $util.emptyArray;

        /**
         * RequestAccountList fcmId.
         * @member {string} fcmId
         * @memberof rti.RequestAccountList
         * @instance
         */
        RequestAccountList.prototype.fcmId = "";

        /**
         * RequestAccountList ibId.
         * @member {string} ibId
         * @memberof rti.RequestAccountList
         * @instance
         */
        RequestAccountList.prototype.ibId = "";

        /**
         * RequestAccountList userType.
         * @member {rti.RequestAccountList.UserType} userType
         * @memberof rti.RequestAccountList
         * @instance
         */
        RequestAccountList.prototype.userType = 0;

        /**
         * Creates a new RequestAccountList instance using the specified properties.
         * @function create
         * @memberof rti.RequestAccountList
         * @static
         * @param {rti.RequestAccountList.$Properties=} [properties] Properties to set
         * @returns {rti.RequestAccountList} RequestAccountList instance
         * @type {{
         *   (properties: rti.RequestAccountList.$Shape): rti.RequestAccountList & rti.RequestAccountList.$Shape;
         *   (properties?: rti.RequestAccountList.$Properties): rti.RequestAccountList;
         * }}
         */
        RequestAccountList.create = function create(properties) {
            return new RequestAccountList(properties);
        };

        /**
         * Encodes the specified RequestAccountList message. Does not implicitly {@link rti.RequestAccountList.verify|verify} messages.
         * @function encode
         * @memberof rti.RequestAccountList
         * @static
         * @param {rti.RequestAccountList.$Properties} message RequestAccountList message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RequestAccountList.encode = function encode(message, writer, _depth) {
            if (!writer)
                writer = $Writer.create();
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw Error("max depth exceeded");
            if (message.userMsg != null && message.userMsg.length)
                for (let i = 0; i < message.userMsg.length; ++i)
                    writer.uint32(/* id 132760, wireType 2 =*/1062082).string(message.userMsg[i]);
            if (message.fcmId != null && Object.hasOwnProperty.call(message, "fcmId"))
                writer.uint32(/* id 154013, wireType 2 =*/1232106).string(message.fcmId);
            if (message.ibId != null && Object.hasOwnProperty.call(message, "ibId"))
                writer.uint32(/* id 154014, wireType 2 =*/1232114).string(message.ibId);
            if (message.userType != null && Object.hasOwnProperty.call(message, "userType"))
                writer.uint32(/* id 154036, wireType 0 =*/1232288).int32(message.userType);
            if (message.templateId != null && Object.hasOwnProperty.call(message, "templateId"))
                writer.uint32(/* id 154467, wireType 0 =*/1235736).int32(message.templateId);
            if (message.$unknowns != null && Object.hasOwnProperty.call(message, "$unknowns"))
                for (let i = 0; i < message.$unknowns.length; ++i)
                    writer.raw(message.$unknowns[i]);
            return writer;
        };

        /**
         * Encodes the specified RequestAccountList message, length delimited. Does not implicitly {@link rti.RequestAccountList.verify|verify} messages.
         * @function encodeDelimited
         * @memberof rti.RequestAccountList
         * @static
         * @param {rti.RequestAccountList.$Properties} message RequestAccountList message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RequestAccountList.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer && writer.len ? writer.fork() : writer).ldelim();
        };

        /**
         * Decodes a RequestAccountList message from the specified reader or buffer.
         * @function decode
         * @memberof rti.RequestAccountList
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {rti.RequestAccountList & rti.RequestAccountList.$Shape} RequestAccountList
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RequestAccountList.decode = function decode(reader, length, _end, _depth, _target) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $Reader.recursionLimit)
                throw Error("max depth exceeded");
            let end = length === undefined ? reader.len : reader.pos + length, message = _target || new $root.rti.RequestAccountList(), value;
            while (reader.pos < end) {
                let start = reader.pos;
                let tag = reader.tag();
                if (tag === _end) {
                    _end = undefined;
                    break;
                }
                let wireType = tag & 7;
                switch (tag >>>= 3) {
                case 154467: {
                        if (wireType !== 0)
                            break;
                        if (value = reader.int32())
                            message.templateId = value;
                        else
                            delete message.templateId;
                        continue;
                    }
                case 132760: {
                        if (wireType !== 2)
                            break;
                        if (!(message.userMsg && message.userMsg.length))
                            message.userMsg = [];
                        message.userMsg.push(reader.string());
                        continue;
                    }
                case 154013: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.string()).length)
                            message.fcmId = value;
                        else
                            delete message.fcmId;
                        continue;
                    }
                case 154014: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.string()).length)
                            message.ibId = value;
                        else
                            delete message.ibId;
                        continue;
                    }
                case 154036: {
                        if (wireType !== 0)
                            break;
                        if (value = reader.int32())
                            message.userType = value;
                        else
                            delete message.userType;
                        continue;
                    }
                }
                reader.skipType(wireType, _depth, tag);
                if (!reader.discardUnknown) {
                    $util.makeProp(message, "$unknowns", false);
                    (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
                }
            }
            if (_end !== undefined)
                throw Error("missing end group");
            return message;
        };

        /**
         * Decodes a RequestAccountList message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof rti.RequestAccountList
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {rti.RequestAccountList & rti.RequestAccountList.$Shape} RequestAccountList
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RequestAccountList.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a RequestAccountList message.
         * @function verify
         * @memberof rti.RequestAccountList
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        RequestAccountList.verify = function verify(message, _depth) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                return "max depth exceeded";
            if (message.templateId != null && message.hasOwnProperty("templateId"))
                if (!$util.isInteger(message.templateId))
                    return "templateId: integer expected";
            if (message.userMsg != null && message.hasOwnProperty("userMsg")) {
                if (!Array.isArray(message.userMsg))
                    return "userMsg: array expected";
                for (let i = 0; i < message.userMsg.length; ++i)
                    if (!$util.isString(message.userMsg[i]))
                        return "userMsg: string[] expected";
            }
            if (message.fcmId != null && message.hasOwnProperty("fcmId"))
                if (!$util.isString(message.fcmId))
                    return "fcmId: string expected";
            if (message.ibId != null && message.hasOwnProperty("ibId"))
                if (!$util.isString(message.ibId))
                    return "ibId: string expected";
            if (message.userType != null && message.hasOwnProperty("userType"))
                switch (message.userType) {
                default:
                    return "userType: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                    break;
                }
            return null;
        };

        /**
         * Creates a RequestAccountList message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof rti.RequestAccountList
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {rti.RequestAccountList} RequestAccountList
         */
        RequestAccountList.fromObject = function fromObject(object, _depth) {
            if (object instanceof $root.rti.RequestAccountList)
                return object;
            if (!$util.isObject(object))
                throw TypeError(".rti.RequestAccountList: object expected");
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw Error("max depth exceeded");
            let message = new $root.rti.RequestAccountList();
            if (object.templateId != null)
                if (Number(object.templateId) !== 0)
                    message.templateId = object.templateId | 0;
            if (object.userMsg) {
                if (!Array.isArray(object.userMsg))
                    throw TypeError(".rti.RequestAccountList.userMsg: array expected");
                message.userMsg = Array(object.userMsg.length);
                for (let i = 0; i < object.userMsg.length; ++i)
                    message.userMsg[i] = String(object.userMsg[i]);
            }
            if (object.fcmId != null)
                if (typeof object.fcmId !== "string" || object.fcmId.length)
                    message.fcmId = String(object.fcmId);
            if (object.ibId != null)
                if (typeof object.ibId !== "string" || object.ibId.length)
                    message.ibId = String(object.ibId);
            if (object.userType !== 0 && (typeof object.userType !== "string" || $root.rti.RequestAccountList.UserType[object.userType] !== 0))
                switch (object.userType) {
                default:
                    if (typeof object.userType === "number") {
                        message.userType = object.userType;
                        break;
                    }
                    break;
                case "USERTYPE_UNSPECIFIED":
                case 0:
                    message.userType = 0;
                    break;
                case "USER_TYPE_FCM":
                case 1:
                    message.userType = 1;
                    break;
                case "USER_TYPE_IB":
                case 2:
                    message.userType = 2;
                    break;
                case "USER_TYPE_TRADER":
                case 3:
                    message.userType = 3;
                    break;
                }
            return message;
        };

        /**
         * Creates a plain object from a RequestAccountList message. Also converts values to other types if specified.
         * @function toObject
         * @memberof rti.RequestAccountList
         * @static
         * @param {rti.RequestAccountList} message RequestAccountList
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RequestAccountList.toObject = function toObject(message, options, _depth) {
            if (!options)
                options = {};
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw Error("max depth exceeded");
            let object = {};
            if (options.arrays || options.defaults)
                object.userMsg = [];
            if (options.defaults) {
                object.fcmId = "";
                object.ibId = "";
                object.userType = options.enums === String ? "USERTYPE_UNSPECIFIED" : 0;
                object.templateId = 0;
            }
            if (message.userMsg && message.userMsg.length) {
                object.userMsg = Array(message.userMsg.length);
                for (let j = 0; j < message.userMsg.length; ++j)
                    object.userMsg[j] = message.userMsg[j];
            }
            if (message.fcmId != null && message.hasOwnProperty("fcmId"))
                object.fcmId = message.fcmId;
            if (message.ibId != null && message.hasOwnProperty("ibId"))
                object.ibId = message.ibId;
            if (message.userType != null && message.hasOwnProperty("userType"))
                object.userType = options.enums === String ? $root.rti.RequestAccountList.UserType[message.userType] === undefined ? message.userType : $root.rti.RequestAccountList.UserType[message.userType] : message.userType;
            if (message.templateId != null && message.hasOwnProperty("templateId"))
                object.templateId = message.templateId;
            return object;
        };

        /**
         * Converts this RequestAccountList to JSON.
         * @function toJSON
         * @memberof rti.RequestAccountList
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RequestAccountList.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the type url for RequestAccountList
         * @function getTypeUrl
         * @memberof rti.RequestAccountList
         * @static
         * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
         * @returns {string} The type url
         */
        RequestAccountList.getTypeUrl = function getTypeUrl(prefix) {
            if (prefix === undefined)
                prefix = "type.googleapis.com";
            return prefix + "/rti.RequestAccountList";
        };

        /**
         * UserType enum.
         * @name rti.RequestAccountList.UserType
         * @enum {number}
         * @property {number} USERTYPE_UNSPECIFIED=0 USERTYPE_UNSPECIFIED value
         * @property {number} USER_TYPE_FCM=1 USER_TYPE_FCM value
         * @property {number} USER_TYPE_IB=2 USER_TYPE_IB value
         * @property {number} USER_TYPE_TRADER=3 USER_TYPE_TRADER value
         */
        RequestAccountList.UserType = (function() {
            const valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "USERTYPE_UNSPECIFIED"] = 0;
            values[valuesById[1] = "USER_TYPE_FCM"] = 1;
            values[valuesById[2] = "USER_TYPE_IB"] = 2;
            values[valuesById[3] = "USER_TYPE_TRADER"] = 3;
            return values;
        })();

        return RequestAccountList;
    })();

    rti.RequestHeartbeat = (function() {

        /**
         * Properties of a RequestHeartbeat.
         * @typedef {Object} rti.RequestHeartbeat.$Properties
         * @property {number|null} [templateId] RequestHeartbeat templateId
         * @property {Array.<string>|null} [userMsg] RequestHeartbeat userMsg
         * @property {number|null} [ssboe] RequestHeartbeat ssboe
         * @property {number|null} [usecs] RequestHeartbeat usecs
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding
         */

        /**
         * Properties of a RequestHeartbeat.
         * @memberof rti
         * @interface IRequestHeartbeat
         * @augments rti.RequestHeartbeat.$Properties
         * @deprecated Use rti.RequestHeartbeat.$Properties instead.
         */

        /**
         * Shape of a RequestHeartbeat.
         * @typedef {rti.RequestHeartbeat.$Properties} rti.RequestHeartbeat.$Shape
         */

        /**
         * Constructs a new RequestHeartbeat.
         * @memberof rti
         * @classdesc Represents a RequestHeartbeat.
         * @constructor
         * @param {rti.RequestHeartbeat.$Properties=} [properties] Properties to set
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding
         */
        function RequestHeartbeat(properties) {
            this.userMsg = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null && keys[i] !== "__proto__")
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * RequestHeartbeat templateId.
         * @member {number} templateId
         * @memberof rti.RequestHeartbeat
         * @instance
         */
        RequestHeartbeat.prototype.templateId = 0;

        /**
         * RequestHeartbeat userMsg.
         * @member {Array.<string>} userMsg
         * @memberof rti.RequestHeartbeat
         * @instance
         */
        RequestHeartbeat.prototype.userMsg = $util.emptyArray;

        /**
         * RequestHeartbeat ssboe.
         * @member {number} ssboe
         * @memberof rti.RequestHeartbeat
         * @instance
         */
        RequestHeartbeat.prototype.ssboe = 0;

        /**
         * RequestHeartbeat usecs.
         * @member {number} usecs
         * @memberof rti.RequestHeartbeat
         * @instance
         */
        RequestHeartbeat.prototype.usecs = 0;

        /**
         * Creates a new RequestHeartbeat instance using the specified properties.
         * @function create
         * @memberof rti.RequestHeartbeat
         * @static
         * @param {rti.RequestHeartbeat.$Properties=} [properties] Properties to set
         * @returns {rti.RequestHeartbeat} RequestHeartbeat instance
         * @type {{
         *   (properties: rti.RequestHeartbeat.$Shape): rti.RequestHeartbeat & rti.RequestHeartbeat.$Shape;
         *   (properties?: rti.RequestHeartbeat.$Properties): rti.RequestHeartbeat;
         * }}
         */
        RequestHeartbeat.create = function create(properties) {
            return new RequestHeartbeat(properties);
        };

        /**
         * Encodes the specified RequestHeartbeat message. Does not implicitly {@link rti.RequestHeartbeat.verify|verify} messages.
         * @function encode
         * @memberof rti.RequestHeartbeat
         * @static
         * @param {rti.RequestHeartbeat.$Properties} message RequestHeartbeat message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RequestHeartbeat.encode = function encode(message, writer, _depth) {
            if (!writer)
                writer = $Writer.create();
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw Error("max depth exceeded");
            if (message.userMsg != null && message.userMsg.length)
                for (let i = 0; i < message.userMsg.length; ++i)
                    writer.uint32(/* id 132760, wireType 2 =*/1062082).string(message.userMsg[i]);
            if (message.ssboe != null && Object.hasOwnProperty.call(message, "ssboe"))
                writer.uint32(/* id 150100, wireType 0 =*/1200800).int32(message.ssboe);
            if (message.usecs != null && Object.hasOwnProperty.call(message, "usecs"))
                writer.uint32(/* id 150101, wireType 0 =*/1200808).int32(message.usecs);
            if (message.templateId != null && Object.hasOwnProperty.call(message, "templateId"))
                writer.uint32(/* id 154467, wireType 0 =*/1235736).int32(message.templateId);
            if (message.$unknowns != null && Object.hasOwnProperty.call(message, "$unknowns"))
                for (let i = 0; i < message.$unknowns.length; ++i)
                    writer.raw(message.$unknowns[i]);
            return writer;
        };

        /**
         * Encodes the specified RequestHeartbeat message, length delimited. Does not implicitly {@link rti.RequestHeartbeat.verify|verify} messages.
         * @function encodeDelimited
         * @memberof rti.RequestHeartbeat
         * @static
         * @param {rti.RequestHeartbeat.$Properties} message RequestHeartbeat message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RequestHeartbeat.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer && writer.len ? writer.fork() : writer).ldelim();
        };

        /**
         * Decodes a RequestHeartbeat message from the specified reader or buffer.
         * @function decode
         * @memberof rti.RequestHeartbeat
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {rti.RequestHeartbeat & rti.RequestHeartbeat.$Shape} RequestHeartbeat
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RequestHeartbeat.decode = function decode(reader, length, _end, _depth, _target) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $Reader.recursionLimit)
                throw Error("max depth exceeded");
            let end = length === undefined ? reader.len : reader.pos + length, message = _target || new $root.rti.RequestHeartbeat(), value;
            while (reader.pos < end) {
                let start = reader.pos;
                let tag = reader.tag();
                if (tag === _end) {
                    _end = undefined;
                    break;
                }
                let wireType = tag & 7;
                switch (tag >>>= 3) {
                case 154467: {
                        if (wireType !== 0)
                            break;
                        if (value = reader.int32())
                            message.templateId = value;
                        else
                            delete message.templateId;
                        continue;
                    }
                case 132760: {
                        if (wireType !== 2)
                            break;
                        if (!(message.userMsg && message.userMsg.length))
                            message.userMsg = [];
                        message.userMsg.push(reader.string());
                        continue;
                    }
                case 150100: {
                        if (wireType !== 0)
                            break;
                        if (value = reader.int32())
                            message.ssboe = value;
                        else
                            delete message.ssboe;
                        continue;
                    }
                case 150101: {
                        if (wireType !== 0)
                            break;
                        if (value = reader.int32())
                            message.usecs = value;
                        else
                            delete message.usecs;
                        continue;
                    }
                }
                reader.skipType(wireType, _depth, tag);
                if (!reader.discardUnknown) {
                    $util.makeProp(message, "$unknowns", false);
                    (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
                }
            }
            if (_end !== undefined)
                throw Error("missing end group");
            return message;
        };

        /**
         * Decodes a RequestHeartbeat message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof rti.RequestHeartbeat
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {rti.RequestHeartbeat & rti.RequestHeartbeat.$Shape} RequestHeartbeat
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RequestHeartbeat.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a RequestHeartbeat message.
         * @function verify
         * @memberof rti.RequestHeartbeat
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        RequestHeartbeat.verify = function verify(message, _depth) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                return "max depth exceeded";
            if (message.templateId != null && message.hasOwnProperty("templateId"))
                if (!$util.isInteger(message.templateId))
                    return "templateId: integer expected";
            if (message.userMsg != null && message.hasOwnProperty("userMsg")) {
                if (!Array.isArray(message.userMsg))
                    return "userMsg: array expected";
                for (let i = 0; i < message.userMsg.length; ++i)
                    if (!$util.isString(message.userMsg[i]))
                        return "userMsg: string[] expected";
            }
            if (message.ssboe != null && message.hasOwnProperty("ssboe"))
                if (!$util.isInteger(message.ssboe))
                    return "ssboe: integer expected";
            if (message.usecs != null && message.hasOwnProperty("usecs"))
                if (!$util.isInteger(message.usecs))
                    return "usecs: integer expected";
            return null;
        };

        /**
         * Creates a RequestHeartbeat message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof rti.RequestHeartbeat
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {rti.RequestHeartbeat} RequestHeartbeat
         */
        RequestHeartbeat.fromObject = function fromObject(object, _depth) {
            if (object instanceof $root.rti.RequestHeartbeat)
                return object;
            if (!$util.isObject(object))
                throw TypeError(".rti.RequestHeartbeat: object expected");
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw Error("max depth exceeded");
            let message = new $root.rti.RequestHeartbeat();
            if (object.templateId != null)
                if (Number(object.templateId) !== 0)
                    message.templateId = object.templateId | 0;
            if (object.userMsg) {
                if (!Array.isArray(object.userMsg))
                    throw TypeError(".rti.RequestHeartbeat.userMsg: array expected");
                message.userMsg = Array(object.userMsg.length);
                for (let i = 0; i < object.userMsg.length; ++i)
                    message.userMsg[i] = String(object.userMsg[i]);
            }
            if (object.ssboe != null)
                if (Number(object.ssboe) !== 0)
                    message.ssboe = object.ssboe | 0;
            if (object.usecs != null)
                if (Number(object.usecs) !== 0)
                    message.usecs = object.usecs | 0;
            return message;
        };

        /**
         * Creates a plain object from a RequestHeartbeat message. Also converts values to other types if specified.
         * @function toObject
         * @memberof rti.RequestHeartbeat
         * @static
         * @param {rti.RequestHeartbeat} message RequestHeartbeat
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RequestHeartbeat.toObject = function toObject(message, options, _depth) {
            if (!options)
                options = {};
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw Error("max depth exceeded");
            let object = {};
            if (options.arrays || options.defaults)
                object.userMsg = [];
            if (options.defaults) {
                object.ssboe = 0;
                object.usecs = 0;
                object.templateId = 0;
            }
            if (message.userMsg && message.userMsg.length) {
                object.userMsg = Array(message.userMsg.length);
                for (let j = 0; j < message.userMsg.length; ++j)
                    object.userMsg[j] = message.userMsg[j];
            }
            if (message.ssboe != null && message.hasOwnProperty("ssboe"))
                object.ssboe = message.ssboe;
            if (message.usecs != null && message.hasOwnProperty("usecs"))
                object.usecs = message.usecs;
            if (message.templateId != null && message.hasOwnProperty("templateId"))
                object.templateId = message.templateId;
            return object;
        };

        /**
         * Converts this RequestHeartbeat to JSON.
         * @function toJSON
         * @memberof rti.RequestHeartbeat
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RequestHeartbeat.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the type url for RequestHeartbeat
         * @function getTypeUrl
         * @memberof rti.RequestHeartbeat
         * @static
         * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
         * @returns {string} The type url
         */
        RequestHeartbeat.getTypeUrl = function getTypeUrl(prefix) {
            if (prefix === undefined)
                prefix = "type.googleapis.com";
            return prefix + "/rti.RequestHeartbeat";
        };

        return RequestHeartbeat;
    })();

    rti.RequestLogin = (function() {

        /**
         * Properties of a RequestLogin.
         * @typedef {Object} rti.RequestLogin.$Properties
         * @property {number|null} [templateId] RequestLogin templateId
         * @property {string|null} [templateVersion] RequestLogin templateVersion
         * @property {Array.<string>|null} [userMsg] RequestLogin userMsg
         * @property {string|null} [user] RequestLogin user
         * @property {string|null} [password] RequestLogin password
         * @property {string|null} [appName] RequestLogin appName
         * @property {string|null} [appVersion] RequestLogin appVersion
         * @property {string|null} [systemName] RequestLogin systemName
         * @property {rti.RequestLogin.SysInfraType|null} [infraType] RequestLogin infraType
         * @property {Array.<string>|null} [macAddr] RequestLogin macAddr
         * @property {string|null} [osVersion] RequestLogin osVersion
         * @property {string|null} [osPlatform] RequestLogin osPlatform
         * @property {boolean|null} [aggregatedQuotes] RequestLogin aggregatedQuotes
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding
         */

        /**
         * Properties of a RequestLogin.
         * @memberof rti
         * @interface IRequestLogin
         * @augments rti.RequestLogin.$Properties
         * @deprecated Use rti.RequestLogin.$Properties instead.
         */

        /**
         * Shape of a RequestLogin.
         * @typedef {rti.RequestLogin.$Properties} rti.RequestLogin.$Shape
         */

        /**
         * Constructs a new RequestLogin.
         * @memberof rti
         * @classdesc Represents a RequestLogin.
         * @constructor
         * @param {rti.RequestLogin.$Properties=} [properties] Properties to set
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding
         */
        function RequestLogin(properties) {
            this.userMsg = [];
            this.macAddr = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null && keys[i] !== "__proto__")
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * RequestLogin templateId.
         * @member {number} templateId
         * @memberof rti.RequestLogin
         * @instance
         */
        RequestLogin.prototype.templateId = 0;

        /**
         * RequestLogin templateVersion.
         * @member {string} templateVersion
         * @memberof rti.RequestLogin
         * @instance
         */
        RequestLogin.prototype.templateVersion = "";

        /**
         * RequestLogin userMsg.
         * @member {Array.<string>} userMsg
         * @memberof rti.RequestLogin
         * @instance
         */
        RequestLogin.prototype.userMsg = $util.emptyArray;

        /**
         * RequestLogin user.
         * @member {string} user
         * @memberof rti.RequestLogin
         * @instance
         */
        RequestLogin.prototype.user = "";

        /**
         * RequestLogin password.
         * @member {string} password
         * @memberof rti.RequestLogin
         * @instance
         */
        RequestLogin.prototype.password = "";

        /**
         * RequestLogin appName.
         * @member {string} appName
         * @memberof rti.RequestLogin
         * @instance
         */
        RequestLogin.prototype.appName = "";

        /**
         * RequestLogin appVersion.
         * @member {string} appVersion
         * @memberof rti.RequestLogin
         * @instance
         */
        RequestLogin.prototype.appVersion = "";

        /**
         * RequestLogin systemName.
         * @member {string} systemName
         * @memberof rti.RequestLogin
         * @instance
         */
        RequestLogin.prototype.systemName = "";

        /**
         * RequestLogin infraType.
         * @member {rti.RequestLogin.SysInfraType} infraType
         * @memberof rti.RequestLogin
         * @instance
         */
        RequestLogin.prototype.infraType = 0;

        /**
         * RequestLogin macAddr.
         * @member {Array.<string>} macAddr
         * @memberof rti.RequestLogin
         * @instance
         */
        RequestLogin.prototype.macAddr = $util.emptyArray;

        /**
         * RequestLogin osVersion.
         * @member {string} osVersion
         * @memberof rti.RequestLogin
         * @instance
         */
        RequestLogin.prototype.osVersion = "";

        /**
         * RequestLogin osPlatform.
         * @member {string} osPlatform
         * @memberof rti.RequestLogin
         * @instance
         */
        RequestLogin.prototype.osPlatform = "";

        /**
         * RequestLogin aggregatedQuotes.
         * @member {boolean} aggregatedQuotes
         * @memberof rti.RequestLogin
         * @instance
         */
        RequestLogin.prototype.aggregatedQuotes = false;

        /**
         * Creates a new RequestLogin instance using the specified properties.
         * @function create
         * @memberof rti.RequestLogin
         * @static
         * @param {rti.RequestLogin.$Properties=} [properties] Properties to set
         * @returns {rti.RequestLogin} RequestLogin instance
         * @type {{
         *   (properties: rti.RequestLogin.$Shape): rti.RequestLogin & rti.RequestLogin.$Shape;
         *   (properties?: rti.RequestLogin.$Properties): rti.RequestLogin;
         * }}
         */
        RequestLogin.create = function create(properties) {
            return new RequestLogin(properties);
        };

        /**
         * Encodes the specified RequestLogin message. Does not implicitly {@link rti.RequestLogin.verify|verify} messages.
         * @function encode
         * @memberof rti.RequestLogin
         * @static
         * @param {rti.RequestLogin.$Properties} message RequestLogin message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RequestLogin.encode = function encode(message, writer, _depth) {
            if (!writer)
                writer = $Writer.create();
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw Error("max depth exceeded");
            if (message.appName != null && Object.hasOwnProperty.call(message, "appName"))
                writer.uint32(/* id 130002, wireType 2 =*/1040018).string(message.appName);
            if (message.password != null && Object.hasOwnProperty.call(message, "password"))
                writer.uint32(/* id 130004, wireType 2 =*/1040034).string(message.password);
            if (message.user != null && Object.hasOwnProperty.call(message, "user"))
                writer.uint32(/* id 131003, wireType 2 =*/1048026).string(message.user);
            if (message.appVersion != null && Object.hasOwnProperty.call(message, "appVersion"))
                writer.uint32(/* id 131803, wireType 2 =*/1054426).string(message.appVersion);
            if (message.userMsg != null && message.userMsg.length)
                for (let i = 0; i < message.userMsg.length; ++i)
                    writer.uint32(/* id 132760, wireType 2 =*/1062082).string(message.userMsg[i]);
            if (message.osPlatform != null && Object.hasOwnProperty.call(message, "osPlatform"))
                writer.uint32(/* id 144020, wireType 2 =*/1152162).string(message.osPlatform);
            if (message.osVersion != null && Object.hasOwnProperty.call(message, "osVersion"))
                writer.uint32(/* id 144021, wireType 2 =*/1152170).string(message.osVersion);
            if (message.macAddr != null && message.macAddr.length)
                for (let i = 0; i < message.macAddr.length; ++i)
                    writer.uint32(/* id 144108, wireType 2 =*/1152866).string(message.macAddr[i]);
            if (message.infraType != null && Object.hasOwnProperty.call(message, "infraType"))
                writer.uint32(/* id 153621, wireType 0 =*/1228968).int32(message.infraType);
            if (message.systemName != null && Object.hasOwnProperty.call(message, "systemName"))
                writer.uint32(/* id 153628, wireType 2 =*/1229026).string(message.systemName);
            if (message.templateVersion != null && Object.hasOwnProperty.call(message, "templateVersion"))
                writer.uint32(/* id 153634, wireType 2 =*/1229074).string(message.templateVersion);
            if (message.aggregatedQuotes != null && Object.hasOwnProperty.call(message, "aggregatedQuotes"))
                writer.uint32(/* id 153644, wireType 0 =*/1229152).bool(message.aggregatedQuotes);
            if (message.templateId != null && Object.hasOwnProperty.call(message, "templateId"))
                writer.uint32(/* id 154467, wireType 0 =*/1235736).int32(message.templateId);
            if (message.$unknowns != null && Object.hasOwnProperty.call(message, "$unknowns"))
                for (let i = 0; i < message.$unknowns.length; ++i)
                    writer.raw(message.$unknowns[i]);
            return writer;
        };

        /**
         * Encodes the specified RequestLogin message, length delimited. Does not implicitly {@link rti.RequestLogin.verify|verify} messages.
         * @function encodeDelimited
         * @memberof rti.RequestLogin
         * @static
         * @param {rti.RequestLogin.$Properties} message RequestLogin message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RequestLogin.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer && writer.len ? writer.fork() : writer).ldelim();
        };

        /**
         * Decodes a RequestLogin message from the specified reader or buffer.
         * @function decode
         * @memberof rti.RequestLogin
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {rti.RequestLogin & rti.RequestLogin.$Shape} RequestLogin
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RequestLogin.decode = function decode(reader, length, _end, _depth, _target) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $Reader.recursionLimit)
                throw Error("max depth exceeded");
            let end = length === undefined ? reader.len : reader.pos + length, message = _target || new $root.rti.RequestLogin(), value;
            while (reader.pos < end) {
                let start = reader.pos;
                let tag = reader.tag();
                if (tag === _end) {
                    _end = undefined;
                    break;
                }
                let wireType = tag & 7;
                switch (tag >>>= 3) {
                case 154467: {
                        if (wireType !== 0)
                            break;
                        if (value = reader.int32())
                            message.templateId = value;
                        else
                            delete message.templateId;
                        continue;
                    }
                case 153634: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.string()).length)
                            message.templateVersion = value;
                        else
                            delete message.templateVersion;
                        continue;
                    }
                case 132760: {
                        if (wireType !== 2)
                            break;
                        if (!(message.userMsg && message.userMsg.length))
                            message.userMsg = [];
                        message.userMsg.push(reader.string());
                        continue;
                    }
                case 131003: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.string()).length)
                            message.user = value;
                        else
                            delete message.user;
                        continue;
                    }
                case 130004: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.string()).length)
                            message.password = value;
                        else
                            delete message.password;
                        continue;
                    }
                case 130002: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.string()).length)
                            message.appName = value;
                        else
                            delete message.appName;
                        continue;
                    }
                case 131803: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.string()).length)
                            message.appVersion = value;
                        else
                            delete message.appVersion;
                        continue;
                    }
                case 153628: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.string()).length)
                            message.systemName = value;
                        else
                            delete message.systemName;
                        continue;
                    }
                case 153621: {
                        if (wireType !== 0)
                            break;
                        if (value = reader.int32())
                            message.infraType = value;
                        else
                            delete message.infraType;
                        continue;
                    }
                case 144108: {
                        if (wireType !== 2)
                            break;
                        if (!(message.macAddr && message.macAddr.length))
                            message.macAddr = [];
                        message.macAddr.push(reader.string());
                        continue;
                    }
                case 144021: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.string()).length)
                            message.osVersion = value;
                        else
                            delete message.osVersion;
                        continue;
                    }
                case 144020: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.string()).length)
                            message.osPlatform = value;
                        else
                            delete message.osPlatform;
                        continue;
                    }
                case 153644: {
                        if (wireType !== 0)
                            break;
                        if (value = reader.bool())
                            message.aggregatedQuotes = value;
                        else
                            delete message.aggregatedQuotes;
                        continue;
                    }
                }
                reader.skipType(wireType, _depth, tag);
                if (!reader.discardUnknown) {
                    $util.makeProp(message, "$unknowns", false);
                    (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
                }
            }
            if (_end !== undefined)
                throw Error("missing end group");
            return message;
        };

        /**
         * Decodes a RequestLogin message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof rti.RequestLogin
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {rti.RequestLogin & rti.RequestLogin.$Shape} RequestLogin
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RequestLogin.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a RequestLogin message.
         * @function verify
         * @memberof rti.RequestLogin
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        RequestLogin.verify = function verify(message, _depth) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                return "max depth exceeded";
            if (message.templateId != null && message.hasOwnProperty("templateId"))
                if (!$util.isInteger(message.templateId))
                    return "templateId: integer expected";
            if (message.templateVersion != null && message.hasOwnProperty("templateVersion"))
                if (!$util.isString(message.templateVersion))
                    return "templateVersion: string expected";
            if (message.userMsg != null && message.hasOwnProperty("userMsg")) {
                if (!Array.isArray(message.userMsg))
                    return "userMsg: array expected";
                for (let i = 0; i < message.userMsg.length; ++i)
                    if (!$util.isString(message.userMsg[i]))
                        return "userMsg: string[] expected";
            }
            if (message.user != null && message.hasOwnProperty("user"))
                if (!$util.isString(message.user))
                    return "user: string expected";
            if (message.password != null && message.hasOwnProperty("password"))
                if (!$util.isString(message.password))
                    return "password: string expected";
            if (message.appName != null && message.hasOwnProperty("appName"))
                if (!$util.isString(message.appName))
                    return "appName: string expected";
            if (message.appVersion != null && message.hasOwnProperty("appVersion"))
                if (!$util.isString(message.appVersion))
                    return "appVersion: string expected";
            if (message.systemName != null && message.hasOwnProperty("systemName"))
                if (!$util.isString(message.systemName))
                    return "systemName: string expected";
            if (message.infraType != null && message.hasOwnProperty("infraType"))
                switch (message.infraType) {
                default:
                    return "infraType: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                    break;
                }
            if (message.macAddr != null && message.hasOwnProperty("macAddr")) {
                if (!Array.isArray(message.macAddr))
                    return "macAddr: array expected";
                for (let i = 0; i < message.macAddr.length; ++i)
                    if (!$util.isString(message.macAddr[i]))
                        return "macAddr: string[] expected";
            }
            if (message.osVersion != null && message.hasOwnProperty("osVersion"))
                if (!$util.isString(message.osVersion))
                    return "osVersion: string expected";
            if (message.osPlatform != null && message.hasOwnProperty("osPlatform"))
                if (!$util.isString(message.osPlatform))
                    return "osPlatform: string expected";
            if (message.aggregatedQuotes != null && message.hasOwnProperty("aggregatedQuotes"))
                if (typeof message.aggregatedQuotes !== "boolean")
                    return "aggregatedQuotes: boolean expected";
            return null;
        };

        /**
         * Creates a RequestLogin message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof rti.RequestLogin
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {rti.RequestLogin} RequestLogin
         */
        RequestLogin.fromObject = function fromObject(object, _depth) {
            if (object instanceof $root.rti.RequestLogin)
                return object;
            if (!$util.isObject(object))
                throw TypeError(".rti.RequestLogin: object expected");
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw Error("max depth exceeded");
            let message = new $root.rti.RequestLogin();
            if (object.templateId != null)
                if (Number(object.templateId) !== 0)
                    message.templateId = object.templateId | 0;
            if (object.templateVersion != null)
                if (typeof object.templateVersion !== "string" || object.templateVersion.length)
                    message.templateVersion = String(object.templateVersion);
            if (object.userMsg) {
                if (!Array.isArray(object.userMsg))
                    throw TypeError(".rti.RequestLogin.userMsg: array expected");
                message.userMsg = Array(object.userMsg.length);
                for (let i = 0; i < object.userMsg.length; ++i)
                    message.userMsg[i] = String(object.userMsg[i]);
            }
            if (object.user != null)
                if (typeof object.user !== "string" || object.user.length)
                    message.user = String(object.user);
            if (object.password != null)
                if (typeof object.password !== "string" || object.password.length)
                    message.password = String(object.password);
            if (object.appName != null)
                if (typeof object.appName !== "string" || object.appName.length)
                    message.appName = String(object.appName);
            if (object.appVersion != null)
                if (typeof object.appVersion !== "string" || object.appVersion.length)
                    message.appVersion = String(object.appVersion);
            if (object.systemName != null)
                if (typeof object.systemName !== "string" || object.systemName.length)
                    message.systemName = String(object.systemName);
            if (object.infraType !== 0 && (typeof object.infraType !== "string" || $root.rti.RequestLogin.SysInfraType[object.infraType] !== 0))
                switch (object.infraType) {
                default:
                    if (typeof object.infraType === "number") {
                        message.infraType = object.infraType;
                        break;
                    }
                    break;
                case "SYSINFRATYPE_UNSPECIFIED":
                case 0:
                    message.infraType = 0;
                    break;
                case "TICKER_PLANT":
                case 1:
                    message.infraType = 1;
                    break;
                case "ORDER_PLANT":
                case 2:
                    message.infraType = 2;
                    break;
                case "HISTORY_PLANT":
                case 3:
                    message.infraType = 3;
                    break;
                case "PNL_PLANT":
                case 4:
                    message.infraType = 4;
                    break;
                case "REPOSITORY_PLANT":
                case 5:
                    message.infraType = 5;
                    break;
                }
            if (object.macAddr) {
                if (!Array.isArray(object.macAddr))
                    throw TypeError(".rti.RequestLogin.macAddr: array expected");
                message.macAddr = Array(object.macAddr.length);
                for (let i = 0; i < object.macAddr.length; ++i)
                    message.macAddr[i] = String(object.macAddr[i]);
            }
            if (object.osVersion != null)
                if (typeof object.osVersion !== "string" || object.osVersion.length)
                    message.osVersion = String(object.osVersion);
            if (object.osPlatform != null)
                if (typeof object.osPlatform !== "string" || object.osPlatform.length)
                    message.osPlatform = String(object.osPlatform);
            if (object.aggregatedQuotes != null)
                if (object.aggregatedQuotes)
                    message.aggregatedQuotes = Boolean(object.aggregatedQuotes);
            return message;
        };

        /**
         * Creates a plain object from a RequestLogin message. Also converts values to other types if specified.
         * @function toObject
         * @memberof rti.RequestLogin
         * @static
         * @param {rti.RequestLogin} message RequestLogin
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RequestLogin.toObject = function toObject(message, options, _depth) {
            if (!options)
                options = {};
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw Error("max depth exceeded");
            let object = {};
            if (options.arrays || options.defaults) {
                object.userMsg = [];
                object.macAddr = [];
            }
            if (options.defaults) {
                object.appName = "";
                object.password = "";
                object.user = "";
                object.appVersion = "";
                object.osPlatform = "";
                object.osVersion = "";
                object.infraType = options.enums === String ? "SYSINFRATYPE_UNSPECIFIED" : 0;
                object.systemName = "";
                object.templateVersion = "";
                object.aggregatedQuotes = false;
                object.templateId = 0;
            }
            if (message.appName != null && message.hasOwnProperty("appName"))
                object.appName = message.appName;
            if (message.password != null && message.hasOwnProperty("password"))
                object.password = message.password;
            if (message.user != null && message.hasOwnProperty("user"))
                object.user = message.user;
            if (message.appVersion != null && message.hasOwnProperty("appVersion"))
                object.appVersion = message.appVersion;
            if (message.userMsg && message.userMsg.length) {
                object.userMsg = Array(message.userMsg.length);
                for (let j = 0; j < message.userMsg.length; ++j)
                    object.userMsg[j] = message.userMsg[j];
            }
            if (message.osPlatform != null && message.hasOwnProperty("osPlatform"))
                object.osPlatform = message.osPlatform;
            if (message.osVersion != null && message.hasOwnProperty("osVersion"))
                object.osVersion = message.osVersion;
            if (message.macAddr && message.macAddr.length) {
                object.macAddr = Array(message.macAddr.length);
                for (let j = 0; j < message.macAddr.length; ++j)
                    object.macAddr[j] = message.macAddr[j];
            }
            if (message.infraType != null && message.hasOwnProperty("infraType"))
                object.infraType = options.enums === String ? $root.rti.RequestLogin.SysInfraType[message.infraType] === undefined ? message.infraType : $root.rti.RequestLogin.SysInfraType[message.infraType] : message.infraType;
            if (message.systemName != null && message.hasOwnProperty("systemName"))
                object.systemName = message.systemName;
            if (message.templateVersion != null && message.hasOwnProperty("templateVersion"))
                object.templateVersion = message.templateVersion;
            if (message.aggregatedQuotes != null && message.hasOwnProperty("aggregatedQuotes"))
                object.aggregatedQuotes = message.aggregatedQuotes;
            if (message.templateId != null && message.hasOwnProperty("templateId"))
                object.templateId = message.templateId;
            return object;
        };

        /**
         * Converts this RequestLogin to JSON.
         * @function toJSON
         * @memberof rti.RequestLogin
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RequestLogin.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the type url for RequestLogin
         * @function getTypeUrl
         * @memberof rti.RequestLogin
         * @static
         * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
         * @returns {string} The type url
         */
        RequestLogin.getTypeUrl = function getTypeUrl(prefix) {
            if (prefix === undefined)
                prefix = "type.googleapis.com";
            return prefix + "/rti.RequestLogin";
        };

        /**
         * SysInfraType enum.
         * @name rti.RequestLogin.SysInfraType
         * @enum {number}
         * @property {number} SYSINFRATYPE_UNSPECIFIED=0 SYSINFRATYPE_UNSPECIFIED value
         * @property {number} TICKER_PLANT=1 TICKER_PLANT value
         * @property {number} ORDER_PLANT=2 ORDER_PLANT value
         * @property {number} HISTORY_PLANT=3 HISTORY_PLANT value
         * @property {number} PNL_PLANT=4 PNL_PLANT value
         * @property {number} REPOSITORY_PLANT=5 REPOSITORY_PLANT value
         */
        RequestLogin.SysInfraType = (function() {
            const valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "SYSINFRATYPE_UNSPECIFIED"] = 0;
            values[valuesById[1] = "TICKER_PLANT"] = 1;
            values[valuesById[2] = "ORDER_PLANT"] = 2;
            values[valuesById[3] = "HISTORY_PLANT"] = 3;
            values[valuesById[4] = "PNL_PLANT"] = 4;
            values[valuesById[5] = "REPOSITORY_PLANT"] = 5;
            return values;
        })();

        return RequestLogin;
    })();

    rti.RequestLogout = (function() {

        /**
         * Properties of a RequestLogout.
         * @typedef {Object} rti.RequestLogout.$Properties
         * @property {number|null} [templateId] RequestLogout templateId
         * @property {Array.<string>|null} [userMsg] RequestLogout userMsg
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding
         */

        /**
         * Properties of a RequestLogout.
         * @memberof rti
         * @interface IRequestLogout
         * @augments rti.RequestLogout.$Properties
         * @deprecated Use rti.RequestLogout.$Properties instead.
         */

        /**
         * Shape of a RequestLogout.
         * @typedef {rti.RequestLogout.$Properties} rti.RequestLogout.$Shape
         */

        /**
         * Constructs a new RequestLogout.
         * @memberof rti
         * @classdesc Represents a RequestLogout.
         * @constructor
         * @param {rti.RequestLogout.$Properties=} [properties] Properties to set
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding
         */
        function RequestLogout(properties) {
            this.userMsg = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null && keys[i] !== "__proto__")
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * RequestLogout templateId.
         * @member {number} templateId
         * @memberof rti.RequestLogout
         * @instance
         */
        RequestLogout.prototype.templateId = 0;

        /**
         * RequestLogout userMsg.
         * @member {Array.<string>} userMsg
         * @memberof rti.RequestLogout
         * @instance
         */
        RequestLogout.prototype.userMsg = $util.emptyArray;

        /**
         * Creates a new RequestLogout instance using the specified properties.
         * @function create
         * @memberof rti.RequestLogout
         * @static
         * @param {rti.RequestLogout.$Properties=} [properties] Properties to set
         * @returns {rti.RequestLogout} RequestLogout instance
         * @type {{
         *   (properties: rti.RequestLogout.$Shape): rti.RequestLogout & rti.RequestLogout.$Shape;
         *   (properties?: rti.RequestLogout.$Properties): rti.RequestLogout;
         * }}
         */
        RequestLogout.create = function create(properties) {
            return new RequestLogout(properties);
        };

        /**
         * Encodes the specified RequestLogout message. Does not implicitly {@link rti.RequestLogout.verify|verify} messages.
         * @function encode
         * @memberof rti.RequestLogout
         * @static
         * @param {rti.RequestLogout.$Properties} message RequestLogout message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RequestLogout.encode = function encode(message, writer, _depth) {
            if (!writer)
                writer = $Writer.create();
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw Error("max depth exceeded");
            if (message.userMsg != null && message.userMsg.length)
                for (let i = 0; i < message.userMsg.length; ++i)
                    writer.uint32(/* id 132760, wireType 2 =*/1062082).string(message.userMsg[i]);
            if (message.templateId != null && Object.hasOwnProperty.call(message, "templateId"))
                writer.uint32(/* id 154467, wireType 0 =*/1235736).int32(message.templateId);
            if (message.$unknowns != null && Object.hasOwnProperty.call(message, "$unknowns"))
                for (let i = 0; i < message.$unknowns.length; ++i)
                    writer.raw(message.$unknowns[i]);
            return writer;
        };

        /**
         * Encodes the specified RequestLogout message, length delimited. Does not implicitly {@link rti.RequestLogout.verify|verify} messages.
         * @function encodeDelimited
         * @memberof rti.RequestLogout
         * @static
         * @param {rti.RequestLogout.$Properties} message RequestLogout message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RequestLogout.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer && writer.len ? writer.fork() : writer).ldelim();
        };

        /**
         * Decodes a RequestLogout message from the specified reader or buffer.
         * @function decode
         * @memberof rti.RequestLogout
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {rti.RequestLogout & rti.RequestLogout.$Shape} RequestLogout
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RequestLogout.decode = function decode(reader, length, _end, _depth, _target) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $Reader.recursionLimit)
                throw Error("max depth exceeded");
            let end = length === undefined ? reader.len : reader.pos + length, message = _target || new $root.rti.RequestLogout(), value;
            while (reader.pos < end) {
                let start = reader.pos;
                let tag = reader.tag();
                if (tag === _end) {
                    _end = undefined;
                    break;
                }
                let wireType = tag & 7;
                switch (tag >>>= 3) {
                case 154467: {
                        if (wireType !== 0)
                            break;
                        if (value = reader.int32())
                            message.templateId = value;
                        else
                            delete message.templateId;
                        continue;
                    }
                case 132760: {
                        if (wireType !== 2)
                            break;
                        if (!(message.userMsg && message.userMsg.length))
                            message.userMsg = [];
                        message.userMsg.push(reader.string());
                        continue;
                    }
                }
                reader.skipType(wireType, _depth, tag);
                if (!reader.discardUnknown) {
                    $util.makeProp(message, "$unknowns", false);
                    (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
                }
            }
            if (_end !== undefined)
                throw Error("missing end group");
            return message;
        };

        /**
         * Decodes a RequestLogout message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof rti.RequestLogout
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {rti.RequestLogout & rti.RequestLogout.$Shape} RequestLogout
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RequestLogout.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a RequestLogout message.
         * @function verify
         * @memberof rti.RequestLogout
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        RequestLogout.verify = function verify(message, _depth) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                return "max depth exceeded";
            if (message.templateId != null && message.hasOwnProperty("templateId"))
                if (!$util.isInteger(message.templateId))
                    return "templateId: integer expected";
            if (message.userMsg != null && message.hasOwnProperty("userMsg")) {
                if (!Array.isArray(message.userMsg))
                    return "userMsg: array expected";
                for (let i = 0; i < message.userMsg.length; ++i)
                    if (!$util.isString(message.userMsg[i]))
                        return "userMsg: string[] expected";
            }
            return null;
        };

        /**
         * Creates a RequestLogout message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof rti.RequestLogout
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {rti.RequestLogout} RequestLogout
         */
        RequestLogout.fromObject = function fromObject(object, _depth) {
            if (object instanceof $root.rti.RequestLogout)
                return object;
            if (!$util.isObject(object))
                throw TypeError(".rti.RequestLogout: object expected");
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw Error("max depth exceeded");
            let message = new $root.rti.RequestLogout();
            if (object.templateId != null)
                if (Number(object.templateId) !== 0)
                    message.templateId = object.templateId | 0;
            if (object.userMsg) {
                if (!Array.isArray(object.userMsg))
                    throw TypeError(".rti.RequestLogout.userMsg: array expected");
                message.userMsg = Array(object.userMsg.length);
                for (let i = 0; i < object.userMsg.length; ++i)
                    message.userMsg[i] = String(object.userMsg[i]);
            }
            return message;
        };

        /**
         * Creates a plain object from a RequestLogout message. Also converts values to other types if specified.
         * @function toObject
         * @memberof rti.RequestLogout
         * @static
         * @param {rti.RequestLogout} message RequestLogout
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RequestLogout.toObject = function toObject(message, options, _depth) {
            if (!options)
                options = {};
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw Error("max depth exceeded");
            let object = {};
            if (options.arrays || options.defaults)
                object.userMsg = [];
            if (options.defaults)
                object.templateId = 0;
            if (message.userMsg && message.userMsg.length) {
                object.userMsg = Array(message.userMsg.length);
                for (let j = 0; j < message.userMsg.length; ++j)
                    object.userMsg[j] = message.userMsg[j];
            }
            if (message.templateId != null && message.hasOwnProperty("templateId"))
                object.templateId = message.templateId;
            return object;
        };

        /**
         * Converts this RequestLogout to JSON.
         * @function toJSON
         * @memberof rti.RequestLogout
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RequestLogout.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the type url for RequestLogout
         * @function getTypeUrl
         * @memberof rti.RequestLogout
         * @static
         * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
         * @returns {string} The type url
         */
        RequestLogout.getTypeUrl = function getTypeUrl(prefix) {
            if (prefix === undefined)
                prefix = "type.googleapis.com";
            return prefix + "/rti.RequestLogout";
        };

        return RequestLogout;
    })();

    rti.RequestRithmicSystemInfo = (function() {

        /**
         * Properties of a RequestRithmicSystemInfo.
         * @typedef {Object} rti.RequestRithmicSystemInfo.$Properties
         * @property {number|null} [templateId] RequestRithmicSystemInfo templateId
         * @property {Array.<string>|null} [userMsg] RequestRithmicSystemInfo userMsg
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding
         */

        /**
         * Properties of a RequestRithmicSystemInfo.
         * @memberof rti
         * @interface IRequestRithmicSystemInfo
         * @augments rti.RequestRithmicSystemInfo.$Properties
         * @deprecated Use rti.RequestRithmicSystemInfo.$Properties instead.
         */

        /**
         * Shape of a RequestRithmicSystemInfo.
         * @typedef {rti.RequestRithmicSystemInfo.$Properties} rti.RequestRithmicSystemInfo.$Shape
         */

        /**
         * Constructs a new RequestRithmicSystemInfo.
         * @memberof rti
         * @classdesc Represents a RequestRithmicSystemInfo.
         * @constructor
         * @param {rti.RequestRithmicSystemInfo.$Properties=} [properties] Properties to set
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding
         */
        function RequestRithmicSystemInfo(properties) {
            this.userMsg = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null && keys[i] !== "__proto__")
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * RequestRithmicSystemInfo templateId.
         * @member {number} templateId
         * @memberof rti.RequestRithmicSystemInfo
         * @instance
         */
        RequestRithmicSystemInfo.prototype.templateId = 0;

        /**
         * RequestRithmicSystemInfo userMsg.
         * @member {Array.<string>} userMsg
         * @memberof rti.RequestRithmicSystemInfo
         * @instance
         */
        RequestRithmicSystemInfo.prototype.userMsg = $util.emptyArray;

        /**
         * Creates a new RequestRithmicSystemInfo instance using the specified properties.
         * @function create
         * @memberof rti.RequestRithmicSystemInfo
         * @static
         * @param {rti.RequestRithmicSystemInfo.$Properties=} [properties] Properties to set
         * @returns {rti.RequestRithmicSystemInfo} RequestRithmicSystemInfo instance
         * @type {{
         *   (properties: rti.RequestRithmicSystemInfo.$Shape): rti.RequestRithmicSystemInfo & rti.RequestRithmicSystemInfo.$Shape;
         *   (properties?: rti.RequestRithmicSystemInfo.$Properties): rti.RequestRithmicSystemInfo;
         * }}
         */
        RequestRithmicSystemInfo.create = function create(properties) {
            return new RequestRithmicSystemInfo(properties);
        };

        /**
         * Encodes the specified RequestRithmicSystemInfo message. Does not implicitly {@link rti.RequestRithmicSystemInfo.verify|verify} messages.
         * @function encode
         * @memberof rti.RequestRithmicSystemInfo
         * @static
         * @param {rti.RequestRithmicSystemInfo.$Properties} message RequestRithmicSystemInfo message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RequestRithmicSystemInfo.encode = function encode(message, writer, _depth) {
            if (!writer)
                writer = $Writer.create();
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw Error("max depth exceeded");
            if (message.userMsg != null && message.userMsg.length)
                for (let i = 0; i < message.userMsg.length; ++i)
                    writer.uint32(/* id 132760, wireType 2 =*/1062082).string(message.userMsg[i]);
            if (message.templateId != null && Object.hasOwnProperty.call(message, "templateId"))
                writer.uint32(/* id 154467, wireType 0 =*/1235736).int32(message.templateId);
            if (message.$unknowns != null && Object.hasOwnProperty.call(message, "$unknowns"))
                for (let i = 0; i < message.$unknowns.length; ++i)
                    writer.raw(message.$unknowns[i]);
            return writer;
        };

        /**
         * Encodes the specified RequestRithmicSystemInfo message, length delimited. Does not implicitly {@link rti.RequestRithmicSystemInfo.verify|verify} messages.
         * @function encodeDelimited
         * @memberof rti.RequestRithmicSystemInfo
         * @static
         * @param {rti.RequestRithmicSystemInfo.$Properties} message RequestRithmicSystemInfo message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RequestRithmicSystemInfo.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer && writer.len ? writer.fork() : writer).ldelim();
        };

        /**
         * Decodes a RequestRithmicSystemInfo message from the specified reader or buffer.
         * @function decode
         * @memberof rti.RequestRithmicSystemInfo
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {rti.RequestRithmicSystemInfo & rti.RequestRithmicSystemInfo.$Shape} RequestRithmicSystemInfo
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RequestRithmicSystemInfo.decode = function decode(reader, length, _end, _depth, _target) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $Reader.recursionLimit)
                throw Error("max depth exceeded");
            let end = length === undefined ? reader.len : reader.pos + length, message = _target || new $root.rti.RequestRithmicSystemInfo(), value;
            while (reader.pos < end) {
                let start = reader.pos;
                let tag = reader.tag();
                if (tag === _end) {
                    _end = undefined;
                    break;
                }
                let wireType = tag & 7;
                switch (tag >>>= 3) {
                case 154467: {
                        if (wireType !== 0)
                            break;
                        if (value = reader.int32())
                            message.templateId = value;
                        else
                            delete message.templateId;
                        continue;
                    }
                case 132760: {
                        if (wireType !== 2)
                            break;
                        if (!(message.userMsg && message.userMsg.length))
                            message.userMsg = [];
                        message.userMsg.push(reader.string());
                        continue;
                    }
                }
                reader.skipType(wireType, _depth, tag);
                if (!reader.discardUnknown) {
                    $util.makeProp(message, "$unknowns", false);
                    (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
                }
            }
            if (_end !== undefined)
                throw Error("missing end group");
            return message;
        };

        /**
         * Decodes a RequestRithmicSystemInfo message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof rti.RequestRithmicSystemInfo
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {rti.RequestRithmicSystemInfo & rti.RequestRithmicSystemInfo.$Shape} RequestRithmicSystemInfo
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RequestRithmicSystemInfo.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a RequestRithmicSystemInfo message.
         * @function verify
         * @memberof rti.RequestRithmicSystemInfo
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        RequestRithmicSystemInfo.verify = function verify(message, _depth) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                return "max depth exceeded";
            if (message.templateId != null && message.hasOwnProperty("templateId"))
                if (!$util.isInteger(message.templateId))
                    return "templateId: integer expected";
            if (message.userMsg != null && message.hasOwnProperty("userMsg")) {
                if (!Array.isArray(message.userMsg))
                    return "userMsg: array expected";
                for (let i = 0; i < message.userMsg.length; ++i)
                    if (!$util.isString(message.userMsg[i]))
                        return "userMsg: string[] expected";
            }
            return null;
        };

        /**
         * Creates a RequestRithmicSystemInfo message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof rti.RequestRithmicSystemInfo
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {rti.RequestRithmicSystemInfo} RequestRithmicSystemInfo
         */
        RequestRithmicSystemInfo.fromObject = function fromObject(object, _depth) {
            if (object instanceof $root.rti.RequestRithmicSystemInfo)
                return object;
            if (!$util.isObject(object))
                throw TypeError(".rti.RequestRithmicSystemInfo: object expected");
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw Error("max depth exceeded");
            let message = new $root.rti.RequestRithmicSystemInfo();
            if (object.templateId != null)
                if (Number(object.templateId) !== 0)
                    message.templateId = object.templateId | 0;
            if (object.userMsg) {
                if (!Array.isArray(object.userMsg))
                    throw TypeError(".rti.RequestRithmicSystemInfo.userMsg: array expected");
                message.userMsg = Array(object.userMsg.length);
                for (let i = 0; i < object.userMsg.length; ++i)
                    message.userMsg[i] = String(object.userMsg[i]);
            }
            return message;
        };

        /**
         * Creates a plain object from a RequestRithmicSystemInfo message. Also converts values to other types if specified.
         * @function toObject
         * @memberof rti.RequestRithmicSystemInfo
         * @static
         * @param {rti.RequestRithmicSystemInfo} message RequestRithmicSystemInfo
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RequestRithmicSystemInfo.toObject = function toObject(message, options, _depth) {
            if (!options)
                options = {};
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw Error("max depth exceeded");
            let object = {};
            if (options.arrays || options.defaults)
                object.userMsg = [];
            if (options.defaults)
                object.templateId = 0;
            if (message.userMsg && message.userMsg.length) {
                object.userMsg = Array(message.userMsg.length);
                for (let j = 0; j < message.userMsg.length; ++j)
                    object.userMsg[j] = message.userMsg[j];
            }
            if (message.templateId != null && message.hasOwnProperty("templateId"))
                object.templateId = message.templateId;
            return object;
        };

        /**
         * Converts this RequestRithmicSystemInfo to JSON.
         * @function toJSON
         * @memberof rti.RequestRithmicSystemInfo
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RequestRithmicSystemInfo.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the type url for RequestRithmicSystemInfo
         * @function getTypeUrl
         * @memberof rti.RequestRithmicSystemInfo
         * @static
         * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
         * @returns {string} The type url
         */
        RequestRithmicSystemInfo.getTypeUrl = function getTypeUrl(prefix) {
            if (prefix === undefined)
                prefix = "type.googleapis.com";
            return prefix + "/rti.RequestRithmicSystemInfo";
        };

        return RequestRithmicSystemInfo;
    })();

    rti.RequestShowFillHistory = (function() {

        /**
         * Properties of a RequestShowFillHistory.
         * @typedef {Object} rti.RequestShowFillHistory.$Properties
         * @property {number|null} [templateId] RequestShowFillHistory templateId
         * @property {Array.<string>|null} [userMsg] RequestShowFillHistory userMsg
         * @property {string|null} [fcmId] RequestShowFillHistory fcmId
         * @property {string|null} [ibId] RequestShowFillHistory ibId
         * @property {string|null} [accountId] RequestShowFillHistory accountId
         * @property {string|null} [indexFormat] RequestShowFillHistory indexFormat
         * @property {number|null} [startIndex] RequestShowFillHistory startIndex
         * @property {number|null} [finishIndex] RequestShowFillHistory finishIndex
         * @property {number|null} [maxRecordCount] RequestShowFillHistory maxRecordCount
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding
         */

        /**
         * Properties of a RequestShowFillHistory.
         * @memberof rti
         * @interface IRequestShowFillHistory
         * @augments rti.RequestShowFillHistory.$Properties
         * @deprecated Use rti.RequestShowFillHistory.$Properties instead.
         */

        /**
         * Shape of a RequestShowFillHistory.
         * @typedef {rti.RequestShowFillHistory.$Properties} rti.RequestShowFillHistory.$Shape
         */

        /**
         * Constructs a new RequestShowFillHistory.
         * @memberof rti
         * @classdesc Represents a RequestShowFillHistory.
         * @constructor
         * @param {rti.RequestShowFillHistory.$Properties=} [properties] Properties to set
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding
         */
        function RequestShowFillHistory(properties) {
            this.userMsg = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null && keys[i] !== "__proto__")
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * RequestShowFillHistory templateId.
         * @member {number} templateId
         * @memberof rti.RequestShowFillHistory
         * @instance
         */
        RequestShowFillHistory.prototype.templateId = 0;

        /**
         * RequestShowFillHistory userMsg.
         * @member {Array.<string>} userMsg
         * @memberof rti.RequestShowFillHistory
         * @instance
         */
        RequestShowFillHistory.prototype.userMsg = $util.emptyArray;

        /**
         * RequestShowFillHistory fcmId.
         * @member {string} fcmId
         * @memberof rti.RequestShowFillHistory
         * @instance
         */
        RequestShowFillHistory.prototype.fcmId = "";

        /**
         * RequestShowFillHistory ibId.
         * @member {string} ibId
         * @memberof rti.RequestShowFillHistory
         * @instance
         */
        RequestShowFillHistory.prototype.ibId = "";

        /**
         * RequestShowFillHistory accountId.
         * @member {string} accountId
         * @memberof rti.RequestShowFillHistory
         * @instance
         */
        RequestShowFillHistory.prototype.accountId = "";

        /**
         * RequestShowFillHistory indexFormat.
         * @member {string} indexFormat
         * @memberof rti.RequestShowFillHistory
         * @instance
         */
        RequestShowFillHistory.prototype.indexFormat = "";

        /**
         * RequestShowFillHistory startIndex.
         * @member {number} startIndex
         * @memberof rti.RequestShowFillHistory
         * @instance
         */
        RequestShowFillHistory.prototype.startIndex = 0;

        /**
         * RequestShowFillHistory finishIndex.
         * @member {number} finishIndex
         * @memberof rti.RequestShowFillHistory
         * @instance
         */
        RequestShowFillHistory.prototype.finishIndex = 0;

        /**
         * RequestShowFillHistory maxRecordCount.
         * @member {number} maxRecordCount
         * @memberof rti.RequestShowFillHistory
         * @instance
         */
        RequestShowFillHistory.prototype.maxRecordCount = 0;

        /**
         * Creates a new RequestShowFillHistory instance using the specified properties.
         * @function create
         * @memberof rti.RequestShowFillHistory
         * @static
         * @param {rti.RequestShowFillHistory.$Properties=} [properties] Properties to set
         * @returns {rti.RequestShowFillHistory} RequestShowFillHistory instance
         * @type {{
         *   (properties: rti.RequestShowFillHistory.$Shape): rti.RequestShowFillHistory & rti.RequestShowFillHistory.$Shape;
         *   (properties?: rti.RequestShowFillHistory.$Properties): rti.RequestShowFillHistory;
         * }}
         */
        RequestShowFillHistory.create = function create(properties) {
            return new RequestShowFillHistory(properties);
        };

        /**
         * Encodes the specified RequestShowFillHistory message. Does not implicitly {@link rti.RequestShowFillHistory.verify|verify} messages.
         * @function encode
         * @memberof rti.RequestShowFillHistory
         * @static
         * @param {rti.RequestShowFillHistory.$Properties} message RequestShowFillHistory message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RequestShowFillHistory.encode = function encode(message, writer, _depth) {
            if (!writer)
                writer = $Writer.create();
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw Error("max depth exceeded");
            if (message.indexFormat != null && Object.hasOwnProperty.call(message, "indexFormat"))
                writer.uint32(/* id 120001, wireType 2 =*/960010).string(message.indexFormat);
            if (message.userMsg != null && message.userMsg.length)
                for (let i = 0; i < message.userMsg.length; ++i)
                    writer.uint32(/* id 132760, wireType 2 =*/1062082).string(message.userMsg[i]);
            if (message.startIndex != null && Object.hasOwnProperty.call(message, "startIndex"))
                writer.uint32(/* id 153002, wireType 0 =*/1224016).int32(message.startIndex);
            if (message.finishIndex != null && Object.hasOwnProperty.call(message, "finishIndex"))
                writer.uint32(/* id 153003, wireType 0 =*/1224024).int32(message.finishIndex);
            if (message.accountId != null && Object.hasOwnProperty.call(message, "accountId"))
                writer.uint32(/* id 154008, wireType 2 =*/1232066).string(message.accountId);
            if (message.fcmId != null && Object.hasOwnProperty.call(message, "fcmId"))
                writer.uint32(/* id 154013, wireType 2 =*/1232106).string(message.fcmId);
            if (message.ibId != null && Object.hasOwnProperty.call(message, "ibId"))
                writer.uint32(/* id 154014, wireType 2 =*/1232114).string(message.ibId);
            if (message.maxRecordCount != null && Object.hasOwnProperty.call(message, "maxRecordCount"))
                writer.uint32(/* id 154020, wireType 0 =*/1232160).int32(message.maxRecordCount);
            if (message.templateId != null && Object.hasOwnProperty.call(message, "templateId"))
                writer.uint32(/* id 154467, wireType 0 =*/1235736).int32(message.templateId);
            if (message.$unknowns != null && Object.hasOwnProperty.call(message, "$unknowns"))
                for (let i = 0; i < message.$unknowns.length; ++i)
                    writer.raw(message.$unknowns[i]);
            return writer;
        };

        /**
         * Encodes the specified RequestShowFillHistory message, length delimited. Does not implicitly {@link rti.RequestShowFillHistory.verify|verify} messages.
         * @function encodeDelimited
         * @memberof rti.RequestShowFillHistory
         * @static
         * @param {rti.RequestShowFillHistory.$Properties} message RequestShowFillHistory message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RequestShowFillHistory.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer && writer.len ? writer.fork() : writer).ldelim();
        };

        /**
         * Decodes a RequestShowFillHistory message from the specified reader or buffer.
         * @function decode
         * @memberof rti.RequestShowFillHistory
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {rti.RequestShowFillHistory & rti.RequestShowFillHistory.$Shape} RequestShowFillHistory
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RequestShowFillHistory.decode = function decode(reader, length, _end, _depth, _target) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $Reader.recursionLimit)
                throw Error("max depth exceeded");
            let end = length === undefined ? reader.len : reader.pos + length, message = _target || new $root.rti.RequestShowFillHistory(), value;
            while (reader.pos < end) {
                let start = reader.pos;
                let tag = reader.tag();
                if (tag === _end) {
                    _end = undefined;
                    break;
                }
                let wireType = tag & 7;
                switch (tag >>>= 3) {
                case 154467: {
                        if (wireType !== 0)
                            break;
                        if (value = reader.int32())
                            message.templateId = value;
                        else
                            delete message.templateId;
                        continue;
                    }
                case 132760: {
                        if (wireType !== 2)
                            break;
                        if (!(message.userMsg && message.userMsg.length))
                            message.userMsg = [];
                        message.userMsg.push(reader.string());
                        continue;
                    }
                case 154013: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.string()).length)
                            message.fcmId = value;
                        else
                            delete message.fcmId;
                        continue;
                    }
                case 154014: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.string()).length)
                            message.ibId = value;
                        else
                            delete message.ibId;
                        continue;
                    }
                case 154008: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.string()).length)
                            message.accountId = value;
                        else
                            delete message.accountId;
                        continue;
                    }
                case 120001: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.string()).length)
                            message.indexFormat = value;
                        else
                            delete message.indexFormat;
                        continue;
                    }
                case 153002: {
                        if (wireType !== 0)
                            break;
                        if (value = reader.int32())
                            message.startIndex = value;
                        else
                            delete message.startIndex;
                        continue;
                    }
                case 153003: {
                        if (wireType !== 0)
                            break;
                        if (value = reader.int32())
                            message.finishIndex = value;
                        else
                            delete message.finishIndex;
                        continue;
                    }
                case 154020: {
                        if (wireType !== 0)
                            break;
                        if (value = reader.int32())
                            message.maxRecordCount = value;
                        else
                            delete message.maxRecordCount;
                        continue;
                    }
                }
                reader.skipType(wireType, _depth, tag);
                if (!reader.discardUnknown) {
                    $util.makeProp(message, "$unknowns", false);
                    (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
                }
            }
            if (_end !== undefined)
                throw Error("missing end group");
            return message;
        };

        /**
         * Decodes a RequestShowFillHistory message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof rti.RequestShowFillHistory
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {rti.RequestShowFillHistory & rti.RequestShowFillHistory.$Shape} RequestShowFillHistory
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RequestShowFillHistory.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a RequestShowFillHistory message.
         * @function verify
         * @memberof rti.RequestShowFillHistory
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        RequestShowFillHistory.verify = function verify(message, _depth) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                return "max depth exceeded";
            if (message.templateId != null && message.hasOwnProperty("templateId"))
                if (!$util.isInteger(message.templateId))
                    return "templateId: integer expected";
            if (message.userMsg != null && message.hasOwnProperty("userMsg")) {
                if (!Array.isArray(message.userMsg))
                    return "userMsg: array expected";
                for (let i = 0; i < message.userMsg.length; ++i)
                    if (!$util.isString(message.userMsg[i]))
                        return "userMsg: string[] expected";
            }
            if (message.fcmId != null && message.hasOwnProperty("fcmId"))
                if (!$util.isString(message.fcmId))
                    return "fcmId: string expected";
            if (message.ibId != null && message.hasOwnProperty("ibId"))
                if (!$util.isString(message.ibId))
                    return "ibId: string expected";
            if (message.accountId != null && message.hasOwnProperty("accountId"))
                if (!$util.isString(message.accountId))
                    return "accountId: string expected";
            if (message.indexFormat != null && message.hasOwnProperty("indexFormat"))
                if (!$util.isString(message.indexFormat))
                    return "indexFormat: string expected";
            if (message.startIndex != null && message.hasOwnProperty("startIndex"))
                if (!$util.isInteger(message.startIndex))
                    return "startIndex: integer expected";
            if (message.finishIndex != null && message.hasOwnProperty("finishIndex"))
                if (!$util.isInteger(message.finishIndex))
                    return "finishIndex: integer expected";
            if (message.maxRecordCount != null && message.hasOwnProperty("maxRecordCount"))
                if (!$util.isInteger(message.maxRecordCount))
                    return "maxRecordCount: integer expected";
            return null;
        };

        /**
         * Creates a RequestShowFillHistory message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof rti.RequestShowFillHistory
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {rti.RequestShowFillHistory} RequestShowFillHistory
         */
        RequestShowFillHistory.fromObject = function fromObject(object, _depth) {
            if (object instanceof $root.rti.RequestShowFillHistory)
                return object;
            if (!$util.isObject(object))
                throw TypeError(".rti.RequestShowFillHistory: object expected");
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw Error("max depth exceeded");
            let message = new $root.rti.RequestShowFillHistory();
            if (object.templateId != null)
                if (Number(object.templateId) !== 0)
                    message.templateId = object.templateId | 0;
            if (object.userMsg) {
                if (!Array.isArray(object.userMsg))
                    throw TypeError(".rti.RequestShowFillHistory.userMsg: array expected");
                message.userMsg = Array(object.userMsg.length);
                for (let i = 0; i < object.userMsg.length; ++i)
                    message.userMsg[i] = String(object.userMsg[i]);
            }
            if (object.fcmId != null)
                if (typeof object.fcmId !== "string" || object.fcmId.length)
                    message.fcmId = String(object.fcmId);
            if (object.ibId != null)
                if (typeof object.ibId !== "string" || object.ibId.length)
                    message.ibId = String(object.ibId);
            if (object.accountId != null)
                if (typeof object.accountId !== "string" || object.accountId.length)
                    message.accountId = String(object.accountId);
            if (object.indexFormat != null)
                if (typeof object.indexFormat !== "string" || object.indexFormat.length)
                    message.indexFormat = String(object.indexFormat);
            if (object.startIndex != null)
                if (Number(object.startIndex) !== 0)
                    message.startIndex = object.startIndex | 0;
            if (object.finishIndex != null)
                if (Number(object.finishIndex) !== 0)
                    message.finishIndex = object.finishIndex | 0;
            if (object.maxRecordCount != null)
                if (Number(object.maxRecordCount) !== 0)
                    message.maxRecordCount = object.maxRecordCount | 0;
            return message;
        };

        /**
         * Creates a plain object from a RequestShowFillHistory message. Also converts values to other types if specified.
         * @function toObject
         * @memberof rti.RequestShowFillHistory
         * @static
         * @param {rti.RequestShowFillHistory} message RequestShowFillHistory
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RequestShowFillHistory.toObject = function toObject(message, options, _depth) {
            if (!options)
                options = {};
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw Error("max depth exceeded");
            let object = {};
            if (options.arrays || options.defaults)
                object.userMsg = [];
            if (options.defaults) {
                object.indexFormat = "";
                object.startIndex = 0;
                object.finishIndex = 0;
                object.accountId = "";
                object.fcmId = "";
                object.ibId = "";
                object.maxRecordCount = 0;
                object.templateId = 0;
            }
            if (message.indexFormat != null && message.hasOwnProperty("indexFormat"))
                object.indexFormat = message.indexFormat;
            if (message.userMsg && message.userMsg.length) {
                object.userMsg = Array(message.userMsg.length);
                for (let j = 0; j < message.userMsg.length; ++j)
                    object.userMsg[j] = message.userMsg[j];
            }
            if (message.startIndex != null && message.hasOwnProperty("startIndex"))
                object.startIndex = message.startIndex;
            if (message.finishIndex != null && message.hasOwnProperty("finishIndex"))
                object.finishIndex = message.finishIndex;
            if (message.accountId != null && message.hasOwnProperty("accountId"))
                object.accountId = message.accountId;
            if (message.fcmId != null && message.hasOwnProperty("fcmId"))
                object.fcmId = message.fcmId;
            if (message.ibId != null && message.hasOwnProperty("ibId"))
                object.ibId = message.ibId;
            if (message.maxRecordCount != null && message.hasOwnProperty("maxRecordCount"))
                object.maxRecordCount = message.maxRecordCount;
            if (message.templateId != null && message.hasOwnProperty("templateId"))
                object.templateId = message.templateId;
            return object;
        };

        /**
         * Converts this RequestShowFillHistory to JSON.
         * @function toJSON
         * @memberof rti.RequestShowFillHistory
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RequestShowFillHistory.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the type url for RequestShowFillHistory
         * @function getTypeUrl
         * @memberof rti.RequestShowFillHistory
         * @static
         * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
         * @returns {string} The type url
         */
        RequestShowFillHistory.getTypeUrl = function getTypeUrl(prefix) {
            if (prefix === undefined)
                prefix = "type.googleapis.com";
            return prefix + "/rti.RequestShowFillHistory";
        };

        return RequestShowFillHistory;
    })();

    rti.RequestShowOrderHistoryDates = (function() {

        /**
         * Properties of a RequestShowOrderHistoryDates.
         * @typedef {Object} rti.RequestShowOrderHistoryDates.$Properties
         * @property {number|null} [templateId] RequestShowOrderHistoryDates templateId
         * @property {Array.<string>|null} [userMsg] RequestShowOrderHistoryDates userMsg
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding
         */

        /**
         * Properties of a RequestShowOrderHistoryDates.
         * @memberof rti
         * @interface IRequestShowOrderHistoryDates
         * @augments rti.RequestShowOrderHistoryDates.$Properties
         * @deprecated Use rti.RequestShowOrderHistoryDates.$Properties instead.
         */

        /**
         * Shape of a RequestShowOrderHistoryDates.
         * @typedef {rti.RequestShowOrderHistoryDates.$Properties} rti.RequestShowOrderHistoryDates.$Shape
         */

        /**
         * Constructs a new RequestShowOrderHistoryDates.
         * @memberof rti
         * @classdesc Represents a RequestShowOrderHistoryDates.
         * @constructor
         * @param {rti.RequestShowOrderHistoryDates.$Properties=} [properties] Properties to set
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding
         */
        function RequestShowOrderHistoryDates(properties) {
            this.userMsg = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null && keys[i] !== "__proto__")
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * RequestShowOrderHistoryDates templateId.
         * @member {number} templateId
         * @memberof rti.RequestShowOrderHistoryDates
         * @instance
         */
        RequestShowOrderHistoryDates.prototype.templateId = 0;

        /**
         * RequestShowOrderHistoryDates userMsg.
         * @member {Array.<string>} userMsg
         * @memberof rti.RequestShowOrderHistoryDates
         * @instance
         */
        RequestShowOrderHistoryDates.prototype.userMsg = $util.emptyArray;

        /**
         * Creates a new RequestShowOrderHistoryDates instance using the specified properties.
         * @function create
         * @memberof rti.RequestShowOrderHistoryDates
         * @static
         * @param {rti.RequestShowOrderHistoryDates.$Properties=} [properties] Properties to set
         * @returns {rti.RequestShowOrderHistoryDates} RequestShowOrderHistoryDates instance
         * @type {{
         *   (properties: rti.RequestShowOrderHistoryDates.$Shape): rti.RequestShowOrderHistoryDates & rti.RequestShowOrderHistoryDates.$Shape;
         *   (properties?: rti.RequestShowOrderHistoryDates.$Properties): rti.RequestShowOrderHistoryDates;
         * }}
         */
        RequestShowOrderHistoryDates.create = function create(properties) {
            return new RequestShowOrderHistoryDates(properties);
        };

        /**
         * Encodes the specified RequestShowOrderHistoryDates message. Does not implicitly {@link rti.RequestShowOrderHistoryDates.verify|verify} messages.
         * @function encode
         * @memberof rti.RequestShowOrderHistoryDates
         * @static
         * @param {rti.RequestShowOrderHistoryDates.$Properties} message RequestShowOrderHistoryDates message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RequestShowOrderHistoryDates.encode = function encode(message, writer, _depth) {
            if (!writer)
                writer = $Writer.create();
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw Error("max depth exceeded");
            if (message.userMsg != null && message.userMsg.length)
                for (let i = 0; i < message.userMsg.length; ++i)
                    writer.uint32(/* id 132760, wireType 2 =*/1062082).string(message.userMsg[i]);
            if (message.templateId != null && Object.hasOwnProperty.call(message, "templateId"))
                writer.uint32(/* id 154467, wireType 0 =*/1235736).int32(message.templateId);
            if (message.$unknowns != null && Object.hasOwnProperty.call(message, "$unknowns"))
                for (let i = 0; i < message.$unknowns.length; ++i)
                    writer.raw(message.$unknowns[i]);
            return writer;
        };

        /**
         * Encodes the specified RequestShowOrderHistoryDates message, length delimited. Does not implicitly {@link rti.RequestShowOrderHistoryDates.verify|verify} messages.
         * @function encodeDelimited
         * @memberof rti.RequestShowOrderHistoryDates
         * @static
         * @param {rti.RequestShowOrderHistoryDates.$Properties} message RequestShowOrderHistoryDates message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RequestShowOrderHistoryDates.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer && writer.len ? writer.fork() : writer).ldelim();
        };

        /**
         * Decodes a RequestShowOrderHistoryDates message from the specified reader or buffer.
         * @function decode
         * @memberof rti.RequestShowOrderHistoryDates
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {rti.RequestShowOrderHistoryDates & rti.RequestShowOrderHistoryDates.$Shape} RequestShowOrderHistoryDates
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RequestShowOrderHistoryDates.decode = function decode(reader, length, _end, _depth, _target) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $Reader.recursionLimit)
                throw Error("max depth exceeded");
            let end = length === undefined ? reader.len : reader.pos + length, message = _target || new $root.rti.RequestShowOrderHistoryDates(), value;
            while (reader.pos < end) {
                let start = reader.pos;
                let tag = reader.tag();
                if (tag === _end) {
                    _end = undefined;
                    break;
                }
                let wireType = tag & 7;
                switch (tag >>>= 3) {
                case 154467: {
                        if (wireType !== 0)
                            break;
                        if (value = reader.int32())
                            message.templateId = value;
                        else
                            delete message.templateId;
                        continue;
                    }
                case 132760: {
                        if (wireType !== 2)
                            break;
                        if (!(message.userMsg && message.userMsg.length))
                            message.userMsg = [];
                        message.userMsg.push(reader.string());
                        continue;
                    }
                }
                reader.skipType(wireType, _depth, tag);
                if (!reader.discardUnknown) {
                    $util.makeProp(message, "$unknowns", false);
                    (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
                }
            }
            if (_end !== undefined)
                throw Error("missing end group");
            return message;
        };

        /**
         * Decodes a RequestShowOrderHistoryDates message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof rti.RequestShowOrderHistoryDates
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {rti.RequestShowOrderHistoryDates & rti.RequestShowOrderHistoryDates.$Shape} RequestShowOrderHistoryDates
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RequestShowOrderHistoryDates.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a RequestShowOrderHistoryDates message.
         * @function verify
         * @memberof rti.RequestShowOrderHistoryDates
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        RequestShowOrderHistoryDates.verify = function verify(message, _depth) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                return "max depth exceeded";
            if (message.templateId != null && message.hasOwnProperty("templateId"))
                if (!$util.isInteger(message.templateId))
                    return "templateId: integer expected";
            if (message.userMsg != null && message.hasOwnProperty("userMsg")) {
                if (!Array.isArray(message.userMsg))
                    return "userMsg: array expected";
                for (let i = 0; i < message.userMsg.length; ++i)
                    if (!$util.isString(message.userMsg[i]))
                        return "userMsg: string[] expected";
            }
            return null;
        };

        /**
         * Creates a RequestShowOrderHistoryDates message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof rti.RequestShowOrderHistoryDates
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {rti.RequestShowOrderHistoryDates} RequestShowOrderHistoryDates
         */
        RequestShowOrderHistoryDates.fromObject = function fromObject(object, _depth) {
            if (object instanceof $root.rti.RequestShowOrderHistoryDates)
                return object;
            if (!$util.isObject(object))
                throw TypeError(".rti.RequestShowOrderHistoryDates: object expected");
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw Error("max depth exceeded");
            let message = new $root.rti.RequestShowOrderHistoryDates();
            if (object.templateId != null)
                if (Number(object.templateId) !== 0)
                    message.templateId = object.templateId | 0;
            if (object.userMsg) {
                if (!Array.isArray(object.userMsg))
                    throw TypeError(".rti.RequestShowOrderHistoryDates.userMsg: array expected");
                message.userMsg = Array(object.userMsg.length);
                for (let i = 0; i < object.userMsg.length; ++i)
                    message.userMsg[i] = String(object.userMsg[i]);
            }
            return message;
        };

        /**
         * Creates a plain object from a RequestShowOrderHistoryDates message. Also converts values to other types if specified.
         * @function toObject
         * @memberof rti.RequestShowOrderHistoryDates
         * @static
         * @param {rti.RequestShowOrderHistoryDates} message RequestShowOrderHistoryDates
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RequestShowOrderHistoryDates.toObject = function toObject(message, options, _depth) {
            if (!options)
                options = {};
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw Error("max depth exceeded");
            let object = {};
            if (options.arrays || options.defaults)
                object.userMsg = [];
            if (options.defaults)
                object.templateId = 0;
            if (message.userMsg && message.userMsg.length) {
                object.userMsg = Array(message.userMsg.length);
                for (let j = 0; j < message.userMsg.length; ++j)
                    object.userMsg[j] = message.userMsg[j];
            }
            if (message.templateId != null && message.hasOwnProperty("templateId"))
                object.templateId = message.templateId;
            return object;
        };

        /**
         * Converts this RequestShowOrderHistoryDates to JSON.
         * @function toJSON
         * @memberof rti.RequestShowOrderHistoryDates
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RequestShowOrderHistoryDates.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the type url for RequestShowOrderHistoryDates
         * @function getTypeUrl
         * @memberof rti.RequestShowOrderHistoryDates
         * @static
         * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
         * @returns {string} The type url
         */
        RequestShowOrderHistoryDates.getTypeUrl = function getTypeUrl(prefix) {
            if (prefix === undefined)
                prefix = "type.googleapis.com";
            return prefix + "/rti.RequestShowOrderHistoryDates";
        };

        return RequestShowOrderHistoryDates;
    })();

    rti.RequestShowOrders = (function() {

        /**
         * Properties of a RequestShowOrders.
         * @typedef {Object} rti.RequestShowOrders.$Properties
         * @property {number|null} [templateId] RequestShowOrders templateId
         * @property {Array.<string>|null} [userMsg] RequestShowOrders userMsg
         * @property {string|null} [fcmId] RequestShowOrders fcmId
         * @property {string|null} [ibId] RequestShowOrders ibId
         * @property {string|null} [accountId] RequestShowOrders accountId
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding
         */

        /**
         * Properties of a RequestShowOrders.
         * @memberof rti
         * @interface IRequestShowOrders
         * @augments rti.RequestShowOrders.$Properties
         * @deprecated Use rti.RequestShowOrders.$Properties instead.
         */

        /**
         * Shape of a RequestShowOrders.
         * @typedef {rti.RequestShowOrders.$Properties} rti.RequestShowOrders.$Shape
         */

        /**
         * Constructs a new RequestShowOrders.
         * @memberof rti
         * @classdesc Represents a RequestShowOrders.
         * @constructor
         * @param {rti.RequestShowOrders.$Properties=} [properties] Properties to set
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding
         */
        function RequestShowOrders(properties) {
            this.userMsg = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null && keys[i] !== "__proto__")
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * RequestShowOrders templateId.
         * @member {number} templateId
         * @memberof rti.RequestShowOrders
         * @instance
         */
        RequestShowOrders.prototype.templateId = 0;

        /**
         * RequestShowOrders userMsg.
         * @member {Array.<string>} userMsg
         * @memberof rti.RequestShowOrders
         * @instance
         */
        RequestShowOrders.prototype.userMsg = $util.emptyArray;

        /**
         * RequestShowOrders fcmId.
         * @member {string} fcmId
         * @memberof rti.RequestShowOrders
         * @instance
         */
        RequestShowOrders.prototype.fcmId = "";

        /**
         * RequestShowOrders ibId.
         * @member {string} ibId
         * @memberof rti.RequestShowOrders
         * @instance
         */
        RequestShowOrders.prototype.ibId = "";

        /**
         * RequestShowOrders accountId.
         * @member {string} accountId
         * @memberof rti.RequestShowOrders
         * @instance
         */
        RequestShowOrders.prototype.accountId = "";

        /**
         * Creates a new RequestShowOrders instance using the specified properties.
         * @function create
         * @memberof rti.RequestShowOrders
         * @static
         * @param {rti.RequestShowOrders.$Properties=} [properties] Properties to set
         * @returns {rti.RequestShowOrders} RequestShowOrders instance
         * @type {{
         *   (properties: rti.RequestShowOrders.$Shape): rti.RequestShowOrders & rti.RequestShowOrders.$Shape;
         *   (properties?: rti.RequestShowOrders.$Properties): rti.RequestShowOrders;
         * }}
         */
        RequestShowOrders.create = function create(properties) {
            return new RequestShowOrders(properties);
        };

        /**
         * Encodes the specified RequestShowOrders message. Does not implicitly {@link rti.RequestShowOrders.verify|verify} messages.
         * @function encode
         * @memberof rti.RequestShowOrders
         * @static
         * @param {rti.RequestShowOrders.$Properties} message RequestShowOrders message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RequestShowOrders.encode = function encode(message, writer, _depth) {
            if (!writer)
                writer = $Writer.create();
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw Error("max depth exceeded");
            if (message.userMsg != null && message.userMsg.length)
                for (let i = 0; i < message.userMsg.length; ++i)
                    writer.uint32(/* id 132760, wireType 2 =*/1062082).string(message.userMsg[i]);
            if (message.accountId != null && Object.hasOwnProperty.call(message, "accountId"))
                writer.uint32(/* id 154008, wireType 2 =*/1232066).string(message.accountId);
            if (message.fcmId != null && Object.hasOwnProperty.call(message, "fcmId"))
                writer.uint32(/* id 154013, wireType 2 =*/1232106).string(message.fcmId);
            if (message.ibId != null && Object.hasOwnProperty.call(message, "ibId"))
                writer.uint32(/* id 154014, wireType 2 =*/1232114).string(message.ibId);
            if (message.templateId != null && Object.hasOwnProperty.call(message, "templateId"))
                writer.uint32(/* id 154467, wireType 0 =*/1235736).int32(message.templateId);
            if (message.$unknowns != null && Object.hasOwnProperty.call(message, "$unknowns"))
                for (let i = 0; i < message.$unknowns.length; ++i)
                    writer.raw(message.$unknowns[i]);
            return writer;
        };

        /**
         * Encodes the specified RequestShowOrders message, length delimited. Does not implicitly {@link rti.RequestShowOrders.verify|verify} messages.
         * @function encodeDelimited
         * @memberof rti.RequestShowOrders
         * @static
         * @param {rti.RequestShowOrders.$Properties} message RequestShowOrders message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RequestShowOrders.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer && writer.len ? writer.fork() : writer).ldelim();
        };

        /**
         * Decodes a RequestShowOrders message from the specified reader or buffer.
         * @function decode
         * @memberof rti.RequestShowOrders
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {rti.RequestShowOrders & rti.RequestShowOrders.$Shape} RequestShowOrders
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RequestShowOrders.decode = function decode(reader, length, _end, _depth, _target) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $Reader.recursionLimit)
                throw Error("max depth exceeded");
            let end = length === undefined ? reader.len : reader.pos + length, message = _target || new $root.rti.RequestShowOrders(), value;
            while (reader.pos < end) {
                let start = reader.pos;
                let tag = reader.tag();
                if (tag === _end) {
                    _end = undefined;
                    break;
                }
                let wireType = tag & 7;
                switch (tag >>>= 3) {
                case 154467: {
                        if (wireType !== 0)
                            break;
                        if (value = reader.int32())
                            message.templateId = value;
                        else
                            delete message.templateId;
                        continue;
                    }
                case 132760: {
                        if (wireType !== 2)
                            break;
                        if (!(message.userMsg && message.userMsg.length))
                            message.userMsg = [];
                        message.userMsg.push(reader.string());
                        continue;
                    }
                case 154013: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.string()).length)
                            message.fcmId = value;
                        else
                            delete message.fcmId;
                        continue;
                    }
                case 154014: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.string()).length)
                            message.ibId = value;
                        else
                            delete message.ibId;
                        continue;
                    }
                case 154008: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.string()).length)
                            message.accountId = value;
                        else
                            delete message.accountId;
                        continue;
                    }
                }
                reader.skipType(wireType, _depth, tag);
                if (!reader.discardUnknown) {
                    $util.makeProp(message, "$unknowns", false);
                    (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
                }
            }
            if (_end !== undefined)
                throw Error("missing end group");
            return message;
        };

        /**
         * Decodes a RequestShowOrders message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof rti.RequestShowOrders
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {rti.RequestShowOrders & rti.RequestShowOrders.$Shape} RequestShowOrders
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RequestShowOrders.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a RequestShowOrders message.
         * @function verify
         * @memberof rti.RequestShowOrders
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        RequestShowOrders.verify = function verify(message, _depth) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                return "max depth exceeded";
            if (message.templateId != null && message.hasOwnProperty("templateId"))
                if (!$util.isInteger(message.templateId))
                    return "templateId: integer expected";
            if (message.userMsg != null && message.hasOwnProperty("userMsg")) {
                if (!Array.isArray(message.userMsg))
                    return "userMsg: array expected";
                for (let i = 0; i < message.userMsg.length; ++i)
                    if (!$util.isString(message.userMsg[i]))
                        return "userMsg: string[] expected";
            }
            if (message.fcmId != null && message.hasOwnProperty("fcmId"))
                if (!$util.isString(message.fcmId))
                    return "fcmId: string expected";
            if (message.ibId != null && message.hasOwnProperty("ibId"))
                if (!$util.isString(message.ibId))
                    return "ibId: string expected";
            if (message.accountId != null && message.hasOwnProperty("accountId"))
                if (!$util.isString(message.accountId))
                    return "accountId: string expected";
            return null;
        };

        /**
         * Creates a RequestShowOrders message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof rti.RequestShowOrders
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {rti.RequestShowOrders} RequestShowOrders
         */
        RequestShowOrders.fromObject = function fromObject(object, _depth) {
            if (object instanceof $root.rti.RequestShowOrders)
                return object;
            if (!$util.isObject(object))
                throw TypeError(".rti.RequestShowOrders: object expected");
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw Error("max depth exceeded");
            let message = new $root.rti.RequestShowOrders();
            if (object.templateId != null)
                if (Number(object.templateId) !== 0)
                    message.templateId = object.templateId | 0;
            if (object.userMsg) {
                if (!Array.isArray(object.userMsg))
                    throw TypeError(".rti.RequestShowOrders.userMsg: array expected");
                message.userMsg = Array(object.userMsg.length);
                for (let i = 0; i < object.userMsg.length; ++i)
                    message.userMsg[i] = String(object.userMsg[i]);
            }
            if (object.fcmId != null)
                if (typeof object.fcmId !== "string" || object.fcmId.length)
                    message.fcmId = String(object.fcmId);
            if (object.ibId != null)
                if (typeof object.ibId !== "string" || object.ibId.length)
                    message.ibId = String(object.ibId);
            if (object.accountId != null)
                if (typeof object.accountId !== "string" || object.accountId.length)
                    message.accountId = String(object.accountId);
            return message;
        };

        /**
         * Creates a plain object from a RequestShowOrders message. Also converts values to other types if specified.
         * @function toObject
         * @memberof rti.RequestShowOrders
         * @static
         * @param {rti.RequestShowOrders} message RequestShowOrders
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RequestShowOrders.toObject = function toObject(message, options, _depth) {
            if (!options)
                options = {};
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw Error("max depth exceeded");
            let object = {};
            if (options.arrays || options.defaults)
                object.userMsg = [];
            if (options.defaults) {
                object.accountId = "";
                object.fcmId = "";
                object.ibId = "";
                object.templateId = 0;
            }
            if (message.userMsg && message.userMsg.length) {
                object.userMsg = Array(message.userMsg.length);
                for (let j = 0; j < message.userMsg.length; ++j)
                    object.userMsg[j] = message.userMsg[j];
            }
            if (message.accountId != null && message.hasOwnProperty("accountId"))
                object.accountId = message.accountId;
            if (message.fcmId != null && message.hasOwnProperty("fcmId"))
                object.fcmId = message.fcmId;
            if (message.ibId != null && message.hasOwnProperty("ibId"))
                object.ibId = message.ibId;
            if (message.templateId != null && message.hasOwnProperty("templateId"))
                object.templateId = message.templateId;
            return object;
        };

        /**
         * Converts this RequestShowOrders to JSON.
         * @function toJSON
         * @memberof rti.RequestShowOrders
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RequestShowOrders.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the type url for RequestShowOrders
         * @function getTypeUrl
         * @memberof rti.RequestShowOrders
         * @static
         * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
         * @returns {string} The type url
         */
        RequestShowOrders.getTypeUrl = function getTypeUrl(prefix) {
            if (prefix === undefined)
                prefix = "type.googleapis.com";
            return prefix + "/rti.RequestShowOrders";
        };

        return RequestShowOrders;
    })();

    rti.RequestSubscribeForOrderUpdates = (function() {

        /**
         * Properties of a RequestSubscribeForOrderUpdates.
         * @typedef {Object} rti.RequestSubscribeForOrderUpdates.$Properties
         * @property {number|null} [templateId] RequestSubscribeForOrderUpdates templateId
         * @property {Array.<string>|null} [userMsg] RequestSubscribeForOrderUpdates userMsg
         * @property {string|null} [fcmId] RequestSubscribeForOrderUpdates fcmId
         * @property {string|null} [ibId] RequestSubscribeForOrderUpdates ibId
         * @property {string|null} [accountId] RequestSubscribeForOrderUpdates accountId
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding
         */

        /**
         * Properties of a RequestSubscribeForOrderUpdates.
         * @memberof rti
         * @interface IRequestSubscribeForOrderUpdates
         * @augments rti.RequestSubscribeForOrderUpdates.$Properties
         * @deprecated Use rti.RequestSubscribeForOrderUpdates.$Properties instead.
         */

        /**
         * Shape of a RequestSubscribeForOrderUpdates.
         * @typedef {rti.RequestSubscribeForOrderUpdates.$Properties} rti.RequestSubscribeForOrderUpdates.$Shape
         */

        /**
         * Constructs a new RequestSubscribeForOrderUpdates.
         * @memberof rti
         * @classdesc Represents a RequestSubscribeForOrderUpdates.
         * @constructor
         * @param {rti.RequestSubscribeForOrderUpdates.$Properties=} [properties] Properties to set
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding
         */
        function RequestSubscribeForOrderUpdates(properties) {
            this.userMsg = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null && keys[i] !== "__proto__")
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * RequestSubscribeForOrderUpdates templateId.
         * @member {number} templateId
         * @memberof rti.RequestSubscribeForOrderUpdates
         * @instance
         */
        RequestSubscribeForOrderUpdates.prototype.templateId = 0;

        /**
         * RequestSubscribeForOrderUpdates userMsg.
         * @member {Array.<string>} userMsg
         * @memberof rti.RequestSubscribeForOrderUpdates
         * @instance
         */
        RequestSubscribeForOrderUpdates.prototype.userMsg = $util.emptyArray;

        /**
         * RequestSubscribeForOrderUpdates fcmId.
         * @member {string} fcmId
         * @memberof rti.RequestSubscribeForOrderUpdates
         * @instance
         */
        RequestSubscribeForOrderUpdates.prototype.fcmId = "";

        /**
         * RequestSubscribeForOrderUpdates ibId.
         * @member {string} ibId
         * @memberof rti.RequestSubscribeForOrderUpdates
         * @instance
         */
        RequestSubscribeForOrderUpdates.prototype.ibId = "";

        /**
         * RequestSubscribeForOrderUpdates accountId.
         * @member {string} accountId
         * @memberof rti.RequestSubscribeForOrderUpdates
         * @instance
         */
        RequestSubscribeForOrderUpdates.prototype.accountId = "";

        /**
         * Creates a new RequestSubscribeForOrderUpdates instance using the specified properties.
         * @function create
         * @memberof rti.RequestSubscribeForOrderUpdates
         * @static
         * @param {rti.RequestSubscribeForOrderUpdates.$Properties=} [properties] Properties to set
         * @returns {rti.RequestSubscribeForOrderUpdates} RequestSubscribeForOrderUpdates instance
         * @type {{
         *   (properties: rti.RequestSubscribeForOrderUpdates.$Shape): rti.RequestSubscribeForOrderUpdates & rti.RequestSubscribeForOrderUpdates.$Shape;
         *   (properties?: rti.RequestSubscribeForOrderUpdates.$Properties): rti.RequestSubscribeForOrderUpdates;
         * }}
         */
        RequestSubscribeForOrderUpdates.create = function create(properties) {
            return new RequestSubscribeForOrderUpdates(properties);
        };

        /**
         * Encodes the specified RequestSubscribeForOrderUpdates message. Does not implicitly {@link rti.RequestSubscribeForOrderUpdates.verify|verify} messages.
         * @function encode
         * @memberof rti.RequestSubscribeForOrderUpdates
         * @static
         * @param {rti.RequestSubscribeForOrderUpdates.$Properties} message RequestSubscribeForOrderUpdates message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RequestSubscribeForOrderUpdates.encode = function encode(message, writer, _depth) {
            if (!writer)
                writer = $Writer.create();
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw Error("max depth exceeded");
            if (message.userMsg != null && message.userMsg.length)
                for (let i = 0; i < message.userMsg.length; ++i)
                    writer.uint32(/* id 132760, wireType 2 =*/1062082).string(message.userMsg[i]);
            if (message.accountId != null && Object.hasOwnProperty.call(message, "accountId"))
                writer.uint32(/* id 154008, wireType 2 =*/1232066).string(message.accountId);
            if (message.fcmId != null && Object.hasOwnProperty.call(message, "fcmId"))
                writer.uint32(/* id 154013, wireType 2 =*/1232106).string(message.fcmId);
            if (message.ibId != null && Object.hasOwnProperty.call(message, "ibId"))
                writer.uint32(/* id 154014, wireType 2 =*/1232114).string(message.ibId);
            if (message.templateId != null && Object.hasOwnProperty.call(message, "templateId"))
                writer.uint32(/* id 154467, wireType 0 =*/1235736).int32(message.templateId);
            if (message.$unknowns != null && Object.hasOwnProperty.call(message, "$unknowns"))
                for (let i = 0; i < message.$unknowns.length; ++i)
                    writer.raw(message.$unknowns[i]);
            return writer;
        };

        /**
         * Encodes the specified RequestSubscribeForOrderUpdates message, length delimited. Does not implicitly {@link rti.RequestSubscribeForOrderUpdates.verify|verify} messages.
         * @function encodeDelimited
         * @memberof rti.RequestSubscribeForOrderUpdates
         * @static
         * @param {rti.RequestSubscribeForOrderUpdates.$Properties} message RequestSubscribeForOrderUpdates message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RequestSubscribeForOrderUpdates.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer && writer.len ? writer.fork() : writer).ldelim();
        };

        /**
         * Decodes a RequestSubscribeForOrderUpdates message from the specified reader or buffer.
         * @function decode
         * @memberof rti.RequestSubscribeForOrderUpdates
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {rti.RequestSubscribeForOrderUpdates & rti.RequestSubscribeForOrderUpdates.$Shape} RequestSubscribeForOrderUpdates
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RequestSubscribeForOrderUpdates.decode = function decode(reader, length, _end, _depth, _target) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $Reader.recursionLimit)
                throw Error("max depth exceeded");
            let end = length === undefined ? reader.len : reader.pos + length, message = _target || new $root.rti.RequestSubscribeForOrderUpdates(), value;
            while (reader.pos < end) {
                let start = reader.pos;
                let tag = reader.tag();
                if (tag === _end) {
                    _end = undefined;
                    break;
                }
                let wireType = tag & 7;
                switch (tag >>>= 3) {
                case 154467: {
                        if (wireType !== 0)
                            break;
                        if (value = reader.int32())
                            message.templateId = value;
                        else
                            delete message.templateId;
                        continue;
                    }
                case 132760: {
                        if (wireType !== 2)
                            break;
                        if (!(message.userMsg && message.userMsg.length))
                            message.userMsg = [];
                        message.userMsg.push(reader.string());
                        continue;
                    }
                case 154013: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.string()).length)
                            message.fcmId = value;
                        else
                            delete message.fcmId;
                        continue;
                    }
                case 154014: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.string()).length)
                            message.ibId = value;
                        else
                            delete message.ibId;
                        continue;
                    }
                case 154008: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.string()).length)
                            message.accountId = value;
                        else
                            delete message.accountId;
                        continue;
                    }
                }
                reader.skipType(wireType, _depth, tag);
                if (!reader.discardUnknown) {
                    $util.makeProp(message, "$unknowns", false);
                    (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
                }
            }
            if (_end !== undefined)
                throw Error("missing end group");
            return message;
        };

        /**
         * Decodes a RequestSubscribeForOrderUpdates message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof rti.RequestSubscribeForOrderUpdates
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {rti.RequestSubscribeForOrderUpdates & rti.RequestSubscribeForOrderUpdates.$Shape} RequestSubscribeForOrderUpdates
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RequestSubscribeForOrderUpdates.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a RequestSubscribeForOrderUpdates message.
         * @function verify
         * @memberof rti.RequestSubscribeForOrderUpdates
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        RequestSubscribeForOrderUpdates.verify = function verify(message, _depth) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                return "max depth exceeded";
            if (message.templateId != null && message.hasOwnProperty("templateId"))
                if (!$util.isInteger(message.templateId))
                    return "templateId: integer expected";
            if (message.userMsg != null && message.hasOwnProperty("userMsg")) {
                if (!Array.isArray(message.userMsg))
                    return "userMsg: array expected";
                for (let i = 0; i < message.userMsg.length; ++i)
                    if (!$util.isString(message.userMsg[i]))
                        return "userMsg: string[] expected";
            }
            if (message.fcmId != null && message.hasOwnProperty("fcmId"))
                if (!$util.isString(message.fcmId))
                    return "fcmId: string expected";
            if (message.ibId != null && message.hasOwnProperty("ibId"))
                if (!$util.isString(message.ibId))
                    return "ibId: string expected";
            if (message.accountId != null && message.hasOwnProperty("accountId"))
                if (!$util.isString(message.accountId))
                    return "accountId: string expected";
            return null;
        };

        /**
         * Creates a RequestSubscribeForOrderUpdates message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof rti.RequestSubscribeForOrderUpdates
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {rti.RequestSubscribeForOrderUpdates} RequestSubscribeForOrderUpdates
         */
        RequestSubscribeForOrderUpdates.fromObject = function fromObject(object, _depth) {
            if (object instanceof $root.rti.RequestSubscribeForOrderUpdates)
                return object;
            if (!$util.isObject(object))
                throw TypeError(".rti.RequestSubscribeForOrderUpdates: object expected");
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw Error("max depth exceeded");
            let message = new $root.rti.RequestSubscribeForOrderUpdates();
            if (object.templateId != null)
                if (Number(object.templateId) !== 0)
                    message.templateId = object.templateId | 0;
            if (object.userMsg) {
                if (!Array.isArray(object.userMsg))
                    throw TypeError(".rti.RequestSubscribeForOrderUpdates.userMsg: array expected");
                message.userMsg = Array(object.userMsg.length);
                for (let i = 0; i < object.userMsg.length; ++i)
                    message.userMsg[i] = String(object.userMsg[i]);
            }
            if (object.fcmId != null)
                if (typeof object.fcmId !== "string" || object.fcmId.length)
                    message.fcmId = String(object.fcmId);
            if (object.ibId != null)
                if (typeof object.ibId !== "string" || object.ibId.length)
                    message.ibId = String(object.ibId);
            if (object.accountId != null)
                if (typeof object.accountId !== "string" || object.accountId.length)
                    message.accountId = String(object.accountId);
            return message;
        };

        /**
         * Creates a plain object from a RequestSubscribeForOrderUpdates message. Also converts values to other types if specified.
         * @function toObject
         * @memberof rti.RequestSubscribeForOrderUpdates
         * @static
         * @param {rti.RequestSubscribeForOrderUpdates} message RequestSubscribeForOrderUpdates
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RequestSubscribeForOrderUpdates.toObject = function toObject(message, options, _depth) {
            if (!options)
                options = {};
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw Error("max depth exceeded");
            let object = {};
            if (options.arrays || options.defaults)
                object.userMsg = [];
            if (options.defaults) {
                object.accountId = "";
                object.fcmId = "";
                object.ibId = "";
                object.templateId = 0;
            }
            if (message.userMsg && message.userMsg.length) {
                object.userMsg = Array(message.userMsg.length);
                for (let j = 0; j < message.userMsg.length; ++j)
                    object.userMsg[j] = message.userMsg[j];
            }
            if (message.accountId != null && message.hasOwnProperty("accountId"))
                object.accountId = message.accountId;
            if (message.fcmId != null && message.hasOwnProperty("fcmId"))
                object.fcmId = message.fcmId;
            if (message.ibId != null && message.hasOwnProperty("ibId"))
                object.ibId = message.ibId;
            if (message.templateId != null && message.hasOwnProperty("templateId"))
                object.templateId = message.templateId;
            return object;
        };

        /**
         * Converts this RequestSubscribeForOrderUpdates to JSON.
         * @function toJSON
         * @memberof rti.RequestSubscribeForOrderUpdates
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RequestSubscribeForOrderUpdates.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the type url for RequestSubscribeForOrderUpdates
         * @function getTypeUrl
         * @memberof rti.RequestSubscribeForOrderUpdates
         * @static
         * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
         * @returns {string} The type url
         */
        RequestSubscribeForOrderUpdates.getTypeUrl = function getTypeUrl(prefix) {
            if (prefix === undefined)
                prefix = "type.googleapis.com";
            return prefix + "/rti.RequestSubscribeForOrderUpdates";
        };

        return RequestSubscribeForOrderUpdates;
    })();

    rti.ResponseAccountList = (function() {

        /**
         * Properties of a ResponseAccountList.
         * @typedef {Object} rti.ResponseAccountList.$Properties
         * @property {number|null} [templateId] ResponseAccountList templateId
         * @property {Array.<string>|null} [userMsg] ResponseAccountList userMsg
         * @property {Array.<string>|null} [rqHandlerRpCode] ResponseAccountList rqHandlerRpCode
         * @property {Array.<string>|null} [rpCode] ResponseAccountList rpCode
         * @property {string|null} [fcmId] ResponseAccountList fcmId
         * @property {string|null} [ibId] ResponseAccountList ibId
         * @property {string|null} [accountId] ResponseAccountList accountId
         * @property {string|null} [accountName] ResponseAccountList accountName
         * @property {string|null} [accountCurrency] ResponseAccountList accountCurrency
         * @property {string|null} [lossLimit] ResponseAccountList lossLimit
         * @property {number|null} [accountCreationSsboe] ResponseAccountList accountCreationSsboe
         * @property {number|null} [accountCreationUsecs] ResponseAccountList accountCreationUsecs
         * @property {string|null} [accountAutoLiquidate] ResponseAccountList accountAutoLiquidate
         * @property {string|null} [autoLiqThresholdCurrentValue] ResponseAccountList autoLiqThresholdCurrentValue
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding
         */

        /**
         * Properties of a ResponseAccountList.
         * @memberof rti
         * @interface IResponseAccountList
         * @augments rti.ResponseAccountList.$Properties
         * @deprecated Use rti.ResponseAccountList.$Properties instead.
         */

        /**
         * Shape of a ResponseAccountList.
         * @typedef {rti.ResponseAccountList.$Properties} rti.ResponseAccountList.$Shape
         */

        /**
         * Constructs a new ResponseAccountList.
         * @memberof rti
         * @classdesc Represents a ResponseAccountList.
         * @constructor
         * @param {rti.ResponseAccountList.$Properties=} [properties] Properties to set
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding
         */
        function ResponseAccountList(properties) {
            this.userMsg = [];
            this.rqHandlerRpCode = [];
            this.rpCode = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null && keys[i] !== "__proto__")
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ResponseAccountList templateId.
         * @member {number} templateId
         * @memberof rti.ResponseAccountList
         * @instance
         */
        ResponseAccountList.prototype.templateId = 0;

        /**
         * ResponseAccountList userMsg.
         * @member {Array.<string>} userMsg
         * @memberof rti.ResponseAccountList
         * @instance
         */
        ResponseAccountList.prototype.userMsg = $util.emptyArray;

        /**
         * ResponseAccountList rqHandlerRpCode.
         * @member {Array.<string>} rqHandlerRpCode
         * @memberof rti.ResponseAccountList
         * @instance
         */
        ResponseAccountList.prototype.rqHandlerRpCode = $util.emptyArray;

        /**
         * ResponseAccountList rpCode.
         * @member {Array.<string>} rpCode
         * @memberof rti.ResponseAccountList
         * @instance
         */
        ResponseAccountList.prototype.rpCode = $util.emptyArray;

        /**
         * ResponseAccountList fcmId.
         * @member {string} fcmId
         * @memberof rti.ResponseAccountList
         * @instance
         */
        ResponseAccountList.prototype.fcmId = "";

        /**
         * ResponseAccountList ibId.
         * @member {string} ibId
         * @memberof rti.ResponseAccountList
         * @instance
         */
        ResponseAccountList.prototype.ibId = "";

        /**
         * ResponseAccountList accountId.
         * @member {string} accountId
         * @memberof rti.ResponseAccountList
         * @instance
         */
        ResponseAccountList.prototype.accountId = "";

        /**
         * ResponseAccountList accountName.
         * @member {string} accountName
         * @memberof rti.ResponseAccountList
         * @instance
         */
        ResponseAccountList.prototype.accountName = "";

        /**
         * ResponseAccountList accountCurrency.
         * @member {string} accountCurrency
         * @memberof rti.ResponseAccountList
         * @instance
         */
        ResponseAccountList.prototype.accountCurrency = "";

        /**
         * ResponseAccountList lossLimit.
         * @member {string} lossLimit
         * @memberof rti.ResponseAccountList
         * @instance
         */
        ResponseAccountList.prototype.lossLimit = "";

        /**
         * ResponseAccountList accountCreationSsboe.
         * @member {number} accountCreationSsboe
         * @memberof rti.ResponseAccountList
         * @instance
         */
        ResponseAccountList.prototype.accountCreationSsboe = 0;

        /**
         * ResponseAccountList accountCreationUsecs.
         * @member {number} accountCreationUsecs
         * @memberof rti.ResponseAccountList
         * @instance
         */
        ResponseAccountList.prototype.accountCreationUsecs = 0;

        /**
         * ResponseAccountList accountAutoLiquidate.
         * @member {string} accountAutoLiquidate
         * @memberof rti.ResponseAccountList
         * @instance
         */
        ResponseAccountList.prototype.accountAutoLiquidate = "";

        /**
         * ResponseAccountList autoLiqThresholdCurrentValue.
         * @member {string} autoLiqThresholdCurrentValue
         * @memberof rti.ResponseAccountList
         * @instance
         */
        ResponseAccountList.prototype.autoLiqThresholdCurrentValue = "";

        /**
         * Creates a new ResponseAccountList instance using the specified properties.
         * @function create
         * @memberof rti.ResponseAccountList
         * @static
         * @param {rti.ResponseAccountList.$Properties=} [properties] Properties to set
         * @returns {rti.ResponseAccountList} ResponseAccountList instance
         * @type {{
         *   (properties: rti.ResponseAccountList.$Shape): rti.ResponseAccountList & rti.ResponseAccountList.$Shape;
         *   (properties?: rti.ResponseAccountList.$Properties): rti.ResponseAccountList;
         * }}
         */
        ResponseAccountList.create = function create(properties) {
            return new ResponseAccountList(properties);
        };

        /**
         * Encodes the specified ResponseAccountList message. Does not implicitly {@link rti.ResponseAccountList.verify|verify} messages.
         * @function encode
         * @memberof rti.ResponseAccountList
         * @static
         * @param {rti.ResponseAccountList.$Properties} message ResponseAccountList message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ResponseAccountList.encode = function encode(message, writer, _depth) {
            if (!writer)
                writer = $Writer.create();
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw Error("max depth exceeded");
            if (message.accountAutoLiquidate != null && Object.hasOwnProperty.call(message, "accountAutoLiquidate"))
                writer.uint32(/* id 131035, wireType 2 =*/1048282).string(message.accountAutoLiquidate);
            if (message.autoLiqThresholdCurrentValue != null && Object.hasOwnProperty.call(message, "autoLiqThresholdCurrentValue"))
                writer.uint32(/* id 131040, wireType 2 =*/1048322).string(message.autoLiqThresholdCurrentValue);
            if (message.userMsg != null && message.userMsg.length)
                for (let i = 0; i < message.userMsg.length; ++i)
                    writer.uint32(/* id 132760, wireType 2 =*/1062082).string(message.userMsg[i]);
            if (message.rqHandlerRpCode != null && message.rqHandlerRpCode.length)
                for (let i = 0; i < message.rqHandlerRpCode.length; ++i)
                    writer.uint32(/* id 132764, wireType 2 =*/1062114).string(message.rqHandlerRpCode[i]);
            if (message.rpCode != null && message.rpCode.length)
                for (let i = 0; i < message.rpCode.length; ++i)
                    writer.uint32(/* id 132766, wireType 2 =*/1062130).string(message.rpCode[i]);
            if (message.accountCreationSsboe != null && Object.hasOwnProperty.call(message, "accountCreationSsboe"))
                writer.uint32(/* id 153171, wireType 0 =*/1225368).int32(message.accountCreationSsboe);
            if (message.accountCreationUsecs != null && Object.hasOwnProperty.call(message, "accountCreationUsecs"))
                writer.uint32(/* id 153172, wireType 0 =*/1225376).int32(message.accountCreationUsecs);
            if (message.accountName != null && Object.hasOwnProperty.call(message, "accountName"))
                writer.uint32(/* id 154002, wireType 2 =*/1232018).string(message.accountName);
            if (message.accountId != null && Object.hasOwnProperty.call(message, "accountId"))
                writer.uint32(/* id 154008, wireType 2 =*/1232066).string(message.accountId);
            if (message.fcmId != null && Object.hasOwnProperty.call(message, "fcmId"))
                writer.uint32(/* id 154013, wireType 2 =*/1232106).string(message.fcmId);
            if (message.ibId != null && Object.hasOwnProperty.call(message, "ibId"))
                writer.uint32(/* id 154014, wireType 2 =*/1232114).string(message.ibId);
            if (message.lossLimit != null && Object.hasOwnProperty.call(message, "lossLimit"))
                writer.uint32(/* id 154019, wireType 2 =*/1232154).string(message.lossLimit);
            if (message.accountCurrency != null && Object.hasOwnProperty.call(message, "accountCurrency"))
                writer.uint32(/* id 154383, wireType 2 =*/1235066).string(message.accountCurrency);
            if (message.templateId != null && Object.hasOwnProperty.call(message, "templateId"))
                writer.uint32(/* id 154467, wireType 0 =*/1235736).int32(message.templateId);
            if (message.$unknowns != null && Object.hasOwnProperty.call(message, "$unknowns"))
                for (let i = 0; i < message.$unknowns.length; ++i)
                    writer.raw(message.$unknowns[i]);
            return writer;
        };

        /**
         * Encodes the specified ResponseAccountList message, length delimited. Does not implicitly {@link rti.ResponseAccountList.verify|verify} messages.
         * @function encodeDelimited
         * @memberof rti.ResponseAccountList
         * @static
         * @param {rti.ResponseAccountList.$Properties} message ResponseAccountList message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ResponseAccountList.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer && writer.len ? writer.fork() : writer).ldelim();
        };

        /**
         * Decodes a ResponseAccountList message from the specified reader or buffer.
         * @function decode
         * @memberof rti.ResponseAccountList
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {rti.ResponseAccountList & rti.ResponseAccountList.$Shape} ResponseAccountList
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ResponseAccountList.decode = function decode(reader, length, _end, _depth, _target) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $Reader.recursionLimit)
                throw Error("max depth exceeded");
            let end = length === undefined ? reader.len : reader.pos + length, message = _target || new $root.rti.ResponseAccountList(), value;
            while (reader.pos < end) {
                let start = reader.pos;
                let tag = reader.tag();
                if (tag === _end) {
                    _end = undefined;
                    break;
                }
                let wireType = tag & 7;
                switch (tag >>>= 3) {
                case 154467: {
                        if (wireType !== 0)
                            break;
                        if (value = reader.int32())
                            message.templateId = value;
                        else
                            delete message.templateId;
                        continue;
                    }
                case 132760: {
                        if (wireType !== 2)
                            break;
                        if (!(message.userMsg && message.userMsg.length))
                            message.userMsg = [];
                        message.userMsg.push(reader.string());
                        continue;
                    }
                case 132764: {
                        if (wireType !== 2)
                            break;
                        if (!(message.rqHandlerRpCode && message.rqHandlerRpCode.length))
                            message.rqHandlerRpCode = [];
                        message.rqHandlerRpCode.push(reader.string());
                        continue;
                    }
                case 132766: {
                        if (wireType !== 2)
                            break;
                        if (!(message.rpCode && message.rpCode.length))
                            message.rpCode = [];
                        message.rpCode.push(reader.string());
                        continue;
                    }
                case 154013: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.string()).length)
                            message.fcmId = value;
                        else
                            delete message.fcmId;
                        continue;
                    }
                case 154014: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.string()).length)
                            message.ibId = value;
                        else
                            delete message.ibId;
                        continue;
                    }
                case 154008: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.string()).length)
                            message.accountId = value;
                        else
                            delete message.accountId;
                        continue;
                    }
                case 154002: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.string()).length)
                            message.accountName = value;
                        else
                            delete message.accountName;
                        continue;
                    }
                case 154383: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.string()).length)
                            message.accountCurrency = value;
                        else
                            delete message.accountCurrency;
                        continue;
                    }
                case 154019: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.string()).length)
                            message.lossLimit = value;
                        else
                            delete message.lossLimit;
                        continue;
                    }
                case 153171: {
                        if (wireType !== 0)
                            break;
                        if (value = reader.int32())
                            message.accountCreationSsboe = value;
                        else
                            delete message.accountCreationSsboe;
                        continue;
                    }
                case 153172: {
                        if (wireType !== 0)
                            break;
                        if (value = reader.int32())
                            message.accountCreationUsecs = value;
                        else
                            delete message.accountCreationUsecs;
                        continue;
                    }
                case 131035: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.string()).length)
                            message.accountAutoLiquidate = value;
                        else
                            delete message.accountAutoLiquidate;
                        continue;
                    }
                case 131040: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.string()).length)
                            message.autoLiqThresholdCurrentValue = value;
                        else
                            delete message.autoLiqThresholdCurrentValue;
                        continue;
                    }
                }
                reader.skipType(wireType, _depth, tag);
                if (!reader.discardUnknown) {
                    $util.makeProp(message, "$unknowns", false);
                    (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
                }
            }
            if (_end !== undefined)
                throw Error("missing end group");
            return message;
        };

        /**
         * Decodes a ResponseAccountList message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof rti.ResponseAccountList
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {rti.ResponseAccountList & rti.ResponseAccountList.$Shape} ResponseAccountList
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ResponseAccountList.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ResponseAccountList message.
         * @function verify
         * @memberof rti.ResponseAccountList
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ResponseAccountList.verify = function verify(message, _depth) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                return "max depth exceeded";
            if (message.templateId != null && message.hasOwnProperty("templateId"))
                if (!$util.isInteger(message.templateId))
                    return "templateId: integer expected";
            if (message.userMsg != null && message.hasOwnProperty("userMsg")) {
                if (!Array.isArray(message.userMsg))
                    return "userMsg: array expected";
                for (let i = 0; i < message.userMsg.length; ++i)
                    if (!$util.isString(message.userMsg[i]))
                        return "userMsg: string[] expected";
            }
            if (message.rqHandlerRpCode != null && message.hasOwnProperty("rqHandlerRpCode")) {
                if (!Array.isArray(message.rqHandlerRpCode))
                    return "rqHandlerRpCode: array expected";
                for (let i = 0; i < message.rqHandlerRpCode.length; ++i)
                    if (!$util.isString(message.rqHandlerRpCode[i]))
                        return "rqHandlerRpCode: string[] expected";
            }
            if (message.rpCode != null && message.hasOwnProperty("rpCode")) {
                if (!Array.isArray(message.rpCode))
                    return "rpCode: array expected";
                for (let i = 0; i < message.rpCode.length; ++i)
                    if (!$util.isString(message.rpCode[i]))
                        return "rpCode: string[] expected";
            }
            if (message.fcmId != null && message.hasOwnProperty("fcmId"))
                if (!$util.isString(message.fcmId))
                    return "fcmId: string expected";
            if (message.ibId != null && message.hasOwnProperty("ibId"))
                if (!$util.isString(message.ibId))
                    return "ibId: string expected";
            if (message.accountId != null && message.hasOwnProperty("accountId"))
                if (!$util.isString(message.accountId))
                    return "accountId: string expected";
            if (message.accountName != null && message.hasOwnProperty("accountName"))
                if (!$util.isString(message.accountName))
                    return "accountName: string expected";
            if (message.accountCurrency != null && message.hasOwnProperty("accountCurrency"))
                if (!$util.isString(message.accountCurrency))
                    return "accountCurrency: string expected";
            if (message.lossLimit != null && message.hasOwnProperty("lossLimit"))
                if (!$util.isString(message.lossLimit))
                    return "lossLimit: string expected";
            if (message.accountCreationSsboe != null && message.hasOwnProperty("accountCreationSsboe"))
                if (!$util.isInteger(message.accountCreationSsboe))
                    return "accountCreationSsboe: integer expected";
            if (message.accountCreationUsecs != null && message.hasOwnProperty("accountCreationUsecs"))
                if (!$util.isInteger(message.accountCreationUsecs))
                    return "accountCreationUsecs: integer expected";
            if (message.accountAutoLiquidate != null && message.hasOwnProperty("accountAutoLiquidate"))
                if (!$util.isString(message.accountAutoLiquidate))
                    return "accountAutoLiquidate: string expected";
            if (message.autoLiqThresholdCurrentValue != null && message.hasOwnProperty("autoLiqThresholdCurrentValue"))
                if (!$util.isString(message.autoLiqThresholdCurrentValue))
                    return "autoLiqThresholdCurrentValue: string expected";
            return null;
        };

        /**
         * Creates a ResponseAccountList message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof rti.ResponseAccountList
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {rti.ResponseAccountList} ResponseAccountList
         */
        ResponseAccountList.fromObject = function fromObject(object, _depth) {
            if (object instanceof $root.rti.ResponseAccountList)
                return object;
            if (!$util.isObject(object))
                throw TypeError(".rti.ResponseAccountList: object expected");
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw Error("max depth exceeded");
            let message = new $root.rti.ResponseAccountList();
            if (object.templateId != null)
                if (Number(object.templateId) !== 0)
                    message.templateId = object.templateId | 0;
            if (object.userMsg) {
                if (!Array.isArray(object.userMsg))
                    throw TypeError(".rti.ResponseAccountList.userMsg: array expected");
                message.userMsg = Array(object.userMsg.length);
                for (let i = 0; i < object.userMsg.length; ++i)
                    message.userMsg[i] = String(object.userMsg[i]);
            }
            if (object.rqHandlerRpCode) {
                if (!Array.isArray(object.rqHandlerRpCode))
                    throw TypeError(".rti.ResponseAccountList.rqHandlerRpCode: array expected");
                message.rqHandlerRpCode = Array(object.rqHandlerRpCode.length);
                for (let i = 0; i < object.rqHandlerRpCode.length; ++i)
                    message.rqHandlerRpCode[i] = String(object.rqHandlerRpCode[i]);
            }
            if (object.rpCode) {
                if (!Array.isArray(object.rpCode))
                    throw TypeError(".rti.ResponseAccountList.rpCode: array expected");
                message.rpCode = Array(object.rpCode.length);
                for (let i = 0; i < object.rpCode.length; ++i)
                    message.rpCode[i] = String(object.rpCode[i]);
            }
            if (object.fcmId != null)
                if (typeof object.fcmId !== "string" || object.fcmId.length)
                    message.fcmId = String(object.fcmId);
            if (object.ibId != null)
                if (typeof object.ibId !== "string" || object.ibId.length)
                    message.ibId = String(object.ibId);
            if (object.accountId != null)
                if (typeof object.accountId !== "string" || object.accountId.length)
                    message.accountId = String(object.accountId);
            if (object.accountName != null)
                if (typeof object.accountName !== "string" || object.accountName.length)
                    message.accountName = String(object.accountName);
            if (object.accountCurrency != null)
                if (typeof object.accountCurrency !== "string" || object.accountCurrency.length)
                    message.accountCurrency = String(object.accountCurrency);
            if (object.lossLimit != null)
                if (typeof object.lossLimit !== "string" || object.lossLimit.length)
                    message.lossLimit = String(object.lossLimit);
            if (object.accountCreationSsboe != null)
                if (Number(object.accountCreationSsboe) !== 0)
                    message.accountCreationSsboe = object.accountCreationSsboe | 0;
            if (object.accountCreationUsecs != null)
                if (Number(object.accountCreationUsecs) !== 0)
                    message.accountCreationUsecs = object.accountCreationUsecs | 0;
            if (object.accountAutoLiquidate != null)
                if (typeof object.accountAutoLiquidate !== "string" || object.accountAutoLiquidate.length)
                    message.accountAutoLiquidate = String(object.accountAutoLiquidate);
            if (object.autoLiqThresholdCurrentValue != null)
                if (typeof object.autoLiqThresholdCurrentValue !== "string" || object.autoLiqThresholdCurrentValue.length)
                    message.autoLiqThresholdCurrentValue = String(object.autoLiqThresholdCurrentValue);
            return message;
        };

        /**
         * Creates a plain object from a ResponseAccountList message. Also converts values to other types if specified.
         * @function toObject
         * @memberof rti.ResponseAccountList
         * @static
         * @param {rti.ResponseAccountList} message ResponseAccountList
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ResponseAccountList.toObject = function toObject(message, options, _depth) {
            if (!options)
                options = {};
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw Error("max depth exceeded");
            let object = {};
            if (options.arrays || options.defaults) {
                object.userMsg = [];
                object.rqHandlerRpCode = [];
                object.rpCode = [];
            }
            if (options.defaults) {
                object.accountAutoLiquidate = "";
                object.autoLiqThresholdCurrentValue = "";
                object.accountCreationSsboe = 0;
                object.accountCreationUsecs = 0;
                object.accountName = "";
                object.accountId = "";
                object.fcmId = "";
                object.ibId = "";
                object.lossLimit = "";
                object.accountCurrency = "";
                object.templateId = 0;
            }
            if (message.accountAutoLiquidate != null && message.hasOwnProperty("accountAutoLiquidate"))
                object.accountAutoLiquidate = message.accountAutoLiquidate;
            if (message.autoLiqThresholdCurrentValue != null && message.hasOwnProperty("autoLiqThresholdCurrentValue"))
                object.autoLiqThresholdCurrentValue = message.autoLiqThresholdCurrentValue;
            if (message.userMsg && message.userMsg.length) {
                object.userMsg = Array(message.userMsg.length);
                for (let j = 0; j < message.userMsg.length; ++j)
                    object.userMsg[j] = message.userMsg[j];
            }
            if (message.rqHandlerRpCode && message.rqHandlerRpCode.length) {
                object.rqHandlerRpCode = Array(message.rqHandlerRpCode.length);
                for (let j = 0; j < message.rqHandlerRpCode.length; ++j)
                    object.rqHandlerRpCode[j] = message.rqHandlerRpCode[j];
            }
            if (message.rpCode && message.rpCode.length) {
                object.rpCode = Array(message.rpCode.length);
                for (let j = 0; j < message.rpCode.length; ++j)
                    object.rpCode[j] = message.rpCode[j];
            }
            if (message.accountCreationSsboe != null && message.hasOwnProperty("accountCreationSsboe"))
                object.accountCreationSsboe = message.accountCreationSsboe;
            if (message.accountCreationUsecs != null && message.hasOwnProperty("accountCreationUsecs"))
                object.accountCreationUsecs = message.accountCreationUsecs;
            if (message.accountName != null && message.hasOwnProperty("accountName"))
                object.accountName = message.accountName;
            if (message.accountId != null && message.hasOwnProperty("accountId"))
                object.accountId = message.accountId;
            if (message.fcmId != null && message.hasOwnProperty("fcmId"))
                object.fcmId = message.fcmId;
            if (message.ibId != null && message.hasOwnProperty("ibId"))
                object.ibId = message.ibId;
            if (message.lossLimit != null && message.hasOwnProperty("lossLimit"))
                object.lossLimit = message.lossLimit;
            if (message.accountCurrency != null && message.hasOwnProperty("accountCurrency"))
                object.accountCurrency = message.accountCurrency;
            if (message.templateId != null && message.hasOwnProperty("templateId"))
                object.templateId = message.templateId;
            return object;
        };

        /**
         * Converts this ResponseAccountList to JSON.
         * @function toJSON
         * @memberof rti.ResponseAccountList
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ResponseAccountList.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the type url for ResponseAccountList
         * @function getTypeUrl
         * @memberof rti.ResponseAccountList
         * @static
         * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
         * @returns {string} The type url
         */
        ResponseAccountList.getTypeUrl = function getTypeUrl(prefix) {
            if (prefix === undefined)
                prefix = "type.googleapis.com";
            return prefix + "/rti.ResponseAccountList";
        };

        return ResponseAccountList;
    })();

    rti.ResponseHeartbeat = (function() {

        /**
         * Properties of a ResponseHeartbeat.
         * @typedef {Object} rti.ResponseHeartbeat.$Properties
         * @property {number|null} [templateId] ResponseHeartbeat templateId
         * @property {Array.<string>|null} [userMsg] ResponseHeartbeat userMsg
         * @property {Array.<string>|null} [rpCode] ResponseHeartbeat rpCode
         * @property {number|null} [ssboe] ResponseHeartbeat ssboe
         * @property {number|null} [usecs] ResponseHeartbeat usecs
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding
         */

        /**
         * Properties of a ResponseHeartbeat.
         * @memberof rti
         * @interface IResponseHeartbeat
         * @augments rti.ResponseHeartbeat.$Properties
         * @deprecated Use rti.ResponseHeartbeat.$Properties instead.
         */

        /**
         * Shape of a ResponseHeartbeat.
         * @typedef {rti.ResponseHeartbeat.$Properties} rti.ResponseHeartbeat.$Shape
         */

        /**
         * Constructs a new ResponseHeartbeat.
         * @memberof rti
         * @classdesc Represents a ResponseHeartbeat.
         * @constructor
         * @param {rti.ResponseHeartbeat.$Properties=} [properties] Properties to set
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding
         */
        function ResponseHeartbeat(properties) {
            this.userMsg = [];
            this.rpCode = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null && keys[i] !== "__proto__")
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ResponseHeartbeat templateId.
         * @member {number} templateId
         * @memberof rti.ResponseHeartbeat
         * @instance
         */
        ResponseHeartbeat.prototype.templateId = 0;

        /**
         * ResponseHeartbeat userMsg.
         * @member {Array.<string>} userMsg
         * @memberof rti.ResponseHeartbeat
         * @instance
         */
        ResponseHeartbeat.prototype.userMsg = $util.emptyArray;

        /**
         * ResponseHeartbeat rpCode.
         * @member {Array.<string>} rpCode
         * @memberof rti.ResponseHeartbeat
         * @instance
         */
        ResponseHeartbeat.prototype.rpCode = $util.emptyArray;

        /**
         * ResponseHeartbeat ssboe.
         * @member {number} ssboe
         * @memberof rti.ResponseHeartbeat
         * @instance
         */
        ResponseHeartbeat.prototype.ssboe = 0;

        /**
         * ResponseHeartbeat usecs.
         * @member {number} usecs
         * @memberof rti.ResponseHeartbeat
         * @instance
         */
        ResponseHeartbeat.prototype.usecs = 0;

        /**
         * Creates a new ResponseHeartbeat instance using the specified properties.
         * @function create
         * @memberof rti.ResponseHeartbeat
         * @static
         * @param {rti.ResponseHeartbeat.$Properties=} [properties] Properties to set
         * @returns {rti.ResponseHeartbeat} ResponseHeartbeat instance
         * @type {{
         *   (properties: rti.ResponseHeartbeat.$Shape): rti.ResponseHeartbeat & rti.ResponseHeartbeat.$Shape;
         *   (properties?: rti.ResponseHeartbeat.$Properties): rti.ResponseHeartbeat;
         * }}
         */
        ResponseHeartbeat.create = function create(properties) {
            return new ResponseHeartbeat(properties);
        };

        /**
         * Encodes the specified ResponseHeartbeat message. Does not implicitly {@link rti.ResponseHeartbeat.verify|verify} messages.
         * @function encode
         * @memberof rti.ResponseHeartbeat
         * @static
         * @param {rti.ResponseHeartbeat.$Properties} message ResponseHeartbeat message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ResponseHeartbeat.encode = function encode(message, writer, _depth) {
            if (!writer)
                writer = $Writer.create();
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw Error("max depth exceeded");
            if (message.userMsg != null && message.userMsg.length)
                for (let i = 0; i < message.userMsg.length; ++i)
                    writer.uint32(/* id 132760, wireType 2 =*/1062082).string(message.userMsg[i]);
            if (message.rpCode != null && message.rpCode.length)
                for (let i = 0; i < message.rpCode.length; ++i)
                    writer.uint32(/* id 132766, wireType 2 =*/1062130).string(message.rpCode[i]);
            if (message.ssboe != null && Object.hasOwnProperty.call(message, "ssboe"))
                writer.uint32(/* id 150100, wireType 0 =*/1200800).int32(message.ssboe);
            if (message.usecs != null && Object.hasOwnProperty.call(message, "usecs"))
                writer.uint32(/* id 150101, wireType 0 =*/1200808).int32(message.usecs);
            if (message.templateId != null && Object.hasOwnProperty.call(message, "templateId"))
                writer.uint32(/* id 154467, wireType 0 =*/1235736).int32(message.templateId);
            if (message.$unknowns != null && Object.hasOwnProperty.call(message, "$unknowns"))
                for (let i = 0; i < message.$unknowns.length; ++i)
                    writer.raw(message.$unknowns[i]);
            return writer;
        };

        /**
         * Encodes the specified ResponseHeartbeat message, length delimited. Does not implicitly {@link rti.ResponseHeartbeat.verify|verify} messages.
         * @function encodeDelimited
         * @memberof rti.ResponseHeartbeat
         * @static
         * @param {rti.ResponseHeartbeat.$Properties} message ResponseHeartbeat message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ResponseHeartbeat.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer && writer.len ? writer.fork() : writer).ldelim();
        };

        /**
         * Decodes a ResponseHeartbeat message from the specified reader or buffer.
         * @function decode
         * @memberof rti.ResponseHeartbeat
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {rti.ResponseHeartbeat & rti.ResponseHeartbeat.$Shape} ResponseHeartbeat
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ResponseHeartbeat.decode = function decode(reader, length, _end, _depth, _target) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $Reader.recursionLimit)
                throw Error("max depth exceeded");
            let end = length === undefined ? reader.len : reader.pos + length, message = _target || new $root.rti.ResponseHeartbeat(), value;
            while (reader.pos < end) {
                let start = reader.pos;
                let tag = reader.tag();
                if (tag === _end) {
                    _end = undefined;
                    break;
                }
                let wireType = tag & 7;
                switch (tag >>>= 3) {
                case 154467: {
                        if (wireType !== 0)
                            break;
                        if (value = reader.int32())
                            message.templateId = value;
                        else
                            delete message.templateId;
                        continue;
                    }
                case 132760: {
                        if (wireType !== 2)
                            break;
                        if (!(message.userMsg && message.userMsg.length))
                            message.userMsg = [];
                        message.userMsg.push(reader.string());
                        continue;
                    }
                case 132766: {
                        if (wireType !== 2)
                            break;
                        if (!(message.rpCode && message.rpCode.length))
                            message.rpCode = [];
                        message.rpCode.push(reader.string());
                        continue;
                    }
                case 150100: {
                        if (wireType !== 0)
                            break;
                        if (value = reader.int32())
                            message.ssboe = value;
                        else
                            delete message.ssboe;
                        continue;
                    }
                case 150101: {
                        if (wireType !== 0)
                            break;
                        if (value = reader.int32())
                            message.usecs = value;
                        else
                            delete message.usecs;
                        continue;
                    }
                }
                reader.skipType(wireType, _depth, tag);
                if (!reader.discardUnknown) {
                    $util.makeProp(message, "$unknowns", false);
                    (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
                }
            }
            if (_end !== undefined)
                throw Error("missing end group");
            return message;
        };

        /**
         * Decodes a ResponseHeartbeat message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof rti.ResponseHeartbeat
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {rti.ResponseHeartbeat & rti.ResponseHeartbeat.$Shape} ResponseHeartbeat
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ResponseHeartbeat.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ResponseHeartbeat message.
         * @function verify
         * @memberof rti.ResponseHeartbeat
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ResponseHeartbeat.verify = function verify(message, _depth) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                return "max depth exceeded";
            if (message.templateId != null && message.hasOwnProperty("templateId"))
                if (!$util.isInteger(message.templateId))
                    return "templateId: integer expected";
            if (message.userMsg != null && message.hasOwnProperty("userMsg")) {
                if (!Array.isArray(message.userMsg))
                    return "userMsg: array expected";
                for (let i = 0; i < message.userMsg.length; ++i)
                    if (!$util.isString(message.userMsg[i]))
                        return "userMsg: string[] expected";
            }
            if (message.rpCode != null && message.hasOwnProperty("rpCode")) {
                if (!Array.isArray(message.rpCode))
                    return "rpCode: array expected";
                for (let i = 0; i < message.rpCode.length; ++i)
                    if (!$util.isString(message.rpCode[i]))
                        return "rpCode: string[] expected";
            }
            if (message.ssboe != null && message.hasOwnProperty("ssboe"))
                if (!$util.isInteger(message.ssboe))
                    return "ssboe: integer expected";
            if (message.usecs != null && message.hasOwnProperty("usecs"))
                if (!$util.isInteger(message.usecs))
                    return "usecs: integer expected";
            return null;
        };

        /**
         * Creates a ResponseHeartbeat message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof rti.ResponseHeartbeat
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {rti.ResponseHeartbeat} ResponseHeartbeat
         */
        ResponseHeartbeat.fromObject = function fromObject(object, _depth) {
            if (object instanceof $root.rti.ResponseHeartbeat)
                return object;
            if (!$util.isObject(object))
                throw TypeError(".rti.ResponseHeartbeat: object expected");
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw Error("max depth exceeded");
            let message = new $root.rti.ResponseHeartbeat();
            if (object.templateId != null)
                if (Number(object.templateId) !== 0)
                    message.templateId = object.templateId | 0;
            if (object.userMsg) {
                if (!Array.isArray(object.userMsg))
                    throw TypeError(".rti.ResponseHeartbeat.userMsg: array expected");
                message.userMsg = Array(object.userMsg.length);
                for (let i = 0; i < object.userMsg.length; ++i)
                    message.userMsg[i] = String(object.userMsg[i]);
            }
            if (object.rpCode) {
                if (!Array.isArray(object.rpCode))
                    throw TypeError(".rti.ResponseHeartbeat.rpCode: array expected");
                message.rpCode = Array(object.rpCode.length);
                for (let i = 0; i < object.rpCode.length; ++i)
                    message.rpCode[i] = String(object.rpCode[i]);
            }
            if (object.ssboe != null)
                if (Number(object.ssboe) !== 0)
                    message.ssboe = object.ssboe | 0;
            if (object.usecs != null)
                if (Number(object.usecs) !== 0)
                    message.usecs = object.usecs | 0;
            return message;
        };

        /**
         * Creates a plain object from a ResponseHeartbeat message. Also converts values to other types if specified.
         * @function toObject
         * @memberof rti.ResponseHeartbeat
         * @static
         * @param {rti.ResponseHeartbeat} message ResponseHeartbeat
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ResponseHeartbeat.toObject = function toObject(message, options, _depth) {
            if (!options)
                options = {};
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw Error("max depth exceeded");
            let object = {};
            if (options.arrays || options.defaults) {
                object.userMsg = [];
                object.rpCode = [];
            }
            if (options.defaults) {
                object.ssboe = 0;
                object.usecs = 0;
                object.templateId = 0;
            }
            if (message.userMsg && message.userMsg.length) {
                object.userMsg = Array(message.userMsg.length);
                for (let j = 0; j < message.userMsg.length; ++j)
                    object.userMsg[j] = message.userMsg[j];
            }
            if (message.rpCode && message.rpCode.length) {
                object.rpCode = Array(message.rpCode.length);
                for (let j = 0; j < message.rpCode.length; ++j)
                    object.rpCode[j] = message.rpCode[j];
            }
            if (message.ssboe != null && message.hasOwnProperty("ssboe"))
                object.ssboe = message.ssboe;
            if (message.usecs != null && message.hasOwnProperty("usecs"))
                object.usecs = message.usecs;
            if (message.templateId != null && message.hasOwnProperty("templateId"))
                object.templateId = message.templateId;
            return object;
        };

        /**
         * Converts this ResponseHeartbeat to JSON.
         * @function toJSON
         * @memberof rti.ResponseHeartbeat
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ResponseHeartbeat.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the type url for ResponseHeartbeat
         * @function getTypeUrl
         * @memberof rti.ResponseHeartbeat
         * @static
         * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
         * @returns {string} The type url
         */
        ResponseHeartbeat.getTypeUrl = function getTypeUrl(prefix) {
            if (prefix === undefined)
                prefix = "type.googleapis.com";
            return prefix + "/rti.ResponseHeartbeat";
        };

        return ResponseHeartbeat;
    })();

    rti.ResponseLogin = (function() {

        /**
         * Properties of a ResponseLogin.
         * @typedef {Object} rti.ResponseLogin.$Properties
         * @property {number|null} [templateId] ResponseLogin templateId
         * @property {string|null} [templateVersion] ResponseLogin templateVersion
         * @property {Array.<string>|null} [userMsg] ResponseLogin userMsg
         * @property {Array.<string>|null} [rpCode] ResponseLogin rpCode
         * @property {string|null} [fcmId] ResponseLogin fcmId
         * @property {string|null} [ibId] ResponseLogin ibId
         * @property {string|null} [countryCode] ResponseLogin countryCode
         * @property {string|null} [stateCode] ResponseLogin stateCode
         * @property {string|null} [uniqueUserId] ResponseLogin uniqueUserId
         * @property {number|null} [heartbeatInterval] ResponseLogin heartbeatInterval
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding
         */

        /**
         * Properties of a ResponseLogin.
         * @memberof rti
         * @interface IResponseLogin
         * @augments rti.ResponseLogin.$Properties
         * @deprecated Use rti.ResponseLogin.$Properties instead.
         */

        /**
         * Shape of a ResponseLogin.
         * @typedef {rti.ResponseLogin.$Properties} rti.ResponseLogin.$Shape
         */

        /**
         * Constructs a new ResponseLogin.
         * @memberof rti
         * @classdesc Represents a ResponseLogin.
         * @constructor
         * @param {rti.ResponseLogin.$Properties=} [properties] Properties to set
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding
         */
        function ResponseLogin(properties) {
            this.userMsg = [];
            this.rpCode = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null && keys[i] !== "__proto__")
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ResponseLogin templateId.
         * @member {number} templateId
         * @memberof rti.ResponseLogin
         * @instance
         */
        ResponseLogin.prototype.templateId = 0;

        /**
         * ResponseLogin templateVersion.
         * @member {string} templateVersion
         * @memberof rti.ResponseLogin
         * @instance
         */
        ResponseLogin.prototype.templateVersion = "";

        /**
         * ResponseLogin userMsg.
         * @member {Array.<string>} userMsg
         * @memberof rti.ResponseLogin
         * @instance
         */
        ResponseLogin.prototype.userMsg = $util.emptyArray;

        /**
         * ResponseLogin rpCode.
         * @member {Array.<string>} rpCode
         * @memberof rti.ResponseLogin
         * @instance
         */
        ResponseLogin.prototype.rpCode = $util.emptyArray;

        /**
         * ResponseLogin fcmId.
         * @member {string} fcmId
         * @memberof rti.ResponseLogin
         * @instance
         */
        ResponseLogin.prototype.fcmId = "";

        /**
         * ResponseLogin ibId.
         * @member {string} ibId
         * @memberof rti.ResponseLogin
         * @instance
         */
        ResponseLogin.prototype.ibId = "";

        /**
         * ResponseLogin countryCode.
         * @member {string} countryCode
         * @memberof rti.ResponseLogin
         * @instance
         */
        ResponseLogin.prototype.countryCode = "";

        /**
         * ResponseLogin stateCode.
         * @member {string} stateCode
         * @memberof rti.ResponseLogin
         * @instance
         */
        ResponseLogin.prototype.stateCode = "";

        /**
         * ResponseLogin uniqueUserId.
         * @member {string} uniqueUserId
         * @memberof rti.ResponseLogin
         * @instance
         */
        ResponseLogin.prototype.uniqueUserId = "";

        /**
         * ResponseLogin heartbeatInterval.
         * @member {number} heartbeatInterval
         * @memberof rti.ResponseLogin
         * @instance
         */
        ResponseLogin.prototype.heartbeatInterval = 0;

        /**
         * Creates a new ResponseLogin instance using the specified properties.
         * @function create
         * @memberof rti.ResponseLogin
         * @static
         * @param {rti.ResponseLogin.$Properties=} [properties] Properties to set
         * @returns {rti.ResponseLogin} ResponseLogin instance
         * @type {{
         *   (properties: rti.ResponseLogin.$Shape): rti.ResponseLogin & rti.ResponseLogin.$Shape;
         *   (properties?: rti.ResponseLogin.$Properties): rti.ResponseLogin;
         * }}
         */
        ResponseLogin.create = function create(properties) {
            return new ResponseLogin(properties);
        };

        /**
         * Encodes the specified ResponseLogin message. Does not implicitly {@link rti.ResponseLogin.verify|verify} messages.
         * @function encode
         * @memberof rti.ResponseLogin
         * @static
         * @param {rti.ResponseLogin.$Properties} message ResponseLogin message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ResponseLogin.encode = function encode(message, writer, _depth) {
            if (!writer)
                writer = $Writer.create();
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw Error("max depth exceeded");
            if (message.userMsg != null && message.userMsg.length)
                for (let i = 0; i < message.userMsg.length; ++i)
                    writer.uint32(/* id 132760, wireType 2 =*/1062082).string(message.userMsg[i]);
            if (message.rpCode != null && message.rpCode.length)
                for (let i = 0; i < message.rpCode.length; ++i)
                    writer.uint32(/* id 132766, wireType 2 =*/1062130).string(message.rpCode[i]);
            if (message.uniqueUserId != null && Object.hasOwnProperty.call(message, "uniqueUserId"))
                writer.uint32(/* id 153428, wireType 2 =*/1227426).string(message.uniqueUserId);
            if (message.heartbeatInterval != null && Object.hasOwnProperty.call(message, "heartbeatInterval"))
                writer.uint32(/* id 153633, wireType 1 =*/1229065).double(message.heartbeatInterval);
            if (message.templateVersion != null && Object.hasOwnProperty.call(message, "templateVersion"))
                writer.uint32(/* id 153634, wireType 2 =*/1229074).string(message.templateVersion);
            if (message.fcmId != null && Object.hasOwnProperty.call(message, "fcmId"))
                writer.uint32(/* id 154013, wireType 2 =*/1232106).string(message.fcmId);
            if (message.ibId != null && Object.hasOwnProperty.call(message, "ibId"))
                writer.uint32(/* id 154014, wireType 2 =*/1232114).string(message.ibId);
            if (message.templateId != null && Object.hasOwnProperty.call(message, "templateId"))
                writer.uint32(/* id 154467, wireType 0 =*/1235736).int32(message.templateId);
            if (message.countryCode != null && Object.hasOwnProperty.call(message, "countryCode"))
                writer.uint32(/* id 154712, wireType 2 =*/1237698).string(message.countryCode);
            if (message.stateCode != null && Object.hasOwnProperty.call(message, "stateCode"))
                writer.uint32(/* id 154713, wireType 2 =*/1237706).string(message.stateCode);
            if (message.$unknowns != null && Object.hasOwnProperty.call(message, "$unknowns"))
                for (let i = 0; i < message.$unknowns.length; ++i)
                    writer.raw(message.$unknowns[i]);
            return writer;
        };

        /**
         * Encodes the specified ResponseLogin message, length delimited. Does not implicitly {@link rti.ResponseLogin.verify|verify} messages.
         * @function encodeDelimited
         * @memberof rti.ResponseLogin
         * @static
         * @param {rti.ResponseLogin.$Properties} message ResponseLogin message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ResponseLogin.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer && writer.len ? writer.fork() : writer).ldelim();
        };

        /**
         * Decodes a ResponseLogin message from the specified reader or buffer.
         * @function decode
         * @memberof rti.ResponseLogin
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {rti.ResponseLogin & rti.ResponseLogin.$Shape} ResponseLogin
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ResponseLogin.decode = function decode(reader, length, _end, _depth, _target) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $Reader.recursionLimit)
                throw Error("max depth exceeded");
            let end = length === undefined ? reader.len : reader.pos + length, message = _target || new $root.rti.ResponseLogin(), value;
            while (reader.pos < end) {
                let start = reader.pos;
                let tag = reader.tag();
                if (tag === _end) {
                    _end = undefined;
                    break;
                }
                let wireType = tag & 7;
                switch (tag >>>= 3) {
                case 154467: {
                        if (wireType !== 0)
                            break;
                        if (value = reader.int32())
                            message.templateId = value;
                        else
                            delete message.templateId;
                        continue;
                    }
                case 153634: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.string()).length)
                            message.templateVersion = value;
                        else
                            delete message.templateVersion;
                        continue;
                    }
                case 132760: {
                        if (wireType !== 2)
                            break;
                        if (!(message.userMsg && message.userMsg.length))
                            message.userMsg = [];
                        message.userMsg.push(reader.string());
                        continue;
                    }
                case 132766: {
                        if (wireType !== 2)
                            break;
                        if (!(message.rpCode && message.rpCode.length))
                            message.rpCode = [];
                        message.rpCode.push(reader.string());
                        continue;
                    }
                case 154013: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.string()).length)
                            message.fcmId = value;
                        else
                            delete message.fcmId;
                        continue;
                    }
                case 154014: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.string()).length)
                            message.ibId = value;
                        else
                            delete message.ibId;
                        continue;
                    }
                case 154712: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.string()).length)
                            message.countryCode = value;
                        else
                            delete message.countryCode;
                        continue;
                    }
                case 154713: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.string()).length)
                            message.stateCode = value;
                        else
                            delete message.stateCode;
                        continue;
                    }
                case 153428: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.string()).length)
                            message.uniqueUserId = value;
                        else
                            delete message.uniqueUserId;
                        continue;
                    }
                case 153633: {
                        if (wireType !== 1)
                            break;
                        if ((value = reader.double()) !== 0)
                            message.heartbeatInterval = value;
                        else
                            delete message.heartbeatInterval;
                        continue;
                    }
                }
                reader.skipType(wireType, _depth, tag);
                if (!reader.discardUnknown) {
                    $util.makeProp(message, "$unknowns", false);
                    (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
                }
            }
            if (_end !== undefined)
                throw Error("missing end group");
            return message;
        };

        /**
         * Decodes a ResponseLogin message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof rti.ResponseLogin
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {rti.ResponseLogin & rti.ResponseLogin.$Shape} ResponseLogin
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ResponseLogin.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ResponseLogin message.
         * @function verify
         * @memberof rti.ResponseLogin
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ResponseLogin.verify = function verify(message, _depth) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                return "max depth exceeded";
            if (message.templateId != null && message.hasOwnProperty("templateId"))
                if (!$util.isInteger(message.templateId))
                    return "templateId: integer expected";
            if (message.templateVersion != null && message.hasOwnProperty("templateVersion"))
                if (!$util.isString(message.templateVersion))
                    return "templateVersion: string expected";
            if (message.userMsg != null && message.hasOwnProperty("userMsg")) {
                if (!Array.isArray(message.userMsg))
                    return "userMsg: array expected";
                for (let i = 0; i < message.userMsg.length; ++i)
                    if (!$util.isString(message.userMsg[i]))
                        return "userMsg: string[] expected";
            }
            if (message.rpCode != null && message.hasOwnProperty("rpCode")) {
                if (!Array.isArray(message.rpCode))
                    return "rpCode: array expected";
                for (let i = 0; i < message.rpCode.length; ++i)
                    if (!$util.isString(message.rpCode[i]))
                        return "rpCode: string[] expected";
            }
            if (message.fcmId != null && message.hasOwnProperty("fcmId"))
                if (!$util.isString(message.fcmId))
                    return "fcmId: string expected";
            if (message.ibId != null && message.hasOwnProperty("ibId"))
                if (!$util.isString(message.ibId))
                    return "ibId: string expected";
            if (message.countryCode != null && message.hasOwnProperty("countryCode"))
                if (!$util.isString(message.countryCode))
                    return "countryCode: string expected";
            if (message.stateCode != null && message.hasOwnProperty("stateCode"))
                if (!$util.isString(message.stateCode))
                    return "stateCode: string expected";
            if (message.uniqueUserId != null && message.hasOwnProperty("uniqueUserId"))
                if (!$util.isString(message.uniqueUserId))
                    return "uniqueUserId: string expected";
            if (message.heartbeatInterval != null && message.hasOwnProperty("heartbeatInterval"))
                if (typeof message.heartbeatInterval !== "number")
                    return "heartbeatInterval: number expected";
            return null;
        };

        /**
         * Creates a ResponseLogin message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof rti.ResponseLogin
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {rti.ResponseLogin} ResponseLogin
         */
        ResponseLogin.fromObject = function fromObject(object, _depth) {
            if (object instanceof $root.rti.ResponseLogin)
                return object;
            if (!$util.isObject(object))
                throw TypeError(".rti.ResponseLogin: object expected");
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw Error("max depth exceeded");
            let message = new $root.rti.ResponseLogin();
            if (object.templateId != null)
                if (Number(object.templateId) !== 0)
                    message.templateId = object.templateId | 0;
            if (object.templateVersion != null)
                if (typeof object.templateVersion !== "string" || object.templateVersion.length)
                    message.templateVersion = String(object.templateVersion);
            if (object.userMsg) {
                if (!Array.isArray(object.userMsg))
                    throw TypeError(".rti.ResponseLogin.userMsg: array expected");
                message.userMsg = Array(object.userMsg.length);
                for (let i = 0; i < object.userMsg.length; ++i)
                    message.userMsg[i] = String(object.userMsg[i]);
            }
            if (object.rpCode) {
                if (!Array.isArray(object.rpCode))
                    throw TypeError(".rti.ResponseLogin.rpCode: array expected");
                message.rpCode = Array(object.rpCode.length);
                for (let i = 0; i < object.rpCode.length; ++i)
                    message.rpCode[i] = String(object.rpCode[i]);
            }
            if (object.fcmId != null)
                if (typeof object.fcmId !== "string" || object.fcmId.length)
                    message.fcmId = String(object.fcmId);
            if (object.ibId != null)
                if (typeof object.ibId !== "string" || object.ibId.length)
                    message.ibId = String(object.ibId);
            if (object.countryCode != null)
                if (typeof object.countryCode !== "string" || object.countryCode.length)
                    message.countryCode = String(object.countryCode);
            if (object.stateCode != null)
                if (typeof object.stateCode !== "string" || object.stateCode.length)
                    message.stateCode = String(object.stateCode);
            if (object.uniqueUserId != null)
                if (typeof object.uniqueUserId !== "string" || object.uniqueUserId.length)
                    message.uniqueUserId = String(object.uniqueUserId);
            if (object.heartbeatInterval != null)
                if (Number(object.heartbeatInterval) !== 0)
                    message.heartbeatInterval = Number(object.heartbeatInterval);
            return message;
        };

        /**
         * Creates a plain object from a ResponseLogin message. Also converts values to other types if specified.
         * @function toObject
         * @memberof rti.ResponseLogin
         * @static
         * @param {rti.ResponseLogin} message ResponseLogin
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ResponseLogin.toObject = function toObject(message, options, _depth) {
            if (!options)
                options = {};
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw Error("max depth exceeded");
            let object = {};
            if (options.arrays || options.defaults) {
                object.userMsg = [];
                object.rpCode = [];
            }
            if (options.defaults) {
                object.uniqueUserId = "";
                object.heartbeatInterval = 0;
                object.templateVersion = "";
                object.fcmId = "";
                object.ibId = "";
                object.templateId = 0;
                object.countryCode = "";
                object.stateCode = "";
            }
            if (message.userMsg && message.userMsg.length) {
                object.userMsg = Array(message.userMsg.length);
                for (let j = 0; j < message.userMsg.length; ++j)
                    object.userMsg[j] = message.userMsg[j];
            }
            if (message.rpCode && message.rpCode.length) {
                object.rpCode = Array(message.rpCode.length);
                for (let j = 0; j < message.rpCode.length; ++j)
                    object.rpCode[j] = message.rpCode[j];
            }
            if (message.uniqueUserId != null && message.hasOwnProperty("uniqueUserId"))
                object.uniqueUserId = message.uniqueUserId;
            if (message.heartbeatInterval != null && message.hasOwnProperty("heartbeatInterval"))
                object.heartbeatInterval = options.json && !isFinite(message.heartbeatInterval) ? String(message.heartbeatInterval) : message.heartbeatInterval;
            if (message.templateVersion != null && message.hasOwnProperty("templateVersion"))
                object.templateVersion = message.templateVersion;
            if (message.fcmId != null && message.hasOwnProperty("fcmId"))
                object.fcmId = message.fcmId;
            if (message.ibId != null && message.hasOwnProperty("ibId"))
                object.ibId = message.ibId;
            if (message.templateId != null && message.hasOwnProperty("templateId"))
                object.templateId = message.templateId;
            if (message.countryCode != null && message.hasOwnProperty("countryCode"))
                object.countryCode = message.countryCode;
            if (message.stateCode != null && message.hasOwnProperty("stateCode"))
                object.stateCode = message.stateCode;
            return object;
        };

        /**
         * Converts this ResponseLogin to JSON.
         * @function toJSON
         * @memberof rti.ResponseLogin
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ResponseLogin.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the type url for ResponseLogin
         * @function getTypeUrl
         * @memberof rti.ResponseLogin
         * @static
         * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
         * @returns {string} The type url
         */
        ResponseLogin.getTypeUrl = function getTypeUrl(prefix) {
            if (prefix === undefined)
                prefix = "type.googleapis.com";
            return prefix + "/rti.ResponseLogin";
        };

        return ResponseLogin;
    })();

    rti.ResponseLogout = (function() {

        /**
         * Properties of a ResponseLogout.
         * @typedef {Object} rti.ResponseLogout.$Properties
         * @property {number|null} [templateId] ResponseLogout templateId
         * @property {Array.<string>|null} [userMsg] ResponseLogout userMsg
         * @property {Array.<string>|null} [rpCode] ResponseLogout rpCode
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding
         */

        /**
         * Properties of a ResponseLogout.
         * @memberof rti
         * @interface IResponseLogout
         * @augments rti.ResponseLogout.$Properties
         * @deprecated Use rti.ResponseLogout.$Properties instead.
         */

        /**
         * Shape of a ResponseLogout.
         * @typedef {rti.ResponseLogout.$Properties} rti.ResponseLogout.$Shape
         */

        /**
         * Constructs a new ResponseLogout.
         * @memberof rti
         * @classdesc Represents a ResponseLogout.
         * @constructor
         * @param {rti.ResponseLogout.$Properties=} [properties] Properties to set
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding
         */
        function ResponseLogout(properties) {
            this.userMsg = [];
            this.rpCode = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null && keys[i] !== "__proto__")
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ResponseLogout templateId.
         * @member {number} templateId
         * @memberof rti.ResponseLogout
         * @instance
         */
        ResponseLogout.prototype.templateId = 0;

        /**
         * ResponseLogout userMsg.
         * @member {Array.<string>} userMsg
         * @memberof rti.ResponseLogout
         * @instance
         */
        ResponseLogout.prototype.userMsg = $util.emptyArray;

        /**
         * ResponseLogout rpCode.
         * @member {Array.<string>} rpCode
         * @memberof rti.ResponseLogout
         * @instance
         */
        ResponseLogout.prototype.rpCode = $util.emptyArray;

        /**
         * Creates a new ResponseLogout instance using the specified properties.
         * @function create
         * @memberof rti.ResponseLogout
         * @static
         * @param {rti.ResponseLogout.$Properties=} [properties] Properties to set
         * @returns {rti.ResponseLogout} ResponseLogout instance
         * @type {{
         *   (properties: rti.ResponseLogout.$Shape): rti.ResponseLogout & rti.ResponseLogout.$Shape;
         *   (properties?: rti.ResponseLogout.$Properties): rti.ResponseLogout;
         * }}
         */
        ResponseLogout.create = function create(properties) {
            return new ResponseLogout(properties);
        };

        /**
         * Encodes the specified ResponseLogout message. Does not implicitly {@link rti.ResponseLogout.verify|verify} messages.
         * @function encode
         * @memberof rti.ResponseLogout
         * @static
         * @param {rti.ResponseLogout.$Properties} message ResponseLogout message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ResponseLogout.encode = function encode(message, writer, _depth) {
            if (!writer)
                writer = $Writer.create();
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw Error("max depth exceeded");
            if (message.userMsg != null && message.userMsg.length)
                for (let i = 0; i < message.userMsg.length; ++i)
                    writer.uint32(/* id 132760, wireType 2 =*/1062082).string(message.userMsg[i]);
            if (message.rpCode != null && message.rpCode.length)
                for (let i = 0; i < message.rpCode.length; ++i)
                    writer.uint32(/* id 132766, wireType 2 =*/1062130).string(message.rpCode[i]);
            if (message.templateId != null && Object.hasOwnProperty.call(message, "templateId"))
                writer.uint32(/* id 154467, wireType 0 =*/1235736).int32(message.templateId);
            if (message.$unknowns != null && Object.hasOwnProperty.call(message, "$unknowns"))
                for (let i = 0; i < message.$unknowns.length; ++i)
                    writer.raw(message.$unknowns[i]);
            return writer;
        };

        /**
         * Encodes the specified ResponseLogout message, length delimited. Does not implicitly {@link rti.ResponseLogout.verify|verify} messages.
         * @function encodeDelimited
         * @memberof rti.ResponseLogout
         * @static
         * @param {rti.ResponseLogout.$Properties} message ResponseLogout message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ResponseLogout.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer && writer.len ? writer.fork() : writer).ldelim();
        };

        /**
         * Decodes a ResponseLogout message from the specified reader or buffer.
         * @function decode
         * @memberof rti.ResponseLogout
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {rti.ResponseLogout & rti.ResponseLogout.$Shape} ResponseLogout
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ResponseLogout.decode = function decode(reader, length, _end, _depth, _target) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $Reader.recursionLimit)
                throw Error("max depth exceeded");
            let end = length === undefined ? reader.len : reader.pos + length, message = _target || new $root.rti.ResponseLogout(), value;
            while (reader.pos < end) {
                let start = reader.pos;
                let tag = reader.tag();
                if (tag === _end) {
                    _end = undefined;
                    break;
                }
                let wireType = tag & 7;
                switch (tag >>>= 3) {
                case 154467: {
                        if (wireType !== 0)
                            break;
                        if (value = reader.int32())
                            message.templateId = value;
                        else
                            delete message.templateId;
                        continue;
                    }
                case 132760: {
                        if (wireType !== 2)
                            break;
                        if (!(message.userMsg && message.userMsg.length))
                            message.userMsg = [];
                        message.userMsg.push(reader.string());
                        continue;
                    }
                case 132766: {
                        if (wireType !== 2)
                            break;
                        if (!(message.rpCode && message.rpCode.length))
                            message.rpCode = [];
                        message.rpCode.push(reader.string());
                        continue;
                    }
                }
                reader.skipType(wireType, _depth, tag);
                if (!reader.discardUnknown) {
                    $util.makeProp(message, "$unknowns", false);
                    (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
                }
            }
            if (_end !== undefined)
                throw Error("missing end group");
            return message;
        };

        /**
         * Decodes a ResponseLogout message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof rti.ResponseLogout
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {rti.ResponseLogout & rti.ResponseLogout.$Shape} ResponseLogout
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ResponseLogout.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ResponseLogout message.
         * @function verify
         * @memberof rti.ResponseLogout
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ResponseLogout.verify = function verify(message, _depth) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                return "max depth exceeded";
            if (message.templateId != null && message.hasOwnProperty("templateId"))
                if (!$util.isInteger(message.templateId))
                    return "templateId: integer expected";
            if (message.userMsg != null && message.hasOwnProperty("userMsg")) {
                if (!Array.isArray(message.userMsg))
                    return "userMsg: array expected";
                for (let i = 0; i < message.userMsg.length; ++i)
                    if (!$util.isString(message.userMsg[i]))
                        return "userMsg: string[] expected";
            }
            if (message.rpCode != null && message.hasOwnProperty("rpCode")) {
                if (!Array.isArray(message.rpCode))
                    return "rpCode: array expected";
                for (let i = 0; i < message.rpCode.length; ++i)
                    if (!$util.isString(message.rpCode[i]))
                        return "rpCode: string[] expected";
            }
            return null;
        };

        /**
         * Creates a ResponseLogout message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof rti.ResponseLogout
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {rti.ResponseLogout} ResponseLogout
         */
        ResponseLogout.fromObject = function fromObject(object, _depth) {
            if (object instanceof $root.rti.ResponseLogout)
                return object;
            if (!$util.isObject(object))
                throw TypeError(".rti.ResponseLogout: object expected");
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw Error("max depth exceeded");
            let message = new $root.rti.ResponseLogout();
            if (object.templateId != null)
                if (Number(object.templateId) !== 0)
                    message.templateId = object.templateId | 0;
            if (object.userMsg) {
                if (!Array.isArray(object.userMsg))
                    throw TypeError(".rti.ResponseLogout.userMsg: array expected");
                message.userMsg = Array(object.userMsg.length);
                for (let i = 0; i < object.userMsg.length; ++i)
                    message.userMsg[i] = String(object.userMsg[i]);
            }
            if (object.rpCode) {
                if (!Array.isArray(object.rpCode))
                    throw TypeError(".rti.ResponseLogout.rpCode: array expected");
                message.rpCode = Array(object.rpCode.length);
                for (let i = 0; i < object.rpCode.length; ++i)
                    message.rpCode[i] = String(object.rpCode[i]);
            }
            return message;
        };

        /**
         * Creates a plain object from a ResponseLogout message. Also converts values to other types if specified.
         * @function toObject
         * @memberof rti.ResponseLogout
         * @static
         * @param {rti.ResponseLogout} message ResponseLogout
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ResponseLogout.toObject = function toObject(message, options, _depth) {
            if (!options)
                options = {};
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw Error("max depth exceeded");
            let object = {};
            if (options.arrays || options.defaults) {
                object.userMsg = [];
                object.rpCode = [];
            }
            if (options.defaults)
                object.templateId = 0;
            if (message.userMsg && message.userMsg.length) {
                object.userMsg = Array(message.userMsg.length);
                for (let j = 0; j < message.userMsg.length; ++j)
                    object.userMsg[j] = message.userMsg[j];
            }
            if (message.rpCode && message.rpCode.length) {
                object.rpCode = Array(message.rpCode.length);
                for (let j = 0; j < message.rpCode.length; ++j)
                    object.rpCode[j] = message.rpCode[j];
            }
            if (message.templateId != null && message.hasOwnProperty("templateId"))
                object.templateId = message.templateId;
            return object;
        };

        /**
         * Converts this ResponseLogout to JSON.
         * @function toJSON
         * @memberof rti.ResponseLogout
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ResponseLogout.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the type url for ResponseLogout
         * @function getTypeUrl
         * @memberof rti.ResponseLogout
         * @static
         * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
         * @returns {string} The type url
         */
        ResponseLogout.getTypeUrl = function getTypeUrl(prefix) {
            if (prefix === undefined)
                prefix = "type.googleapis.com";
            return prefix + "/rti.ResponseLogout";
        };

        return ResponseLogout;
    })();

    rti.ResponseRithmicSystemInfo = (function() {

        /**
         * Properties of a ResponseRithmicSystemInfo.
         * @typedef {Object} rti.ResponseRithmicSystemInfo.$Properties
         * @property {number|null} [templateId] ResponseRithmicSystemInfo templateId
         * @property {Array.<string>|null} [userMsg] ResponseRithmicSystemInfo userMsg
         * @property {Array.<string>|null} [rpCode] ResponseRithmicSystemInfo rpCode
         * @property {Array.<string>|null} [systemName] ResponseRithmicSystemInfo systemName
         * @property {Array.<boolean>|null} [hasAggregatedQuotes] ResponseRithmicSystemInfo hasAggregatedQuotes
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding
         */

        /**
         * Properties of a ResponseRithmicSystemInfo.
         * @memberof rti
         * @interface IResponseRithmicSystemInfo
         * @augments rti.ResponseRithmicSystemInfo.$Properties
         * @deprecated Use rti.ResponseRithmicSystemInfo.$Properties instead.
         */

        /**
         * Shape of a ResponseRithmicSystemInfo.
         * @typedef {rti.ResponseRithmicSystemInfo.$Properties} rti.ResponseRithmicSystemInfo.$Shape
         */

        /**
         * Constructs a new ResponseRithmicSystemInfo.
         * @memberof rti
         * @classdesc Represents a ResponseRithmicSystemInfo.
         * @constructor
         * @param {rti.ResponseRithmicSystemInfo.$Properties=} [properties] Properties to set
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding
         */
        function ResponseRithmicSystemInfo(properties) {
            this.userMsg = [];
            this.rpCode = [];
            this.systemName = [];
            this.hasAggregatedQuotes = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null && keys[i] !== "__proto__")
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ResponseRithmicSystemInfo templateId.
         * @member {number} templateId
         * @memberof rti.ResponseRithmicSystemInfo
         * @instance
         */
        ResponseRithmicSystemInfo.prototype.templateId = 0;

        /**
         * ResponseRithmicSystemInfo userMsg.
         * @member {Array.<string>} userMsg
         * @memberof rti.ResponseRithmicSystemInfo
         * @instance
         */
        ResponseRithmicSystemInfo.prototype.userMsg = $util.emptyArray;

        /**
         * ResponseRithmicSystemInfo rpCode.
         * @member {Array.<string>} rpCode
         * @memberof rti.ResponseRithmicSystemInfo
         * @instance
         */
        ResponseRithmicSystemInfo.prototype.rpCode = $util.emptyArray;

        /**
         * ResponseRithmicSystemInfo systemName.
         * @member {Array.<string>} systemName
         * @memberof rti.ResponseRithmicSystemInfo
         * @instance
         */
        ResponseRithmicSystemInfo.prototype.systemName = $util.emptyArray;

        /**
         * ResponseRithmicSystemInfo hasAggregatedQuotes.
         * @member {Array.<boolean>} hasAggregatedQuotes
         * @memberof rti.ResponseRithmicSystemInfo
         * @instance
         */
        ResponseRithmicSystemInfo.prototype.hasAggregatedQuotes = $util.emptyArray;

        /**
         * Creates a new ResponseRithmicSystemInfo instance using the specified properties.
         * @function create
         * @memberof rti.ResponseRithmicSystemInfo
         * @static
         * @param {rti.ResponseRithmicSystemInfo.$Properties=} [properties] Properties to set
         * @returns {rti.ResponseRithmicSystemInfo} ResponseRithmicSystemInfo instance
         * @type {{
         *   (properties: rti.ResponseRithmicSystemInfo.$Shape): rti.ResponseRithmicSystemInfo & rti.ResponseRithmicSystemInfo.$Shape;
         *   (properties?: rti.ResponseRithmicSystemInfo.$Properties): rti.ResponseRithmicSystemInfo;
         * }}
         */
        ResponseRithmicSystemInfo.create = function create(properties) {
            return new ResponseRithmicSystemInfo(properties);
        };

        /**
         * Encodes the specified ResponseRithmicSystemInfo message. Does not implicitly {@link rti.ResponseRithmicSystemInfo.verify|verify} messages.
         * @function encode
         * @memberof rti.ResponseRithmicSystemInfo
         * @static
         * @param {rti.ResponseRithmicSystemInfo.$Properties} message ResponseRithmicSystemInfo message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ResponseRithmicSystemInfo.encode = function encode(message, writer, _depth) {
            if (!writer)
                writer = $Writer.create();
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw Error("max depth exceeded");
            if (message.userMsg != null && message.userMsg.length)
                for (let i = 0; i < message.userMsg.length; ++i)
                    writer.uint32(/* id 132760, wireType 2 =*/1062082).string(message.userMsg[i]);
            if (message.rpCode != null && message.rpCode.length)
                for (let i = 0; i < message.rpCode.length; ++i)
                    writer.uint32(/* id 132766, wireType 2 =*/1062130).string(message.rpCode[i]);
            if (message.systemName != null && message.systemName.length)
                for (let i = 0; i < message.systemName.length; ++i)
                    writer.uint32(/* id 153628, wireType 2 =*/1229026).string(message.systemName[i]);
            if (message.hasAggregatedQuotes != null && message.hasAggregatedQuotes.length) {
                writer.uint32(/* id 153649, wireType 2 =*/1229194).fork();
                for (let i = 0; i < message.hasAggregatedQuotes.length; ++i)
                    writer.bool(message.hasAggregatedQuotes[i]);
                writer.ldelim();
            }
            if (message.templateId != null && Object.hasOwnProperty.call(message, "templateId"))
                writer.uint32(/* id 154467, wireType 0 =*/1235736).int32(message.templateId);
            if (message.$unknowns != null && Object.hasOwnProperty.call(message, "$unknowns"))
                for (let i = 0; i < message.$unknowns.length; ++i)
                    writer.raw(message.$unknowns[i]);
            return writer;
        };

        /**
         * Encodes the specified ResponseRithmicSystemInfo message, length delimited. Does not implicitly {@link rti.ResponseRithmicSystemInfo.verify|verify} messages.
         * @function encodeDelimited
         * @memberof rti.ResponseRithmicSystemInfo
         * @static
         * @param {rti.ResponseRithmicSystemInfo.$Properties} message ResponseRithmicSystemInfo message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ResponseRithmicSystemInfo.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer && writer.len ? writer.fork() : writer).ldelim();
        };

        /**
         * Decodes a ResponseRithmicSystemInfo message from the specified reader or buffer.
         * @function decode
         * @memberof rti.ResponseRithmicSystemInfo
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {rti.ResponseRithmicSystemInfo & rti.ResponseRithmicSystemInfo.$Shape} ResponseRithmicSystemInfo
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ResponseRithmicSystemInfo.decode = function decode(reader, length, _end, _depth, _target) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $Reader.recursionLimit)
                throw Error("max depth exceeded");
            let end = length === undefined ? reader.len : reader.pos + length, message = _target || new $root.rti.ResponseRithmicSystemInfo(), value;
            while (reader.pos < end) {
                let start = reader.pos;
                let tag = reader.tag();
                if (tag === _end) {
                    _end = undefined;
                    break;
                }
                let wireType = tag & 7;
                switch (tag >>>= 3) {
                case 154467: {
                        if (wireType !== 0)
                            break;
                        if (value = reader.int32())
                            message.templateId = value;
                        else
                            delete message.templateId;
                        continue;
                    }
                case 132760: {
                        if (wireType !== 2)
                            break;
                        if (!(message.userMsg && message.userMsg.length))
                            message.userMsg = [];
                        message.userMsg.push(reader.string());
                        continue;
                    }
                case 132766: {
                        if (wireType !== 2)
                            break;
                        if (!(message.rpCode && message.rpCode.length))
                            message.rpCode = [];
                        message.rpCode.push(reader.string());
                        continue;
                    }
                case 153628: {
                        if (wireType !== 2)
                            break;
                        if (!(message.systemName && message.systemName.length))
                            message.systemName = [];
                        message.systemName.push(reader.string());
                        continue;
                    }
                case 153649: {
                        if (wireType === 2) {
                            if (!(message.hasAggregatedQuotes && message.hasAggregatedQuotes.length))
                                message.hasAggregatedQuotes = [];
                            let end2 = reader.uint32() + reader.pos;
                            while (reader.pos < end2)
                                message.hasAggregatedQuotes.push(reader.bool());
                            continue;
                        }
                        if (wireType !== 0)
                            break;
                        if (!(message.hasAggregatedQuotes && message.hasAggregatedQuotes.length))
                            message.hasAggregatedQuotes = [];
                        message.hasAggregatedQuotes.push(reader.bool());
                        continue;
                    }
                }
                reader.skipType(wireType, _depth, tag);
                if (!reader.discardUnknown) {
                    $util.makeProp(message, "$unknowns", false);
                    (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
                }
            }
            if (_end !== undefined)
                throw Error("missing end group");
            return message;
        };

        /**
         * Decodes a ResponseRithmicSystemInfo message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof rti.ResponseRithmicSystemInfo
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {rti.ResponseRithmicSystemInfo & rti.ResponseRithmicSystemInfo.$Shape} ResponseRithmicSystemInfo
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ResponseRithmicSystemInfo.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ResponseRithmicSystemInfo message.
         * @function verify
         * @memberof rti.ResponseRithmicSystemInfo
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ResponseRithmicSystemInfo.verify = function verify(message, _depth) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                return "max depth exceeded";
            if (message.templateId != null && message.hasOwnProperty("templateId"))
                if (!$util.isInteger(message.templateId))
                    return "templateId: integer expected";
            if (message.userMsg != null && message.hasOwnProperty("userMsg")) {
                if (!Array.isArray(message.userMsg))
                    return "userMsg: array expected";
                for (let i = 0; i < message.userMsg.length; ++i)
                    if (!$util.isString(message.userMsg[i]))
                        return "userMsg: string[] expected";
            }
            if (message.rpCode != null && message.hasOwnProperty("rpCode")) {
                if (!Array.isArray(message.rpCode))
                    return "rpCode: array expected";
                for (let i = 0; i < message.rpCode.length; ++i)
                    if (!$util.isString(message.rpCode[i]))
                        return "rpCode: string[] expected";
            }
            if (message.systemName != null && message.hasOwnProperty("systemName")) {
                if (!Array.isArray(message.systemName))
                    return "systemName: array expected";
                for (let i = 0; i < message.systemName.length; ++i)
                    if (!$util.isString(message.systemName[i]))
                        return "systemName: string[] expected";
            }
            if (message.hasAggregatedQuotes != null && message.hasOwnProperty("hasAggregatedQuotes")) {
                if (!Array.isArray(message.hasAggregatedQuotes))
                    return "hasAggregatedQuotes: array expected";
                for (let i = 0; i < message.hasAggregatedQuotes.length; ++i)
                    if (typeof message.hasAggregatedQuotes[i] !== "boolean")
                        return "hasAggregatedQuotes: boolean[] expected";
            }
            return null;
        };

        /**
         * Creates a ResponseRithmicSystemInfo message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof rti.ResponseRithmicSystemInfo
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {rti.ResponseRithmicSystemInfo} ResponseRithmicSystemInfo
         */
        ResponseRithmicSystemInfo.fromObject = function fromObject(object, _depth) {
            if (object instanceof $root.rti.ResponseRithmicSystemInfo)
                return object;
            if (!$util.isObject(object))
                throw TypeError(".rti.ResponseRithmicSystemInfo: object expected");
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw Error("max depth exceeded");
            let message = new $root.rti.ResponseRithmicSystemInfo();
            if (object.templateId != null)
                if (Number(object.templateId) !== 0)
                    message.templateId = object.templateId | 0;
            if (object.userMsg) {
                if (!Array.isArray(object.userMsg))
                    throw TypeError(".rti.ResponseRithmicSystemInfo.userMsg: array expected");
                message.userMsg = Array(object.userMsg.length);
                for (let i = 0; i < object.userMsg.length; ++i)
                    message.userMsg[i] = String(object.userMsg[i]);
            }
            if (object.rpCode) {
                if (!Array.isArray(object.rpCode))
                    throw TypeError(".rti.ResponseRithmicSystemInfo.rpCode: array expected");
                message.rpCode = Array(object.rpCode.length);
                for (let i = 0; i < object.rpCode.length; ++i)
                    message.rpCode[i] = String(object.rpCode[i]);
            }
            if (object.systemName) {
                if (!Array.isArray(object.systemName))
                    throw TypeError(".rti.ResponseRithmicSystemInfo.systemName: array expected");
                message.systemName = Array(object.systemName.length);
                for (let i = 0; i < object.systemName.length; ++i)
                    message.systemName[i] = String(object.systemName[i]);
            }
            if (object.hasAggregatedQuotes) {
                if (!Array.isArray(object.hasAggregatedQuotes))
                    throw TypeError(".rti.ResponseRithmicSystemInfo.hasAggregatedQuotes: array expected");
                message.hasAggregatedQuotes = Array(object.hasAggregatedQuotes.length);
                for (let i = 0; i < object.hasAggregatedQuotes.length; ++i)
                    message.hasAggregatedQuotes[i] = Boolean(object.hasAggregatedQuotes[i]);
            }
            return message;
        };

        /**
         * Creates a plain object from a ResponseRithmicSystemInfo message. Also converts values to other types if specified.
         * @function toObject
         * @memberof rti.ResponseRithmicSystemInfo
         * @static
         * @param {rti.ResponseRithmicSystemInfo} message ResponseRithmicSystemInfo
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ResponseRithmicSystemInfo.toObject = function toObject(message, options, _depth) {
            if (!options)
                options = {};
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw Error("max depth exceeded");
            let object = {};
            if (options.arrays || options.defaults) {
                object.userMsg = [];
                object.rpCode = [];
                object.systemName = [];
                object.hasAggregatedQuotes = [];
            }
            if (options.defaults)
                object.templateId = 0;
            if (message.userMsg && message.userMsg.length) {
                object.userMsg = Array(message.userMsg.length);
                for (let j = 0; j < message.userMsg.length; ++j)
                    object.userMsg[j] = message.userMsg[j];
            }
            if (message.rpCode && message.rpCode.length) {
                object.rpCode = Array(message.rpCode.length);
                for (let j = 0; j < message.rpCode.length; ++j)
                    object.rpCode[j] = message.rpCode[j];
            }
            if (message.systemName && message.systemName.length) {
                object.systemName = Array(message.systemName.length);
                for (let j = 0; j < message.systemName.length; ++j)
                    object.systemName[j] = message.systemName[j];
            }
            if (message.hasAggregatedQuotes && message.hasAggregatedQuotes.length) {
                object.hasAggregatedQuotes = Array(message.hasAggregatedQuotes.length);
                for (let j = 0; j < message.hasAggregatedQuotes.length; ++j)
                    object.hasAggregatedQuotes[j] = message.hasAggregatedQuotes[j];
            }
            if (message.templateId != null && message.hasOwnProperty("templateId"))
                object.templateId = message.templateId;
            return object;
        };

        /**
         * Converts this ResponseRithmicSystemInfo to JSON.
         * @function toJSON
         * @memberof rti.ResponseRithmicSystemInfo
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ResponseRithmicSystemInfo.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the type url for ResponseRithmicSystemInfo
         * @function getTypeUrl
         * @memberof rti.ResponseRithmicSystemInfo
         * @static
         * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
         * @returns {string} The type url
         */
        ResponseRithmicSystemInfo.getTypeUrl = function getTypeUrl(prefix) {
            if (prefix === undefined)
                prefix = "type.googleapis.com";
            return prefix + "/rti.ResponseRithmicSystemInfo";
        };

        return ResponseRithmicSystemInfo;
    })();

    rti.ResponseShowFillHistory = (function() {

        /**
         * Properties of a ResponseShowFillHistory.
         * @typedef {Object} rti.ResponseShowFillHistory.$Properties
         * @property {number|null} [templateId] ResponseShowFillHistory templateId
         * @property {Array.<string>|null} [userMsg] ResponseShowFillHistory userMsg
         * @property {Array.<string>|null} [rqHandlerRpCode] ResponseShowFillHistory rqHandlerRpCode
         * @property {Array.<string>|null} [rpCode] ResponseShowFillHistory rpCode
         * @property {string|null} [basketId] ResponseShowFillHistory basketId
         * @property {string|null} [sequenceNumber] ResponseShowFillHistory sequenceNumber
         * @property {string|null} [origSequenceNumber] ResponseShowFillHistory origSequenceNumber
         * @property {string|null} [corSequenceNumber] ResponseShowFillHistory corSequenceNumber
         * @property {string|null} [fcmId] ResponseShowFillHistory fcmId
         * @property {string|null} [ibId] ResponseShowFillHistory ibId
         * @property {string|null} [accountId] ResponseShowFillHistory accountId
         * @property {string|null} [symbol] ResponseShowFillHistory symbol
         * @property {string|null} [exchange] ResponseShowFillHistory exchange
         * @property {string|null} [tradeExchange] ResponseShowFillHistory tradeExchange
         * @property {string|null} [tradeRoute] ResponseShowFillHistory tradeRoute
         * @property {string|null} [exchangeOrderId] ResponseShowFillHistory exchangeOrderId
         * @property {string|null} [instrumentType] ResponseShowFillHistory instrumentType
         * @property {string|null} [transactionType] ResponseShowFillHistory transactionType
         * @property {string|null} [duration] ResponseShowFillHistory duration
         * @property {string|null} [priceType] ResponseShowFillHistory priceType
         * @property {string|null} [origPriceType] ResponseShowFillHistory origPriceType
         * @property {string|null} [manualOrAuto] ResponseShowFillHistory manualOrAuto
         * @property {string|null} [fillTime] ResponseShowFillHistory fillTime
         * @property {string|null} [fillDate] ResponseShowFillHistory fillDate
         * @property {string|null} [fillId] ResponseShowFillHistory fillId
         * @property {number|null} [price] ResponseShowFillHistory price
         * @property {number|null} [triggerPrice] ResponseShowFillHistory triggerPrice
         * @property {number|null} [fillPrice] ResponseShowFillHistory fillPrice
         * @property {number|null} [avgFillPrice] ResponseShowFillHistory avgFillPrice
         * @property {number|null} [fillSize] ResponseShowFillHistory fillSize
         * @property {number|null} [totalFillSize] ResponseShowFillHistory totalFillSize
         * @property {number|null} [totalUnfilledSize] ResponseShowFillHistory totalUnfilledSize
         * @property {number|null} [ssboe] ResponseShowFillHistory ssboe
         * @property {number|null} [usecs] ResponseShowFillHistory usecs
         * @property {number|null} [sourceSsboe] ResponseShowFillHistory sourceSsboe
         * @property {number|null} [sourceUsecs] ResponseShowFillHistory sourceUsecs
         * @property {number|null} [sourceNsecs] ResponseShowFillHistory sourceNsecs
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding
         */

        /**
         * Properties of a ResponseShowFillHistory.
         * @memberof rti
         * @interface IResponseShowFillHistory
         * @augments rti.ResponseShowFillHistory.$Properties
         * @deprecated Use rti.ResponseShowFillHistory.$Properties instead.
         */

        /**
         * Shape of a ResponseShowFillHistory.
         * @typedef {rti.ResponseShowFillHistory.$Properties} rti.ResponseShowFillHistory.$Shape
         */

        /**
         * Constructs a new ResponseShowFillHistory.
         * @memberof rti
         * @classdesc Represents a ResponseShowFillHistory.
         * @constructor
         * @param {rti.ResponseShowFillHistory.$Properties=} [properties] Properties to set
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding
         */
        function ResponseShowFillHistory(properties) {
            this.userMsg = [];
            this.rqHandlerRpCode = [];
            this.rpCode = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null && keys[i] !== "__proto__")
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ResponseShowFillHistory templateId.
         * @member {number} templateId
         * @memberof rti.ResponseShowFillHistory
         * @instance
         */
        ResponseShowFillHistory.prototype.templateId = 0;

        /**
         * ResponseShowFillHistory userMsg.
         * @member {Array.<string>} userMsg
         * @memberof rti.ResponseShowFillHistory
         * @instance
         */
        ResponseShowFillHistory.prototype.userMsg = $util.emptyArray;

        /**
         * ResponseShowFillHistory rqHandlerRpCode.
         * @member {Array.<string>} rqHandlerRpCode
         * @memberof rti.ResponseShowFillHistory
         * @instance
         */
        ResponseShowFillHistory.prototype.rqHandlerRpCode = $util.emptyArray;

        /**
         * ResponseShowFillHistory rpCode.
         * @member {Array.<string>} rpCode
         * @memberof rti.ResponseShowFillHistory
         * @instance
         */
        ResponseShowFillHistory.prototype.rpCode = $util.emptyArray;

        /**
         * ResponseShowFillHistory basketId.
         * @member {string} basketId
         * @memberof rti.ResponseShowFillHistory
         * @instance
         */
        ResponseShowFillHistory.prototype.basketId = "";

        /**
         * ResponseShowFillHistory sequenceNumber.
         * @member {string} sequenceNumber
         * @memberof rti.ResponseShowFillHistory
         * @instance
         */
        ResponseShowFillHistory.prototype.sequenceNumber = "";

        /**
         * ResponseShowFillHistory origSequenceNumber.
         * @member {string} origSequenceNumber
         * @memberof rti.ResponseShowFillHistory
         * @instance
         */
        ResponseShowFillHistory.prototype.origSequenceNumber = "";

        /**
         * ResponseShowFillHistory corSequenceNumber.
         * @member {string} corSequenceNumber
         * @memberof rti.ResponseShowFillHistory
         * @instance
         */
        ResponseShowFillHistory.prototype.corSequenceNumber = "";

        /**
         * ResponseShowFillHistory fcmId.
         * @member {string} fcmId
         * @memberof rti.ResponseShowFillHistory
         * @instance
         */
        ResponseShowFillHistory.prototype.fcmId = "";

        /**
         * ResponseShowFillHistory ibId.
         * @member {string} ibId
         * @memberof rti.ResponseShowFillHistory
         * @instance
         */
        ResponseShowFillHistory.prototype.ibId = "";

        /**
         * ResponseShowFillHistory accountId.
         * @member {string} accountId
         * @memberof rti.ResponseShowFillHistory
         * @instance
         */
        ResponseShowFillHistory.prototype.accountId = "";

        /**
         * ResponseShowFillHistory symbol.
         * @member {string} symbol
         * @memberof rti.ResponseShowFillHistory
         * @instance
         */
        ResponseShowFillHistory.prototype.symbol = "";

        /**
         * ResponseShowFillHistory exchange.
         * @member {string} exchange
         * @memberof rti.ResponseShowFillHistory
         * @instance
         */
        ResponseShowFillHistory.prototype.exchange = "";

        /**
         * ResponseShowFillHistory tradeExchange.
         * @member {string} tradeExchange
         * @memberof rti.ResponseShowFillHistory
         * @instance
         */
        ResponseShowFillHistory.prototype.tradeExchange = "";

        /**
         * ResponseShowFillHistory tradeRoute.
         * @member {string} tradeRoute
         * @memberof rti.ResponseShowFillHistory
         * @instance
         */
        ResponseShowFillHistory.prototype.tradeRoute = "";

        /**
         * ResponseShowFillHistory exchangeOrderId.
         * @member {string} exchangeOrderId
         * @memberof rti.ResponseShowFillHistory
         * @instance
         */
        ResponseShowFillHistory.prototype.exchangeOrderId = "";

        /**
         * ResponseShowFillHistory instrumentType.
         * @member {string} instrumentType
         * @memberof rti.ResponseShowFillHistory
         * @instance
         */
        ResponseShowFillHistory.prototype.instrumentType = "";

        /**
         * ResponseShowFillHistory transactionType.
         * @member {string} transactionType
         * @memberof rti.ResponseShowFillHistory
         * @instance
         */
        ResponseShowFillHistory.prototype.transactionType = "";

        /**
         * ResponseShowFillHistory duration.
         * @member {string} duration
         * @memberof rti.ResponseShowFillHistory
         * @instance
         */
        ResponseShowFillHistory.prototype.duration = "";

        /**
         * ResponseShowFillHistory priceType.
         * @member {string} priceType
         * @memberof rti.ResponseShowFillHistory
         * @instance
         */
        ResponseShowFillHistory.prototype.priceType = "";

        /**
         * ResponseShowFillHistory origPriceType.
         * @member {string} origPriceType
         * @memberof rti.ResponseShowFillHistory
         * @instance
         */
        ResponseShowFillHistory.prototype.origPriceType = "";

        /**
         * ResponseShowFillHistory manualOrAuto.
         * @member {string} manualOrAuto
         * @memberof rti.ResponseShowFillHistory
         * @instance
         */
        ResponseShowFillHistory.prototype.manualOrAuto = "";

        /**
         * ResponseShowFillHistory fillTime.
         * @member {string} fillTime
         * @memberof rti.ResponseShowFillHistory
         * @instance
         */
        ResponseShowFillHistory.prototype.fillTime = "";

        /**
         * ResponseShowFillHistory fillDate.
         * @member {string} fillDate
         * @memberof rti.ResponseShowFillHistory
         * @instance
         */
        ResponseShowFillHistory.prototype.fillDate = "";

        /**
         * ResponseShowFillHistory fillId.
         * @member {string} fillId
         * @memberof rti.ResponseShowFillHistory
         * @instance
         */
        ResponseShowFillHistory.prototype.fillId = "";

        /**
         * ResponseShowFillHistory price.
         * @member {number} price
         * @memberof rti.ResponseShowFillHistory
         * @instance
         */
        ResponseShowFillHistory.prototype.price = 0;

        /**
         * ResponseShowFillHistory triggerPrice.
         * @member {number} triggerPrice
         * @memberof rti.ResponseShowFillHistory
         * @instance
         */
        ResponseShowFillHistory.prototype.triggerPrice = 0;

        /**
         * ResponseShowFillHistory fillPrice.
         * @member {number} fillPrice
         * @memberof rti.ResponseShowFillHistory
         * @instance
         */
        ResponseShowFillHistory.prototype.fillPrice = 0;

        /**
         * ResponseShowFillHistory avgFillPrice.
         * @member {number} avgFillPrice
         * @memberof rti.ResponseShowFillHistory
         * @instance
         */
        ResponseShowFillHistory.prototype.avgFillPrice = 0;

        /**
         * ResponseShowFillHistory fillSize.
         * @member {number} fillSize
         * @memberof rti.ResponseShowFillHistory
         * @instance
         */
        ResponseShowFillHistory.prototype.fillSize = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * ResponseShowFillHistory totalFillSize.
         * @member {number} totalFillSize
         * @memberof rti.ResponseShowFillHistory
         * @instance
         */
        ResponseShowFillHistory.prototype.totalFillSize = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * ResponseShowFillHistory totalUnfilledSize.
         * @member {number} totalUnfilledSize
         * @memberof rti.ResponseShowFillHistory
         * @instance
         */
        ResponseShowFillHistory.prototype.totalUnfilledSize = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * ResponseShowFillHistory ssboe.
         * @member {number} ssboe
         * @memberof rti.ResponseShowFillHistory
         * @instance
         */
        ResponseShowFillHistory.prototype.ssboe = 0;

        /**
         * ResponseShowFillHistory usecs.
         * @member {number} usecs
         * @memberof rti.ResponseShowFillHistory
         * @instance
         */
        ResponseShowFillHistory.prototype.usecs = 0;

        /**
         * ResponseShowFillHistory sourceSsboe.
         * @member {number} sourceSsboe
         * @memberof rti.ResponseShowFillHistory
         * @instance
         */
        ResponseShowFillHistory.prototype.sourceSsboe = 0;

        /**
         * ResponseShowFillHistory sourceUsecs.
         * @member {number} sourceUsecs
         * @memberof rti.ResponseShowFillHistory
         * @instance
         */
        ResponseShowFillHistory.prototype.sourceUsecs = 0;

        /**
         * ResponseShowFillHistory sourceNsecs.
         * @member {number} sourceNsecs
         * @memberof rti.ResponseShowFillHistory
         * @instance
         */
        ResponseShowFillHistory.prototype.sourceNsecs = 0;

        /**
         * Creates a new ResponseShowFillHistory instance using the specified properties.
         * @function create
         * @memberof rti.ResponseShowFillHistory
         * @static
         * @param {rti.ResponseShowFillHistory.$Properties=} [properties] Properties to set
         * @returns {rti.ResponseShowFillHistory} ResponseShowFillHistory instance
         * @type {{
         *   (properties: rti.ResponseShowFillHistory.$Shape): rti.ResponseShowFillHistory & rti.ResponseShowFillHistory.$Shape;
         *   (properties?: rti.ResponseShowFillHistory.$Properties): rti.ResponseShowFillHistory;
         * }}
         */
        ResponseShowFillHistory.create = function create(properties) {
            return new ResponseShowFillHistory(properties);
        };

        /**
         * Encodes the specified ResponseShowFillHistory message. Does not implicitly {@link rti.ResponseShowFillHistory.verify|verify} messages.
         * @function encode
         * @memberof rti.ResponseShowFillHistory
         * @static
         * @param {rti.ResponseShowFillHistory.$Properties} message ResponseShowFillHistory message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ResponseShowFillHistory.encode = function encode(message, writer, _depth) {
            if (!writer)
                writer = $Writer.create();
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw Error("max depth exceeded");
            if (message.symbol != null && Object.hasOwnProperty.call(message, "symbol"))
                writer.uint32(/* id 110100, wireType 2 =*/880802).string(message.symbol);
            if (message.exchange != null && Object.hasOwnProperty.call(message, "exchange"))
                writer.uint32(/* id 110101, wireType 2 =*/880810).string(message.exchange);
            if (message.instrumentType != null && Object.hasOwnProperty.call(message, "instrumentType"))
                writer.uint32(/* id 110116, wireType 2 =*/880930).string(message.instrumentType);
            if (message.basketId != null && Object.hasOwnProperty.call(message, "basketId"))
                writer.uint32(/* id 110300, wireType 2 =*/882402).string(message.basketId);
            if (message.price != null && Object.hasOwnProperty.call(message, "price"))
                writer.uint32(/* id 110306, wireType 1 =*/882449).double(message.price);
            if (message.fillPrice != null && Object.hasOwnProperty.call(message, "fillPrice"))
                writer.uint32(/* id 110307, wireType 1 =*/882457).double(message.fillPrice);
            if (message.fillSize != null && Object.hasOwnProperty.call(message, "fillSize"))
                writer.uint32(/* id 110308, wireType 0 =*/882464).uint64(message.fillSize);
            if (message.fillTime != null && Object.hasOwnProperty.call(message, "fillTime"))
                writer.uint32(/* id 110309, wireType 2 =*/882474).string(message.fillTime);
            if (message.fillDate != null && Object.hasOwnProperty.call(message, "fillDate"))
                writer.uint32(/* id 110310, wireType 2 =*/882482).string(message.fillDate);
            if (message.fillId != null && Object.hasOwnProperty.call(message, "fillId"))
                writer.uint32(/* id 110311, wireType 2 =*/882490).string(message.fillId);
            if (message.avgFillPrice != null && Object.hasOwnProperty.call(message, "avgFillPrice"))
                writer.uint32(/* id 110322, wireType 1 =*/882577).double(message.avgFillPrice);
            if (message.sequenceNumber != null && Object.hasOwnProperty.call(message, "sequenceNumber"))
                writer.uint32(/* id 112002, wireType 2 =*/896018).string(message.sequenceNumber);
            if (message.transactionType != null && Object.hasOwnProperty.call(message, "transactionType"))
                writer.uint32(/* id 112003, wireType 2 =*/896026).string(message.transactionType);
            if (message.duration != null && Object.hasOwnProperty.call(message, "duration"))
                writer.uint32(/* id 112005, wireType 2 =*/896042).string(message.duration);
            if (message.priceType != null && Object.hasOwnProperty.call(message, "priceType"))
                writer.uint32(/* id 112008, wireType 2 =*/896066).string(message.priceType);
            if (message.tradeRoute != null && Object.hasOwnProperty.call(message, "tradeRoute"))
                writer.uint32(/* id 112016, wireType 2 =*/896130).string(message.tradeRoute);
            if (message.tradeExchange != null && Object.hasOwnProperty.call(message, "tradeExchange"))
                writer.uint32(/* id 112021, wireType 2 =*/896170).string(message.tradeExchange);
            if (message.userMsg != null && message.userMsg.length)
                for (let i = 0; i < message.userMsg.length; ++i)
                    writer.uint32(/* id 132760, wireType 2 =*/1062082).string(message.userMsg[i]);
            if (message.rqHandlerRpCode != null && message.rqHandlerRpCode.length)
                for (let i = 0; i < message.rqHandlerRpCode.length; ++i)
                    writer.uint32(/* id 132764, wireType 2 =*/1062114).string(message.rqHandlerRpCode[i]);
            if (message.rpCode != null && message.rpCode.length)
                for (let i = 0; i < message.rpCode.length; ++i)
                    writer.uint32(/* id 132766, wireType 2 =*/1062130).string(message.rpCode[i]);
            if (message.exchangeOrderId != null && Object.hasOwnProperty.call(message, "exchangeOrderId"))
                writer.uint32(/* id 149238, wireType 2 =*/1193906).string(message.exchangeOrderId);
            if (message.triggerPrice != null && Object.hasOwnProperty.call(message, "triggerPrice"))
                writer.uint32(/* id 149247, wireType 1 =*/1193977).double(message.triggerPrice);
            if (message.origSequenceNumber != null && Object.hasOwnProperty.call(message, "origSequenceNumber"))
                writer.uint32(/* id 149263, wireType 2 =*/1194106).string(message.origSequenceNumber);
            if (message.corSequenceNumber != null && Object.hasOwnProperty.call(message, "corSequenceNumber"))
                writer.uint32(/* id 149264, wireType 2 =*/1194114).string(message.corSequenceNumber);
            if (message.ssboe != null && Object.hasOwnProperty.call(message, "ssboe"))
                writer.uint32(/* id 150100, wireType 0 =*/1200800).int32(message.ssboe);
            if (message.usecs != null && Object.hasOwnProperty.call(message, "usecs"))
                writer.uint32(/* id 150101, wireType 0 =*/1200808).int32(message.usecs);
            if (message.sourceSsboe != null && Object.hasOwnProperty.call(message, "sourceSsboe"))
                writer.uint32(/* id 150400, wireType 0 =*/1203200).int32(message.sourceSsboe);
            if (message.sourceUsecs != null && Object.hasOwnProperty.call(message, "sourceUsecs"))
                writer.uint32(/* id 150401, wireType 0 =*/1203208).int32(message.sourceUsecs);
            if (message.sourceNsecs != null && Object.hasOwnProperty.call(message, "sourceNsecs"))
                writer.uint32(/* id 150404, wireType 0 =*/1203232).int32(message.sourceNsecs);
            if (message.accountId != null && Object.hasOwnProperty.call(message, "accountId"))
                writer.uint32(/* id 154008, wireType 2 =*/1232066).string(message.accountId);
            if (message.fcmId != null && Object.hasOwnProperty.call(message, "fcmId"))
                writer.uint32(/* id 154013, wireType 2 =*/1232106).string(message.fcmId);
            if (message.ibId != null && Object.hasOwnProperty.call(message, "ibId"))
                writer.uint32(/* id 154014, wireType 2 =*/1232114).string(message.ibId);
            if (message.totalFillSize != null && Object.hasOwnProperty.call(message, "totalFillSize"))
                writer.uint32(/* id 154111, wireType 0 =*/1232888).uint64(message.totalFillSize);
            if (message.totalUnfilledSize != null && Object.hasOwnProperty.call(message, "totalUnfilledSize"))
                writer.uint32(/* id 154112, wireType 0 =*/1232896).uint64(message.totalUnfilledSize);
            if (message.templateId != null && Object.hasOwnProperty.call(message, "templateId"))
                writer.uint32(/* id 154467, wireType 0 =*/1235736).int32(message.templateId);
            if (message.manualOrAuto != null && Object.hasOwnProperty.call(message, "manualOrAuto"))
                writer.uint32(/* id 154710, wireType 2 =*/1237682).string(message.manualOrAuto);
            if (message.origPriceType != null && Object.hasOwnProperty.call(message, "origPriceType"))
                writer.uint32(/* id 154770, wireType 2 =*/1238162).string(message.origPriceType);
            if (message.$unknowns != null && Object.hasOwnProperty.call(message, "$unknowns"))
                for (let i = 0; i < message.$unknowns.length; ++i)
                    writer.raw(message.$unknowns[i]);
            return writer;
        };

        /**
         * Encodes the specified ResponseShowFillHistory message, length delimited. Does not implicitly {@link rti.ResponseShowFillHistory.verify|verify} messages.
         * @function encodeDelimited
         * @memberof rti.ResponseShowFillHistory
         * @static
         * @param {rti.ResponseShowFillHistory.$Properties} message ResponseShowFillHistory message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ResponseShowFillHistory.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer && writer.len ? writer.fork() : writer).ldelim();
        };

        /**
         * Decodes a ResponseShowFillHistory message from the specified reader or buffer.
         * @function decode
         * @memberof rti.ResponseShowFillHistory
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {rti.ResponseShowFillHistory & rti.ResponseShowFillHistory.$Shape} ResponseShowFillHistory
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ResponseShowFillHistory.decode = function decode(reader, length, _end, _depth, _target) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $Reader.recursionLimit)
                throw Error("max depth exceeded");
            let end = length === undefined ? reader.len : reader.pos + length, message = _target || new $root.rti.ResponseShowFillHistory(), value;
            while (reader.pos < end) {
                let start = reader.pos;
                let tag = reader.tag();
                if (tag === _end) {
                    _end = undefined;
                    break;
                }
                let wireType = tag & 7;
                switch (tag >>>= 3) {
                case 154467: {
                        if (wireType !== 0)
                            break;
                        if (value = reader.int32())
                            message.templateId = value;
                        else
                            delete message.templateId;
                        continue;
                    }
                case 132760: {
                        if (wireType !== 2)
                            break;
                        if (!(message.userMsg && message.userMsg.length))
                            message.userMsg = [];
                        message.userMsg.push(reader.string());
                        continue;
                    }
                case 132764: {
                        if (wireType !== 2)
                            break;
                        if (!(message.rqHandlerRpCode && message.rqHandlerRpCode.length))
                            message.rqHandlerRpCode = [];
                        message.rqHandlerRpCode.push(reader.string());
                        continue;
                    }
                case 132766: {
                        if (wireType !== 2)
                            break;
                        if (!(message.rpCode && message.rpCode.length))
                            message.rpCode = [];
                        message.rpCode.push(reader.string());
                        continue;
                    }
                case 110300: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.string()).length)
                            message.basketId = value;
                        else
                            delete message.basketId;
                        continue;
                    }
                case 112002: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.string()).length)
                            message.sequenceNumber = value;
                        else
                            delete message.sequenceNumber;
                        continue;
                    }
                case 149263: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.string()).length)
                            message.origSequenceNumber = value;
                        else
                            delete message.origSequenceNumber;
                        continue;
                    }
                case 149264: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.string()).length)
                            message.corSequenceNumber = value;
                        else
                            delete message.corSequenceNumber;
                        continue;
                    }
                case 154013: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.string()).length)
                            message.fcmId = value;
                        else
                            delete message.fcmId;
                        continue;
                    }
                case 154014: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.string()).length)
                            message.ibId = value;
                        else
                            delete message.ibId;
                        continue;
                    }
                case 154008: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.string()).length)
                            message.accountId = value;
                        else
                            delete message.accountId;
                        continue;
                    }
                case 110100: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.string()).length)
                            message.symbol = value;
                        else
                            delete message.symbol;
                        continue;
                    }
                case 110101: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.string()).length)
                            message.exchange = value;
                        else
                            delete message.exchange;
                        continue;
                    }
                case 112021: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.string()).length)
                            message.tradeExchange = value;
                        else
                            delete message.tradeExchange;
                        continue;
                    }
                case 112016: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.string()).length)
                            message.tradeRoute = value;
                        else
                            delete message.tradeRoute;
                        continue;
                    }
                case 149238: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.string()).length)
                            message.exchangeOrderId = value;
                        else
                            delete message.exchangeOrderId;
                        continue;
                    }
                case 110116: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.string()).length)
                            message.instrumentType = value;
                        else
                            delete message.instrumentType;
                        continue;
                    }
                case 112003: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.string()).length)
                            message.transactionType = value;
                        else
                            delete message.transactionType;
                        continue;
                    }
                case 112005: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.string()).length)
                            message.duration = value;
                        else
                            delete message.duration;
                        continue;
                    }
                case 112008: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.string()).length)
                            message.priceType = value;
                        else
                            delete message.priceType;
                        continue;
                    }
                case 154770: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.string()).length)
                            message.origPriceType = value;
                        else
                            delete message.origPriceType;
                        continue;
                    }
                case 154710: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.string()).length)
                            message.manualOrAuto = value;
                        else
                            delete message.manualOrAuto;
                        continue;
                    }
                case 110309: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.string()).length)
                            message.fillTime = value;
                        else
                            delete message.fillTime;
                        continue;
                    }
                case 110310: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.string()).length)
                            message.fillDate = value;
                        else
                            delete message.fillDate;
                        continue;
                    }
                case 110311: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.string()).length)
                            message.fillId = value;
                        else
                            delete message.fillId;
                        continue;
                    }
                case 110306: {
                        if (wireType !== 1)
                            break;
                        if ((value = reader.double()) !== 0)
                            message.price = value;
                        else
                            delete message.price;
                        continue;
                    }
                case 149247: {
                        if (wireType !== 1)
                            break;
                        if ((value = reader.double()) !== 0)
                            message.triggerPrice = value;
                        else
                            delete message.triggerPrice;
                        continue;
                    }
                case 110307: {
                        if (wireType !== 1)
                            break;
                        if ((value = reader.double()) !== 0)
                            message.fillPrice = value;
                        else
                            delete message.fillPrice;
                        continue;
                    }
                case 110322: {
                        if (wireType !== 1)
                            break;
                        if ((value = reader.double()) !== 0)
                            message.avgFillPrice = value;
                        else
                            delete message.avgFillPrice;
                        continue;
                    }
                case 110308: {
                        if (wireType !== 0)
                            break;
                        if (typeof (value = reader.uint64()) === "object" ? value.low || value.high : value !== 0)
                            message.fillSize = value;
                        else
                            delete message.fillSize;
                        continue;
                    }
                case 154111: {
                        if (wireType !== 0)
                            break;
                        if (typeof (value = reader.uint64()) === "object" ? value.low || value.high : value !== 0)
                            message.totalFillSize = value;
                        else
                            delete message.totalFillSize;
                        continue;
                    }
                case 154112: {
                        if (wireType !== 0)
                            break;
                        if (typeof (value = reader.uint64()) === "object" ? value.low || value.high : value !== 0)
                            message.totalUnfilledSize = value;
                        else
                            delete message.totalUnfilledSize;
                        continue;
                    }
                case 150100: {
                        if (wireType !== 0)
                            break;
                        if (value = reader.int32())
                            message.ssboe = value;
                        else
                            delete message.ssboe;
                        continue;
                    }
                case 150101: {
                        if (wireType !== 0)
                            break;
                        if (value = reader.int32())
                            message.usecs = value;
                        else
                            delete message.usecs;
                        continue;
                    }
                case 150400: {
                        if (wireType !== 0)
                            break;
                        if (value = reader.int32())
                            message.sourceSsboe = value;
                        else
                            delete message.sourceSsboe;
                        continue;
                    }
                case 150401: {
                        if (wireType !== 0)
                            break;
                        if (value = reader.int32())
                            message.sourceUsecs = value;
                        else
                            delete message.sourceUsecs;
                        continue;
                    }
                case 150404: {
                        if (wireType !== 0)
                            break;
                        if (value = reader.int32())
                            message.sourceNsecs = value;
                        else
                            delete message.sourceNsecs;
                        continue;
                    }
                }
                reader.skipType(wireType, _depth, tag);
                if (!reader.discardUnknown) {
                    $util.makeProp(message, "$unknowns", false);
                    (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
                }
            }
            if (_end !== undefined)
                throw Error("missing end group");
            return message;
        };

        /**
         * Decodes a ResponseShowFillHistory message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof rti.ResponseShowFillHistory
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {rti.ResponseShowFillHistory & rti.ResponseShowFillHistory.$Shape} ResponseShowFillHistory
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ResponseShowFillHistory.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ResponseShowFillHistory message.
         * @function verify
         * @memberof rti.ResponseShowFillHistory
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ResponseShowFillHistory.verify = function verify(message, _depth) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                return "max depth exceeded";
            if (message.templateId != null && message.hasOwnProperty("templateId"))
                if (!$util.isInteger(message.templateId))
                    return "templateId: integer expected";
            if (message.userMsg != null && message.hasOwnProperty("userMsg")) {
                if (!Array.isArray(message.userMsg))
                    return "userMsg: array expected";
                for (let i = 0; i < message.userMsg.length; ++i)
                    if (!$util.isString(message.userMsg[i]))
                        return "userMsg: string[] expected";
            }
            if (message.rqHandlerRpCode != null && message.hasOwnProperty("rqHandlerRpCode")) {
                if (!Array.isArray(message.rqHandlerRpCode))
                    return "rqHandlerRpCode: array expected";
                for (let i = 0; i < message.rqHandlerRpCode.length; ++i)
                    if (!$util.isString(message.rqHandlerRpCode[i]))
                        return "rqHandlerRpCode: string[] expected";
            }
            if (message.rpCode != null && message.hasOwnProperty("rpCode")) {
                if (!Array.isArray(message.rpCode))
                    return "rpCode: array expected";
                for (let i = 0; i < message.rpCode.length; ++i)
                    if (!$util.isString(message.rpCode[i]))
                        return "rpCode: string[] expected";
            }
            if (message.basketId != null && message.hasOwnProperty("basketId"))
                if (!$util.isString(message.basketId))
                    return "basketId: string expected";
            if (message.sequenceNumber != null && message.hasOwnProperty("sequenceNumber"))
                if (!$util.isString(message.sequenceNumber))
                    return "sequenceNumber: string expected";
            if (message.origSequenceNumber != null && message.hasOwnProperty("origSequenceNumber"))
                if (!$util.isString(message.origSequenceNumber))
                    return "origSequenceNumber: string expected";
            if (message.corSequenceNumber != null && message.hasOwnProperty("corSequenceNumber"))
                if (!$util.isString(message.corSequenceNumber))
                    return "corSequenceNumber: string expected";
            if (message.fcmId != null && message.hasOwnProperty("fcmId"))
                if (!$util.isString(message.fcmId))
                    return "fcmId: string expected";
            if (message.ibId != null && message.hasOwnProperty("ibId"))
                if (!$util.isString(message.ibId))
                    return "ibId: string expected";
            if (message.accountId != null && message.hasOwnProperty("accountId"))
                if (!$util.isString(message.accountId))
                    return "accountId: string expected";
            if (message.symbol != null && message.hasOwnProperty("symbol"))
                if (!$util.isString(message.symbol))
                    return "symbol: string expected";
            if (message.exchange != null && message.hasOwnProperty("exchange"))
                if (!$util.isString(message.exchange))
                    return "exchange: string expected";
            if (message.tradeExchange != null && message.hasOwnProperty("tradeExchange"))
                if (!$util.isString(message.tradeExchange))
                    return "tradeExchange: string expected";
            if (message.tradeRoute != null && message.hasOwnProperty("tradeRoute"))
                if (!$util.isString(message.tradeRoute))
                    return "tradeRoute: string expected";
            if (message.exchangeOrderId != null && message.hasOwnProperty("exchangeOrderId"))
                if (!$util.isString(message.exchangeOrderId))
                    return "exchangeOrderId: string expected";
            if (message.instrumentType != null && message.hasOwnProperty("instrumentType"))
                if (!$util.isString(message.instrumentType))
                    return "instrumentType: string expected";
            if (message.transactionType != null && message.hasOwnProperty("transactionType"))
                if (!$util.isString(message.transactionType))
                    return "transactionType: string expected";
            if (message.duration != null && message.hasOwnProperty("duration"))
                if (!$util.isString(message.duration))
                    return "duration: string expected";
            if (message.priceType != null && message.hasOwnProperty("priceType"))
                if (!$util.isString(message.priceType))
                    return "priceType: string expected";
            if (message.origPriceType != null && message.hasOwnProperty("origPriceType"))
                if (!$util.isString(message.origPriceType))
                    return "origPriceType: string expected";
            if (message.manualOrAuto != null && message.hasOwnProperty("manualOrAuto"))
                if (!$util.isString(message.manualOrAuto))
                    return "manualOrAuto: string expected";
            if (message.fillTime != null && message.hasOwnProperty("fillTime"))
                if (!$util.isString(message.fillTime))
                    return "fillTime: string expected";
            if (message.fillDate != null && message.hasOwnProperty("fillDate"))
                if (!$util.isString(message.fillDate))
                    return "fillDate: string expected";
            if (message.fillId != null && message.hasOwnProperty("fillId"))
                if (!$util.isString(message.fillId))
                    return "fillId: string expected";
            if (message.price != null && message.hasOwnProperty("price"))
                if (typeof message.price !== "number")
                    return "price: number expected";
            if (message.triggerPrice != null && message.hasOwnProperty("triggerPrice"))
                if (typeof message.triggerPrice !== "number")
                    return "triggerPrice: number expected";
            if (message.fillPrice != null && message.hasOwnProperty("fillPrice"))
                if (typeof message.fillPrice !== "number")
                    return "fillPrice: number expected";
            if (message.avgFillPrice != null && message.hasOwnProperty("avgFillPrice"))
                if (typeof message.avgFillPrice !== "number")
                    return "avgFillPrice: number expected";
            if (message.fillSize != null && message.hasOwnProperty("fillSize"))
                if (!$util.isInteger(message.fillSize) && !(message.fillSize && $util.isInteger(message.fillSize.low) && $util.isInteger(message.fillSize.high)))
                    return "fillSize: integer|Long expected";
            if (message.totalFillSize != null && message.hasOwnProperty("totalFillSize"))
                if (!$util.isInteger(message.totalFillSize) && !(message.totalFillSize && $util.isInteger(message.totalFillSize.low) && $util.isInteger(message.totalFillSize.high)))
                    return "totalFillSize: integer|Long expected";
            if (message.totalUnfilledSize != null && message.hasOwnProperty("totalUnfilledSize"))
                if (!$util.isInteger(message.totalUnfilledSize) && !(message.totalUnfilledSize && $util.isInteger(message.totalUnfilledSize.low) && $util.isInteger(message.totalUnfilledSize.high)))
                    return "totalUnfilledSize: integer|Long expected";
            if (message.ssboe != null && message.hasOwnProperty("ssboe"))
                if (!$util.isInteger(message.ssboe))
                    return "ssboe: integer expected";
            if (message.usecs != null && message.hasOwnProperty("usecs"))
                if (!$util.isInteger(message.usecs))
                    return "usecs: integer expected";
            if (message.sourceSsboe != null && message.hasOwnProperty("sourceSsboe"))
                if (!$util.isInteger(message.sourceSsboe))
                    return "sourceSsboe: integer expected";
            if (message.sourceUsecs != null && message.hasOwnProperty("sourceUsecs"))
                if (!$util.isInteger(message.sourceUsecs))
                    return "sourceUsecs: integer expected";
            if (message.sourceNsecs != null && message.hasOwnProperty("sourceNsecs"))
                if (!$util.isInteger(message.sourceNsecs))
                    return "sourceNsecs: integer expected";
            return null;
        };

        /**
         * Creates a ResponseShowFillHistory message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof rti.ResponseShowFillHistory
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {rti.ResponseShowFillHistory} ResponseShowFillHistory
         */
        ResponseShowFillHistory.fromObject = function fromObject(object, _depth) {
            if (object instanceof $root.rti.ResponseShowFillHistory)
                return object;
            if (!$util.isObject(object))
                throw TypeError(".rti.ResponseShowFillHistory: object expected");
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw Error("max depth exceeded");
            let message = new $root.rti.ResponseShowFillHistory();
            if (object.templateId != null)
                if (Number(object.templateId) !== 0)
                    message.templateId = object.templateId | 0;
            if (object.userMsg) {
                if (!Array.isArray(object.userMsg))
                    throw TypeError(".rti.ResponseShowFillHistory.userMsg: array expected");
                message.userMsg = Array(object.userMsg.length);
                for (let i = 0; i < object.userMsg.length; ++i)
                    message.userMsg[i] = String(object.userMsg[i]);
            }
            if (object.rqHandlerRpCode) {
                if (!Array.isArray(object.rqHandlerRpCode))
                    throw TypeError(".rti.ResponseShowFillHistory.rqHandlerRpCode: array expected");
                message.rqHandlerRpCode = Array(object.rqHandlerRpCode.length);
                for (let i = 0; i < object.rqHandlerRpCode.length; ++i)
                    message.rqHandlerRpCode[i] = String(object.rqHandlerRpCode[i]);
            }
            if (object.rpCode) {
                if (!Array.isArray(object.rpCode))
                    throw TypeError(".rti.ResponseShowFillHistory.rpCode: array expected");
                message.rpCode = Array(object.rpCode.length);
                for (let i = 0; i < object.rpCode.length; ++i)
                    message.rpCode[i] = String(object.rpCode[i]);
            }
            if (object.basketId != null)
                if (typeof object.basketId !== "string" || object.basketId.length)
                    message.basketId = String(object.basketId);
            if (object.sequenceNumber != null)
                if (typeof object.sequenceNumber !== "string" || object.sequenceNumber.length)
                    message.sequenceNumber = String(object.sequenceNumber);
            if (object.origSequenceNumber != null)
                if (typeof object.origSequenceNumber !== "string" || object.origSequenceNumber.length)
                    message.origSequenceNumber = String(object.origSequenceNumber);
            if (object.corSequenceNumber != null)
                if (typeof object.corSequenceNumber !== "string" || object.corSequenceNumber.length)
                    message.corSequenceNumber = String(object.corSequenceNumber);
            if (object.fcmId != null)
                if (typeof object.fcmId !== "string" || object.fcmId.length)
                    message.fcmId = String(object.fcmId);
            if (object.ibId != null)
                if (typeof object.ibId !== "string" || object.ibId.length)
                    message.ibId = String(object.ibId);
            if (object.accountId != null)
                if (typeof object.accountId !== "string" || object.accountId.length)
                    message.accountId = String(object.accountId);
            if (object.symbol != null)
                if (typeof object.symbol !== "string" || object.symbol.length)
                    message.symbol = String(object.symbol);
            if (object.exchange != null)
                if (typeof object.exchange !== "string" || object.exchange.length)
                    message.exchange = String(object.exchange);
            if (object.tradeExchange != null)
                if (typeof object.tradeExchange !== "string" || object.tradeExchange.length)
                    message.tradeExchange = String(object.tradeExchange);
            if (object.tradeRoute != null)
                if (typeof object.tradeRoute !== "string" || object.tradeRoute.length)
                    message.tradeRoute = String(object.tradeRoute);
            if (object.exchangeOrderId != null)
                if (typeof object.exchangeOrderId !== "string" || object.exchangeOrderId.length)
                    message.exchangeOrderId = String(object.exchangeOrderId);
            if (object.instrumentType != null)
                if (typeof object.instrumentType !== "string" || object.instrumentType.length)
                    message.instrumentType = String(object.instrumentType);
            if (object.transactionType != null)
                if (typeof object.transactionType !== "string" || object.transactionType.length)
                    message.transactionType = String(object.transactionType);
            if (object.duration != null)
                if (typeof object.duration !== "string" || object.duration.length)
                    message.duration = String(object.duration);
            if (object.priceType != null)
                if (typeof object.priceType !== "string" || object.priceType.length)
                    message.priceType = String(object.priceType);
            if (object.origPriceType != null)
                if (typeof object.origPriceType !== "string" || object.origPriceType.length)
                    message.origPriceType = String(object.origPriceType);
            if (object.manualOrAuto != null)
                if (typeof object.manualOrAuto !== "string" || object.manualOrAuto.length)
                    message.manualOrAuto = String(object.manualOrAuto);
            if (object.fillTime != null)
                if (typeof object.fillTime !== "string" || object.fillTime.length)
                    message.fillTime = String(object.fillTime);
            if (object.fillDate != null)
                if (typeof object.fillDate !== "string" || object.fillDate.length)
                    message.fillDate = String(object.fillDate);
            if (object.fillId != null)
                if (typeof object.fillId !== "string" || object.fillId.length)
                    message.fillId = String(object.fillId);
            if (object.price != null)
                if (Number(object.price) !== 0)
                    message.price = Number(object.price);
            if (object.triggerPrice != null)
                if (Number(object.triggerPrice) !== 0)
                    message.triggerPrice = Number(object.triggerPrice);
            if (object.fillPrice != null)
                if (Number(object.fillPrice) !== 0)
                    message.fillPrice = Number(object.fillPrice);
            if (object.avgFillPrice != null)
                if (Number(object.avgFillPrice) !== 0)
                    message.avgFillPrice = Number(object.avgFillPrice);
            if (object.fillSize != null)
                if (typeof object.fillSize === "object" ? object.fillSize.low || object.fillSize.high : Number(object.fillSize) !== 0)
                    if ($util.Long)
                        message.fillSize = $util.Long.fromValue(object.fillSize, true);
                    else if (typeof object.fillSize === "string")
                        message.fillSize = parseInt(object.fillSize, 10);
                    else if (typeof object.fillSize === "number")
                        message.fillSize = object.fillSize;
                    else if (typeof object.fillSize === "object")
                        message.fillSize = new $util.LongBits(object.fillSize.low >>> 0, object.fillSize.high >>> 0).toNumber(true);
            if (object.totalFillSize != null)
                if (typeof object.totalFillSize === "object" ? object.totalFillSize.low || object.totalFillSize.high : Number(object.totalFillSize) !== 0)
                    if ($util.Long)
                        message.totalFillSize = $util.Long.fromValue(object.totalFillSize, true);
                    else if (typeof object.totalFillSize === "string")
                        message.totalFillSize = parseInt(object.totalFillSize, 10);
                    else if (typeof object.totalFillSize === "number")
                        message.totalFillSize = object.totalFillSize;
                    else if (typeof object.totalFillSize === "object")
                        message.totalFillSize = new $util.LongBits(object.totalFillSize.low >>> 0, object.totalFillSize.high >>> 0).toNumber(true);
            if (object.totalUnfilledSize != null)
                if (typeof object.totalUnfilledSize === "object" ? object.totalUnfilledSize.low || object.totalUnfilledSize.high : Number(object.totalUnfilledSize) !== 0)
                    if ($util.Long)
                        message.totalUnfilledSize = $util.Long.fromValue(object.totalUnfilledSize, true);
                    else if (typeof object.totalUnfilledSize === "string")
                        message.totalUnfilledSize = parseInt(object.totalUnfilledSize, 10);
                    else if (typeof object.totalUnfilledSize === "number")
                        message.totalUnfilledSize = object.totalUnfilledSize;
                    else if (typeof object.totalUnfilledSize === "object")
                        message.totalUnfilledSize = new $util.LongBits(object.totalUnfilledSize.low >>> 0, object.totalUnfilledSize.high >>> 0).toNumber(true);
            if (object.ssboe != null)
                if (Number(object.ssboe) !== 0)
                    message.ssboe = object.ssboe | 0;
            if (object.usecs != null)
                if (Number(object.usecs) !== 0)
                    message.usecs = object.usecs | 0;
            if (object.sourceSsboe != null)
                if (Number(object.sourceSsboe) !== 0)
                    message.sourceSsboe = object.sourceSsboe | 0;
            if (object.sourceUsecs != null)
                if (Number(object.sourceUsecs) !== 0)
                    message.sourceUsecs = object.sourceUsecs | 0;
            if (object.sourceNsecs != null)
                if (Number(object.sourceNsecs) !== 0)
                    message.sourceNsecs = object.sourceNsecs | 0;
            return message;
        };

        /**
         * Creates a plain object from a ResponseShowFillHistory message. Also converts values to other types if specified.
         * @function toObject
         * @memberof rti.ResponseShowFillHistory
         * @static
         * @param {rti.ResponseShowFillHistory} message ResponseShowFillHistory
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ResponseShowFillHistory.toObject = function toObject(message, options, _depth) {
            if (!options)
                options = {};
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw Error("max depth exceeded");
            let object = {};
            if (options.arrays || options.defaults) {
                object.userMsg = [];
                object.rqHandlerRpCode = [];
                object.rpCode = [];
            }
            if (options.defaults) {
                object.symbol = "";
                object.exchange = "";
                object.instrumentType = "";
                object.basketId = "";
                object.price = 0;
                object.fillPrice = 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.fillSize = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : typeof BigInt !== "undefined" && options.longs === BigInt ? long.toBigInt() : long;
                } else
                    object.fillSize = options.longs === String ? "0" : typeof BigInt !== "undefined" && options.longs === BigInt ? BigInt("0") : 0;
                object.fillTime = "";
                object.fillDate = "";
                object.fillId = "";
                object.avgFillPrice = 0;
                object.sequenceNumber = "";
                object.transactionType = "";
                object.duration = "";
                object.priceType = "";
                object.tradeRoute = "";
                object.tradeExchange = "";
                object.exchangeOrderId = "";
                object.triggerPrice = 0;
                object.origSequenceNumber = "";
                object.corSequenceNumber = "";
                object.ssboe = 0;
                object.usecs = 0;
                object.sourceSsboe = 0;
                object.sourceUsecs = 0;
                object.sourceNsecs = 0;
                object.accountId = "";
                object.fcmId = "";
                object.ibId = "";
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.totalFillSize = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : typeof BigInt !== "undefined" && options.longs === BigInt ? long.toBigInt() : long;
                } else
                    object.totalFillSize = options.longs === String ? "0" : typeof BigInt !== "undefined" && options.longs === BigInt ? BigInt("0") : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.totalUnfilledSize = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : typeof BigInt !== "undefined" && options.longs === BigInt ? long.toBigInt() : long;
                } else
                    object.totalUnfilledSize = options.longs === String ? "0" : typeof BigInt !== "undefined" && options.longs === BigInt ? BigInt("0") : 0;
                object.templateId = 0;
                object.manualOrAuto = "";
                object.origPriceType = "";
            }
            if (message.symbol != null && message.hasOwnProperty("symbol"))
                object.symbol = message.symbol;
            if (message.exchange != null && message.hasOwnProperty("exchange"))
                object.exchange = message.exchange;
            if (message.instrumentType != null && message.hasOwnProperty("instrumentType"))
                object.instrumentType = message.instrumentType;
            if (message.basketId != null && message.hasOwnProperty("basketId"))
                object.basketId = message.basketId;
            if (message.price != null && message.hasOwnProperty("price"))
                object.price = options.json && !isFinite(message.price) ? String(message.price) : message.price;
            if (message.fillPrice != null && message.hasOwnProperty("fillPrice"))
                object.fillPrice = options.json && !isFinite(message.fillPrice) ? String(message.fillPrice) : message.fillPrice;
            if (message.fillSize != null && message.hasOwnProperty("fillSize"))
                if (typeof BigInt !== "undefined" && options.longs === BigInt)
                    object.fillSize = typeof message.fillSize === "number" ? BigInt(message.fillSize) : $util.Long.fromBits(message.fillSize.low >>> 0, message.fillSize.high >>> 0, true).toBigInt();
                else if (typeof message.fillSize === "number")
                    object.fillSize = options.longs === String ? String(message.fillSize) : message.fillSize;
                else
                    object.fillSize = options.longs === String ? $util.Long.prototype.toString.call(message.fillSize) : options.longs === Number ? new $util.LongBits(message.fillSize.low >>> 0, message.fillSize.high >>> 0).toNumber(true) : message.fillSize;
            if (message.fillTime != null && message.hasOwnProperty("fillTime"))
                object.fillTime = message.fillTime;
            if (message.fillDate != null && message.hasOwnProperty("fillDate"))
                object.fillDate = message.fillDate;
            if (message.fillId != null && message.hasOwnProperty("fillId"))
                object.fillId = message.fillId;
            if (message.avgFillPrice != null && message.hasOwnProperty("avgFillPrice"))
                object.avgFillPrice = options.json && !isFinite(message.avgFillPrice) ? String(message.avgFillPrice) : message.avgFillPrice;
            if (message.sequenceNumber != null && message.hasOwnProperty("sequenceNumber"))
                object.sequenceNumber = message.sequenceNumber;
            if (message.transactionType != null && message.hasOwnProperty("transactionType"))
                object.transactionType = message.transactionType;
            if (message.duration != null && message.hasOwnProperty("duration"))
                object.duration = message.duration;
            if (message.priceType != null && message.hasOwnProperty("priceType"))
                object.priceType = message.priceType;
            if (message.tradeRoute != null && message.hasOwnProperty("tradeRoute"))
                object.tradeRoute = message.tradeRoute;
            if (message.tradeExchange != null && message.hasOwnProperty("tradeExchange"))
                object.tradeExchange = message.tradeExchange;
            if (message.userMsg && message.userMsg.length) {
                object.userMsg = Array(message.userMsg.length);
                for (let j = 0; j < message.userMsg.length; ++j)
                    object.userMsg[j] = message.userMsg[j];
            }
            if (message.rqHandlerRpCode && message.rqHandlerRpCode.length) {
                object.rqHandlerRpCode = Array(message.rqHandlerRpCode.length);
                for (let j = 0; j < message.rqHandlerRpCode.length; ++j)
                    object.rqHandlerRpCode[j] = message.rqHandlerRpCode[j];
            }
            if (message.rpCode && message.rpCode.length) {
                object.rpCode = Array(message.rpCode.length);
                for (let j = 0; j < message.rpCode.length; ++j)
                    object.rpCode[j] = message.rpCode[j];
            }
            if (message.exchangeOrderId != null && message.hasOwnProperty("exchangeOrderId"))
                object.exchangeOrderId = message.exchangeOrderId;
            if (message.triggerPrice != null && message.hasOwnProperty("triggerPrice"))
                object.triggerPrice = options.json && !isFinite(message.triggerPrice) ? String(message.triggerPrice) : message.triggerPrice;
            if (message.origSequenceNumber != null && message.hasOwnProperty("origSequenceNumber"))
                object.origSequenceNumber = message.origSequenceNumber;
            if (message.corSequenceNumber != null && message.hasOwnProperty("corSequenceNumber"))
                object.corSequenceNumber = message.corSequenceNumber;
            if (message.ssboe != null && message.hasOwnProperty("ssboe"))
                object.ssboe = message.ssboe;
            if (message.usecs != null && message.hasOwnProperty("usecs"))
                object.usecs = message.usecs;
            if (message.sourceSsboe != null && message.hasOwnProperty("sourceSsboe"))
                object.sourceSsboe = message.sourceSsboe;
            if (message.sourceUsecs != null && message.hasOwnProperty("sourceUsecs"))
                object.sourceUsecs = message.sourceUsecs;
            if (message.sourceNsecs != null && message.hasOwnProperty("sourceNsecs"))
                object.sourceNsecs = message.sourceNsecs;
            if (message.accountId != null && message.hasOwnProperty("accountId"))
                object.accountId = message.accountId;
            if (message.fcmId != null && message.hasOwnProperty("fcmId"))
                object.fcmId = message.fcmId;
            if (message.ibId != null && message.hasOwnProperty("ibId"))
                object.ibId = message.ibId;
            if (message.totalFillSize != null && message.hasOwnProperty("totalFillSize"))
                if (typeof BigInt !== "undefined" && options.longs === BigInt)
                    object.totalFillSize = typeof message.totalFillSize === "number" ? BigInt(message.totalFillSize) : $util.Long.fromBits(message.totalFillSize.low >>> 0, message.totalFillSize.high >>> 0, true).toBigInt();
                else if (typeof message.totalFillSize === "number")
                    object.totalFillSize = options.longs === String ? String(message.totalFillSize) : message.totalFillSize;
                else
                    object.totalFillSize = options.longs === String ? $util.Long.prototype.toString.call(message.totalFillSize) : options.longs === Number ? new $util.LongBits(message.totalFillSize.low >>> 0, message.totalFillSize.high >>> 0).toNumber(true) : message.totalFillSize;
            if (message.totalUnfilledSize != null && message.hasOwnProperty("totalUnfilledSize"))
                if (typeof BigInt !== "undefined" && options.longs === BigInt)
                    object.totalUnfilledSize = typeof message.totalUnfilledSize === "number" ? BigInt(message.totalUnfilledSize) : $util.Long.fromBits(message.totalUnfilledSize.low >>> 0, message.totalUnfilledSize.high >>> 0, true).toBigInt();
                else if (typeof message.totalUnfilledSize === "number")
                    object.totalUnfilledSize = options.longs === String ? String(message.totalUnfilledSize) : message.totalUnfilledSize;
                else
                    object.totalUnfilledSize = options.longs === String ? $util.Long.prototype.toString.call(message.totalUnfilledSize) : options.longs === Number ? new $util.LongBits(message.totalUnfilledSize.low >>> 0, message.totalUnfilledSize.high >>> 0).toNumber(true) : message.totalUnfilledSize;
            if (message.templateId != null && message.hasOwnProperty("templateId"))
                object.templateId = message.templateId;
            if (message.manualOrAuto != null && message.hasOwnProperty("manualOrAuto"))
                object.manualOrAuto = message.manualOrAuto;
            if (message.origPriceType != null && message.hasOwnProperty("origPriceType"))
                object.origPriceType = message.origPriceType;
            return object;
        };

        /**
         * Converts this ResponseShowFillHistory to JSON.
         * @function toJSON
         * @memberof rti.ResponseShowFillHistory
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ResponseShowFillHistory.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the type url for ResponseShowFillHistory
         * @function getTypeUrl
         * @memberof rti.ResponseShowFillHistory
         * @static
         * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
         * @returns {string} The type url
         */
        ResponseShowFillHistory.getTypeUrl = function getTypeUrl(prefix) {
            if (prefix === undefined)
                prefix = "type.googleapis.com";
            return prefix + "/rti.ResponseShowFillHistory";
        };

        return ResponseShowFillHistory;
    })();

    rti.ResponseShowOrderHistoryDates = (function() {

        /**
         * Properties of a ResponseShowOrderHistoryDates.
         * @typedef {Object} rti.ResponseShowOrderHistoryDates.$Properties
         * @property {number|null} [templateId] ResponseShowOrderHistoryDates templateId
         * @property {Array.<string>|null} [userMsg] ResponseShowOrderHistoryDates userMsg
         * @property {Array.<string>|null} [rqHandlerRpCode] ResponseShowOrderHistoryDates rqHandlerRpCode
         * @property {Array.<string>|null} [rpCode] ResponseShowOrderHistoryDates rpCode
         * @property {Array.<string>|null} [date] ResponseShowOrderHistoryDates date
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding
         */

        /**
         * Properties of a ResponseShowOrderHistoryDates.
         * @memberof rti
         * @interface IResponseShowOrderHistoryDates
         * @augments rti.ResponseShowOrderHistoryDates.$Properties
         * @deprecated Use rti.ResponseShowOrderHistoryDates.$Properties instead.
         */

        /**
         * Shape of a ResponseShowOrderHistoryDates.
         * @typedef {rti.ResponseShowOrderHistoryDates.$Properties} rti.ResponseShowOrderHistoryDates.$Shape
         */

        /**
         * Constructs a new ResponseShowOrderHistoryDates.
         * @memberof rti
         * @classdesc Represents a ResponseShowOrderHistoryDates.
         * @constructor
         * @param {rti.ResponseShowOrderHistoryDates.$Properties=} [properties] Properties to set
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding
         */
        function ResponseShowOrderHistoryDates(properties) {
            this.userMsg = [];
            this.rqHandlerRpCode = [];
            this.rpCode = [];
            this.date = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null && keys[i] !== "__proto__")
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ResponseShowOrderHistoryDates templateId.
         * @member {number} templateId
         * @memberof rti.ResponseShowOrderHistoryDates
         * @instance
         */
        ResponseShowOrderHistoryDates.prototype.templateId = 0;

        /**
         * ResponseShowOrderHistoryDates userMsg.
         * @member {Array.<string>} userMsg
         * @memberof rti.ResponseShowOrderHistoryDates
         * @instance
         */
        ResponseShowOrderHistoryDates.prototype.userMsg = $util.emptyArray;

        /**
         * ResponseShowOrderHistoryDates rqHandlerRpCode.
         * @member {Array.<string>} rqHandlerRpCode
         * @memberof rti.ResponseShowOrderHistoryDates
         * @instance
         */
        ResponseShowOrderHistoryDates.prototype.rqHandlerRpCode = $util.emptyArray;

        /**
         * ResponseShowOrderHistoryDates rpCode.
         * @member {Array.<string>} rpCode
         * @memberof rti.ResponseShowOrderHistoryDates
         * @instance
         */
        ResponseShowOrderHistoryDates.prototype.rpCode = $util.emptyArray;

        /**
         * ResponseShowOrderHistoryDates date.
         * @member {Array.<string>} date
         * @memberof rti.ResponseShowOrderHistoryDates
         * @instance
         */
        ResponseShowOrderHistoryDates.prototype.date = $util.emptyArray;

        /**
         * Creates a new ResponseShowOrderHistoryDates instance using the specified properties.
         * @function create
         * @memberof rti.ResponseShowOrderHistoryDates
         * @static
         * @param {rti.ResponseShowOrderHistoryDates.$Properties=} [properties] Properties to set
         * @returns {rti.ResponseShowOrderHistoryDates} ResponseShowOrderHistoryDates instance
         * @type {{
         *   (properties: rti.ResponseShowOrderHistoryDates.$Shape): rti.ResponseShowOrderHistoryDates & rti.ResponseShowOrderHistoryDates.$Shape;
         *   (properties?: rti.ResponseShowOrderHistoryDates.$Properties): rti.ResponseShowOrderHistoryDates;
         * }}
         */
        ResponseShowOrderHistoryDates.create = function create(properties) {
            return new ResponseShowOrderHistoryDates(properties);
        };

        /**
         * Encodes the specified ResponseShowOrderHistoryDates message. Does not implicitly {@link rti.ResponseShowOrderHistoryDates.verify|verify} messages.
         * @function encode
         * @memberof rti.ResponseShowOrderHistoryDates
         * @static
         * @param {rti.ResponseShowOrderHistoryDates.$Properties} message ResponseShowOrderHistoryDates message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ResponseShowOrderHistoryDates.encode = function encode(message, writer, _depth) {
            if (!writer)
                writer = $Writer.create();
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw Error("max depth exceeded");
            if (message.date != null && message.date.length)
                for (let i = 0; i < message.date.length; ++i)
                    writer.uint32(/* id 110615, wireType 2 =*/884922).string(message.date[i]);
            if (message.userMsg != null && message.userMsg.length)
                for (let i = 0; i < message.userMsg.length; ++i)
                    writer.uint32(/* id 132760, wireType 2 =*/1062082).string(message.userMsg[i]);
            if (message.rqHandlerRpCode != null && message.rqHandlerRpCode.length)
                for (let i = 0; i < message.rqHandlerRpCode.length; ++i)
                    writer.uint32(/* id 132764, wireType 2 =*/1062114).string(message.rqHandlerRpCode[i]);
            if (message.rpCode != null && message.rpCode.length)
                for (let i = 0; i < message.rpCode.length; ++i)
                    writer.uint32(/* id 132766, wireType 2 =*/1062130).string(message.rpCode[i]);
            if (message.templateId != null && Object.hasOwnProperty.call(message, "templateId"))
                writer.uint32(/* id 154467, wireType 0 =*/1235736).int32(message.templateId);
            if (message.$unknowns != null && Object.hasOwnProperty.call(message, "$unknowns"))
                for (let i = 0; i < message.$unknowns.length; ++i)
                    writer.raw(message.$unknowns[i]);
            return writer;
        };

        /**
         * Encodes the specified ResponseShowOrderHistoryDates message, length delimited. Does not implicitly {@link rti.ResponseShowOrderHistoryDates.verify|verify} messages.
         * @function encodeDelimited
         * @memberof rti.ResponseShowOrderHistoryDates
         * @static
         * @param {rti.ResponseShowOrderHistoryDates.$Properties} message ResponseShowOrderHistoryDates message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ResponseShowOrderHistoryDates.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer && writer.len ? writer.fork() : writer).ldelim();
        };

        /**
         * Decodes a ResponseShowOrderHistoryDates message from the specified reader or buffer.
         * @function decode
         * @memberof rti.ResponseShowOrderHistoryDates
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {rti.ResponseShowOrderHistoryDates & rti.ResponseShowOrderHistoryDates.$Shape} ResponseShowOrderHistoryDates
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ResponseShowOrderHistoryDates.decode = function decode(reader, length, _end, _depth, _target) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $Reader.recursionLimit)
                throw Error("max depth exceeded");
            let end = length === undefined ? reader.len : reader.pos + length, message = _target || new $root.rti.ResponseShowOrderHistoryDates(), value;
            while (reader.pos < end) {
                let start = reader.pos;
                let tag = reader.tag();
                if (tag === _end) {
                    _end = undefined;
                    break;
                }
                let wireType = tag & 7;
                switch (tag >>>= 3) {
                case 154467: {
                        if (wireType !== 0)
                            break;
                        if (value = reader.int32())
                            message.templateId = value;
                        else
                            delete message.templateId;
                        continue;
                    }
                case 132760: {
                        if (wireType !== 2)
                            break;
                        if (!(message.userMsg && message.userMsg.length))
                            message.userMsg = [];
                        message.userMsg.push(reader.string());
                        continue;
                    }
                case 132764: {
                        if (wireType !== 2)
                            break;
                        if (!(message.rqHandlerRpCode && message.rqHandlerRpCode.length))
                            message.rqHandlerRpCode = [];
                        message.rqHandlerRpCode.push(reader.string());
                        continue;
                    }
                case 132766: {
                        if (wireType !== 2)
                            break;
                        if (!(message.rpCode && message.rpCode.length))
                            message.rpCode = [];
                        message.rpCode.push(reader.string());
                        continue;
                    }
                case 110615: {
                        if (wireType !== 2)
                            break;
                        if (!(message.date && message.date.length))
                            message.date = [];
                        message.date.push(reader.string());
                        continue;
                    }
                }
                reader.skipType(wireType, _depth, tag);
                if (!reader.discardUnknown) {
                    $util.makeProp(message, "$unknowns", false);
                    (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
                }
            }
            if (_end !== undefined)
                throw Error("missing end group");
            return message;
        };

        /**
         * Decodes a ResponseShowOrderHistoryDates message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof rti.ResponseShowOrderHistoryDates
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {rti.ResponseShowOrderHistoryDates & rti.ResponseShowOrderHistoryDates.$Shape} ResponseShowOrderHistoryDates
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ResponseShowOrderHistoryDates.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ResponseShowOrderHistoryDates message.
         * @function verify
         * @memberof rti.ResponseShowOrderHistoryDates
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ResponseShowOrderHistoryDates.verify = function verify(message, _depth) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                return "max depth exceeded";
            if (message.templateId != null && message.hasOwnProperty("templateId"))
                if (!$util.isInteger(message.templateId))
                    return "templateId: integer expected";
            if (message.userMsg != null && message.hasOwnProperty("userMsg")) {
                if (!Array.isArray(message.userMsg))
                    return "userMsg: array expected";
                for (let i = 0; i < message.userMsg.length; ++i)
                    if (!$util.isString(message.userMsg[i]))
                        return "userMsg: string[] expected";
            }
            if (message.rqHandlerRpCode != null && message.hasOwnProperty("rqHandlerRpCode")) {
                if (!Array.isArray(message.rqHandlerRpCode))
                    return "rqHandlerRpCode: array expected";
                for (let i = 0; i < message.rqHandlerRpCode.length; ++i)
                    if (!$util.isString(message.rqHandlerRpCode[i]))
                        return "rqHandlerRpCode: string[] expected";
            }
            if (message.rpCode != null && message.hasOwnProperty("rpCode")) {
                if (!Array.isArray(message.rpCode))
                    return "rpCode: array expected";
                for (let i = 0; i < message.rpCode.length; ++i)
                    if (!$util.isString(message.rpCode[i]))
                        return "rpCode: string[] expected";
            }
            if (message.date != null && message.hasOwnProperty("date")) {
                if (!Array.isArray(message.date))
                    return "date: array expected";
                for (let i = 0; i < message.date.length; ++i)
                    if (!$util.isString(message.date[i]))
                        return "date: string[] expected";
            }
            return null;
        };

        /**
         * Creates a ResponseShowOrderHistoryDates message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof rti.ResponseShowOrderHistoryDates
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {rti.ResponseShowOrderHistoryDates} ResponseShowOrderHistoryDates
         */
        ResponseShowOrderHistoryDates.fromObject = function fromObject(object, _depth) {
            if (object instanceof $root.rti.ResponseShowOrderHistoryDates)
                return object;
            if (!$util.isObject(object))
                throw TypeError(".rti.ResponseShowOrderHistoryDates: object expected");
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw Error("max depth exceeded");
            let message = new $root.rti.ResponseShowOrderHistoryDates();
            if (object.templateId != null)
                if (Number(object.templateId) !== 0)
                    message.templateId = object.templateId | 0;
            if (object.userMsg) {
                if (!Array.isArray(object.userMsg))
                    throw TypeError(".rti.ResponseShowOrderHistoryDates.userMsg: array expected");
                message.userMsg = Array(object.userMsg.length);
                for (let i = 0; i < object.userMsg.length; ++i)
                    message.userMsg[i] = String(object.userMsg[i]);
            }
            if (object.rqHandlerRpCode) {
                if (!Array.isArray(object.rqHandlerRpCode))
                    throw TypeError(".rti.ResponseShowOrderHistoryDates.rqHandlerRpCode: array expected");
                message.rqHandlerRpCode = Array(object.rqHandlerRpCode.length);
                for (let i = 0; i < object.rqHandlerRpCode.length; ++i)
                    message.rqHandlerRpCode[i] = String(object.rqHandlerRpCode[i]);
            }
            if (object.rpCode) {
                if (!Array.isArray(object.rpCode))
                    throw TypeError(".rti.ResponseShowOrderHistoryDates.rpCode: array expected");
                message.rpCode = Array(object.rpCode.length);
                for (let i = 0; i < object.rpCode.length; ++i)
                    message.rpCode[i] = String(object.rpCode[i]);
            }
            if (object.date) {
                if (!Array.isArray(object.date))
                    throw TypeError(".rti.ResponseShowOrderHistoryDates.date: array expected");
                message.date = Array(object.date.length);
                for (let i = 0; i < object.date.length; ++i)
                    message.date[i] = String(object.date[i]);
            }
            return message;
        };

        /**
         * Creates a plain object from a ResponseShowOrderHistoryDates message. Also converts values to other types if specified.
         * @function toObject
         * @memberof rti.ResponseShowOrderHistoryDates
         * @static
         * @param {rti.ResponseShowOrderHistoryDates} message ResponseShowOrderHistoryDates
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ResponseShowOrderHistoryDates.toObject = function toObject(message, options, _depth) {
            if (!options)
                options = {};
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw Error("max depth exceeded");
            let object = {};
            if (options.arrays || options.defaults) {
                object.date = [];
                object.userMsg = [];
                object.rqHandlerRpCode = [];
                object.rpCode = [];
            }
            if (options.defaults)
                object.templateId = 0;
            if (message.date && message.date.length) {
                object.date = Array(message.date.length);
                for (let j = 0; j < message.date.length; ++j)
                    object.date[j] = message.date[j];
            }
            if (message.userMsg && message.userMsg.length) {
                object.userMsg = Array(message.userMsg.length);
                for (let j = 0; j < message.userMsg.length; ++j)
                    object.userMsg[j] = message.userMsg[j];
            }
            if (message.rqHandlerRpCode && message.rqHandlerRpCode.length) {
                object.rqHandlerRpCode = Array(message.rqHandlerRpCode.length);
                for (let j = 0; j < message.rqHandlerRpCode.length; ++j)
                    object.rqHandlerRpCode[j] = message.rqHandlerRpCode[j];
            }
            if (message.rpCode && message.rpCode.length) {
                object.rpCode = Array(message.rpCode.length);
                for (let j = 0; j < message.rpCode.length; ++j)
                    object.rpCode[j] = message.rpCode[j];
            }
            if (message.templateId != null && message.hasOwnProperty("templateId"))
                object.templateId = message.templateId;
            return object;
        };

        /**
         * Converts this ResponseShowOrderHistoryDates to JSON.
         * @function toJSON
         * @memberof rti.ResponseShowOrderHistoryDates
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ResponseShowOrderHistoryDates.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the type url for ResponseShowOrderHistoryDates
         * @function getTypeUrl
         * @memberof rti.ResponseShowOrderHistoryDates
         * @static
         * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
         * @returns {string} The type url
         */
        ResponseShowOrderHistoryDates.getTypeUrl = function getTypeUrl(prefix) {
            if (prefix === undefined)
                prefix = "type.googleapis.com";
            return prefix + "/rti.ResponseShowOrderHistoryDates";
        };

        return ResponseShowOrderHistoryDates;
    })();

    rti.ResponseShowOrders = (function() {

        /**
         * Properties of a ResponseShowOrders.
         * @typedef {Object} rti.ResponseShowOrders.$Properties
         * @property {number|null} [templateId] ResponseShowOrders templateId
         * @property {Array.<string>|null} [userMsg] ResponseShowOrders userMsg
         * @property {Array.<string>|null} [rpCode] ResponseShowOrders rpCode
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding
         */

        /**
         * Properties of a ResponseShowOrders.
         * @memberof rti
         * @interface IResponseShowOrders
         * @augments rti.ResponseShowOrders.$Properties
         * @deprecated Use rti.ResponseShowOrders.$Properties instead.
         */

        /**
         * Shape of a ResponseShowOrders.
         * @typedef {rti.ResponseShowOrders.$Properties} rti.ResponseShowOrders.$Shape
         */

        /**
         * Constructs a new ResponseShowOrders.
         * @memberof rti
         * @classdesc Represents a ResponseShowOrders.
         * @constructor
         * @param {rti.ResponseShowOrders.$Properties=} [properties] Properties to set
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding
         */
        function ResponseShowOrders(properties) {
            this.userMsg = [];
            this.rpCode = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null && keys[i] !== "__proto__")
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ResponseShowOrders templateId.
         * @member {number} templateId
         * @memberof rti.ResponseShowOrders
         * @instance
         */
        ResponseShowOrders.prototype.templateId = 0;

        /**
         * ResponseShowOrders userMsg.
         * @member {Array.<string>} userMsg
         * @memberof rti.ResponseShowOrders
         * @instance
         */
        ResponseShowOrders.prototype.userMsg = $util.emptyArray;

        /**
         * ResponseShowOrders rpCode.
         * @member {Array.<string>} rpCode
         * @memberof rti.ResponseShowOrders
         * @instance
         */
        ResponseShowOrders.prototype.rpCode = $util.emptyArray;

        /**
         * Creates a new ResponseShowOrders instance using the specified properties.
         * @function create
         * @memberof rti.ResponseShowOrders
         * @static
         * @param {rti.ResponseShowOrders.$Properties=} [properties] Properties to set
         * @returns {rti.ResponseShowOrders} ResponseShowOrders instance
         * @type {{
         *   (properties: rti.ResponseShowOrders.$Shape): rti.ResponseShowOrders & rti.ResponseShowOrders.$Shape;
         *   (properties?: rti.ResponseShowOrders.$Properties): rti.ResponseShowOrders;
         * }}
         */
        ResponseShowOrders.create = function create(properties) {
            return new ResponseShowOrders(properties);
        };

        /**
         * Encodes the specified ResponseShowOrders message. Does not implicitly {@link rti.ResponseShowOrders.verify|verify} messages.
         * @function encode
         * @memberof rti.ResponseShowOrders
         * @static
         * @param {rti.ResponseShowOrders.$Properties} message ResponseShowOrders message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ResponseShowOrders.encode = function encode(message, writer, _depth) {
            if (!writer)
                writer = $Writer.create();
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw Error("max depth exceeded");
            if (message.userMsg != null && message.userMsg.length)
                for (let i = 0; i < message.userMsg.length; ++i)
                    writer.uint32(/* id 132760, wireType 2 =*/1062082).string(message.userMsg[i]);
            if (message.rpCode != null && message.rpCode.length)
                for (let i = 0; i < message.rpCode.length; ++i)
                    writer.uint32(/* id 132766, wireType 2 =*/1062130).string(message.rpCode[i]);
            if (message.templateId != null && Object.hasOwnProperty.call(message, "templateId"))
                writer.uint32(/* id 154467, wireType 0 =*/1235736).int32(message.templateId);
            if (message.$unknowns != null && Object.hasOwnProperty.call(message, "$unknowns"))
                for (let i = 0; i < message.$unknowns.length; ++i)
                    writer.raw(message.$unknowns[i]);
            return writer;
        };

        /**
         * Encodes the specified ResponseShowOrders message, length delimited. Does not implicitly {@link rti.ResponseShowOrders.verify|verify} messages.
         * @function encodeDelimited
         * @memberof rti.ResponseShowOrders
         * @static
         * @param {rti.ResponseShowOrders.$Properties} message ResponseShowOrders message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ResponseShowOrders.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer && writer.len ? writer.fork() : writer).ldelim();
        };

        /**
         * Decodes a ResponseShowOrders message from the specified reader or buffer.
         * @function decode
         * @memberof rti.ResponseShowOrders
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {rti.ResponseShowOrders & rti.ResponseShowOrders.$Shape} ResponseShowOrders
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ResponseShowOrders.decode = function decode(reader, length, _end, _depth, _target) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $Reader.recursionLimit)
                throw Error("max depth exceeded");
            let end = length === undefined ? reader.len : reader.pos + length, message = _target || new $root.rti.ResponseShowOrders(), value;
            while (reader.pos < end) {
                let start = reader.pos;
                let tag = reader.tag();
                if (tag === _end) {
                    _end = undefined;
                    break;
                }
                let wireType = tag & 7;
                switch (tag >>>= 3) {
                case 154467: {
                        if (wireType !== 0)
                            break;
                        if (value = reader.int32())
                            message.templateId = value;
                        else
                            delete message.templateId;
                        continue;
                    }
                case 132760: {
                        if (wireType !== 2)
                            break;
                        if (!(message.userMsg && message.userMsg.length))
                            message.userMsg = [];
                        message.userMsg.push(reader.string());
                        continue;
                    }
                case 132766: {
                        if (wireType !== 2)
                            break;
                        if (!(message.rpCode && message.rpCode.length))
                            message.rpCode = [];
                        message.rpCode.push(reader.string());
                        continue;
                    }
                }
                reader.skipType(wireType, _depth, tag);
                if (!reader.discardUnknown) {
                    $util.makeProp(message, "$unknowns", false);
                    (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
                }
            }
            if (_end !== undefined)
                throw Error("missing end group");
            return message;
        };

        /**
         * Decodes a ResponseShowOrders message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof rti.ResponseShowOrders
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {rti.ResponseShowOrders & rti.ResponseShowOrders.$Shape} ResponseShowOrders
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ResponseShowOrders.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ResponseShowOrders message.
         * @function verify
         * @memberof rti.ResponseShowOrders
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ResponseShowOrders.verify = function verify(message, _depth) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                return "max depth exceeded";
            if (message.templateId != null && message.hasOwnProperty("templateId"))
                if (!$util.isInteger(message.templateId))
                    return "templateId: integer expected";
            if (message.userMsg != null && message.hasOwnProperty("userMsg")) {
                if (!Array.isArray(message.userMsg))
                    return "userMsg: array expected";
                for (let i = 0; i < message.userMsg.length; ++i)
                    if (!$util.isString(message.userMsg[i]))
                        return "userMsg: string[] expected";
            }
            if (message.rpCode != null && message.hasOwnProperty("rpCode")) {
                if (!Array.isArray(message.rpCode))
                    return "rpCode: array expected";
                for (let i = 0; i < message.rpCode.length; ++i)
                    if (!$util.isString(message.rpCode[i]))
                        return "rpCode: string[] expected";
            }
            return null;
        };

        /**
         * Creates a ResponseShowOrders message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof rti.ResponseShowOrders
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {rti.ResponseShowOrders} ResponseShowOrders
         */
        ResponseShowOrders.fromObject = function fromObject(object, _depth) {
            if (object instanceof $root.rti.ResponseShowOrders)
                return object;
            if (!$util.isObject(object))
                throw TypeError(".rti.ResponseShowOrders: object expected");
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw Error("max depth exceeded");
            let message = new $root.rti.ResponseShowOrders();
            if (object.templateId != null)
                if (Number(object.templateId) !== 0)
                    message.templateId = object.templateId | 0;
            if (object.userMsg) {
                if (!Array.isArray(object.userMsg))
                    throw TypeError(".rti.ResponseShowOrders.userMsg: array expected");
                message.userMsg = Array(object.userMsg.length);
                for (let i = 0; i < object.userMsg.length; ++i)
                    message.userMsg[i] = String(object.userMsg[i]);
            }
            if (object.rpCode) {
                if (!Array.isArray(object.rpCode))
                    throw TypeError(".rti.ResponseShowOrders.rpCode: array expected");
                message.rpCode = Array(object.rpCode.length);
                for (let i = 0; i < object.rpCode.length; ++i)
                    message.rpCode[i] = String(object.rpCode[i]);
            }
            return message;
        };

        /**
         * Creates a plain object from a ResponseShowOrders message. Also converts values to other types if specified.
         * @function toObject
         * @memberof rti.ResponseShowOrders
         * @static
         * @param {rti.ResponseShowOrders} message ResponseShowOrders
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ResponseShowOrders.toObject = function toObject(message, options, _depth) {
            if (!options)
                options = {};
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw Error("max depth exceeded");
            let object = {};
            if (options.arrays || options.defaults) {
                object.userMsg = [];
                object.rpCode = [];
            }
            if (options.defaults)
                object.templateId = 0;
            if (message.userMsg && message.userMsg.length) {
                object.userMsg = Array(message.userMsg.length);
                for (let j = 0; j < message.userMsg.length; ++j)
                    object.userMsg[j] = message.userMsg[j];
            }
            if (message.rpCode && message.rpCode.length) {
                object.rpCode = Array(message.rpCode.length);
                for (let j = 0; j < message.rpCode.length; ++j)
                    object.rpCode[j] = message.rpCode[j];
            }
            if (message.templateId != null && message.hasOwnProperty("templateId"))
                object.templateId = message.templateId;
            return object;
        };

        /**
         * Converts this ResponseShowOrders to JSON.
         * @function toJSON
         * @memberof rti.ResponseShowOrders
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ResponseShowOrders.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the type url for ResponseShowOrders
         * @function getTypeUrl
         * @memberof rti.ResponseShowOrders
         * @static
         * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
         * @returns {string} The type url
         */
        ResponseShowOrders.getTypeUrl = function getTypeUrl(prefix) {
            if (prefix === undefined)
                prefix = "type.googleapis.com";
            return prefix + "/rti.ResponseShowOrders";
        };

        return ResponseShowOrders;
    })();

    rti.ResponseSubscribeForOrderUpdates = (function() {

        /**
         * Properties of a ResponseSubscribeForOrderUpdates.
         * @typedef {Object} rti.ResponseSubscribeForOrderUpdates.$Properties
         * @property {number|null} [templateId] ResponseSubscribeForOrderUpdates templateId
         * @property {Array.<string>|null} [userMsg] ResponseSubscribeForOrderUpdates userMsg
         * @property {Array.<string>|null} [rpCode] ResponseSubscribeForOrderUpdates rpCode
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding
         */

        /**
         * Properties of a ResponseSubscribeForOrderUpdates.
         * @memberof rti
         * @interface IResponseSubscribeForOrderUpdates
         * @augments rti.ResponseSubscribeForOrderUpdates.$Properties
         * @deprecated Use rti.ResponseSubscribeForOrderUpdates.$Properties instead.
         */

        /**
         * Shape of a ResponseSubscribeForOrderUpdates.
         * @typedef {rti.ResponseSubscribeForOrderUpdates.$Properties} rti.ResponseSubscribeForOrderUpdates.$Shape
         */

        /**
         * Constructs a new ResponseSubscribeForOrderUpdates.
         * @memberof rti
         * @classdesc Represents a ResponseSubscribeForOrderUpdates.
         * @constructor
         * @param {rti.ResponseSubscribeForOrderUpdates.$Properties=} [properties] Properties to set
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding
         */
        function ResponseSubscribeForOrderUpdates(properties) {
            this.userMsg = [];
            this.rpCode = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null && keys[i] !== "__proto__")
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ResponseSubscribeForOrderUpdates templateId.
         * @member {number} templateId
         * @memberof rti.ResponseSubscribeForOrderUpdates
         * @instance
         */
        ResponseSubscribeForOrderUpdates.prototype.templateId = 0;

        /**
         * ResponseSubscribeForOrderUpdates userMsg.
         * @member {Array.<string>} userMsg
         * @memberof rti.ResponseSubscribeForOrderUpdates
         * @instance
         */
        ResponseSubscribeForOrderUpdates.prototype.userMsg = $util.emptyArray;

        /**
         * ResponseSubscribeForOrderUpdates rpCode.
         * @member {Array.<string>} rpCode
         * @memberof rti.ResponseSubscribeForOrderUpdates
         * @instance
         */
        ResponseSubscribeForOrderUpdates.prototype.rpCode = $util.emptyArray;

        /**
         * Creates a new ResponseSubscribeForOrderUpdates instance using the specified properties.
         * @function create
         * @memberof rti.ResponseSubscribeForOrderUpdates
         * @static
         * @param {rti.ResponseSubscribeForOrderUpdates.$Properties=} [properties] Properties to set
         * @returns {rti.ResponseSubscribeForOrderUpdates} ResponseSubscribeForOrderUpdates instance
         * @type {{
         *   (properties: rti.ResponseSubscribeForOrderUpdates.$Shape): rti.ResponseSubscribeForOrderUpdates & rti.ResponseSubscribeForOrderUpdates.$Shape;
         *   (properties?: rti.ResponseSubscribeForOrderUpdates.$Properties): rti.ResponseSubscribeForOrderUpdates;
         * }}
         */
        ResponseSubscribeForOrderUpdates.create = function create(properties) {
            return new ResponseSubscribeForOrderUpdates(properties);
        };

        /**
         * Encodes the specified ResponseSubscribeForOrderUpdates message. Does not implicitly {@link rti.ResponseSubscribeForOrderUpdates.verify|verify} messages.
         * @function encode
         * @memberof rti.ResponseSubscribeForOrderUpdates
         * @static
         * @param {rti.ResponseSubscribeForOrderUpdates.$Properties} message ResponseSubscribeForOrderUpdates message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ResponseSubscribeForOrderUpdates.encode = function encode(message, writer, _depth) {
            if (!writer)
                writer = $Writer.create();
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw Error("max depth exceeded");
            if (message.userMsg != null && message.userMsg.length)
                for (let i = 0; i < message.userMsg.length; ++i)
                    writer.uint32(/* id 132760, wireType 2 =*/1062082).string(message.userMsg[i]);
            if (message.rpCode != null && message.rpCode.length)
                for (let i = 0; i < message.rpCode.length; ++i)
                    writer.uint32(/* id 132766, wireType 2 =*/1062130).string(message.rpCode[i]);
            if (message.templateId != null && Object.hasOwnProperty.call(message, "templateId"))
                writer.uint32(/* id 154467, wireType 0 =*/1235736).int32(message.templateId);
            if (message.$unknowns != null && Object.hasOwnProperty.call(message, "$unknowns"))
                for (let i = 0; i < message.$unknowns.length; ++i)
                    writer.raw(message.$unknowns[i]);
            return writer;
        };

        /**
         * Encodes the specified ResponseSubscribeForOrderUpdates message, length delimited. Does not implicitly {@link rti.ResponseSubscribeForOrderUpdates.verify|verify} messages.
         * @function encodeDelimited
         * @memberof rti.ResponseSubscribeForOrderUpdates
         * @static
         * @param {rti.ResponseSubscribeForOrderUpdates.$Properties} message ResponseSubscribeForOrderUpdates message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ResponseSubscribeForOrderUpdates.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer && writer.len ? writer.fork() : writer).ldelim();
        };

        /**
         * Decodes a ResponseSubscribeForOrderUpdates message from the specified reader or buffer.
         * @function decode
         * @memberof rti.ResponseSubscribeForOrderUpdates
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {rti.ResponseSubscribeForOrderUpdates & rti.ResponseSubscribeForOrderUpdates.$Shape} ResponseSubscribeForOrderUpdates
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ResponseSubscribeForOrderUpdates.decode = function decode(reader, length, _end, _depth, _target) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $Reader.recursionLimit)
                throw Error("max depth exceeded");
            let end = length === undefined ? reader.len : reader.pos + length, message = _target || new $root.rti.ResponseSubscribeForOrderUpdates(), value;
            while (reader.pos < end) {
                let start = reader.pos;
                let tag = reader.tag();
                if (tag === _end) {
                    _end = undefined;
                    break;
                }
                let wireType = tag & 7;
                switch (tag >>>= 3) {
                case 154467: {
                        if (wireType !== 0)
                            break;
                        if (value = reader.int32())
                            message.templateId = value;
                        else
                            delete message.templateId;
                        continue;
                    }
                case 132760: {
                        if (wireType !== 2)
                            break;
                        if (!(message.userMsg && message.userMsg.length))
                            message.userMsg = [];
                        message.userMsg.push(reader.string());
                        continue;
                    }
                case 132766: {
                        if (wireType !== 2)
                            break;
                        if (!(message.rpCode && message.rpCode.length))
                            message.rpCode = [];
                        message.rpCode.push(reader.string());
                        continue;
                    }
                }
                reader.skipType(wireType, _depth, tag);
                if (!reader.discardUnknown) {
                    $util.makeProp(message, "$unknowns", false);
                    (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
                }
            }
            if (_end !== undefined)
                throw Error("missing end group");
            return message;
        };

        /**
         * Decodes a ResponseSubscribeForOrderUpdates message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof rti.ResponseSubscribeForOrderUpdates
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {rti.ResponseSubscribeForOrderUpdates & rti.ResponseSubscribeForOrderUpdates.$Shape} ResponseSubscribeForOrderUpdates
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ResponseSubscribeForOrderUpdates.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ResponseSubscribeForOrderUpdates message.
         * @function verify
         * @memberof rti.ResponseSubscribeForOrderUpdates
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ResponseSubscribeForOrderUpdates.verify = function verify(message, _depth) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                return "max depth exceeded";
            if (message.templateId != null && message.hasOwnProperty("templateId"))
                if (!$util.isInteger(message.templateId))
                    return "templateId: integer expected";
            if (message.userMsg != null && message.hasOwnProperty("userMsg")) {
                if (!Array.isArray(message.userMsg))
                    return "userMsg: array expected";
                for (let i = 0; i < message.userMsg.length; ++i)
                    if (!$util.isString(message.userMsg[i]))
                        return "userMsg: string[] expected";
            }
            if (message.rpCode != null && message.hasOwnProperty("rpCode")) {
                if (!Array.isArray(message.rpCode))
                    return "rpCode: array expected";
                for (let i = 0; i < message.rpCode.length; ++i)
                    if (!$util.isString(message.rpCode[i]))
                        return "rpCode: string[] expected";
            }
            return null;
        };

        /**
         * Creates a ResponseSubscribeForOrderUpdates message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof rti.ResponseSubscribeForOrderUpdates
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {rti.ResponseSubscribeForOrderUpdates} ResponseSubscribeForOrderUpdates
         */
        ResponseSubscribeForOrderUpdates.fromObject = function fromObject(object, _depth) {
            if (object instanceof $root.rti.ResponseSubscribeForOrderUpdates)
                return object;
            if (!$util.isObject(object))
                throw TypeError(".rti.ResponseSubscribeForOrderUpdates: object expected");
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw Error("max depth exceeded");
            let message = new $root.rti.ResponseSubscribeForOrderUpdates();
            if (object.templateId != null)
                if (Number(object.templateId) !== 0)
                    message.templateId = object.templateId | 0;
            if (object.userMsg) {
                if (!Array.isArray(object.userMsg))
                    throw TypeError(".rti.ResponseSubscribeForOrderUpdates.userMsg: array expected");
                message.userMsg = Array(object.userMsg.length);
                for (let i = 0; i < object.userMsg.length; ++i)
                    message.userMsg[i] = String(object.userMsg[i]);
            }
            if (object.rpCode) {
                if (!Array.isArray(object.rpCode))
                    throw TypeError(".rti.ResponseSubscribeForOrderUpdates.rpCode: array expected");
                message.rpCode = Array(object.rpCode.length);
                for (let i = 0; i < object.rpCode.length; ++i)
                    message.rpCode[i] = String(object.rpCode[i]);
            }
            return message;
        };

        /**
         * Creates a plain object from a ResponseSubscribeForOrderUpdates message. Also converts values to other types if specified.
         * @function toObject
         * @memberof rti.ResponseSubscribeForOrderUpdates
         * @static
         * @param {rti.ResponseSubscribeForOrderUpdates} message ResponseSubscribeForOrderUpdates
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ResponseSubscribeForOrderUpdates.toObject = function toObject(message, options, _depth) {
            if (!options)
                options = {};
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw Error("max depth exceeded");
            let object = {};
            if (options.arrays || options.defaults) {
                object.userMsg = [];
                object.rpCode = [];
            }
            if (options.defaults)
                object.templateId = 0;
            if (message.userMsg && message.userMsg.length) {
                object.userMsg = Array(message.userMsg.length);
                for (let j = 0; j < message.userMsg.length; ++j)
                    object.userMsg[j] = message.userMsg[j];
            }
            if (message.rpCode && message.rpCode.length) {
                object.rpCode = Array(message.rpCode.length);
                for (let j = 0; j < message.rpCode.length; ++j)
                    object.rpCode[j] = message.rpCode[j];
            }
            if (message.templateId != null && message.hasOwnProperty("templateId"))
                object.templateId = message.templateId;
            return object;
        };

        /**
         * Converts this ResponseSubscribeForOrderUpdates to JSON.
         * @function toJSON
         * @memberof rti.ResponseSubscribeForOrderUpdates
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ResponseSubscribeForOrderUpdates.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the type url for ResponseSubscribeForOrderUpdates
         * @function getTypeUrl
         * @memberof rti.ResponseSubscribeForOrderUpdates
         * @static
         * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
         * @returns {string} The type url
         */
        ResponseSubscribeForOrderUpdates.getTypeUrl = function getTypeUrl(prefix) {
            if (prefix === undefined)
                prefix = "type.googleapis.com";
            return prefix + "/rti.ResponseSubscribeForOrderUpdates";
        };

        return ResponseSubscribeForOrderUpdates;
    })();

    rti.RithmicOrderNotification = (function() {

        /**
         * Properties of a RithmicOrderNotification.
         * @typedef {Object} rti.RithmicOrderNotification.$Properties
         * @property {number|null} [templateId] RithmicOrderNotification templateId
         * @property {string|null} [userTag] RithmicOrderNotification userTag
         * @property {rti.RithmicOrderNotification.NotifyType|null} [notifyType] RithmicOrderNotification notifyType
         * @property {boolean|null} [isSnapshot] RithmicOrderNotification isSnapshot
         * @property {string|null} [status] RithmicOrderNotification status
         * @property {string|null} [basketId] RithmicOrderNotification basketId
         * @property {string|null} [originalBasketId] RithmicOrderNotification originalBasketId
         * @property {string|null} [linkedBasketIds] RithmicOrderNotification linkedBasketIds
         * @property {string|null} [fcmId] RithmicOrderNotification fcmId
         * @property {string|null} [ibId] RithmicOrderNotification ibId
         * @property {string|null} [userId] RithmicOrderNotification userId
         * @property {string|null} [accountId] RithmicOrderNotification accountId
         * @property {string|null} [symbol] RithmicOrderNotification symbol
         * @property {string|null} [exchange] RithmicOrderNotification exchange
         * @property {string|null} [tradeExchange] RithmicOrderNotification tradeExchange
         * @property {string|null} [tradeRoute] RithmicOrderNotification tradeRoute
         * @property {string|null} [exchangeOrderId] RithmicOrderNotification exchangeOrderId
         * @property {string|null} [instrumentType] RithmicOrderNotification instrumentType
         * @property {string|null} [completionReason] RithmicOrderNotification completionReason
         * @property {number|null} [quantity] RithmicOrderNotification quantity
         * @property {number|null} [quanReleasePending] RithmicOrderNotification quanReleasePending
         * @property {number|null} [price] RithmicOrderNotification price
         * @property {number|null} [triggerPrice] RithmicOrderNotification triggerPrice
         * @property {rti.RithmicOrderNotification.TransactionType|null} [transactionType] RithmicOrderNotification transactionType
         * @property {rti.RithmicOrderNotification.Duration|null} [duration] RithmicOrderNotification duration
         * @property {rti.RithmicOrderNotification.PriceType|null} [priceType] RithmicOrderNotification priceType
         * @property {rti.RithmicOrderNotification.PriceType|null} [origPriceType] RithmicOrderNotification origPriceType
         * @property {rti.RithmicOrderNotification.OrderPlacement|null} [manualOrAuto] RithmicOrderNotification manualOrAuto
         * @property {rti.RithmicOrderNotification.BracketType|null} [bracketType] RithmicOrderNotification bracketType
         * @property {number|null} [avgFillPrice] RithmicOrderNotification avgFillPrice
         * @property {number|null} [totalFillSize] RithmicOrderNotification totalFillSize
         * @property {number|null} [totalUnfilledSize] RithmicOrderNotification totalUnfilledSize
         * @property {string|null} [sequenceNumber] RithmicOrderNotification sequenceNumber
         * @property {string|null} [origSequenceNumber] RithmicOrderNotification origSequenceNumber
         * @property {string|null} [corSequenceNumber] RithmicOrderNotification corSequenceNumber
         * @property {string|null} [currency] RithmicOrderNotification currency
         * @property {string|null} [countryCode] RithmicOrderNotification countryCode
         * @property {string|null} [text] RithmicOrderNotification text
         * @property {string|null} [reportText] RithmicOrderNotification reportText
         * @property {string|null} [remarks] RithmicOrderNotification remarks
         * @property {string|null} [windowName] RithmicOrderNotification windowName
         * @property {string|null} [originatorWindowName] RithmicOrderNotification originatorWindowName
         * @property {number|null} [cancelAtSsboe] RithmicOrderNotification cancelAtSsboe
         * @property {number|null} [cancelAtUsecs] RithmicOrderNotification cancelAtUsecs
         * @property {number|null} [cancelAfterSecs] RithmicOrderNotification cancelAfterSecs
         * @property {number|null} [ssboe] RithmicOrderNotification ssboe
         * @property {number|null} [usecs] RithmicOrderNotification usecs
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding
         */

        /**
         * Properties of a RithmicOrderNotification.
         * @memberof rti
         * @interface IRithmicOrderNotification
         * @augments rti.RithmicOrderNotification.$Properties
         * @deprecated Use rti.RithmicOrderNotification.$Properties instead.
         */

        /**
         * Shape of a RithmicOrderNotification.
         * @typedef {rti.RithmicOrderNotification.$Properties} rti.RithmicOrderNotification.$Shape
         */

        /**
         * Constructs a new RithmicOrderNotification.
         * @memberof rti
         * @classdesc Represents a RithmicOrderNotification.
         * @constructor
         * @param {rti.RithmicOrderNotification.$Properties=} [properties] Properties to set
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding
         */
        function RithmicOrderNotification(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null && keys[i] !== "__proto__")
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * RithmicOrderNotification templateId.
         * @member {number} templateId
         * @memberof rti.RithmicOrderNotification
         * @instance
         */
        RithmicOrderNotification.prototype.templateId = 0;

        /**
         * RithmicOrderNotification userTag.
         * @member {string} userTag
         * @memberof rti.RithmicOrderNotification
         * @instance
         */
        RithmicOrderNotification.prototype.userTag = "";

        /**
         * RithmicOrderNotification notifyType.
         * @member {rti.RithmicOrderNotification.NotifyType} notifyType
         * @memberof rti.RithmicOrderNotification
         * @instance
         */
        RithmicOrderNotification.prototype.notifyType = 0;

        /**
         * RithmicOrderNotification isSnapshot.
         * @member {boolean} isSnapshot
         * @memberof rti.RithmicOrderNotification
         * @instance
         */
        RithmicOrderNotification.prototype.isSnapshot = false;

        /**
         * RithmicOrderNotification status.
         * @member {string} status
         * @memberof rti.RithmicOrderNotification
         * @instance
         */
        RithmicOrderNotification.prototype.status = "";

        /**
         * RithmicOrderNotification basketId.
         * @member {string} basketId
         * @memberof rti.RithmicOrderNotification
         * @instance
         */
        RithmicOrderNotification.prototype.basketId = "";

        /**
         * RithmicOrderNotification originalBasketId.
         * @member {string} originalBasketId
         * @memberof rti.RithmicOrderNotification
         * @instance
         */
        RithmicOrderNotification.prototype.originalBasketId = "";

        /**
         * RithmicOrderNotification linkedBasketIds.
         * @member {string} linkedBasketIds
         * @memberof rti.RithmicOrderNotification
         * @instance
         */
        RithmicOrderNotification.prototype.linkedBasketIds = "";

        /**
         * RithmicOrderNotification fcmId.
         * @member {string} fcmId
         * @memberof rti.RithmicOrderNotification
         * @instance
         */
        RithmicOrderNotification.prototype.fcmId = "";

        /**
         * RithmicOrderNotification ibId.
         * @member {string} ibId
         * @memberof rti.RithmicOrderNotification
         * @instance
         */
        RithmicOrderNotification.prototype.ibId = "";

        /**
         * RithmicOrderNotification userId.
         * @member {string} userId
         * @memberof rti.RithmicOrderNotification
         * @instance
         */
        RithmicOrderNotification.prototype.userId = "";

        /**
         * RithmicOrderNotification accountId.
         * @member {string} accountId
         * @memberof rti.RithmicOrderNotification
         * @instance
         */
        RithmicOrderNotification.prototype.accountId = "";

        /**
         * RithmicOrderNotification symbol.
         * @member {string} symbol
         * @memberof rti.RithmicOrderNotification
         * @instance
         */
        RithmicOrderNotification.prototype.symbol = "";

        /**
         * RithmicOrderNotification exchange.
         * @member {string} exchange
         * @memberof rti.RithmicOrderNotification
         * @instance
         */
        RithmicOrderNotification.prototype.exchange = "";

        /**
         * RithmicOrderNotification tradeExchange.
         * @member {string} tradeExchange
         * @memberof rti.RithmicOrderNotification
         * @instance
         */
        RithmicOrderNotification.prototype.tradeExchange = "";

        /**
         * RithmicOrderNotification tradeRoute.
         * @member {string} tradeRoute
         * @memberof rti.RithmicOrderNotification
         * @instance
         */
        RithmicOrderNotification.prototype.tradeRoute = "";

        /**
         * RithmicOrderNotification exchangeOrderId.
         * @member {string} exchangeOrderId
         * @memberof rti.RithmicOrderNotification
         * @instance
         */
        RithmicOrderNotification.prototype.exchangeOrderId = "";

        /**
         * RithmicOrderNotification instrumentType.
         * @member {string} instrumentType
         * @memberof rti.RithmicOrderNotification
         * @instance
         */
        RithmicOrderNotification.prototype.instrumentType = "";

        /**
         * RithmicOrderNotification completionReason.
         * @member {string} completionReason
         * @memberof rti.RithmicOrderNotification
         * @instance
         */
        RithmicOrderNotification.prototype.completionReason = "";

        /**
         * RithmicOrderNotification quantity.
         * @member {number} quantity
         * @memberof rti.RithmicOrderNotification
         * @instance
         */
        RithmicOrderNotification.prototype.quantity = 0;

        /**
         * RithmicOrderNotification quanReleasePending.
         * @member {number} quanReleasePending
         * @memberof rti.RithmicOrderNotification
         * @instance
         */
        RithmicOrderNotification.prototype.quanReleasePending = 0;

        /**
         * RithmicOrderNotification price.
         * @member {number} price
         * @memberof rti.RithmicOrderNotification
         * @instance
         */
        RithmicOrderNotification.prototype.price = 0;

        /**
         * RithmicOrderNotification triggerPrice.
         * @member {number} triggerPrice
         * @memberof rti.RithmicOrderNotification
         * @instance
         */
        RithmicOrderNotification.prototype.triggerPrice = 0;

        /**
         * RithmicOrderNotification transactionType.
         * @member {rti.RithmicOrderNotification.TransactionType} transactionType
         * @memberof rti.RithmicOrderNotification
         * @instance
         */
        RithmicOrderNotification.prototype.transactionType = 0;

        /**
         * RithmicOrderNotification duration.
         * @member {rti.RithmicOrderNotification.Duration} duration
         * @memberof rti.RithmicOrderNotification
         * @instance
         */
        RithmicOrderNotification.prototype.duration = 0;

        /**
         * RithmicOrderNotification priceType.
         * @member {rti.RithmicOrderNotification.PriceType} priceType
         * @memberof rti.RithmicOrderNotification
         * @instance
         */
        RithmicOrderNotification.prototype.priceType = 0;

        /**
         * RithmicOrderNotification origPriceType.
         * @member {rti.RithmicOrderNotification.PriceType} origPriceType
         * @memberof rti.RithmicOrderNotification
         * @instance
         */
        RithmicOrderNotification.prototype.origPriceType = 0;

        /**
         * RithmicOrderNotification manualOrAuto.
         * @member {rti.RithmicOrderNotification.OrderPlacement} manualOrAuto
         * @memberof rti.RithmicOrderNotification
         * @instance
         */
        RithmicOrderNotification.prototype.manualOrAuto = 0;

        /**
         * RithmicOrderNotification bracketType.
         * @member {rti.RithmicOrderNotification.BracketType} bracketType
         * @memberof rti.RithmicOrderNotification
         * @instance
         */
        RithmicOrderNotification.prototype.bracketType = 0;

        /**
         * RithmicOrderNotification avgFillPrice.
         * @member {number} avgFillPrice
         * @memberof rti.RithmicOrderNotification
         * @instance
         */
        RithmicOrderNotification.prototype.avgFillPrice = 0;

        /**
         * RithmicOrderNotification totalFillSize.
         * @member {number} totalFillSize
         * @memberof rti.RithmicOrderNotification
         * @instance
         */
        RithmicOrderNotification.prototype.totalFillSize = 0;

        /**
         * RithmicOrderNotification totalUnfilledSize.
         * @member {number} totalUnfilledSize
         * @memberof rti.RithmicOrderNotification
         * @instance
         */
        RithmicOrderNotification.prototype.totalUnfilledSize = 0;

        /**
         * RithmicOrderNotification sequenceNumber.
         * @member {string} sequenceNumber
         * @memberof rti.RithmicOrderNotification
         * @instance
         */
        RithmicOrderNotification.prototype.sequenceNumber = "";

        /**
         * RithmicOrderNotification origSequenceNumber.
         * @member {string} origSequenceNumber
         * @memberof rti.RithmicOrderNotification
         * @instance
         */
        RithmicOrderNotification.prototype.origSequenceNumber = "";

        /**
         * RithmicOrderNotification corSequenceNumber.
         * @member {string} corSequenceNumber
         * @memberof rti.RithmicOrderNotification
         * @instance
         */
        RithmicOrderNotification.prototype.corSequenceNumber = "";

        /**
         * RithmicOrderNotification currency.
         * @member {string} currency
         * @memberof rti.RithmicOrderNotification
         * @instance
         */
        RithmicOrderNotification.prototype.currency = "";

        /**
         * RithmicOrderNotification countryCode.
         * @member {string} countryCode
         * @memberof rti.RithmicOrderNotification
         * @instance
         */
        RithmicOrderNotification.prototype.countryCode = "";

        /**
         * RithmicOrderNotification text.
         * @member {string} text
         * @memberof rti.RithmicOrderNotification
         * @instance
         */
        RithmicOrderNotification.prototype.text = "";

        /**
         * RithmicOrderNotification reportText.
         * @member {string} reportText
         * @memberof rti.RithmicOrderNotification
         * @instance
         */
        RithmicOrderNotification.prototype.reportText = "";

        /**
         * RithmicOrderNotification remarks.
         * @member {string} remarks
         * @memberof rti.RithmicOrderNotification
         * @instance
         */
        RithmicOrderNotification.prototype.remarks = "";

        /**
         * RithmicOrderNotification windowName.
         * @member {string} windowName
         * @memberof rti.RithmicOrderNotification
         * @instance
         */
        RithmicOrderNotification.prototype.windowName = "";

        /**
         * RithmicOrderNotification originatorWindowName.
         * @member {string} originatorWindowName
         * @memberof rti.RithmicOrderNotification
         * @instance
         */
        RithmicOrderNotification.prototype.originatorWindowName = "";

        /**
         * RithmicOrderNotification cancelAtSsboe.
         * @member {number} cancelAtSsboe
         * @memberof rti.RithmicOrderNotification
         * @instance
         */
        RithmicOrderNotification.prototype.cancelAtSsboe = 0;

        /**
         * RithmicOrderNotification cancelAtUsecs.
         * @member {number} cancelAtUsecs
         * @memberof rti.RithmicOrderNotification
         * @instance
         */
        RithmicOrderNotification.prototype.cancelAtUsecs = 0;

        /**
         * RithmicOrderNotification cancelAfterSecs.
         * @member {number} cancelAfterSecs
         * @memberof rti.RithmicOrderNotification
         * @instance
         */
        RithmicOrderNotification.prototype.cancelAfterSecs = 0;

        /**
         * RithmicOrderNotification ssboe.
         * @member {number} ssboe
         * @memberof rti.RithmicOrderNotification
         * @instance
         */
        RithmicOrderNotification.prototype.ssboe = 0;

        /**
         * RithmicOrderNotification usecs.
         * @member {number} usecs
         * @memberof rti.RithmicOrderNotification
         * @instance
         */
        RithmicOrderNotification.prototype.usecs = 0;

        /**
         * Creates a new RithmicOrderNotification instance using the specified properties.
         * @function create
         * @memberof rti.RithmicOrderNotification
         * @static
         * @param {rti.RithmicOrderNotification.$Properties=} [properties] Properties to set
         * @returns {rti.RithmicOrderNotification} RithmicOrderNotification instance
         * @type {{
         *   (properties: rti.RithmicOrderNotification.$Shape): rti.RithmicOrderNotification & rti.RithmicOrderNotification.$Shape;
         *   (properties?: rti.RithmicOrderNotification.$Properties): rti.RithmicOrderNotification;
         * }}
         */
        RithmicOrderNotification.create = function create(properties) {
            return new RithmicOrderNotification(properties);
        };

        /**
         * Encodes the specified RithmicOrderNotification message. Does not implicitly {@link rti.RithmicOrderNotification.verify|verify} messages.
         * @function encode
         * @memberof rti.RithmicOrderNotification
         * @static
         * @param {rti.RithmicOrderNotification.$Properties} message RithmicOrderNotification message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RithmicOrderNotification.encode = function encode(message, writer, _depth) {
            if (!writer)
                writer = $Writer.create();
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw Error("max depth exceeded");
            if (message.symbol != null && Object.hasOwnProperty.call(message, "symbol"))
                writer.uint32(/* id 110100, wireType 2 =*/880802).string(message.symbol);
            if (message.exchange != null && Object.hasOwnProperty.call(message, "exchange"))
                writer.uint32(/* id 110101, wireType 2 =*/880810).string(message.exchange);
            if (message.instrumentType != null && Object.hasOwnProperty.call(message, "instrumentType"))
                writer.uint32(/* id 110116, wireType 2 =*/880930).string(message.instrumentType);
            if (message.isSnapshot != null && Object.hasOwnProperty.call(message, "isSnapshot"))
                writer.uint32(/* id 110121, wireType 0 =*/880968).bool(message.isSnapshot);
            if (message.basketId != null && Object.hasOwnProperty.call(message, "basketId"))
                writer.uint32(/* id 110300, wireType 2 =*/882402).string(message.basketId);
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 110303, wireType 2 =*/882426).string(message.status);
            if (message.price != null && Object.hasOwnProperty.call(message, "price"))
                writer.uint32(/* id 110306, wireType 1 =*/882449).double(message.price);
            if (message.avgFillPrice != null && Object.hasOwnProperty.call(message, "avgFillPrice"))
                writer.uint32(/* id 110322, wireType 1 =*/882577).double(message.avgFillPrice);
            if (message.linkedBasketIds != null && Object.hasOwnProperty.call(message, "linkedBasketIds"))
                writer.uint32(/* id 110358, wireType 2 =*/882866).string(message.linkedBasketIds);
            if (message.sequenceNumber != null && Object.hasOwnProperty.call(message, "sequenceNumber"))
                writer.uint32(/* id 112002, wireType 2 =*/896018).string(message.sequenceNumber);
            if (message.transactionType != null && Object.hasOwnProperty.call(message, "transactionType"))
                writer.uint32(/* id 112003, wireType 0 =*/896024).int32(message.transactionType);
            if (message.quantity != null && Object.hasOwnProperty.call(message, "quantity"))
                writer.uint32(/* id 112004, wireType 0 =*/896032).int32(message.quantity);
            if (message.duration != null && Object.hasOwnProperty.call(message, "duration"))
                writer.uint32(/* id 112005, wireType 0 =*/896040).int32(message.duration);
            if (message.priceType != null && Object.hasOwnProperty.call(message, "priceType"))
                writer.uint32(/* id 112008, wireType 0 =*/896064).int32(message.priceType);
            if (message.tradeRoute != null && Object.hasOwnProperty.call(message, "tradeRoute"))
                writer.uint32(/* id 112016, wireType 2 =*/896130).string(message.tradeRoute);
            if (message.tradeExchange != null && Object.hasOwnProperty.call(message, "tradeExchange"))
                writer.uint32(/* id 112021, wireType 2 =*/896170).string(message.tradeExchange);
            if (message.quanReleasePending != null && Object.hasOwnProperty.call(message, "quanReleasePending"))
                writer.uint32(/* id 112027, wireType 0 =*/896216).int32(message.quanReleasePending);
            if (message.text != null && Object.hasOwnProperty.call(message, "text"))
                writer.uint32(/* id 120008, wireType 2 =*/960066).string(message.text);
            if (message.reportText != null && Object.hasOwnProperty.call(message, "reportText"))
                writer.uint32(/* id 120028, wireType 2 =*/960226).string(message.reportText);
            if (message.userId != null && Object.hasOwnProperty.call(message, "userId"))
                writer.uint32(/* id 131003, wireType 2 =*/1048026).string(message.userId);
            if (message.exchangeOrderId != null && Object.hasOwnProperty.call(message, "exchangeOrderId"))
                writer.uint32(/* id 149238, wireType 2 =*/1193906).string(message.exchangeOrderId);
            if (message.triggerPrice != null && Object.hasOwnProperty.call(message, "triggerPrice"))
                writer.uint32(/* id 149247, wireType 1 =*/1193977).double(message.triggerPrice);
            if (message.origSequenceNumber != null && Object.hasOwnProperty.call(message, "origSequenceNumber"))
                writer.uint32(/* id 149263, wireType 2 =*/1194106).string(message.origSequenceNumber);
            if (message.corSequenceNumber != null && Object.hasOwnProperty.call(message, "corSequenceNumber"))
                writer.uint32(/* id 149264, wireType 2 =*/1194114).string(message.corSequenceNumber);
            if (message.completionReason != null && Object.hasOwnProperty.call(message, "completionReason"))
                writer.uint32(/* id 149273, wireType 2 =*/1194186).string(message.completionReason);
            if (message.ssboe != null && Object.hasOwnProperty.call(message, "ssboe"))
                writer.uint32(/* id 150100, wireType 0 =*/1200800).int32(message.ssboe);
            if (message.usecs != null && Object.hasOwnProperty.call(message, "usecs"))
                writer.uint32(/* id 150101, wireType 0 =*/1200808).int32(message.usecs);
            if (message.notifyType != null && Object.hasOwnProperty.call(message, "notifyType"))
                writer.uint32(/* id 153625, wireType 0 =*/1229000).int32(message.notifyType);
            if (message.accountId != null && Object.hasOwnProperty.call(message, "accountId"))
                writer.uint32(/* id 154008, wireType 2 =*/1232066).string(message.accountId);
            if (message.fcmId != null && Object.hasOwnProperty.call(message, "fcmId"))
                writer.uint32(/* id 154013, wireType 2 =*/1232106).string(message.fcmId);
            if (message.ibId != null && Object.hasOwnProperty.call(message, "ibId"))
                writer.uint32(/* id 154014, wireType 2 =*/1232114).string(message.ibId);
            if (message.totalFillSize != null && Object.hasOwnProperty.call(message, "totalFillSize"))
                writer.uint32(/* id 154111, wireType 0 =*/1232888).int32(message.totalFillSize);
            if (message.totalUnfilledSize != null && Object.hasOwnProperty.call(message, "totalUnfilledSize"))
                writer.uint32(/* id 154112, wireType 0 =*/1232896).int32(message.totalUnfilledSize);
            if (message.userTag != null && Object.hasOwnProperty.call(message, "userTag"))
                writer.uint32(/* id 154119, wireType 2 =*/1232954).string(message.userTag);
            if (message.countryCode != null && Object.hasOwnProperty.call(message, "countryCode"))
                writer.uint32(/* id 154172, wireType 2 =*/1233378).string(message.countryCode);
            if (message.currency != null && Object.hasOwnProperty.call(message, "currency"))
                writer.uint32(/* id 154382, wireType 2 =*/1235058).string(message.currency);
            if (message.templateId != null && Object.hasOwnProperty.call(message, "templateId"))
                writer.uint32(/* id 154467, wireType 0 =*/1235736).int32(message.templateId);
            if (message.cancelAfterSecs != null && Object.hasOwnProperty.call(message, "cancelAfterSecs"))
                writer.uint32(/* id 154488, wireType 0 =*/1235904).int32(message.cancelAfterSecs);
            if (message.originalBasketId != null && Object.hasOwnProperty.call(message, "originalBasketId"))
                writer.uint32(/* id 154497, wireType 2 =*/1235978).string(message.originalBasketId);
            if (message.windowName != null && Object.hasOwnProperty.call(message, "windowName"))
                writer.uint32(/* id 154629, wireType 2 =*/1237034).string(message.windowName);
            if (message.originatorWindowName != null && Object.hasOwnProperty.call(message, "originatorWindowName"))
                writer.uint32(/* id 154671, wireType 2 =*/1237370).string(message.originatorWindowName);
            if (message.manualOrAuto != null && Object.hasOwnProperty.call(message, "manualOrAuto"))
                writer.uint32(/* id 154710, wireType 0 =*/1237680).int32(message.manualOrAuto);
            if (message.origPriceType != null && Object.hasOwnProperty.call(message, "origPriceType"))
                writer.uint32(/* id 154770, wireType 0 =*/1238160).int32(message.origPriceType);
            if (message.remarks != null && Object.hasOwnProperty.call(message, "remarks"))
                writer.uint32(/* id 154806, wireType 2 =*/1238450).string(message.remarks);
            if (message.cancelAtSsboe != null && Object.hasOwnProperty.call(message, "cancelAtSsboe"))
                writer.uint32(/* id 157085, wireType 0 =*/1256680).int32(message.cancelAtSsboe);
            if (message.cancelAtUsecs != null && Object.hasOwnProperty.call(message, "cancelAtUsecs"))
                writer.uint32(/* id 157086, wireType 0 =*/1256688).int32(message.cancelAtUsecs);
            if (message.bracketType != null && Object.hasOwnProperty.call(message, "bracketType"))
                writer.uint32(/* id 157087, wireType 0 =*/1256696).int32(message.bracketType);
            if (message.$unknowns != null && Object.hasOwnProperty.call(message, "$unknowns"))
                for (let i = 0; i < message.$unknowns.length; ++i)
                    writer.raw(message.$unknowns[i]);
            return writer;
        };

        /**
         * Encodes the specified RithmicOrderNotification message, length delimited. Does not implicitly {@link rti.RithmicOrderNotification.verify|verify} messages.
         * @function encodeDelimited
         * @memberof rti.RithmicOrderNotification
         * @static
         * @param {rti.RithmicOrderNotification.$Properties} message RithmicOrderNotification message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RithmicOrderNotification.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer && writer.len ? writer.fork() : writer).ldelim();
        };

        /**
         * Decodes a RithmicOrderNotification message from the specified reader or buffer.
         * @function decode
         * @memberof rti.RithmicOrderNotification
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {rti.RithmicOrderNotification & rti.RithmicOrderNotification.$Shape} RithmicOrderNotification
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RithmicOrderNotification.decode = function decode(reader, length, _end, _depth, _target) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $Reader.recursionLimit)
                throw Error("max depth exceeded");
            let end = length === undefined ? reader.len : reader.pos + length, message = _target || new $root.rti.RithmicOrderNotification(), value;
            while (reader.pos < end) {
                let start = reader.pos;
                let tag = reader.tag();
                if (tag === _end) {
                    _end = undefined;
                    break;
                }
                let wireType = tag & 7;
                switch (tag >>>= 3) {
                case 154467: {
                        if (wireType !== 0)
                            break;
                        if (value = reader.int32())
                            message.templateId = value;
                        else
                            delete message.templateId;
                        continue;
                    }
                case 154119: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.string()).length)
                            message.userTag = value;
                        else
                            delete message.userTag;
                        continue;
                    }
                case 153625: {
                        if (wireType !== 0)
                            break;
                        if (value = reader.int32())
                            message.notifyType = value;
                        else
                            delete message.notifyType;
                        continue;
                    }
                case 110121: {
                        if (wireType !== 0)
                            break;
                        if (value = reader.bool())
                            message.isSnapshot = value;
                        else
                            delete message.isSnapshot;
                        continue;
                    }
                case 110303: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.string()).length)
                            message.status = value;
                        else
                            delete message.status;
                        continue;
                    }
                case 110300: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.string()).length)
                            message.basketId = value;
                        else
                            delete message.basketId;
                        continue;
                    }
                case 154497: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.string()).length)
                            message.originalBasketId = value;
                        else
                            delete message.originalBasketId;
                        continue;
                    }
                case 110358: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.string()).length)
                            message.linkedBasketIds = value;
                        else
                            delete message.linkedBasketIds;
                        continue;
                    }
                case 154013: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.string()).length)
                            message.fcmId = value;
                        else
                            delete message.fcmId;
                        continue;
                    }
                case 154014: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.string()).length)
                            message.ibId = value;
                        else
                            delete message.ibId;
                        continue;
                    }
                case 131003: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.string()).length)
                            message.userId = value;
                        else
                            delete message.userId;
                        continue;
                    }
                case 154008: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.string()).length)
                            message.accountId = value;
                        else
                            delete message.accountId;
                        continue;
                    }
                case 110100: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.string()).length)
                            message.symbol = value;
                        else
                            delete message.symbol;
                        continue;
                    }
                case 110101: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.string()).length)
                            message.exchange = value;
                        else
                            delete message.exchange;
                        continue;
                    }
                case 112021: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.string()).length)
                            message.tradeExchange = value;
                        else
                            delete message.tradeExchange;
                        continue;
                    }
                case 112016: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.string()).length)
                            message.tradeRoute = value;
                        else
                            delete message.tradeRoute;
                        continue;
                    }
                case 149238: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.string()).length)
                            message.exchangeOrderId = value;
                        else
                            delete message.exchangeOrderId;
                        continue;
                    }
                case 110116: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.string()).length)
                            message.instrumentType = value;
                        else
                            delete message.instrumentType;
                        continue;
                    }
                case 149273: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.string()).length)
                            message.completionReason = value;
                        else
                            delete message.completionReason;
                        continue;
                    }
                case 112004: {
                        if (wireType !== 0)
                            break;
                        if (value = reader.int32())
                            message.quantity = value;
                        else
                            delete message.quantity;
                        continue;
                    }
                case 112027: {
                        if (wireType !== 0)
                            break;
                        if (value = reader.int32())
                            message.quanReleasePending = value;
                        else
                            delete message.quanReleasePending;
                        continue;
                    }
                case 110306: {
                        if (wireType !== 1)
                            break;
                        if ((value = reader.double()) !== 0)
                            message.price = value;
                        else
                            delete message.price;
                        continue;
                    }
                case 149247: {
                        if (wireType !== 1)
                            break;
                        if ((value = reader.double()) !== 0)
                            message.triggerPrice = value;
                        else
                            delete message.triggerPrice;
                        continue;
                    }
                case 112003: {
                        if (wireType !== 0)
                            break;
                        if (value = reader.int32())
                            message.transactionType = value;
                        else
                            delete message.transactionType;
                        continue;
                    }
                case 112005: {
                        if (wireType !== 0)
                            break;
                        if (value = reader.int32())
                            message.duration = value;
                        else
                            delete message.duration;
                        continue;
                    }
                case 112008: {
                        if (wireType !== 0)
                            break;
                        if (value = reader.int32())
                            message.priceType = value;
                        else
                            delete message.priceType;
                        continue;
                    }
                case 154770: {
                        if (wireType !== 0)
                            break;
                        if (value = reader.int32())
                            message.origPriceType = value;
                        else
                            delete message.origPriceType;
                        continue;
                    }
                case 154710: {
                        if (wireType !== 0)
                            break;
                        if (value = reader.int32())
                            message.manualOrAuto = value;
                        else
                            delete message.manualOrAuto;
                        continue;
                    }
                case 157087: {
                        if (wireType !== 0)
                            break;
                        if (value = reader.int32())
                            message.bracketType = value;
                        else
                            delete message.bracketType;
                        continue;
                    }
                case 110322: {
                        if (wireType !== 1)
                            break;
                        if ((value = reader.double()) !== 0)
                            message.avgFillPrice = value;
                        else
                            delete message.avgFillPrice;
                        continue;
                    }
                case 154111: {
                        if (wireType !== 0)
                            break;
                        if (value = reader.int32())
                            message.totalFillSize = value;
                        else
                            delete message.totalFillSize;
                        continue;
                    }
                case 154112: {
                        if (wireType !== 0)
                            break;
                        if (value = reader.int32())
                            message.totalUnfilledSize = value;
                        else
                            delete message.totalUnfilledSize;
                        continue;
                    }
                case 112002: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.string()).length)
                            message.sequenceNumber = value;
                        else
                            delete message.sequenceNumber;
                        continue;
                    }
                case 149263: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.string()).length)
                            message.origSequenceNumber = value;
                        else
                            delete message.origSequenceNumber;
                        continue;
                    }
                case 149264: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.string()).length)
                            message.corSequenceNumber = value;
                        else
                            delete message.corSequenceNumber;
                        continue;
                    }
                case 154382: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.string()).length)
                            message.currency = value;
                        else
                            delete message.currency;
                        continue;
                    }
                case 154172: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.string()).length)
                            message.countryCode = value;
                        else
                            delete message.countryCode;
                        continue;
                    }
                case 120008: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.string()).length)
                            message.text = value;
                        else
                            delete message.text;
                        continue;
                    }
                case 120028: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.string()).length)
                            message.reportText = value;
                        else
                            delete message.reportText;
                        continue;
                    }
                case 154806: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.string()).length)
                            message.remarks = value;
                        else
                            delete message.remarks;
                        continue;
                    }
                case 154629: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.string()).length)
                            message.windowName = value;
                        else
                            delete message.windowName;
                        continue;
                    }
                case 154671: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.string()).length)
                            message.originatorWindowName = value;
                        else
                            delete message.originatorWindowName;
                        continue;
                    }
                case 157085: {
                        if (wireType !== 0)
                            break;
                        if (value = reader.int32())
                            message.cancelAtSsboe = value;
                        else
                            delete message.cancelAtSsboe;
                        continue;
                    }
                case 157086: {
                        if (wireType !== 0)
                            break;
                        if (value = reader.int32())
                            message.cancelAtUsecs = value;
                        else
                            delete message.cancelAtUsecs;
                        continue;
                    }
                case 154488: {
                        if (wireType !== 0)
                            break;
                        if (value = reader.int32())
                            message.cancelAfterSecs = value;
                        else
                            delete message.cancelAfterSecs;
                        continue;
                    }
                case 150100: {
                        if (wireType !== 0)
                            break;
                        if (value = reader.int32())
                            message.ssboe = value;
                        else
                            delete message.ssboe;
                        continue;
                    }
                case 150101: {
                        if (wireType !== 0)
                            break;
                        if (value = reader.int32())
                            message.usecs = value;
                        else
                            delete message.usecs;
                        continue;
                    }
                }
                reader.skipType(wireType, _depth, tag);
                if (!reader.discardUnknown) {
                    $util.makeProp(message, "$unknowns", false);
                    (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
                }
            }
            if (_end !== undefined)
                throw Error("missing end group");
            return message;
        };

        /**
         * Decodes a RithmicOrderNotification message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof rti.RithmicOrderNotification
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {rti.RithmicOrderNotification & rti.RithmicOrderNotification.$Shape} RithmicOrderNotification
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RithmicOrderNotification.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a RithmicOrderNotification message.
         * @function verify
         * @memberof rti.RithmicOrderNotification
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        RithmicOrderNotification.verify = function verify(message, _depth) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                return "max depth exceeded";
            if (message.templateId != null && message.hasOwnProperty("templateId"))
                if (!$util.isInteger(message.templateId))
                    return "templateId: integer expected";
            if (message.userTag != null && message.hasOwnProperty("userTag"))
                if (!$util.isString(message.userTag))
                    return "userTag: string expected";
            if (message.notifyType != null && message.hasOwnProperty("notifyType"))
                switch (message.notifyType) {
                default:
                    return "notifyType: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 19:
                case 20:
                    break;
                }
            if (message.isSnapshot != null && message.hasOwnProperty("isSnapshot"))
                if (typeof message.isSnapshot !== "boolean")
                    return "isSnapshot: boolean expected";
            if (message.status != null && message.hasOwnProperty("status"))
                if (!$util.isString(message.status))
                    return "status: string expected";
            if (message.basketId != null && message.hasOwnProperty("basketId"))
                if (!$util.isString(message.basketId))
                    return "basketId: string expected";
            if (message.originalBasketId != null && message.hasOwnProperty("originalBasketId"))
                if (!$util.isString(message.originalBasketId))
                    return "originalBasketId: string expected";
            if (message.linkedBasketIds != null && message.hasOwnProperty("linkedBasketIds"))
                if (!$util.isString(message.linkedBasketIds))
                    return "linkedBasketIds: string expected";
            if (message.fcmId != null && message.hasOwnProperty("fcmId"))
                if (!$util.isString(message.fcmId))
                    return "fcmId: string expected";
            if (message.ibId != null && message.hasOwnProperty("ibId"))
                if (!$util.isString(message.ibId))
                    return "ibId: string expected";
            if (message.userId != null && message.hasOwnProperty("userId"))
                if (!$util.isString(message.userId))
                    return "userId: string expected";
            if (message.accountId != null && message.hasOwnProperty("accountId"))
                if (!$util.isString(message.accountId))
                    return "accountId: string expected";
            if (message.symbol != null && message.hasOwnProperty("symbol"))
                if (!$util.isString(message.symbol))
                    return "symbol: string expected";
            if (message.exchange != null && message.hasOwnProperty("exchange"))
                if (!$util.isString(message.exchange))
                    return "exchange: string expected";
            if (message.tradeExchange != null && message.hasOwnProperty("tradeExchange"))
                if (!$util.isString(message.tradeExchange))
                    return "tradeExchange: string expected";
            if (message.tradeRoute != null && message.hasOwnProperty("tradeRoute"))
                if (!$util.isString(message.tradeRoute))
                    return "tradeRoute: string expected";
            if (message.exchangeOrderId != null && message.hasOwnProperty("exchangeOrderId"))
                if (!$util.isString(message.exchangeOrderId))
                    return "exchangeOrderId: string expected";
            if (message.instrumentType != null && message.hasOwnProperty("instrumentType"))
                if (!$util.isString(message.instrumentType))
                    return "instrumentType: string expected";
            if (message.completionReason != null && message.hasOwnProperty("completionReason"))
                if (!$util.isString(message.completionReason))
                    return "completionReason: string expected";
            if (message.quantity != null && message.hasOwnProperty("quantity"))
                if (!$util.isInteger(message.quantity))
                    return "quantity: integer expected";
            if (message.quanReleasePending != null && message.hasOwnProperty("quanReleasePending"))
                if (!$util.isInteger(message.quanReleasePending))
                    return "quanReleasePending: integer expected";
            if (message.price != null && message.hasOwnProperty("price"))
                if (typeof message.price !== "number")
                    return "price: number expected";
            if (message.triggerPrice != null && message.hasOwnProperty("triggerPrice"))
                if (typeof message.triggerPrice !== "number")
                    return "triggerPrice: number expected";
            if (message.transactionType != null && message.hasOwnProperty("transactionType"))
                switch (message.transactionType) {
                default:
                    return "transactionType: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                    break;
                }
            if (message.duration != null && message.hasOwnProperty("duration"))
                switch (message.duration) {
                default:
                    return "duration: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                    break;
                }
            if (message.priceType != null && message.hasOwnProperty("priceType"))
                switch (message.priceType) {
                default:
                    return "priceType: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                    break;
                }
            if (message.origPriceType != null && message.hasOwnProperty("origPriceType"))
                switch (message.origPriceType) {
                default:
                    return "origPriceType: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                    break;
                }
            if (message.manualOrAuto != null && message.hasOwnProperty("manualOrAuto"))
                switch (message.manualOrAuto) {
                default:
                    return "manualOrAuto: enum value expected";
                case 0:
                case 1:
                case 2:
                    break;
                }
            if (message.bracketType != null && message.hasOwnProperty("bracketType"))
                switch (message.bracketType) {
                default:
                    return "bracketType: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                    break;
                }
            if (message.avgFillPrice != null && message.hasOwnProperty("avgFillPrice"))
                if (typeof message.avgFillPrice !== "number")
                    return "avgFillPrice: number expected";
            if (message.totalFillSize != null && message.hasOwnProperty("totalFillSize"))
                if (!$util.isInteger(message.totalFillSize))
                    return "totalFillSize: integer expected";
            if (message.totalUnfilledSize != null && message.hasOwnProperty("totalUnfilledSize"))
                if (!$util.isInteger(message.totalUnfilledSize))
                    return "totalUnfilledSize: integer expected";
            if (message.sequenceNumber != null && message.hasOwnProperty("sequenceNumber"))
                if (!$util.isString(message.sequenceNumber))
                    return "sequenceNumber: string expected";
            if (message.origSequenceNumber != null && message.hasOwnProperty("origSequenceNumber"))
                if (!$util.isString(message.origSequenceNumber))
                    return "origSequenceNumber: string expected";
            if (message.corSequenceNumber != null && message.hasOwnProperty("corSequenceNumber"))
                if (!$util.isString(message.corSequenceNumber))
                    return "corSequenceNumber: string expected";
            if (message.currency != null && message.hasOwnProperty("currency"))
                if (!$util.isString(message.currency))
                    return "currency: string expected";
            if (message.countryCode != null && message.hasOwnProperty("countryCode"))
                if (!$util.isString(message.countryCode))
                    return "countryCode: string expected";
            if (message.text != null && message.hasOwnProperty("text"))
                if (!$util.isString(message.text))
                    return "text: string expected";
            if (message.reportText != null && message.hasOwnProperty("reportText"))
                if (!$util.isString(message.reportText))
                    return "reportText: string expected";
            if (message.remarks != null && message.hasOwnProperty("remarks"))
                if (!$util.isString(message.remarks))
                    return "remarks: string expected";
            if (message.windowName != null && message.hasOwnProperty("windowName"))
                if (!$util.isString(message.windowName))
                    return "windowName: string expected";
            if (message.originatorWindowName != null && message.hasOwnProperty("originatorWindowName"))
                if (!$util.isString(message.originatorWindowName))
                    return "originatorWindowName: string expected";
            if (message.cancelAtSsboe != null && message.hasOwnProperty("cancelAtSsboe"))
                if (!$util.isInteger(message.cancelAtSsboe))
                    return "cancelAtSsboe: integer expected";
            if (message.cancelAtUsecs != null && message.hasOwnProperty("cancelAtUsecs"))
                if (!$util.isInteger(message.cancelAtUsecs))
                    return "cancelAtUsecs: integer expected";
            if (message.cancelAfterSecs != null && message.hasOwnProperty("cancelAfterSecs"))
                if (!$util.isInteger(message.cancelAfterSecs))
                    return "cancelAfterSecs: integer expected";
            if (message.ssboe != null && message.hasOwnProperty("ssboe"))
                if (!$util.isInteger(message.ssboe))
                    return "ssboe: integer expected";
            if (message.usecs != null && message.hasOwnProperty("usecs"))
                if (!$util.isInteger(message.usecs))
                    return "usecs: integer expected";
            return null;
        };

        /**
         * Creates a RithmicOrderNotification message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof rti.RithmicOrderNotification
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {rti.RithmicOrderNotification} RithmicOrderNotification
         */
        RithmicOrderNotification.fromObject = function fromObject(object, _depth) {
            if (object instanceof $root.rti.RithmicOrderNotification)
                return object;
            if (!$util.isObject(object))
                throw TypeError(".rti.RithmicOrderNotification: object expected");
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw Error("max depth exceeded");
            let message = new $root.rti.RithmicOrderNotification();
            if (object.templateId != null)
                if (Number(object.templateId) !== 0)
                    message.templateId = object.templateId | 0;
            if (object.userTag != null)
                if (typeof object.userTag !== "string" || object.userTag.length)
                    message.userTag = String(object.userTag);
            if (object.notifyType !== 0 && (typeof object.notifyType !== "string" || $root.rti.RithmicOrderNotification.NotifyType[object.notifyType] !== 0))
                switch (object.notifyType) {
                default:
                    if (typeof object.notifyType === "number") {
                        message.notifyType = object.notifyType;
                        break;
                    }
                    break;
                case "NOTIFYTYPE_UNSPECIFIED":
                case 0:
                    message.notifyType = 0;
                    break;
                case "ORDER_RCVD_FROM_CLNT":
                case 1:
                    message.notifyType = 1;
                    break;
                case "MODIFY_RCVD_FROM_CLNT":
                case 2:
                    message.notifyType = 2;
                    break;
                case "CANCEL_RCVD_FROM_CLNT":
                case 3:
                    message.notifyType = 3;
                    break;
                case "OPEN_PENDING":
                case 4:
                    message.notifyType = 4;
                    break;
                case "MODIFY_PENDING":
                case 5:
                    message.notifyType = 5;
                    break;
                case "CANCEL_PENDING":
                case 6:
                    message.notifyType = 6;
                    break;
                case "ORDER_RCVD_BY_EXCH_GTWY":
                case 7:
                    message.notifyType = 7;
                    break;
                case "MODIFY_RCVD_BY_EXCH_GTWY":
                case 8:
                    message.notifyType = 8;
                    break;
                case "CANCEL_RCVD_BY_EXCH_GTWY":
                case 9:
                    message.notifyType = 9;
                    break;
                case "ORDER_SENT_TO_EXCH":
                case 10:
                    message.notifyType = 10;
                    break;
                case "MODIFY_SENT_TO_EXCH":
                case 11:
                    message.notifyType = 11;
                    break;
                case "CANCEL_SENT_TO_EXCH":
                case 12:
                    message.notifyType = 12;
                    break;
                case "OPEN":
                case 13:
                    message.notifyType = 13;
                    break;
                case "MODIFIED":
                case 14:
                    message.notifyType = 14;
                    break;
                case "COMPLETE":
                case 15:
                    message.notifyType = 15;
                    break;
                case "MODIFICATION_FAILED":
                case 16:
                    message.notifyType = 16;
                    break;
                case "CANCELLATION_FAILED":
                case 17:
                    message.notifyType = 17;
                    break;
                case "TRIGGER_PENDING":
                case 18:
                    message.notifyType = 18;
                    break;
                case "GENERIC":
                case 19:
                    message.notifyType = 19;
                    break;
                case "LINK_ORDERS_FAILED":
                case 20:
                    message.notifyType = 20;
                    break;
                }
            if (object.isSnapshot != null)
                if (object.isSnapshot)
                    message.isSnapshot = Boolean(object.isSnapshot);
            if (object.status != null)
                if (typeof object.status !== "string" || object.status.length)
                    message.status = String(object.status);
            if (object.basketId != null)
                if (typeof object.basketId !== "string" || object.basketId.length)
                    message.basketId = String(object.basketId);
            if (object.originalBasketId != null)
                if (typeof object.originalBasketId !== "string" || object.originalBasketId.length)
                    message.originalBasketId = String(object.originalBasketId);
            if (object.linkedBasketIds != null)
                if (typeof object.linkedBasketIds !== "string" || object.linkedBasketIds.length)
                    message.linkedBasketIds = String(object.linkedBasketIds);
            if (object.fcmId != null)
                if (typeof object.fcmId !== "string" || object.fcmId.length)
                    message.fcmId = String(object.fcmId);
            if (object.ibId != null)
                if (typeof object.ibId !== "string" || object.ibId.length)
                    message.ibId = String(object.ibId);
            if (object.userId != null)
                if (typeof object.userId !== "string" || object.userId.length)
                    message.userId = String(object.userId);
            if (object.accountId != null)
                if (typeof object.accountId !== "string" || object.accountId.length)
                    message.accountId = String(object.accountId);
            if (object.symbol != null)
                if (typeof object.symbol !== "string" || object.symbol.length)
                    message.symbol = String(object.symbol);
            if (object.exchange != null)
                if (typeof object.exchange !== "string" || object.exchange.length)
                    message.exchange = String(object.exchange);
            if (object.tradeExchange != null)
                if (typeof object.tradeExchange !== "string" || object.tradeExchange.length)
                    message.tradeExchange = String(object.tradeExchange);
            if (object.tradeRoute != null)
                if (typeof object.tradeRoute !== "string" || object.tradeRoute.length)
                    message.tradeRoute = String(object.tradeRoute);
            if (object.exchangeOrderId != null)
                if (typeof object.exchangeOrderId !== "string" || object.exchangeOrderId.length)
                    message.exchangeOrderId = String(object.exchangeOrderId);
            if (object.instrumentType != null)
                if (typeof object.instrumentType !== "string" || object.instrumentType.length)
                    message.instrumentType = String(object.instrumentType);
            if (object.completionReason != null)
                if (typeof object.completionReason !== "string" || object.completionReason.length)
                    message.completionReason = String(object.completionReason);
            if (object.quantity != null)
                if (Number(object.quantity) !== 0)
                    message.quantity = object.quantity | 0;
            if (object.quanReleasePending != null)
                if (Number(object.quanReleasePending) !== 0)
                    message.quanReleasePending = object.quanReleasePending | 0;
            if (object.price != null)
                if (Number(object.price) !== 0)
                    message.price = Number(object.price);
            if (object.triggerPrice != null)
                if (Number(object.triggerPrice) !== 0)
                    message.triggerPrice = Number(object.triggerPrice);
            if (object.transactionType !== 0 && (typeof object.transactionType !== "string" || $root.rti.RithmicOrderNotification.TransactionType[object.transactionType] !== 0))
                switch (object.transactionType) {
                default:
                    if (typeof object.transactionType === "number") {
                        message.transactionType = object.transactionType;
                        break;
                    }
                    break;
                case "TRANSACTIONTYPE_UNSPECIFIED":
                case 0:
                    message.transactionType = 0;
                    break;
                case "BUY":
                case 1:
                    message.transactionType = 1;
                    break;
                case "SELL":
                case 2:
                    message.transactionType = 2;
                    break;
                case "SS":
                case 3:
                    message.transactionType = 3;
                    break;
                }
            if (object.duration !== 0 && (typeof object.duration !== "string" || $root.rti.RithmicOrderNotification.Duration[object.duration] !== 0))
                switch (object.duration) {
                default:
                    if (typeof object.duration === "number") {
                        message.duration = object.duration;
                        break;
                    }
                    break;
                case "DURATION_UNSPECIFIED":
                case 0:
                    message.duration = 0;
                    break;
                case "DAY":
                case 1:
                    message.duration = 1;
                    break;
                case "GTC":
                case 2:
                    message.duration = 2;
                    break;
                case "IOC":
                case 3:
                    message.duration = 3;
                    break;
                case "FOK":
                case 4:
                    message.duration = 4;
                    break;
                }
            if (object.priceType !== 0 && (typeof object.priceType !== "string" || $root.rti.RithmicOrderNotification.PriceType[object.priceType] !== 0))
                switch (object.priceType) {
                default:
                    if (typeof object.priceType === "number") {
                        message.priceType = object.priceType;
                        break;
                    }
                    break;
                case "PRICETYPE_UNSPECIFIED":
                case 0:
                    message.priceType = 0;
                    break;
                case "LIMIT":
                case 1:
                    message.priceType = 1;
                    break;
                case "MARKET":
                case 2:
                    message.priceType = 2;
                    break;
                case "STOP_LIMIT":
                case 3:
                    message.priceType = 3;
                    break;
                case "STOP_MARKET":
                case 4:
                    message.priceType = 4;
                    break;
                }
            if (object.origPriceType !== 0 && (typeof object.origPriceType !== "string" || $root.rti.RithmicOrderNotification.PriceType[object.origPriceType] !== 0))
                switch (object.origPriceType) {
                default:
                    if (typeof object.origPriceType === "number") {
                        message.origPriceType = object.origPriceType;
                        break;
                    }
                    break;
                case "PRICETYPE_UNSPECIFIED":
                case 0:
                    message.origPriceType = 0;
                    break;
                case "LIMIT":
                case 1:
                    message.origPriceType = 1;
                    break;
                case "MARKET":
                case 2:
                    message.origPriceType = 2;
                    break;
                case "STOP_LIMIT":
                case 3:
                    message.origPriceType = 3;
                    break;
                case "STOP_MARKET":
                case 4:
                    message.origPriceType = 4;
                    break;
                }
            if (object.manualOrAuto !== 0 && (typeof object.manualOrAuto !== "string" || $root.rti.RithmicOrderNotification.OrderPlacement[object.manualOrAuto] !== 0))
                switch (object.manualOrAuto) {
                default:
                    if (typeof object.manualOrAuto === "number") {
                        message.manualOrAuto = object.manualOrAuto;
                        break;
                    }
                    break;
                case "ORDERPLACEMENT_UNSPECIFIED":
                case 0:
                    message.manualOrAuto = 0;
                    break;
                case "MANUAL":
                case 1:
                    message.manualOrAuto = 1;
                    break;
                case "AUTO":
                case 2:
                    message.manualOrAuto = 2;
                    break;
                }
            if (object.bracketType !== 0 && (typeof object.bracketType !== "string" || $root.rti.RithmicOrderNotification.BracketType[object.bracketType] !== 0))
                switch (object.bracketType) {
                default:
                    if (typeof object.bracketType === "number") {
                        message.bracketType = object.bracketType;
                        break;
                    }
                    break;
                case "BRACKETTYPE_UNSPECIFIED":
                case 0:
                    message.bracketType = 0;
                    break;
                case "STOP_ONLY":
                case 1:
                    message.bracketType = 1;
                    break;
                case "TARGET_ONLY":
                case 2:
                    message.bracketType = 2;
                    break;
                case "TARGET_AND_STOP":
                case 3:
                    message.bracketType = 3;
                    break;
                case "STOP_ONLY_STATIC":
                case 4:
                    message.bracketType = 4;
                    break;
                case "TARGET_ONLY_STATIC":
                case 5:
                    message.bracketType = 5;
                    break;
                case "TARGET_AND_STOP_STATIC":
                case 6:
                    message.bracketType = 6;
                    break;
                }
            if (object.avgFillPrice != null)
                if (Number(object.avgFillPrice) !== 0)
                    message.avgFillPrice = Number(object.avgFillPrice);
            if (object.totalFillSize != null)
                if (Number(object.totalFillSize) !== 0)
                    message.totalFillSize = object.totalFillSize | 0;
            if (object.totalUnfilledSize != null)
                if (Number(object.totalUnfilledSize) !== 0)
                    message.totalUnfilledSize = object.totalUnfilledSize | 0;
            if (object.sequenceNumber != null)
                if (typeof object.sequenceNumber !== "string" || object.sequenceNumber.length)
                    message.sequenceNumber = String(object.sequenceNumber);
            if (object.origSequenceNumber != null)
                if (typeof object.origSequenceNumber !== "string" || object.origSequenceNumber.length)
                    message.origSequenceNumber = String(object.origSequenceNumber);
            if (object.corSequenceNumber != null)
                if (typeof object.corSequenceNumber !== "string" || object.corSequenceNumber.length)
                    message.corSequenceNumber = String(object.corSequenceNumber);
            if (object.currency != null)
                if (typeof object.currency !== "string" || object.currency.length)
                    message.currency = String(object.currency);
            if (object.countryCode != null)
                if (typeof object.countryCode !== "string" || object.countryCode.length)
                    message.countryCode = String(object.countryCode);
            if (object.text != null)
                if (typeof object.text !== "string" || object.text.length)
                    message.text = String(object.text);
            if (object.reportText != null)
                if (typeof object.reportText !== "string" || object.reportText.length)
                    message.reportText = String(object.reportText);
            if (object.remarks != null)
                if (typeof object.remarks !== "string" || object.remarks.length)
                    message.remarks = String(object.remarks);
            if (object.windowName != null)
                if (typeof object.windowName !== "string" || object.windowName.length)
                    message.windowName = String(object.windowName);
            if (object.originatorWindowName != null)
                if (typeof object.originatorWindowName !== "string" || object.originatorWindowName.length)
                    message.originatorWindowName = String(object.originatorWindowName);
            if (object.cancelAtSsboe != null)
                if (Number(object.cancelAtSsboe) !== 0)
                    message.cancelAtSsboe = object.cancelAtSsboe | 0;
            if (object.cancelAtUsecs != null)
                if (Number(object.cancelAtUsecs) !== 0)
                    message.cancelAtUsecs = object.cancelAtUsecs | 0;
            if (object.cancelAfterSecs != null)
                if (Number(object.cancelAfterSecs) !== 0)
                    message.cancelAfterSecs = object.cancelAfterSecs | 0;
            if (object.ssboe != null)
                if (Number(object.ssboe) !== 0)
                    message.ssboe = object.ssboe | 0;
            if (object.usecs != null)
                if (Number(object.usecs) !== 0)
                    message.usecs = object.usecs | 0;
            return message;
        };

        /**
         * Creates a plain object from a RithmicOrderNotification message. Also converts values to other types if specified.
         * @function toObject
         * @memberof rti.RithmicOrderNotification
         * @static
         * @param {rti.RithmicOrderNotification} message RithmicOrderNotification
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RithmicOrderNotification.toObject = function toObject(message, options, _depth) {
            if (!options)
                options = {};
            if (_depth === undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw Error("max depth exceeded");
            let object = {};
            if (options.defaults) {
                object.symbol = "";
                object.exchange = "";
                object.instrumentType = "";
                object.isSnapshot = false;
                object.basketId = "";
                object.status = "";
                object.price = 0;
                object.avgFillPrice = 0;
                object.linkedBasketIds = "";
                object.sequenceNumber = "";
                object.transactionType = options.enums === String ? "TRANSACTIONTYPE_UNSPECIFIED" : 0;
                object.quantity = 0;
                object.duration = options.enums === String ? "DURATION_UNSPECIFIED" : 0;
                object.priceType = options.enums === String ? "PRICETYPE_UNSPECIFIED" : 0;
                object.tradeRoute = "";
                object.tradeExchange = "";
                object.quanReleasePending = 0;
                object.text = "";
                object.reportText = "";
                object.userId = "";
                object.exchangeOrderId = "";
                object.triggerPrice = 0;
                object.origSequenceNumber = "";
                object.corSequenceNumber = "";
                object.completionReason = "";
                object.ssboe = 0;
                object.usecs = 0;
                object.notifyType = options.enums === String ? "NOTIFYTYPE_UNSPECIFIED" : 0;
                object.accountId = "";
                object.fcmId = "";
                object.ibId = "";
                object.totalFillSize = 0;
                object.totalUnfilledSize = 0;
                object.userTag = "";
                object.countryCode = "";
                object.currency = "";
                object.templateId = 0;
                object.cancelAfterSecs = 0;
                object.originalBasketId = "";
                object.windowName = "";
                object.originatorWindowName = "";
                object.manualOrAuto = options.enums === String ? "ORDERPLACEMENT_UNSPECIFIED" : 0;
                object.origPriceType = options.enums === String ? "PRICETYPE_UNSPECIFIED" : 0;
                object.remarks = "";
                object.cancelAtSsboe = 0;
                object.cancelAtUsecs = 0;
                object.bracketType = options.enums === String ? "BRACKETTYPE_UNSPECIFIED" : 0;
            }
            if (message.symbol != null && message.hasOwnProperty("symbol"))
                object.symbol = message.symbol;
            if (message.exchange != null && message.hasOwnProperty("exchange"))
                object.exchange = message.exchange;
            if (message.instrumentType != null && message.hasOwnProperty("instrumentType"))
                object.instrumentType = message.instrumentType;
            if (message.isSnapshot != null && message.hasOwnProperty("isSnapshot"))
                object.isSnapshot = message.isSnapshot;
            if (message.basketId != null && message.hasOwnProperty("basketId"))
                object.basketId = message.basketId;
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = message.status;
            if (message.price != null && message.hasOwnProperty("price"))
                object.price = options.json && !isFinite(message.price) ? String(message.price) : message.price;
            if (message.avgFillPrice != null && message.hasOwnProperty("avgFillPrice"))
                object.avgFillPrice = options.json && !isFinite(message.avgFillPrice) ? String(message.avgFillPrice) : message.avgFillPrice;
            if (message.linkedBasketIds != null && message.hasOwnProperty("linkedBasketIds"))
                object.linkedBasketIds = message.linkedBasketIds;
            if (message.sequenceNumber != null && message.hasOwnProperty("sequenceNumber"))
                object.sequenceNumber = message.sequenceNumber;
            if (message.transactionType != null && message.hasOwnProperty("transactionType"))
                object.transactionType = options.enums === String ? $root.rti.RithmicOrderNotification.TransactionType[message.transactionType] === undefined ? message.transactionType : $root.rti.RithmicOrderNotification.TransactionType[message.transactionType] : message.transactionType;
            if (message.quantity != null && message.hasOwnProperty("quantity"))
                object.quantity = message.quantity;
            if (message.duration != null && message.hasOwnProperty("duration"))
                object.duration = options.enums === String ? $root.rti.RithmicOrderNotification.Duration[message.duration] === undefined ? message.duration : $root.rti.RithmicOrderNotification.Duration[message.duration] : message.duration;
            if (message.priceType != null && message.hasOwnProperty("priceType"))
                object.priceType = options.enums === String ? $root.rti.RithmicOrderNotification.PriceType[message.priceType] === undefined ? message.priceType : $root.rti.RithmicOrderNotification.PriceType[message.priceType] : message.priceType;
            if (message.tradeRoute != null && message.hasOwnProperty("tradeRoute"))
                object.tradeRoute = message.tradeRoute;
            if (message.tradeExchange != null && message.hasOwnProperty("tradeExchange"))
                object.tradeExchange = message.tradeExchange;
            if (message.quanReleasePending != null && message.hasOwnProperty("quanReleasePending"))
                object.quanReleasePending = message.quanReleasePending;
            if (message.text != null && message.hasOwnProperty("text"))
                object.text = message.text;
            if (message.reportText != null && message.hasOwnProperty("reportText"))
                object.reportText = message.reportText;
            if (message.userId != null && message.hasOwnProperty("userId"))
                object.userId = message.userId;
            if (message.exchangeOrderId != null && message.hasOwnProperty("exchangeOrderId"))
                object.exchangeOrderId = message.exchangeOrderId;
            if (message.triggerPrice != null && message.hasOwnProperty("triggerPrice"))
                object.triggerPrice = options.json && !isFinite(message.triggerPrice) ? String(message.triggerPrice) : message.triggerPrice;
            if (message.origSequenceNumber != null && message.hasOwnProperty("origSequenceNumber"))
                object.origSequenceNumber = message.origSequenceNumber;
            if (message.corSequenceNumber != null && message.hasOwnProperty("corSequenceNumber"))
                object.corSequenceNumber = message.corSequenceNumber;
            if (message.completionReason != null && message.hasOwnProperty("completionReason"))
                object.completionReason = message.completionReason;
            if (message.ssboe != null && message.hasOwnProperty("ssboe"))
                object.ssboe = message.ssboe;
            if (message.usecs != null && message.hasOwnProperty("usecs"))
                object.usecs = message.usecs;
            if (message.notifyType != null && message.hasOwnProperty("notifyType"))
                object.notifyType = options.enums === String ? $root.rti.RithmicOrderNotification.NotifyType[message.notifyType] === undefined ? message.notifyType : $root.rti.RithmicOrderNotification.NotifyType[message.notifyType] : message.notifyType;
            if (message.accountId != null && message.hasOwnProperty("accountId"))
                object.accountId = message.accountId;
            if (message.fcmId != null && message.hasOwnProperty("fcmId"))
                object.fcmId = message.fcmId;
            if (message.ibId != null && message.hasOwnProperty("ibId"))
                object.ibId = message.ibId;
            if (message.totalFillSize != null && message.hasOwnProperty("totalFillSize"))
                object.totalFillSize = message.totalFillSize;
            if (message.totalUnfilledSize != null && message.hasOwnProperty("totalUnfilledSize"))
                object.totalUnfilledSize = message.totalUnfilledSize;
            if (message.userTag != null && message.hasOwnProperty("userTag"))
                object.userTag = message.userTag;
            if (message.countryCode != null && message.hasOwnProperty("countryCode"))
                object.countryCode = message.countryCode;
            if (message.currency != null && message.hasOwnProperty("currency"))
                object.currency = message.currency;
            if (message.templateId != null && message.hasOwnProperty("templateId"))
                object.templateId = message.templateId;
            if (message.cancelAfterSecs != null && message.hasOwnProperty("cancelAfterSecs"))
                object.cancelAfterSecs = message.cancelAfterSecs;
            if (message.originalBasketId != null && message.hasOwnProperty("originalBasketId"))
                object.originalBasketId = message.originalBasketId;
            if (message.windowName != null && message.hasOwnProperty("windowName"))
                object.windowName = message.windowName;
            if (message.originatorWindowName != null && message.hasOwnProperty("originatorWindowName"))
                object.originatorWindowName = message.originatorWindowName;
            if (message.manualOrAuto != null && message.hasOwnProperty("manualOrAuto"))
                object.manualOrAuto = options.enums === String ? $root.rti.RithmicOrderNotification.OrderPlacement[message.manualOrAuto] === undefined ? message.manualOrAuto : $root.rti.RithmicOrderNotification.OrderPlacement[message.manualOrAuto] : message.manualOrAuto;
            if (message.origPriceType != null && message.hasOwnProperty("origPriceType"))
                object.origPriceType = options.enums === String ? $root.rti.RithmicOrderNotification.PriceType[message.origPriceType] === undefined ? message.origPriceType : $root.rti.RithmicOrderNotification.PriceType[message.origPriceType] : message.origPriceType;
            if (message.remarks != null && message.hasOwnProperty("remarks"))
                object.remarks = message.remarks;
            if (message.cancelAtSsboe != null && message.hasOwnProperty("cancelAtSsboe"))
                object.cancelAtSsboe = message.cancelAtSsboe;
            if (message.cancelAtUsecs != null && message.hasOwnProperty("cancelAtUsecs"))
                object.cancelAtUsecs = message.cancelAtUsecs;
            if (message.bracketType != null && message.hasOwnProperty("bracketType"))
                object.bracketType = options.enums === String ? $root.rti.RithmicOrderNotification.BracketType[message.bracketType] === undefined ? message.bracketType : $root.rti.RithmicOrderNotification.BracketType[message.bracketType] : message.bracketType;
            return object;
        };

        /**
         * Converts this RithmicOrderNotification to JSON.
         * @function toJSON
         * @memberof rti.RithmicOrderNotification
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RithmicOrderNotification.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the type url for RithmicOrderNotification
         * @function getTypeUrl
         * @memberof rti.RithmicOrderNotification
         * @static
         * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
         * @returns {string} The type url
         */
        RithmicOrderNotification.getTypeUrl = function getTypeUrl(prefix) {
            if (prefix === undefined)
                prefix = "type.googleapis.com";
            return prefix + "/rti.RithmicOrderNotification";
        };

        /**
         * NotifyType enum.
         * @name rti.RithmicOrderNotification.NotifyType
         * @enum {number}
         * @property {number} NOTIFYTYPE_UNSPECIFIED=0 NOTIFYTYPE_UNSPECIFIED value
         * @property {number} ORDER_RCVD_FROM_CLNT=1 ORDER_RCVD_FROM_CLNT value
         * @property {number} MODIFY_RCVD_FROM_CLNT=2 MODIFY_RCVD_FROM_CLNT value
         * @property {number} CANCEL_RCVD_FROM_CLNT=3 CANCEL_RCVD_FROM_CLNT value
         * @property {number} OPEN_PENDING=4 OPEN_PENDING value
         * @property {number} MODIFY_PENDING=5 MODIFY_PENDING value
         * @property {number} CANCEL_PENDING=6 CANCEL_PENDING value
         * @property {number} ORDER_RCVD_BY_EXCH_GTWY=7 ORDER_RCVD_BY_EXCH_GTWY value
         * @property {number} MODIFY_RCVD_BY_EXCH_GTWY=8 MODIFY_RCVD_BY_EXCH_GTWY value
         * @property {number} CANCEL_RCVD_BY_EXCH_GTWY=9 CANCEL_RCVD_BY_EXCH_GTWY value
         * @property {number} ORDER_SENT_TO_EXCH=10 ORDER_SENT_TO_EXCH value
         * @property {number} MODIFY_SENT_TO_EXCH=11 MODIFY_SENT_TO_EXCH value
         * @property {number} CANCEL_SENT_TO_EXCH=12 CANCEL_SENT_TO_EXCH value
         * @property {number} OPEN=13 OPEN value
         * @property {number} MODIFIED=14 MODIFIED value
         * @property {number} COMPLETE=15 COMPLETE value
         * @property {number} MODIFICATION_FAILED=16 MODIFICATION_FAILED value
         * @property {number} CANCELLATION_FAILED=17 CANCELLATION_FAILED value
         * @property {number} TRIGGER_PENDING=18 TRIGGER_PENDING value
         * @property {number} GENERIC=19 GENERIC value
         * @property {number} LINK_ORDERS_FAILED=20 LINK_ORDERS_FAILED value
         */
        RithmicOrderNotification.NotifyType = (function() {
            const valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "NOTIFYTYPE_UNSPECIFIED"] = 0;
            values[valuesById[1] = "ORDER_RCVD_FROM_CLNT"] = 1;
            values[valuesById[2] = "MODIFY_RCVD_FROM_CLNT"] = 2;
            values[valuesById[3] = "CANCEL_RCVD_FROM_CLNT"] = 3;
            values[valuesById[4] = "OPEN_PENDING"] = 4;
            values[valuesById[5] = "MODIFY_PENDING"] = 5;
            values[valuesById[6] = "CANCEL_PENDING"] = 6;
            values[valuesById[7] = "ORDER_RCVD_BY_EXCH_GTWY"] = 7;
            values[valuesById[8] = "MODIFY_RCVD_BY_EXCH_GTWY"] = 8;
            values[valuesById[9] = "CANCEL_RCVD_BY_EXCH_GTWY"] = 9;
            values[valuesById[10] = "ORDER_SENT_TO_EXCH"] = 10;
            values[valuesById[11] = "MODIFY_SENT_TO_EXCH"] = 11;
            values[valuesById[12] = "CANCEL_SENT_TO_EXCH"] = 12;
            values[valuesById[13] = "OPEN"] = 13;
            values[valuesById[14] = "MODIFIED"] = 14;
            values[valuesById[15] = "COMPLETE"] = 15;
            values[valuesById[16] = "MODIFICATION_FAILED"] = 16;
            values[valuesById[17] = "CANCELLATION_FAILED"] = 17;
            values[valuesById[18] = "TRIGGER_PENDING"] = 18;
            values[valuesById[19] = "GENERIC"] = 19;
            values[valuesById[20] = "LINK_ORDERS_FAILED"] = 20;
            return values;
        })();

        /**
         * TransactionType enum.
         * @name rti.RithmicOrderNotification.TransactionType
         * @enum {number}
         * @property {number} TRANSACTIONTYPE_UNSPECIFIED=0 TRANSACTIONTYPE_UNSPECIFIED value
         * @property {number} BUY=1 BUY value
         * @property {number} SELL=2 SELL value
         * @property {number} SS=3 SS value
         */
        RithmicOrderNotification.TransactionType = (function() {
            const valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "TRANSACTIONTYPE_UNSPECIFIED"] = 0;
            values[valuesById[1] = "BUY"] = 1;
            values[valuesById[2] = "SELL"] = 2;
            values[valuesById[3] = "SS"] = 3;
            return values;
        })();

        /**
         * Duration enum.
         * @name rti.RithmicOrderNotification.Duration
         * @enum {number}
         * @property {number} DURATION_UNSPECIFIED=0 DURATION_UNSPECIFIED value
         * @property {number} DAY=1 DAY value
         * @property {number} GTC=2 GTC value
         * @property {number} IOC=3 IOC value
         * @property {number} FOK=4 FOK value
         */
        RithmicOrderNotification.Duration = (function() {
            const valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "DURATION_UNSPECIFIED"] = 0;
            values[valuesById[1] = "DAY"] = 1;
            values[valuesById[2] = "GTC"] = 2;
            values[valuesById[3] = "IOC"] = 3;
            values[valuesById[4] = "FOK"] = 4;
            return values;
        })();

        /**
         * PriceType enum.
         * @name rti.RithmicOrderNotification.PriceType
         * @enum {number}
         * @property {number} PRICETYPE_UNSPECIFIED=0 PRICETYPE_UNSPECIFIED value
         * @property {number} LIMIT=1 LIMIT value
         * @property {number} MARKET=2 MARKET value
         * @property {number} STOP_LIMIT=3 STOP_LIMIT value
         * @property {number} STOP_MARKET=4 STOP_MARKET value
         */
        RithmicOrderNotification.PriceType = (function() {
            const valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "PRICETYPE_UNSPECIFIED"] = 0;
            values[valuesById[1] = "LIMIT"] = 1;
            values[valuesById[2] = "MARKET"] = 2;
            values[valuesById[3] = "STOP_LIMIT"] = 3;
            values[valuesById[4] = "STOP_MARKET"] = 4;
            return values;
        })();

        /**
         * BracketType enum.
         * @name rti.RithmicOrderNotification.BracketType
         * @enum {number}
         * @property {number} BRACKETTYPE_UNSPECIFIED=0 BRACKETTYPE_UNSPECIFIED value
         * @property {number} STOP_ONLY=1 STOP_ONLY value
         * @property {number} TARGET_ONLY=2 TARGET_ONLY value
         * @property {number} TARGET_AND_STOP=3 TARGET_AND_STOP value
         * @property {number} STOP_ONLY_STATIC=4 STOP_ONLY_STATIC value
         * @property {number} TARGET_ONLY_STATIC=5 TARGET_ONLY_STATIC value
         * @property {number} TARGET_AND_STOP_STATIC=6 TARGET_AND_STOP_STATIC value
         */
        RithmicOrderNotification.BracketType = (function() {
            const valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "BRACKETTYPE_UNSPECIFIED"] = 0;
            values[valuesById[1] = "STOP_ONLY"] = 1;
            values[valuesById[2] = "TARGET_ONLY"] = 2;
            values[valuesById[3] = "TARGET_AND_STOP"] = 3;
            values[valuesById[4] = "STOP_ONLY_STATIC"] = 4;
            values[valuesById[5] = "TARGET_ONLY_STATIC"] = 5;
            values[valuesById[6] = "TARGET_AND_STOP_STATIC"] = 6;
            return values;
        })();

        /**
         * OrderPlacement enum.
         * @name rti.RithmicOrderNotification.OrderPlacement
         * @enum {number}
         * @property {number} ORDERPLACEMENT_UNSPECIFIED=0 ORDERPLACEMENT_UNSPECIFIED value
         * @property {number} MANUAL=1 MANUAL value
         * @property {number} AUTO=2 AUTO value
         */
        RithmicOrderNotification.OrderPlacement = (function() {
            const valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "ORDERPLACEMENT_UNSPECIFIED"] = 0;
            values[valuesById[1] = "MANUAL"] = 1;
            values[valuesById[2] = "AUTO"] = 2;
            return values;
        })();

        return RithmicOrderNotification;
    })();

    return rti;
})();

export {
  $root as default
};
